import React from "react";
import { connect } from "react-redux";
import "../../../common/tabComponents/TabComponents.scss";
import { Row, Col, Container } from "react-bootstrap";
import { submit, stopSubmit, touch, change } from 'redux-form';
import Header from "../../../common/header/Header";
import "../DataEntryDetails.scss";
import DataEntryDetailsLeftPane from "./DataEntryDetailsLeftPane";
import DataEntryDetailsRightPane from "./DataEntryDetailsRightPane";
import RequestorContactModal from "./RequestorContactModal";
import AssignContactModal, { NewContactValues, RequestorContact } from "./AssignContactModal";
import { shouldPrefillContactForm } from "./createPrefill";
import DataEntryDetailsBody from "./DataEntryDetailsBody";
import { tabItems } from "../DataEntryTabConstants";
import {
    onChangeDataEntryTab,
    getTransactionAttributesActionCreator,
    getFeeScheduleData,
    getTransactionNotesRequest,
    getAdditionalChargeType,
    getAdditionalChargeRecordsCreator,
    getTransactionDocuments,
    getRejectOptions,
    getShippingServicesData,
    getReleaseMethodOptionsData,
    setReleaseMethodActionCreator,
    getTransactionNoteTypes,
    uploadMultipleDocumentsActionCreator,
    getDocumentByIdActionCreator,
    resetDataEntryState,
    updateDocumentActionCreator,
    getDoucmentSourcesActionCreator,
    deleteDocumentActionCreator,
    getRetrieveProtocolActionCreator,
    getCancellationReasons,
    checkDuplicateTransactions,
    getSelectedPHICodesActionCreator,
    getAuditTypesRequest,
    getOBOsRequest,
    getPHICodesRequest,
    getUserGroupsActionCreator,
    getDisclosureReasonActionCreator,
    updateFormSyncErrorsActionCreator,
    getUserTasksActionCreator,
    getRequestTypesAndPurposesRequest,
    getFacilityDiscloseInstitutionsRequest,
    requestorVerificationEmailSent,
    RequestorVerificationEmailSentReset,
    setLastUsedRequestorInfo,
    requestorCompleteActionCreator,
    billingCompleteActionCreator,
    detailsCompleteActionCreator,
    getFacilityAdditionalFieldsActionCreator,
    getWaitAndHoldReasons,
    getQAErrorsActionCreator,
    getQAIssuesActionCreator,
    getQAPDIssuesActionCreator,
    updateBillingPaneFields,
    updateBillToRequestorDetailsRequest,
    setCertificationTemplateAction,
    updateAdditionalChargesActionCreator,
    putDigitalFaxValidationCreator,
    createPatientRecordRequest,
    getAssessmentResultsActionCreator,
    getAIFeedbackActionCreator,
    getReviewEntitiesActionCreator,
    getAuditUsersActionCreator,
    getCertificationTypesAction,
    setPDFPageNumberActionCreator,
    setGroundingHighlightActionCreator,
    setCurrentFileTypeActionCreator,
    getSensitivityTypesActionCreator,
    getFacilityConfigurationsActionCreator,
    getIntakeIntelligenceActionCreator,
    updateInformationToReleaseActionCreator,
    updateSensitiveInfoActionCreator,
    putAuditTransactionSensitiveInfoCreator,
    getAuditTrail,
    setClassicModeOverrideActionCreator,
    nextTransactionIdActionCreator,
    readBarCodeDDSRequest,
    updateDisclosureInformationActionCreator,
    completeTransactionTaskActionCreator,
} from "../DataEntryDetailsDucks";
import { commitQuickEntryActionCreator, QuickEntryMatchSummaryPayload } from "../IntakeDucks";
import { IntakeFetchGateInputs, isIntakeAnalysisDecisionReady, shouldFetchExistingIntakeAnalysis } from "../intakeFetchGate";
import { classifyIntakeAnalysisOutcome } from "../intakeAnalysisOutcome";
import { isQuickEntryEligibleFromInputs } from "../quickEntryEligibility";
import { IntakeStuckGateInputs, isIntakeStuckCandidate, shouldClearConfirmedIntakeStuck, INTAKE_STUCK_SETTLE_MS } from "../intakeStuckGate";
import { nextRangeForAllDates, nextRangeForServiceDate } from "../serviceDateAllDates";
import { buildQuickEntryCorrections, QuickEntryCorrectionInput, QuickEntryCorrectionPayload } from "./QuickEntryCorrections";
import QuickEntryBillingPane, { QuickEntryBillingFields, digitalFaxMatchesOnFile } from "./QuickEntryBillingPane";
import { computeQuickEntryBillingDefaults, computeQuickEntryReleaseMethodResync, QUICK_ENTRY_BILLING_DEFAULT_FIELDS, QuickEntryBillingDefaultField, getQuickEntryBillingSendToAddressFromFormValues, computeQuickEntryBillToDefaults, QUICK_ENTRY_BILL_TO_DEFAULT_FIELDS, QuickEntryBillToDefaultField, QuickEntryRequestorBillingDetails, QuickEntryBillToContactFallback, computeQuickEntryBillToRecordResync, QuickEntryBillToWrittenValues, QuickEntryBillToWrittenRows, billToFieldsReconciledWithRecord } from "./quickEntryBillingDefaults";
import { serverValidationMessage } from "./serverValidationError";
import QuickEntryTransactionCreatedCard from "./QuickEntryTransactionCreatedCard";
import DuplicateTXPopup from "../../../common/alertPopup/DuplicateTXPopup";
import { buildDuplicateCompareTransaction } from "./duplicateCompare";
import QuickEntryRecordsPane, { QuickEntryRecordsPaneSummary } from "./QuickEntryRecordsPane";
import LeaveQuickEntryModal from "../../../common/modal/LeaveQuickEntryModal";
import {
  getOutboundTemplateRequest,
  getNextQATransaction,
  clearTransactionId,
} from "../../landingPage/LandingPageDucks";
import { getRoutePathName } from "../../landingPage/LandingPage";
import { reset } from 'redux-form';
import { FormConstants, RequestorFormConstants, BillingFormconstants } from "./DataEntryFieldsConstants";
import localValidations, { ignoreFields, infoToReleaseValidiation, isDateNotSqlOverflow } from './validations/localValidations';
import { getMomentDate, generateSendToRequestorObject } from "../../../common/utils/appUtils";
import { postCancellationReasonsActionCreators } from "../DataEntryDetailsDucks";
import LoadingSpinner from "../../../common/loadingSpinner/loadingSpinner";
import toast, { Toaster } from "react-hot-toast";
import TransactionDocument, { DocumentUploadRequest } from "../../../models/document";
import FeeSchedule from "../../../models/feeSchedule";
import { DISCLOSURE_ACCOUNTING, DISABILITY_OR_SOCIAL_SECURITY, AUDIT, DISCLOSURE_EVENT, INTERNAL, TypeOfRequestorID } from "../../../models/requestType";
import { SensitiveInfoRelease, SensitiveInfoType, TransactionDetails, ReleaseInfoUpdate, SensitiveInfoUpdateAPI, Release, SensitiveInfo } from "../../../models/transaction";
import { Requestor } from "../../../models/requestor";
import { DropdownOption } from "../../../common/formFields/DropdownField";
import TransactionIssue, { QaError } from "../../../models/transactionIssue";
import { AssessmentResult, DRUG, EntityTypeId, HIV, HPV, PSYC_MHLT, ReviewEntity, STD } from "../../../models/assessment";
import { Address, AdministrationLevel, NameIdPair } from "../../../models/misc";
import AuditData from "../../../models/auditData";
import { RootState } from "typesafe-actions";
import { FeatureFlags, getQAFeatureFlagsRequest as getQAFeatureFlagsRequestActionCreator } from "../../login/LoginPageDucks";
import { RequestAnalysis, RequestAnalysisData, RequestAnalysisStatus, FieldGroupRow, FieldGroupRowStatus, isFieldGroupRowOutstanding, isFieldGroupRowConfirmDisabled, FieldGrounding, GroundingState, analysisBelongsToTransaction} from "../../../models/intake";
import { writeFieldToForm, isUtcMidnightDate, utcMidnightDateToMMDDYYYY, formatQuickEntryServiceDateShort, toLocalCalendarDayMidnight, toDisplayDate, floatingCalendarDayIso } from "./formFieldHelpers";
import { takeQuickEntryEditSnapshot, QuickEntryEditSnapshot } from "../quickEntryEditSnapshot";
import { resolveClinicSeedTarget, resolveRequestTypePurposeSeed } from "./clinicSeedTarget";
import { withResolvedTypePurpose, shouldSyncRequestPurpose } from "./requestTypePurposeResolver";
import { resolveConfirmedPatientId } from "./confirmedPatientId";
import { optionSetsEqual } from "./quickEntryOptionSet";
import { isConfirmAllEnabled } from "./confirmAllGate";
import { computeQuickEntryRehydration, buildPersistedPatientMatch, buildPersistedRequestorMatch, transactionDetailsMatchesId, resolvePersistedMatchGate, QUICK_ENTRY_REQUEST_INFO_FIELDS } from "./quickEntryRehydration";
import FacilityConfiguration from "../../../models/facilityConfiguration";
import QuickEntryFieldGroupList from "./QuickEntryFieldGroupList";
import QuickEntryFieldConfidence, { confidenceKeyForRow, rowCanBeGrounded } from "./QuickEntryFieldConfidence";
import QuickEntryGroundingIcon, { findFieldGrounding } from "./QuickEntryGroundingIcon";
import QuickEntryActionFooter from "./QuickEntryActionFooter";
import RequestTypePurposeField, { mapRequestTypePurposeToFieldGroupRow, REQUEST_TYPE_PURPOSE_ROW_ID, resolveRequestTypePurposeGrounding } from "./RequestTypePurposeField";
import ReceivedDateField, { mapReceivedDateToFieldGroupRow, RECEIVED_DATE_ROW_ID } from "./ReceivedDateField";
import DueDateField, { mapDueDateToFieldGroupRow, DUE_DATE_ROW_ID } from "./DueDateField";
import RequestIdField, { mapRequestIdToFieldGroupRow, REQUEST_ID_ROW_ID } from "./RequestIdField";
import AuthorizationDateField, { mapAuthorizationDateToFieldGroupRow, AUTHORIZATION_DATE_ROW_ID } from "./AuthorizationDateField";
// AB#35150: Classic's date rules, shared so Quick Entry cannot word the same problem differently.
import {
  validateAuthorizationDate,
  validateRequestDate,
  validateReceivedDate,
  validateDueDate,
  validateServiceDate,
  validateServiceDateRange,
  OUT_OF_RANGE_DATE_MESSAGE,
} from "./quickEntryDateValidation";
import { hasCompleteDateShape, isOutOfRangeDateEntry, INVALID_DATE_MESSAGE } from "./quickEntryFieldConstraints";
import RequestDateField, { mapRequestDateToFieldGroupRow, REQUEST_DATE_ROW_ID } from "./RequestDateField";
import CaseNumberField, { mapCaseNumberToFieldGroupRow, CASE_NUMBER_ROW_ID } from "./CaseNumberField";
import DdsFieldsGroup, { applyDdsCompletenessToRequestorRow, resolveDdsSiteCode } from "./DdsFieldsGroup";
import ClinicResponsibleField, { mapClinicResponsibleToFieldGroupRow, CLINIC_RESPONSIBLE_ROW_ID } from "./ClinicResponsibleField";
import AuditTypeField, { mapAuditTypeToFieldGroupRow, AUDIT_TYPE_ROW_ID, AuditTypeOption } from "./AuditTypeField";
import OnBehalfOfField, { mapOnBehalfOfToFieldGroupRow, ON_BEHALF_OF_ROW_ID, OnBehalfOfOption } from "./OnBehalfOfField";
import {
    mapRecordsRequestedToFieldGroupRow, RECORDS_REQUESTED_ROW_ID,
    mapServiceDateFromToFieldGroupRow, SERVICE_DATE_FROM_ROW_ID,
    mapServiceDateToToFieldGroupRow, SERVICE_DATE_TO_ROW_ID,
    getReleaseDateRange, buildReleaseInfoWithItemToggle, buildReleaseInfoWithDateRange,
    matchAiReleaseItemIds, isRecordsRequestedDocSourced, serviceDateDocSourced,
    mergeQuickEntryReleaseInfo, coerceDate, buildRecordsRequestedAiCorrectionValue,
    recordsRequestedDisplayNames, otherDocumentsNote, OTHER_DOCUMENTS_RELEASE_ID,
} from "./RecordsRequestedField";
import { computeAuditSensitiveInfoDefaults } from "./auditSensitiveInfoDefaults";
import SensitiveInfoField, { mapSensitiveInfoToFieldGroupRow, SENSITIVE_INFO_ROW_ID, buildSensitiveInfoRevertPayload, buildSensitiveInfoAuditMessage, matchAiSensitiveInfoIds, isSensitiveInfoDocSourced, isSensitiveInfoResolved, buildSensitiveInfoAiCorrectionValue, buildSensitiveInfoSpecialistCorrectionValue } from "./SensitiveInfoField";
import QuickEntryDisclosureRow, {
    mapDisclosureInfoToFieldGroupRow,
    PhiCodeOption,
    diffPhiCodeSelections,
    DISCLOSURE_INFO_ROW_ID,
    QuickEntryDisclosureDraft,
    isDisclosureDraftComplete,
    buildDisclosureUpdatePayload,
    disclosureDraftFromTransaction,
} from "./QuickEntryDisclosureRow";
import PatientInfoRow, { mapPatientInfoToFieldGroupRow, PATIENT_INFO_ROW_ID, PatientCreateValues } from "./PatientInfoRow";
import RequestorInfoRow, { mapRequestorInfoToFieldGroupRow, REQUESTOR_INFO_ROW_ID, RequestorCreateValues, ModalRequestorSelection } from "./RequestorInfoRow";
import ProviderFacilityField, { mapProviderFacilityToFieldGroupRow, PROVIDER_FACILITY_ROW_ID, ProviderFacilityValues } from "./ProviderFacilityField";
import { patientSearchApi, requestorSearchApi, requestorContactApi, exitToClassicIntakeApi, quickEntrySessionStartedApi, releaseInfoPreviewApi, phiDisclosedApi } from "./matchApi";
import { validateFeeScheduleApi } from "../test/DataEntry.APIs";
import {
  DEFAULT_PATIENT_MATCH_STATE,
  DEFAULT_REQUESTOR_MATCH_STATE,
  PatientMatchState,
  RequestorMatchState,
  toDisplayDob,
} from "../matchState";
import { RequestType, RequestPurposeUpdate } from "../../../models/requestType";
import DateField from "../../../common/formFields/DateField";
import { CheckboxList, Item as CheckboxItem } from "../../../common/formFields/CheckboxList";
import { DEFAULT_MIN_DATE, API_INITIAL, API_FETCHING, API_SUCCESS, API_FAILURE, ReduxApiStatus, HttpResponse, INVALID_DATE } from "../../../common/constants/ApiConstants";
import { DocTypes } from "../../../common/constants/DocTypes";
import { patchRequest, post } from "../../../services/Network";
import { buildSendToContactPatchParams, sendToContactPatchUrl } from "./requestorContactSave";

/*
 * AB#38161: the Provider/Facility group in its UNSCOPED state, which is the only state v1.1b has.
 *
 * PRD v2.10 line 136 is a FEATURE 1 acceptance criterion, not a Feature 3 one: Quick Entry treats
 * the group as optional and nullable from day one, renders "a value or nothing", and shows a
 * "No provider specified" state when Feature 3 returns nothing OR is flag-gated / not yet enabled -
 * rather than an empty or broken row. So it ships in v1.1b even though Feature 3 itself (#33165 /
 * Spec #34099) is deferred to August to ship with QA AI 1.2, its only consumer.
 *
 * Nothing on this branch can produce a value: the extraction, the read model and the commit path
 * all live on the Feature 3 branch, so the row is hard-wired unscoped and read-only here rather
 * than derived from analysis fields that are always undefined. Feature 3's PR (!9593) replaces
 * these two constants with its flag-driven and analysis-driven equivalents - the call sites below
 * are the seam it plugs into. Deliberately NOT flag-driven in the meantime: an editable field whose
 * value is discarded on reopen is worse than no field at all, and with no commit path here a
 * config-only flag flip would produce exactly that.
 */
// AB#38499: the range a patient DOB can actually be STORED in. tblPatientData.DateOfBirth is
// smalldatetime, so anything outside 1900-01-01 .. 2079-06-06 raises Msg 242 on insert. These
// mirror SearchableDobMin/SearchableDobMax in PatientManager.cs deliberately - the server guards
// the SEARCH path with the same two dates, and the create path has to agree with it or the two
// halves of the same field disagree about what is acceptable.
//
// Not "not in the future" (which is what Classic's isValidDob uses, and is a tighter, arguably
// better semantic bound): that would additionally reject dates like 2030 which store fine today,
// and this fix is scoped to the overflow. Raised as a follow-up instead.
const STORABLE_DOB_MIN = new Date(1900, 0, 1);
const STORABLE_DOB_MAX = new Date(2079, 5, 6); // month is 0-based: 5 = June

const PROVIDER_FACILITY_UNSCOPED: ProviderFacilityValues = { providerName: "", facilityName: "", department: "" };
const PROVIDER_FACILITY_NO_CAPTURE = () => { /* unreachable: allowEntry={false} renders no inputs, so nothing can change */ };

/**
 * Coalesce 2026-07-20 (F1c #34101 + F1d #34102): the Patient/Requestor match
 * rows can reach FieldGroupRowStatus.LowConfidence (a MULTIPLE match). They are
 * resolved by picking a candidate in F1c's in-row match grid, NOT by F1d's
 * generic Acknowledge checkbox - so those two rows are excluded from the
 * acknowledge affordance. The patient/requestor gate (isPatientRequestorConfirmed)
 * already requires a single match, so suppressing acknowledge keeps the row's
 * outstanding state and the gate from disagreeing.
 *
 * Request Type/Purpose (AB#35098) belongs here for the same reason. Its amber
 * "purpose-uncertain" state means a Type resolved but no valid child Purpose did,
 * and Purpose is a REQUIRED field (localValidations: "Purpose Type is required").
 * It is resolved by picking a purpose in the row's own dropdown - which clears the
 * amber state automatically - never by acknowledging it away. Without this, the
 * generic Acknowledge checkbox would clear the row from the outstanding count and
 * enable Confirm All while PURPOSE_TYPE is still unset.
 *
 * Sensitive Information (AB#38735) belongs here for the third variant of the same reason. Its
 * amber means the AI proposed a set of protected categories and nobody has checked them against
 * the document. There is no version of "I accept that as it stands" that is safe to offer as a
 * tickbox: the extraction over-declares on 57.1% of documents, so acknowledging it away is
 * exactly the disclosure risk the amber exists to stop. It is resolved by answering every
 * category and Confirming the row, which clears it automatically.
 *
 * THE INCONSISTENCY WITH REQUEST TYPE/PURPOSE IS DELIBERATE - DO NOT FLATTEN IT.
 *
 * AB#38739 made Request Type/Purpose always-amber too, so Quick Entry now has two permanently
 * amber rows that behave differently, which reads like an oversight and is not. That row is
 * ACKNOWLEDGE-SATISFIABLE on purpose - its own comment in RequestTypePurposeField says the amber
 * "stays acknowledge-satisfiable and non-blocking per the PRD, so this costs one deliberate click
 * and gates no submission" - because it guards routing and billing, where one deliberate click is
 * a proportionate check. (AB#38683 then dropped that row's id from this set whenever a purpose
 * exists from either the form or the extraction, which is every case in which it is amber at all.)
 *
 * Sensitive Information stays in the set unconditionally. A click-through does not protect against
 * asserting consent the patient never gave; only reading the document and answering the
 * questionnaire does. Making the two rows behave alike, in either direction, is a product decision
 * with a disclosure-risk consequence - not a tidy-up. Pinned by test 4.3 in
 * DataEntryDetails.sensitiveInfoAmber.test.tsx, which asserts both contracts side by side.
 */
const QUICK_ENTRY_SELF_RESOLVING_ROW_IDS: ReadonlySet<string> = new Set([
  PATIENT_INFO_ROW_ID,
  REQUESTOR_INFO_ROW_ID,
  REQUEST_TYPE_PURPOSE_ROW_ID,
  SENSITIVE_INFO_ROW_ID,
]);

/**
 * Maps each Quick Entry row id to its backend FieldIdentifier name(s) (Spec
 * #34102 / F1d, AC4). Only Request Type/Purpose has any real AI-extracted
 * data wired today (RequestTypePurposeField's mapper reads
 * RequestAnalysisData; every other row's own mapper - AuthorizationDateField,
 * RequestDateField, CaseNumberField, ClinicResponsibleField,
 * RecordsRequestedField x3, SensitiveInfoField - hardcodes
 * isAiPreSelected: false and never reads RequestAnalysisData at all,
 * confirmed by reading each mapper). getQuickEntryCorrectionPayloads
 * therefore only derives a real aiValue for the two Request Type/Purpose
 * entries; every other row's aiValue is correctly null until a sibling Spec
 * wires AI extraction for it.
 */
// AC9 (Spec #34102 / F1d): how long the Billing pane's "Transaction created"
// success card waits before auto-advancing to the next Data Entry queue item
// (master-demo-v6.html's own copy: "Auto-advancing to the next item in the
// Data Entry queue…"). Mirrors this codebase's existing WaitAndHoldModal.tsx
// pattern of a short setTimeout before firing a queue-navigation action.
const QUICK_ENTRY_AUTO_ADVANCE_DELAY_MS = 2500;

// AB#37856: Sensitive Information is the exception to the "every row except Request
// Type/Purpose has a null aiValue" note in the doc block above (which is separated from this
// table by an unrelated constant, so read it there) - its aiValue and SpecialistValue come
// from SensitiveInfoField's own mappers rather than `null` + the row's summary string. No new
// field name is registered; only the values changed. Every other row here is unchanged.
const QUICK_ENTRY_ROW_FIELD_NAMES: Readonly<Record<string, readonly string[]>> = {
  [REQUEST_TYPE_PURPOSE_ROW_ID]: ["RequestType", "RequestPurpose"],
  // Service Date-From/-To are deliberately NOT in this table (bug fix,
  // reproduced live against the running backend: "User submitted unknown
  // field name DateRangeFrom1 for Quick Entry commit", 400). Neither
  // "DateRangeFrom1" nor "DateRangeTo1" is a name AnalysisFieldMapper.cs's
  // switch resolves - RecordsRequestedField.tsx's own doc comment (lines
  // 21-29) confirms these two rows are NOT redux-form/RequestAnalysisData
  // fields at all; they're backed by component-local state and persisted
  // via their own immediate saveInformationToRelease API call, entirely
  // separate from the AI-extraction/correction-feedback system FieldIdentifier
  // belongs to. They were never supposed to be part of the Confirm-All
  // bulk-correction-commit payload - getQuickEntryCorrectionPayloads' `if
  // (!fieldNames) return;` guard already skips any row with no entry here,
  // so omitting them is the fix, not a workaround.
  [RECORDS_REQUESTED_ROW_ID]: ["InfoReleaseSections"],
  [AUTHORIZATION_DATE_ROW_ID]: ["AuthorizationDate"],
  [REQUEST_DATE_ROW_ID]: ["RequestDate"],
  [RECEIVED_DATE_ROW_ID]: ["ReceivedDate"],
  [DUE_DATE_ROW_ID]: ["DueDate"],
  [CASE_NUMBER_ROW_ID]: ["CaseNumber"],
  [CLINIC_RESPONSIBLE_ROW_ID]: ["ClinicName"],
  [SENSITIVE_INFO_ROW_ID]: ["SensitiveInfoDeclarations"],
};

/**
 * Correction field names whose row `value` is a human-formatted date string
 * (e.g. "July 16, 2026"). Their SpecialistValue is normalized to ISO yyyy-MM-dd
 * before commit (AB#34102, F1d 🟡 fix) so the audit/reporting layer stores a
 * parseable date, not a locale-dependent display string.
 */
// AB#38683: ReceivedDate and DueDate were missing here, so their committed
// SpecialistValue stayed in display form ("01/04/2026") while the stored extraction is
// ISO - 289 Received_Date and 275 Due_date rows on aspTest read as specialist changes
// purely because of that. All four Quick Entry dates now normalise the same way.
const QUICK_ENTRY_DATE_FIELD_NAMES: ReadonlySet<string> = new Set(
  ["AuthorizationDate", "RequestDate", "ReceivedDate", "DueDate"]);

/**
 * Spec #35135 (AC6): rows that a Disclosure Accounting (type 66) transaction has
 * no use for and that Classic likewise hides for that type. They are omitted from
 * the Quick Entry row list entirely rather than rendered as "Not applicable yet"
 * placeholders - a Disclosure Accounting pane is a short, purposeful list.
 * Service Date / Records Requested / Sensitive Info are this Spec's new hiding
 * work; Authorization Date / Request Date were already gated out by
 * isQuickEntryRowApplicable before this Spec (that gate is unchanged) and are
 * listed here only so the pane doesn't render them as dead placeholders.
 */
const DISCLOSURE_ACCOUNTING_HIDDEN_ROW_IDS: ReadonlySet<string> = new Set([
  SERVICE_DATE_FROM_ROW_ID,
  SERVICE_DATE_TO_ROW_ID,
  RECORDS_REQUESTED_ROW_ID,
  SENSITIVE_INFO_ROW_ID,
  AUTHORIZATION_DATE_ROW_ID,
  REQUEST_DATE_ROW_ID,
]);

// AB#35095: Classic pre-selects "Charge for Postage?" = "Default" on a fresh
// transaction (RadioField defaultSelected: postageIsApplied, RightPane 2745) and
// persists it. Seed the QE billing model with the same value so a new QE txn
// pre-selects Default and rides postageIsApplied="Default" into the save, rather
// than saving no postage at all. Seeded in the MODEL (not forced in render) so it
// persists and survives the Back-to-Quick-Entry round trip (BR13); a loaded/entered
// Yes/No overwrites it via onFieldsChange and is never clobbered.
// AB#31605 (round-1 CRITICAL-4/WARNING-4, round-2 W-1/W-3): how long any callback-style
// Confirm-All write waits for its saga callback before its settle-guard gives up. Needed
// because these sagas are takeLatest and fire no callback when cancelled - teardown on
// unmount being the path that actually matters - so the promises would otherwise never
// settle. Generous enough that a real round-trip always wins the race.
// See settleGuardedWrite for what each write falls back TO, and why it differs.
const QUICK_ENTRY_WRITE_SETTLE_TIMEOUT_MS = 10000;

/**
 * AB#37853 (Phase 13, ceiling raised in Phase 13b): hard ceiling on how long the Billing pane may
 * show "Loading..." and keep Fee Schedule / Release Method disabled while the post-Confirm-All
 * defaults are in flight.
 *
 * This is a CORRECTNESS backstop, not a nicety. The fee-schedule saga has three exits and only one
 * of them ever refreshes transactionDetails: on a thrown error it dispatches getFeeScheduleFailure
 * (which has NO reducer case at all, so it changes no observable state), and on a non-2xx response
 * that does not throw it dispatches nothing whatsoever. On either path the values never arrive, so
 * a flag cleared only by "the values landed" would stay set forever - disabling precisely the two
 * controls this Bug exists to make usable.
 *
 * WHY 45s AND NOT 10s. The window now opens when Billing is ENTERED off Confirm All, not when the
 * re-fetch fires, so this ceiling must cover the Confirm-All persist gate (~8 sequential writes,
 * measured at roughly 10 SECONDS in manual testing) PLUS the re-fetch that follows it. At the
 * original 10s the timeout would routinely fire mid-gate and unlock the controls while the values
 * were still coming - reintroducing the exact editable window this phase exists to close, and
 * doing it silently. The value must stay comfortably above the observed gate duration; that floor
 * is pinned by a test so it cannot drift back down unnoticed.
 *
 * Erring long is the safe direction. Too long only means a slower recovery from a genuinely silent
 * failure, which the early-clear paths already handle for every failure mode that IS observable;
 * too short reintroduces the bug.
 */
const QUICK_ENTRY_BILLING_DEFAULTS_PENDING_TIMEOUT_MS = 45000;

const DEFAULT_QUICK_ENTRY_BILLING_FIELDS: QuickEntryBillingFields = { chargeForPostage: "Default" };

/** Local-time calendar day -> ISO yyyy-MM-dd; passes empty/unparseable values through unchanged (avoids the UTC day-shift `toISOString` would cause in US zones). */
const toIsoDateParts = (parsed: Date): string => {
  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const day = String(parsed.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const toIsoDateCorrectionValue = (value: string | null): string | null => {
  if (!value) {
    return value;
  }
  const parsed = new Date(value);
  if (isNaN(parsed.getTime())) {
    return value;
  }
  return toIsoDateParts(parsed);
};

/**
 * AB#38683. The AI's extracted date for a correction, on the same calendar day the specialist
 * side resolves to. coerceDate because redux-persist round-trips these to ISO strings.
 *
 * MUST go through floatingCalendarDayIso, not toIsoDateParts. An AI-extracted date parses at UTC
 * MIDNIGHT (models/intake.ts tryParseDate, on the API's "yyyy-MM-dd"), and reading LOCAL parts off
 * that lands a day early everywhere behind UTC - so aiValue came out "2026-07-15" against a
 * specialist value of "2026-07-16" and every accepted date recorded as edited. Measured across
 * America/New_York, Chicago, Denver, Los_Angeles and Pacific/Honolulu; correct only in UTC and
 * ahead of it. Found by John James's review of PR !10280.
 *
 * floatingCalendarDayIso is the repo's canonical answer: it branches on isUtcMidnightDate, so the
 * AI shape reads its UTC day and a specialist-picked local-midnight value reads its local day.
 * Do NOT instead make toIsoDateParts read UTC - the specialist side parses an MM/DD/YYYY display
 * string to LOCAL midnight and is already right; that over-correction is what AB#37982's round-1
 * review caught.
 */
const toAiIsoDate = (value: Date | string | undefined): string | null => {
  const parsed = coerceDate(value);
  return parsed && !isNaN(parsed.getTime()) ? floatingCalendarDayIso(parsed) : null;
};

export interface HealthSystemCounts {
  "total": number,
  "dataEntry": number,
  "recordAttachment": number,
  "recordValidation": number,
  "userTasks": number,
  "qaReview": number,
  "facilityActionRequired": number
}

export interface FacilitiesCountsModal {
  facility: NameIdPair<number>,
  transactionCounts: HealthSystemCounts,
}

export interface Facility {
  id: number,
  name: string,
  userTaskCounts?: HealthSystemCounts,
  billingStates: readonly AdministrationLevel[],
  useClinics: boolean,
  useDepartments: boolean,
  useRequestID: boolean,
  useEMPI: boolean,
  prohibitTraining: boolean,
  qaExcluded: boolean,
  address: Address,
}

export interface HealthSystemModal {
  id: number,
  name: string,
  facilities: FacilitiesCountsModal[],
}

export interface OrganizationDetailsModal {
  healthSystem: HealthSystemModal,
  transactionCounts: HealthSystemCounts,
  facilityCounts: FacilitiesCountsModal[],
}


interface Props {
  onChangeDataEntryTab: Function;
  activeTabId: number;
  proceedBtnClick: false;
  selectedHealthOrganizationDetails: OrganizationDetailsModal,
  selectedFacilityDetails: FacilitiesCountsModal,
  resetForm: Function,
  transactionId: string,
  getRequestsAndPurposes: Function,
  purposeOfRequests: any,
  transactionIDAttributes: any,
  getTransactionAttributes: Function,
  assignTransactionID: Function,
  resetDataEntryState: Function,
  /**
   * RecordsRequestedField's save callback (Spec #34098 / F1a) - same action the classic pane
   * already dispatches. AB#37995: the optional callbacks let the Confirm-All gate await the POST.
   */
  saveInformationToRelease: (data: ReleaseInfoUpdate, onSuccess?: () => void, onError?: () => void) => void,
  /** SensitiveInfoField's save callback (Spec #34098 / F1a) - same action the classic pane already dispatches. */
  saveAndUpdateSensitiveInfo: (data: SensitiveInfoUpdateAPI) => void,
  /** AB#35086: audit call sitting alongside saveAndUpdateSensitiveInfo - same action the classic pane dispatches. */
  putAuditTransactionSensitiveInfo: (transactionId: string, recordContains: string) => void,
  /** AB#35086: refreshes the History tab's audit trail data - same action PdfViewer.tsx dispatches after a save/view/annotate. */
  getAuditTrailData: (transactionId: string) => void,
  patientDetails?: any,
  transactionDetails?: TransactionDetails,
  getFacilityFeeSchedules: (organizationId: number, transactionId: string) => void,
  getTransactionNotesRequest: Function,
  transactionNotes: any,
  getAdditionalChargeType: Function,
  getAdditionalChargeRecords: Function,
  getTransactionDocuments: Function,
  documentsList: readonly TransactionDocument[],
  getRejectOptions: Function,
  getFacilityShippingServices: Function,
  getFacilityReleaseMethods: (facilityId: number, transactionId: string) => void,
  getTransactionNoteTypes: Function,
  uploadMultipleDocuments: (request: DocumentUploadRequest) => void,
  getDocumentById: (documentId: string) => void,
  updateDocument: (data: any) => void,
  getDocumentSources: Function,
  documentSources: DropdownOption[],
  getRejectionLetter: Function,
  getEntityTypes: () => void,
  getAIFeedback: () => void,
  getAssessmentResults: (transactionId: string) => void,
  assessmentResult?: AssessmentResult,
  getReviewEntities: (transactionId: string) => void,
  deleteDocument: (documentId: string) => void,
  deleteAuxDocument: (documentId: string) => void,
  deleteDocumentSuccess?: boolean,
  getRetrieveProtocol: Function,
  retrieveProtocol: any,
  transactionCancellationReasons: Function,
  /** AB#35095: Classic's duplicate-transaction check (GET_DUPLICATE_TRANSACTIONS), fired when the QE Billing step becomes active - same action Classic fires on Billing-tab entry. */
  checkDuplicateTransactions?: (transactionId: string, caseNumber: string) => void,
  formState: any,
  /** Options source for the shared ClinicResponsibleField (Spec #34098 / F1a) - same state.dataEntryState.discloseInstitutions the classic RightPane already reads. */
  discloseInstitutions?: any,
  /** Spec #35289 (AC1): option sources for the Audit(53) Quick Entry rows - the same
   * state.dataEntryState.auditTypes / onBehalfOf slices Classic's RightPane reads. */
  auditTypes?: readonly AuditTypeOption[],
  onBehalfOf?: readonly OnBehalfOfOption[],
  /** AB#35289 (AC4 fix): fetch-once guards + the fetch actions for the Audit(53)
   * option lists. Classic populates these via RightPane; Quick Entry never mounts
   * RightPane, so DataEntryDetails must dispatch them itself (see
   * fetchAuditFieldOptionsForQuickEntry). */
  getAuditTypesAPIStatus?: ReduxApiStatus,
  getOBOsAPIStatus?: ReduxApiStatus,
  getAuditTypesRequest?: () => void,
  getOBOsRequest?: () => void,
  /** AB#35289 (Internal billing parity): one-shot post-Confirm-All transactionDetails
   * re-fetch (getFeeScheduleData with setDefault=true -> re-dispatches getTransactionAttributes)
   * so the backend-assigned Internal courtesy fee schedule + fresh isInternalRequest populate and
   * lock the QE Fee Schedule dropdown. See refreshBillingAfterConfirmAllOnce. */
  refreshBillingAfterConfirmAll?: (facilityId: number, transactionId: string) => void,
  getSelectedPHICodes: Function,
  getPHICodesRequest: any,
  getUserGroups: (organizationId: number) => void,
  getDisclosureReasons: Function,
  /**
   * Spec #35135 (AC3): Disclosure Reason options for the Quick Entry disclosure
   * row, read from the SAME state.dataEntryState.disclosureReasons slice Classic's
   * accordion uses. Already fetched once on mount by initialAPICalls ->
   * getDisclosureReasons; this Spec adds no new fetch.
   */
  disclosureReasons?: readonly DropdownOption[],
  /**
   * AB#35135 follow-up: the PHI codes available for this transaction, each carrying
   * the server's own `isRetrieved` selection flag. Same
   * state.dataEntryState.selectedPHICodes slice Classic's disclosure accordion reads
   * (DataEntryDetailsRightPane passes it as `phiCodes`). Quick Entry ALREADY
   * dispatches getSelectedPHICodes on mount (initialAPICalls) but never read the
   * result back until the disclosure row needed it - no new fetch is added.
   */
  selectedPHICodes?: readonly PhiCodeOption[],
  submitForm: Function,
  stopSubmit: Function,
  updateFormSyncErrors: Function,
  getUserTasks: Function,
  userTasks: any,
  userTaskComments: any,
  touch: Function,
  getFacilityDiscloseInstitutionsRequest: Function,
  feeSchedules?: FeeSchedule[],
  history: any,
  logoutUser: Function,
  userState: any,
  additionalChargeRecords: any,
  /** AB#35095: certification template options (state.dataEntryState.certificationTypes) - threaded into the Quick Entry billing pane's certification dropdown (AutoCertification ON). */
  certificationTypes?: readonly any[],
  /** AB#35095: additional-charge GL-code options (state.dataEntryState.additionalChargeType, normalized by id) - threaded into the Quick Entry billing pane's charge-type dropdowns. */
  additionalChargeType?: any,
  isRequestorVerificationEmailSent: boolean,
  requestorVerificationEmailPopupTriggered: boolean,
  requestorVerificationEmailSentReset: Function,
  requestorVerificationEmailSent: Function,
  setLastUsedRequestorInfo: any,
  requestorDetails?: Requestor,
  /**
   * AB#37981: the transaction's own bill-to record (state.dataEntryState.requestorBillingDetails),
   * loaded by the getTransactionAttributes saga whenever transactionDetails.billToContact.id is
   * set. The source Classic's Bill To section is seeded from, and now Quick Entry's too.
   */
  requestorBillingDetails?: QuickEntryRequestorBillingDetails,
  patchRequestorComplete?: Function,
  patchBillingComplete?: Function,
  /** Spec #35135 (AC4a): Classic's disclosure save, dispatched once from the Quick Entry Confirm-All gate. */
  updateDisclosureInformation?: (data: any, onSuccess?: () => void, onError?: () => void) => void,
  /** Spec #35135 (AC9): the shared finalize for Disclosure Accounting - completeTransactionAPI, NOT BillingComplete. */
  completeTransaction?: (transactionId: string, onSuccess?: () => void, onError?: () => void) => void,
  /** AB#35086: existing Classic-Mode "DetailsComplete" action, fired at Quick Entry's Confirm-All so the data-entry-stage audit event (EnteredDetails) is emitted for QE transactions the same way Classic emits it. */
  /**
   * AB#31605 (round-1 review CRITICAL-4): onSuccess/onError are optional and every
   * pre-existing caller (Classic's tab-navigation trigger) omits them. Quick Entry
   * needs them so the type-66 finalize can run AFTER this audit write rather than
   * racing it for locks on the same transaction row.
   */
  patchDetailsComplete?: (transactionId: string, onSuccess?: () => void, onError?: () => void) => void,
  postCancellationReasonsDispatch?: any
  intiaTxlSagaCallCount: number,
  getFacilityAdditionalFieldsActionCreator?: Function,
  transactionWaitAndHoldReasons: Function,
  requestContext: any,
  getOutboundTemplateRequest?: Function,
  uploadDocumentSuccess: any,
  getQAErrors: () => void,
  qaErrors: QaError[],
  getQAIssues: (transactionId: string) => Promise<void>,
  QAIssues: TransactionIssue[],
  /**
   * Fires the QA PD Issues fetch on mount so the Redux store is populated for
   * DataEntryDetailsRightPane's own Redux-connected read of the same slice
   * (RightPane has its own mapStateToProps/mapDispatchToProps for this data -
   * see DataEntryDetailsRightPane.tsx). The resulting value is not consumed
   * here, so unlike QAIssues above there is no corresponding value prop.
   */
  getQAPDIssues: (transactionId: string) => Promise<void>,
  qaPDIssues: TransactionIssue[],
  updateBillingPaneFields?:Function,
  /** AB#35095: Classic's bill-to + prepayment save path (updateBillToRequestorData). onSuccess/onError let the QE completion gate await it. */
  updateBillToRequestorData?: (data: any, onSuccess?: () => void, onError?: () => void) => void,
  /** AB#35095: Classic's certification-template save path (setCertificationTemplate), used only when AutoCertification is ON. */
  setCertificationTemplate?: (transactionId: string, certificationType: string, onSuccess?: () => void, onError?: () => void) => void,
  /** AB#35095: Classic's additional-charges save path (the same one AdditionalChargeRows uses). */
  updateAdditionalCharges?: (requestData: any, onSuccess?: () => void, onError?: () => void) => void,
  /** AB#35095 (#7): Classic's digital-fax validation endpoint (PUT auditTrail/{id}/digitalfax) - used when releaseMethodId===3. */
  putDigitalFaxValidation?: (transactionId: string, faxNumber: any, onSuccess?: () => void, onError?: () => void) => void,
  /** Creates + links a NEW patient to the transaction (Classic's add-new-patient path); used by Quick Entry's Confirm-All patient persist. onError lets the caller settle its await gate on failure. */
  createPatientRecordRequest?: (data: any, onSuccess?: () => void, onError?: () => void) => void,
  getNextQATransaction: Function,
  getAuditUsers?: Function,
  getCertificationTypes: Function,
  featureFlags: FeatureFlags,
  getTransactionDocumentsAPIStatus: any;
  setPageNumber: Function,
  setGroundingHighlight: Function,
  pageNumber: number,
  currentFile: string,
  setCurrentFileType: Function,
  currentFileType?: string,
  auditTrail?: Array<AuditData>,
  getFacilityConfiguration: Function,
  getIntakeIntelligence: (organizationId: number, requestBufferId: number) => void,
  requestAnalysis?: RequestAnalysis,
  // In-flight status of the intake analysis fetch/trigger. API_FETCHING while the AI
  // extraction request is running (can take up to the extractor's ~100s timeout) —
  // drives the "Analyzing…" loading toast + inline Quick Entry panel (AB#34102).
  getIntakeIntelligenceStatus?: ReduxApiStatus,
  requestIntakeIntelligenceStatus?: ReduxApiStatus,
  /**
   * Per-facility DB toggle (Tech Lead note, AB#34098): the SAME gate
   * DataEntryDetailsBody.tsx already checks (`facilityConfiguration
   * .intakeIntelligenceEnabled`) to show/hide the classic Extract button.
   * Quick Entry must require it too - a facility with IntakeIntelligence
   * on globally but this toggle off must never become Quick-Entry-eligible.
   */
  facilityConfiguration?: FacilityConfiguration,
  /**
   * Classic-Mode-exit override (owned/authored by F1d #34102 - F1a only
   * reads it). Defaults to false until F1d lands the real exit dialog.
   */
  classicModeOverride?: boolean,
  healthSystemDataEntryCount?: number,
  getQAFeatureFlagsRequest: Function,
  /**
   * AC11 (F1a): needed to mount the shared RequestTypePurposeField inside
   * the Quick Entry row - mirrors DataEntryDetailsRightPane's own
   * `requestTypes: state.dataEntryState.requestTypes` binding.
   */
  requestTypes?: readonly RequestType[],
  /**
   * AC11 (F1a): raw dispatch, needed because RequestTypePurposeField's
   * contract takes `dispatch: Function` directly (it calls writeFieldToForm
   * itself) rather than a pre-bound action creator.
   */
  dispatch?: Function,
  /**
   * DDS barcode-scan wiring (Spec #35136 / F1f) - the SAME redux
   * action/reducer/saga Classic Mode already uses (DataEntryDetailsDucks), now
   * also bound into the Quick Entry container so the new DDS row can trigger and
   * consume a scan. `transactionDDS` is state.dataEntryState.readBarCodeDDS (the
   * parsed barcode result); `readBarCodeDDSAPIStatus` gates the auto-populate.
   */
  readBarCodeDDSRequest?: (documentId: string) => void,
  transactionDDS?: any,
  readBarCodeDDSAPIStatus?: ReduxApiStatus,
  /**
   * Spec #34102 (F1d), AC4/AC5/AC6: the Confirm-All bulk correction commit.
   * onSuccess/onConflict/onNoIntakeRecord/onError mirror
   * commitQuickEntryActionCreator's own contract (IntakeDucks.ts) - a 409
   * (write-once guard tripped) and a 404 (no RequestIntake row; combo
   * af935bf backend outcome) are each distinguished from a generic failure
   * (Tests 5.1/5.2).
   */
  commitQuickEntry?: (
    organizationId: number,
    requestBufferId: number,
    corrections: readonly QuickEntryCorrectionPayload[],
    onSuccess?: (completedDate: string) => void,
    onConflict?: () => void,
    onNoIntakeRecord?: () => void,
    onError?: () => void,
    matchSummary?: QuickEntryMatchSummaryPayload,
  ) => void,
  /** Spec #34102 (F1d), AC11/AC12: the only writer of classicModeOverride. */
  setClassicModeOverride?: (value: boolean) => void,
  /** Quick Entry Billing pane's Release Method options (Spec #34102 / F1d, AC7) - same state.dataEntryState.releaseMethod list the classic Billing tab already fetches via getFacilityReleaseMethods (called unconditionally on mount, both modes). */
  releaseMethodOptions?: readonly NameIdPair<number>[],
  /** AB#38349: applies the release method a contact save re-evaluated server-side, exactly as Classic's patchSendToRequestorContactSaga / createSendToContactSaga do. Always dispatched via adoptServerReleaseMethod, which owns the releaseMethodOptions guard and the resync bookkeeping. */
  setReleaseMethod?: (releaseMethodId: number) => void,
  /** AB#35095 layout parity: Shipping Service picker options (state.dataEntryState.shippingService; value=name). */
  shippingServiceOptions?: readonly { readonly label: string; readonly value: string }[],
  /**
   * AC9 (Spec #34102 / F1d): the real queue-navigation call for the Billing
   * pane's "Transaction created" success card auto-advance / "Next Queue
   * Item" button - same nextTransactionIdActionCreator QuickEntryActionFooter's
   * own "Next Request" already dispatches (DataEntryDetailsDucks.ts).
   */
  getNextTransactionId?: (facilityId: number, context: number) => void,
  /** AC9: clears the current transaction id before navigating to the next queue item - same action QuickEntryActionFooter's "Next Request" already dispatches. */
  clearTransactionId?: () => void,
}

interface State {
  test: string;
  active: boolean[];
  tabClick: boolean,
  showLoadingSpinner: boolean,
  showRequestorPopUp: boolean,
  hasUserMadeAnyChanges: boolean,
  /**
   * Quick Entry only: row ids the specialist has explicitly clicked "Edit"
   * on. A Confirmed row shows its plain value + an Edit affordance by
   * default (master-demo-v6.html's row anatomy) and only shows the live
   * editable control while its id is in this set or its status isn't
   * Confirmed yet. Classic mode's shared field components stay always-
   * editable (unaffected) - this toggle is purely a Quick Entry list
   * behavior layered on top in renderQuickEntryRowContent.
   */
  quickEntryEditingRowIds: ReadonlySet<string>,
  /**
   * Quick Entry only (Spec #34102 / F1d, AC3/Business Rule 2): ids of
   * LowConfidence rows the specialist has explicitly acknowledged. Replaces
   * the F1a-era EMPTY_VERIFIED_ROW_IDS stub constant - once a row's id is in
   * this set it no longer counts as outstanding, mirroring the
   * quickEntryEditingRowIds state pattern above.
   */
  quickEntryAcknowledgedLowConfidenceIds: ReadonlySet<string>,
  /**
   * Bug fix (AB#38158, defect 2): the row whose Confirm button was clicked while the row can only
   * be cleared by Acknowledge. Confirm's only effect is clearing quickEntryEditingRowIds, and
   * isEditing re-derives from row.status, so on an ungrounded (amber) Request Type & Purpose row
   * the click was reported as doing nothing at all - "not disabled, click registers, row does not
   * confirm, no validation message". The button keeps every side effect it had (the Purpose
   * round-trip, AB#35289's Internal-requestor re-evaluation); this only makes it SAY what will
   * actually clear the row. Undefined = no message showing.
   */
  quickEntryConfirmBlockedRowId?: string,
  /**
   * Quick Entry only (Spec #34101 / F1c): snapshot of a row's pre-edit value(s),
   * captured when the specialist clicks [Edit] so Cancel can restore them. Keyed by
   * rowId. AB#35152 split the payload into the redux-form half (`form`, per
   * QE_ROW_FORM_FIELDS) and the component-state half (`state`, per
   * QE_ROW_STATE_KEYS) - Records Requested / Sensitive Information / the Service
   * Date rows keep their value in State, so a form-only snapshot could never revert
   * them. An entry is present only while its row is open for edit; onQuickEntry-
   * FieldConfirmed deletes it, which is what lets the next [Edit] capture afresh.
   */
  quickEntryEditSnapshots: Readonly<Record<string, QuickEntryEditSnapshot>>,
  /**
   * Quick Entry only: optimistic local override of transactionDetails.
   * releaseInfo. Split into 3 independent rows (Service Date-From, Service
   * Date-To, Records Requested per master-demo-v6.html), each mounted as
   * its own top-level component in renderQuickEntryRowContent's switch -
   * they aren't siblings within one component's JSX, so the shared
   * checked-items/date-range view has to live here rather than in any one
   * row's own local state (same reasoning as quickEntryEditingRowIds).
   * null = not yet touched this transaction, derive straight from props.
   */
  quickEntryReleaseInfo: readonly Release[] | null,
  /**
   * AB#35149 (adapted for AB#31605): true while the read-only record-type preview for a
   * just-changed Purpose is in flight. Disables Confirm All for that window so a fast
   * specialist cannot commit the old purpose's rows before the new set lands. Base held a
   * releaseInfo baseline here for a componentDidUpdate comparison against a refetched
   * transaction; there is no longer a POST or refetch, so the comparison is done inline in
   * onQuickEntryRequestPurposeChange and this is just an in-flight flag.
   */
  quickEntryPurposeSyncing: boolean,
  /**
   * AB#31605: the server-computed record-type OPTION SET for the purpose currently
   * selected in the dropdown, fetched read-only via releaseInfoPreviewApi.
   *
   * Quick Entry used to get this set by POSTing transactions/purpose and refetching
   * the transaction - a server write from an unconfirmed dropdown selection. For
   * purpose 43 (Disclosure Event) that write migrates the transaction into tblRPQ
   * and DELETEs its tblRequestBuffer row, and the refetch also ejected the
   * specialist into Classic (the refreshed StatusIndicatorID failed
   * isQuickEntryDataEntryStatus). The preview replaces both.
   *
   * Supersedes transactionDetails.releaseInfo as the option set in
   * getQuickEntryReleaseInfo while non-null; the specialist's own checked/date
   * state still lives in quickEntryReleaseInfo above and is merged on top.
   * null = no purpose change this session, use the transaction's own set.
   */
  quickEntryReleaseInfoPreview: readonly Release[] | null,
  quickEntryReleaseComments: string | null,
  /**
   * Quick Entry only: scratch From/To/AllDates the specialist is actively
   * typing, tracked SEPARATELY from quickEntryReleaseInfo's own Release[]
   * items. Release.dateOfService requires both from AND to together (see
   * models/transaction.ts's DateRange), so a half-entered range (From set,
   * To not yet) has nowhere valid to live in that array - deriving the
   * DateField's displayed value back from releaseInfo caused the field to
   * revert to empty on every render (direct user report). Classic mode's
   * InfoToRelease.tsx avoids this the same way: fromDate/toDate live in
   * their own useState, independent of the Release[] representation, which
   * is only ever built (via buildReleaseInfoWithDateRange) once a complete
   * range is ready to persist/validate. null = not yet touched this
   * transaction, derive from getReleaseDateRange(releaseInfo) instead.
   */
  quickEntryServiceDateOverride: { from?: Date; to?: Date; allDates: boolean } | null,
  /**
   * AB#38460: which date rows currently hold text the picker could not read (99/99/9999,
   * 02/30/1996), keyed by row id. Covers all six Quick Entry date rows.
   *
   * Kept OUT of the values themselves deliberately, and that is what makes the six behave
   * alike. quickEntryServiceDateOverride is Date-typed and feeds formatServiceDate,
   * buildReleaseInfoWithDateRange and the save payload, so a sentinel parked there would have to
   * be defended against at every one of those call sites. The four redux-form dates DO still
   * receive the sentinel as their form value, and that is exactly why they needed this too: the
   * mask emits a transient empty value mid-typing, which wiped the form field and took the error
   * message with it, so the error vanished as soon as the specialist touched the box again. A
   * flag the value cannot clobber keeps the message up until the entry is actually fixed.
   */
  quickEntryInvalidDates: Readonly<Record<string, { text: string; committed: boolean }>>,
  /**
   * Quick Entry only: per-row remount counter for the date pickers, passed to DateField as
   * resyncKey (see that prop's docblock for why a remount is the only way to clear text the
   * picker's [displayDate, value] effect will never re-sync).
   *
   * A COUNTER, bumped only in onQuickEntryFieldConfirmed. Deriving it from
   * quickEntryEditingRowIds membership was tried and REVERTED (David Heifetz, PR !10140 t54570):
   * that set changes on the way INTO edit mode as well as out. An empty date row is not
   * Confirmed, so it already renders its field with no [Edit] button - typing straight into the
   * box is the only way to fill it - and the first keystroke calls onEditQuickEntryRow, which
   * really does change the set. The picker remounted mid-entry, so the character landed but the
   * caret did not survive it and the next keystroke went to <body>. All six date rows, not just
   * the four a specialist normally types into.
   *
   * onQuickEntryFieldConfirmed has exactly two non-test callers - onQuickEntryEditCancel and the
   * Confirm button - and nothing calls it on change, so "never while typing" holds by
   * construction rather than by care. Its own !has(rowId) early return no-ops for a row that was
   * never in edit mode.
   *
   * Deliberately NOT bumped where onQuickEntryServiceDateChange clears the same invalid flag: a
   * usable date changes `value`, so the picker re-syncs on its own there, and bumping would be
   * the mid-entry remount all over again. Transaction switch and document replace need no entry
   * here either - quickEntryIntakeGeneration keys the whole row list and remounts everything.
   *
   * Per row, never global: rows are independently editable, so one row confirming must not
   * remount a sibling the specialist is still typing in.
   */
  quickEntryDateResyncKeys: Readonly<Record<string, number>>,
  /**
   * Quick Entry only: optimistic local override of transactionDetails.sensitiveInfo,
   * mirroring quickEntryReleaseInfo above - deferred to Confirm All instead of
   * persisting immediately via saveAndUpdateSensitiveInfo (bug fix, direct user
   * report: stale choices from an earlier document survived a document replace,
   * and Classic Mode could see Quick Entry's in-progress answers before Confirm
   * All ran). null = not yet touched this transaction, derive straight from props.
   */
  quickEntrySensitiveInfo: readonly SensitiveInfo[] | null,
  /**
   * Spec #35135 (Disclosure Accounting): the specialist's in-progress disclosure
   * entry. LOCAL ONLY while editing - no server call fires on change or blur
   * (AC4). The one write happens at Confirm All inside
   * persistQuickEntrySelectionsToTransaction's awaited gate, exactly like every
   * other Quick Entry field. null = untouched this transaction, derive from the
   * transaction's saved disclosure record instead (getQuickEntryDisclosureDraft),
   * mirroring quickEntryReleaseInfo / quickEntrySensitiveInfo above.
   */
  quickEntryDisclosureDraft: QuickEntryDisclosureDraft | null,
  /**
   * Bug fix (direct user report): bumped every time a document replace resets
   * intake analysis (see the requestAnalysis-defined-to-undefined transition in
   * componentDidUpdate). Passed as the `key` on the Request Info pane's content
   * so Patient/Requestor (and their local match-resolution state) fully remount
   * and re-search against the new extraction - the ONE case a remount is
   * actually wanted, as opposed to switching Quick Entry step-tabs (Fix A),
   * which must NOT remount them.
   */
  quickEntryIntakeGeneration: number,
  /**
   * AB#38014: a request document is attached but intake never started and never resolved, and
   * that has held long enough (INTAKE_STUCK_SETTLE_MS) to be believed rather than being the
   * brief gap before the extraction POST sets API_FETCHING. Reported as the retryable intake
   * failure it effectively is - same message, and the row list stops hiding behind the
   * "Add a request document" placeholder. Reset on transaction change and whenever intake
   * starts or resolves. See intakeStuckGate.ts.
   */
  quickEntryIntakeStuck: boolean,
  /** AB#35289 (source-flagged reset): bumped to REMOUNT only the Requestor row (its own React
   * key) so its automated-match effect re-fires - used to re-run the requestor auto-match with
   * the Internal type filter when the request type flips to Internal and the current requestor
   * was an AI guess. Requestor-scoped (unlike quickEntryIntakeGeneration, which remounts the whole
   * pane incl. Patient) so the reset never disturbs a resolved patient. */
  quickEntryRequestorResetGeneration: number,
  /** Spec #34102 (F1d), AC5/AC8/AC10, Business Rule 15: which Quick Entry step-tab is currently displayed. */
  quickEntryActiveStepTab: "requestInfo" | "billing" | "records",
  /** AB#35116 Phase 1: whether the classic Requestor/Contact modal is open. */
  requestorModalOpen: boolean,
  /** Whether the Assign Contact popup (contacts grid / add-new-contact form) is open. */
  assignContactOpen: boolean,
  /**
   * AB#35119 (reopened): the server's own message when an immediate contact save was refused, shown
   * ON the requestor row. Held here rather than toasted so it stays visible next to the field that
   * caused it instead of vanishing.
   */
  quickEntryContactSaveError?: string,
  /**
   * The contact assigned from the Assign Contact popup. Displayed over whatever contact
   * the requestor record or the document carried, for ALL three resolve paths - a
   * created or auto-matched requestor has no quickEntryModalRequestor to merge into
   * (that only exists for a classic-grid pick). Cleared whenever the requestor changes,
   * so a contact can't outlive the requestor it belongs to.
   */
  quickEntryAssignedContact?: NewContactValues,
  /** AB#35116: bumped when the classic results grid's "Add new Requestor" is clicked, opening the requestor row's create-requestor modal. */
  quickEntryCreateRequestorSignal: number,
  /**
   * AB#35116: the keys the specialist had in the requestor row's inline search boxes
   * when they clicked Search. The modal seeds its classic search from these - NOT from
   * the AI extraction - so a cleared fax stays cleared. undefined => no inline search
   * ran, fall back to the extracted values.
   */
  // AB#39478: the four Advanced Search keys ride alongside fax/email/siteCode - the classic
  // pane already sends all of them to the search, it just had no way to receive them from QE.
  quickEntryRequestorSearchKeys?: {
    readonly fax?: string,
    readonly email?: string,
    readonly siteCode?: string,
    readonly address?: string,
    readonly zip?: string,
    readonly requestorName?: string,
    readonly contactName?: string,
  },
  /** Bumped on every requestor Search click so the modal re-runs the classic search even on unchanged keys. */
  quickEntryRequestorSearchSignal?: number,
  /** AB#35116: the requestor picked in the classic results grid, shown on the QE requestor row. */
  quickEntryModalRequestor?: ModalRequestorSelection,
  /** Spec #34102 (F1d), AC5/AC6: set once Confirm-All succeeds. Unlocks the Billing tab for the rest of this mount and is the client-side no-resubmit guard - the server's write-once guard (CompletedDate) is the authoritative one. */
  quickEntryCommitCompletedDate: string | null,
  /** Spec #34102 (F1d), AC9/AC10: set once "Create Transaction"/"Create & Continue" succeeds. Unlocks the Records tab. */
  quickEntryTransactionCreated: boolean,
  /**
   * Spec #34102 (F1d), AC9: true only after "Create Transaction" (the primary,
   * "I'm done with this one" action) succeeds - shows the Billing pane's
   * "Transaction created" success card (Request ID + auto-advance message +
   * manual "Next Queue Item" button), per master-demo-v6.html's `.txn-created`
   * state. Deliberately NOT set by "Create & Continue to Record Attachment" -
   * that path keeps working the SAME transaction (Records tab), so an
   * "auto-advancing to the next queue item" message there would be wrong.
   */
  quickEntryShowTransactionCreatedCard: boolean,
  /** Spec #34102 (F1d): true while the Confirm-All commit request is in flight - client-side guard against a double-click firing two requests (the server's write-once guard is the actual race-condition defense, AC6/Test 4.1). */
  quickEntrySubmitting: boolean,
  /** Bug fix (Spec #34102 / F1d, direct user report): true while persistQuickEntryBillingFields's sequenced updateBillingPaneFields -> patchBillingComplete round trip is in flight - guards against a double-click firing two BillingComplete/MoveToRPQ calls while the first is still resolving. */
  quickEntryBillingSubmitting: boolean,
  /** Spec #34102 (F1d), AC11: "Leave Quick Entry?" dialog visibility. */
  quickEntryShowLeaveModal: boolean,
  /** Spec #34102 (F1d), Business Rule 13: Billing pane fields entered so far - lifted up here (not local to QuickEntryBillingPane) so they survive a "Back to Quick Entry" -> re-open-Billing round trip without re-submitting the bulk commit. */
  quickEntryBillingFields: QuickEntryBillingFields,
  /**
   * AB#35088 (QA retest finding 2): bumped each time the release method the SERVER recomputed
   * from the requestor contact is adopted into quickEntryBillingFields. The Billing pane takes
   * the new value on a bump and only on a bump - see QuickEntryBillingPane's
   * releaseMethodResyncSignal for why the pane cannot make that call itself.
   */
  quickEntryReleaseMethodResyncSignal: number,
  /** AB#37981 round 2: bumped when the Bill To block adopts a change the SERVER made to the bill-to
   *  record. Same contract as quickEntryReleaseMethodResyncSignal above. */
  quickEntryBillToRecordSignal: number,
  /**
   * AB#38349 (review round 5): has the OPERATOR picked Release Method in the Billing pane's own
   * dropdown since the last server-derived value was adopted? Kept HERE rather than in the pane,
   * because the pane UNMOUNTS: it renders only while quickEntryActiveStepTab === "billing" (:1770),
   * and every control that can change the requestor contact lives on the Request Info pane. So the
   * operator has to leave Billing for the release method to become stale for the row's contact at
   * all, and a pane-local flag is back to false by the time the staleness suppression is evaluated
   * on re-entry - while their PICK survives the round trip in quickEntryBillingFields. The flag has
   * to survive with it, or the suppression hides a correct warning about a value they chose by hand.
   */
  quickEntryReleaseMethodPickedByOperator: boolean,
  /**
   * AB#38349 round 2: the requestor contact the release method ON SCREEN was DERIVED FOR - i.e. the
   * transaction's linked contact as observed the last time the server's release method actually
   * CHANGED. Not the same thing as the currently linked contact, and that difference is the fix.
   *
   * Round 1 inferred staleness by comparing the row's contact against the linked contact. That is a
   * proxy which holds only while the link has not moved, and Confirm All moves it: it posts
   * transactions/sendToContact with the row's OWN contact, so the two ids become equal by
   * construction while the release method is still the value derived for the previous contact. The
   * proxy then reads "not stale" and the red assertion this fix exists to replace comes back.
   * Measured on Dev-Test 2026-08-27: 5.82s of Download plus the red error after Confirm All.
   */
  quickEntryReleaseMethodDerivedForContactId: number | undefined,
  /**
   * AB#37853 (Phase 13): true while the ONE-SHOT post-Confirm-All billing re-fetch is in
   * flight, i.e. while Fee Schedule / Release Method defaults are expected but have not
   * arrived. Drives the Billing pane's "Loading..." placeholder and its temporary disable, so
   * an empty dropdown reads as "a value is coming" rather than "pick one yourself".
   *
   * MUST NEVER BE STUCK TRUE. Leaving it set would disable exactly the two controls Bug 37853
   * exists to make usable, recreating the deadlock this whole Bug is about - strictly worse
   * than the cosmetic problem it solves. See beginQuickEntryBillingDefaultsPending for the
   * three independent clear paths.
   */
  quickEntryBillingDefaultsPending: boolean,
  /**
   * Quick Entry only (Spec #34101 / F1c): the LIVE match state each of the
   * Patient/Requestor rows reports up via onMatchStateChange. The row
   * components own the real search lifecycle (their own
   * apiResult/isSearching/serviceUnavailable useState), so the parent has to
   * be TOLD the outcome to render the correct numbered-list badge icon (green
   * single / amber multiple / red no-match|unavailable / neutral awaiting) AND
   * to feed the F1d Confirm-All gate (isPatientRequestorConfirmed). Defaults
   * to the awaitingDocument/neutral state.
   */
  patientMatchState: PatientMatchState,
  requestorMatchState: RequestorMatchState,
  /**
   * How the patient row resolved this session, captured so Confirm All can
   * persist it to the transaction the way Classic does: "select" carries the
   * matched patient's DB id (-> patientDataid on UpdateTransaction); "create"
   * means the specialist entered a new patient (-> createPatientRecordRequest,
   * values read from the DATA_ENTRY_FIELDS_FORM draft writePatientToForm wrote).
   * Undefined until the row resolves. Quick Entry defers this to Confirm All
   * (unlike Classic's persist-on-select), so without it the patient never lands
   * on the transaction record - see persistQuickEntrySelectionsToTransaction /
   * createQuickEntryPatient.
   */
  quickEntryPatientResolution?: { mode: "select"; patientId?: number } | { mode: "create" },
  /**
   * How the requestor row resolved this session. "select" carries the matched
   * requestor + contact DB ids (-> sendToRequestorid / sendToRequestorContactid
   * on UpdateTransaction, the same link Classic's send-to-requestor persist uses).
   * "create" is captured but NOT yet persisted at Confirm All - the create-new
   * requestor path (createSendTo + createSendToContact) needs the create endpoint
   * to return the new requestor id to attach the contact; tracked in
   * plan-quick-entry-txn-persistence-31605.md. Undefined until the row resolves.
   */
  // AB#35289 (source-flagged reset): `source` records whether the requestor was resolved by an
  // AI automated match ("auto") or a deliberate operator action ("manual": grid/modal pick,
  // create-new, or a rehydrated committed prior choice). Used to re-evaluate ONLY an "auto"
  // requestor when the request type flips to Internal, while preserving deliberate picks.
  /**
   * AB#38938: `contactFromDocument` records whether the requestor now on the row is the one the
   * DOCUMENT names, and therefore whether the document's extracted CONTACT belongs to it. Absent
   * means yes. It is set false only when the specialist created a requestor after DECLINING a DB
   * match, because the document's contact then belongs to the organisation they rejected.
   *
   * Carried HERE rather than in its own state field so it is cleared by the same resets that clear
   * the resolution - a document replace, an Internal type switch, advancing to the next
   * transaction. A separate flag would have to be found and cleared in each of those places.
   */
  quickEntryRequestorResolution?: { mode: "select"; requestorId?: number; contactId?: number; source?: "auto" | "manual"; contactFromDocument?: boolean } | { mode: "create"; requestorId?: number; contactId?: number; source?: "auto" | "manual"; contactFromDocument?: boolean },
  /**
   * Bug fix (Spec #34102 / F1d, direct user report): transactionId this
   * session's quickEntryOriginal* snapshot below was captured for - guards
   * captureQuickEntryOriginalSnapshotIfNeeded so it fires exactly once per
   * transaction (not on every unrelated re-render), the same one-per-
   * transaction cadence as the transactionId-change reset block in
   * componentDidUpdate.
   */
  quickEntrySnapshotTransactionId: string | null,
  /**
   * Bug fix (Spec #34102 / F1d, direct user report): "Switching to Classic
   * Mode should NOT carry over data entered in Quick Entry" (LeaveQuickEntryModal's
   * own "clean slate" copy) - but RecordsRequestedField/SensitiveInfoField
   * persist immediately (saveInformationToRelease/saveAndUpdateSensitiveInfo),
   * straight into the SAME transactionDetails.releaseInfo/sensitiveInfo
   * Classic Mode reads, unlike every other Quick Entry field (a redux-form
   * draft nothing persists until Confirm-All/Create Transaction). There is
   * no separate Quick-Entry-only draft for these two fields to simply
   * discard on "Switch to Classic Mode" - reverting the actual persisted
   * record (revertQuickEntryRecordsAndSensitiveInfo) needs a pre-Quick-Entry
   * snapshot to revert TO. Captured once per transaction, on first load;
   * null until then.
   */
  quickEntryOriginalReleaseInfo: readonly Release[] | null,
  quickEntryOriginalRequestComments: string | undefined,
  quickEntryOriginalSensitiveInfo: readonly SensitiveInfo[] | null,
  /**
   * Bug fix (AB#31605, direct user report): transactionId this session's Quick
   * Entry form was last rehydrated from the persisted transactionDetails for -
   * guards rehydrateQuickEntryFromTransaction so it fills the EMPTY request-info
   * fields from the SAVED transaction exactly once per transaction (same
   * one-per-transaction cadence as quickEntrySnapshotTransactionId). Reset in
   * the transactionId-change block so a new transaction re-rehydrates, but
   * deliberately NOT on a document replace: a mid-session replace clears the
   * form and the fresh AI extraction must win, so rehydrate must not re-fire and
   * resurrect the old saved values.
   */
  quickEntryRehydratedTransactionId: string | null,
  /**
   * Bug fix (AB#31605 review): transactionId a FRESH AI extraction (new doc
   * attach / re-run intake - the requestAnalysis object->null->object transition
   * in componentDidUpdate) happened for THIS session. Drives preferPersistedMatch
   * for the Patient/Requestor rows: on a plain reopen (no fresh extraction) the
   * persisted link WINS - the rows pre-resolve from it and suppress the automated
   * search that would otherwise re-search off the STALE re-fetched AI keys; once a
   * fresh extraction fires this flips so the new extraction drives the search
   * instead. Reset on transaction-change (a new tx is a reopen until proven
   * otherwise); set in the document-replace block.
   */
  quickEntryFreshExtractionTransactionId: string | null,
}

interface tabItemModal {
  id: number,
  label: string
}

/** AB#35116 Phase 2: exact amber message when a requestor is selected but no contact assigned. */
export const REQUESTOR_CONTACT_REQUIRED_MESSAGE = "Requestor selected. Contact assignment required before transaction completion.";

/**
 * Bug fix (AB#38158, defect 2): shown when Confirm is clicked on a row whose amber can only be
 * cleared by the Acknowledge checkbox. Names the control that works instead of leaving the click
 * silent. Catalog/UI wording only - no PHI (AC12).
 *
 * Deliberately says nothing about WHICH amber this is (review finding). The trigger,
 * isQuickEntryRowAcknowledgeable, carries no cause, and this row has two: AB#37979's ungrounded
 * type, and AB#35075's secondary candidate - where the value WAS matched in the document and the
 * doubt is only that a rival type also fit. The old wording ("could not be verified against the
 * document") was false on that second path and contradicted the row's own "Also matched X" hint.
 * The cause is already stated per-row by statusExplanation / the field hint; this message's job is
 * only to name the control that clears the row.
 */
export const QUICK_ENTRY_ACKNOWLEDGE_REQUIRED_MESSAGE = "This value needs your acknowledgement, so Confirm cannot clear this row - tick Acknowledge to accept it as it stands.";

/**
 * Review round 2 (John James / adversarial sweep, PR !10065). The message above covers the row that
 * Acknowledge clears. There is a second row Confirm cannot clear and which has no Acknowledge control
 * either: a SELF-RESOLVING LowConfidence row, reachable by changing Request Type and back without
 * re-picking a purpose, which leaves PURPOSE_TYPE = 0. Without this the specialist gets the original
 * AB#38158 symptom back - a live Confirm button that does nothing and says nothing.
 */
export const QUICK_ENTRY_PURPOSE_REQUIRED_MESSAGE = "Confirm cannot clear this row while Purpose is empty - select a Purpose to resolve it.";

/**
 * AB#38735. The third self-resolving row, and the reason it needs its own copy: making Sensitive
 * Information self-resolving turns on the same needsSelfResolution branch, which would otherwise
 * tell a specialist looking at a list of protected categories to "select a Purpose". That is the
 * AB#38158 silent-Confirm symptom with a wrong sentence instead of no sentence.
 */
export const QUICK_ENTRY_SENSITIVE_INFO_REQUIRED_MESSAGE = "Confirm cannot clear this row until every category is answered - include or exclude each one.";

/**
 * AB#38735 (decision 13). Shown above the checklist while the answers on screen are still
 * exactly the extraction's, so the specialist knows the ticks are a starting point rather than
 * a finding. Fixed copy: it names no category, echoes no declaration and interpolates no
 * document text, so it cannot become a PHI channel (.claude/rules/hipaa-compliance.md).
 *
 * An inline hint rather than the row's statusExplanation, which cannot render here -
 * QuickEntryFieldGroupList shows that only when customContent is null, and this component
 * supplies renderRowContent for every row.
 */
export const QUICK_ENTRY_SENSITIVE_INFO_UNVERIFIED_HINT = "AI-suggested from the document and not verified. Review the document and set the categories.";

/**
 * AB#35116: single source of truth for "a contact will be linked to this requestor"
 * - any contact field filled. Both the amber gate (isRequestorAmber) and the
 * create-time contact link (createQuickEntryRequestor) use it, so they can't desync.
 */
export function willLinkContact(values: any): boolean {
  return Boolean(
    values?.[RequestorFormConstants.FIRST_NAME] || values?.[RequestorFormConstants.LAST_NAME]
    || values?.[RequestorFormConstants.PHONE_NUMBER] || values?.[RequestorFormConstants.EMAIL]
    || values?.[RequestorFormConstants.FAX_NUMBER],
  );
}

/**
 * Where one Confirm-All persist gate reports the request purpose it left in the DATABASE, or null
 * when it left none - an earlier write failed before persistPurposeLast could run, or the write
 * was rolled back with a 409 (AB#39265).
 *
 * WHY AN OUT-PARAMETER rather than part of the gate's resolved value. Three callers await that
 * promise and every one of them cares only whether the writes succeeded; widening the contract to
 * an object would change what they - and five existing tests that pin the boolean - are reading,
 * for a fact that concerns exactly one caller. WHY NOT AN INSTANCE FIELD: two gates overlap
 * whenever a second Confirm All starts before the first drains (the in-flight guard keys on
 * quickEntrySubmitting, which the tab flip has already cleared), and a field would let the first
 * gate's verdict decide the second gate's refresh. One record per gate run, created by the caller.
 */
interface QuickEntryPurposeVerdict {
  persistedPurposeId: number | null;
}

export class DataEntryDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.props.resetForm()
    this.props.onChangeDataEntryTab(1, false)
  }
  state: State = {
    test: "",
    active: [false, false, false, false],
    tabClick: false,
    showLoadingSpinner: false,
    showRequestorPopUp: false,
    hasUserMadeAnyChanges: false,
    quickEntryEditingRowIds: new Set(),
    quickEntryAcknowledgedLowConfidenceIds: new Set(),
    quickEntryConfirmBlockedRowId: undefined,
    quickEntryEditSnapshots: {},
    quickEntryReleaseInfo: null,
    quickEntryPurposeSyncing: false,
    quickEntryReleaseInfoPreview: null,
    quickEntryReleaseComments: null,
    quickEntryServiceDateOverride: null,
    quickEntryInvalidDates: {},
    quickEntryDateResyncKeys: {},
    quickEntrySensitiveInfo: null,
    quickEntryDisclosureDraft: null,
    quickEntryIntakeGeneration: 0,
    quickEntryIntakeStuck: false,
    quickEntryRequestorResetGeneration: 0,
    quickEntryActiveStepTab: "requestInfo",
    requestorModalOpen: false,
    assignContactOpen: false,
    quickEntryContactSaveError: undefined,
    quickEntryCreateRequestorSignal: 0,
    quickEntryCommitCompletedDate: null,
    quickEntryTransactionCreated: false,
    quickEntryShowTransactionCreatedCard: false,
    quickEntrySubmitting: false,
    quickEntryBillingSubmitting: false,
    quickEntryShowLeaveModal: false,
    quickEntryBillingFields: { ...DEFAULT_QUICK_ENTRY_BILLING_FIELDS },
    quickEntryReleaseMethodResyncSignal: 0,
    quickEntryBillToRecordSignal: 0,
    quickEntryReleaseMethodPickedByOperator: false,
    quickEntryReleaseMethodDerivedForContactId: undefined,
    quickEntryBillingDefaultsPending: false,
    patientMatchState: DEFAULT_PATIENT_MATCH_STATE,
    requestorMatchState: DEFAULT_REQUESTOR_MATCH_STATE,
    quickEntrySnapshotTransactionId: null,
    quickEntryOriginalReleaseInfo: null,
    quickEntryOriginalRequestComments: undefined,
    quickEntryOriginalSensitiveInfo: null,
    quickEntryRehydratedTransactionId: null,
    quickEntryFreshExtractionTransactionId: null,
  };

  /** AC9 (Spec #34102 / F1d): pending auto-advance-to-next-queue-item timer, started by onQuickEntryCreateTransaction, cleared by onNextQueueItem or unmount. */
  quickEntryAutoAdvanceTimer: ReturnType<typeof setTimeout> | null = null;

  componentDidMount() {
    if(global.userID === undefined){
      const id = sessionStorage.getItem("userID");
      global.userID = id ? Number(id) : 0;
    }
    this.setState({ showLoadingSpinner: true })
    if(this.props.requestContext == 3 || this.props.requestContext == 4){
      this.props.onChangeDataEntryTab(4, true)
      const id: number = 4;
      this.handleSelectedTab(4 - 1);
    }else{
      const id: number = this.props.activeTabId;
      this.handleSelectedTab(id - 1);
    }

    this.initialAPICalls(this.props.transactionId)
    this.fetchAuditFieldOptionsForQuickEntry();
    this.setState({ showLoadingSpinner: false });
  }

  /**
   * AB#35289 (AC4 fix): populate the Audit Type / On Behalf Of option lists for Quick
   * Entry. Classic loads these by mounting DataEntryDetailsRightPane, whose effects
   * dispatch getAuditTypesRequest / getOBOsRequest (DataEntryDetailsRightPane.tsx:526-546).
   * Quick Entry renders its own shell and never mounts that pane (the requestor modal reuse
   * is fenced out with hostContext==='requestorModal'), so those slices stayed [] and the QE
   * Audit dropdowns rendered empty. Dispatch the SAME actions here.
   *
   * Gated to Quick Entry so Classic is byte-unchanged (it keeps fetching via RightPane), and
   * fetch-once via API status so componentDidMount + repeated componentDidUpdate calls don't
   * re-dispatch. Called again from componentDidUpdate because QE eligibility depends on
   * transactionDetails, which is still loading at mount. The fetch itself takes no args (the
   * sagas call getAuditTypesAPI / getOBOsAPI directly), matching Classic.
   */
  private fetchAuditFieldOptionsForQuickEntry = () => {
    if (!this.isQuickEntryEligible()) { return; }
    if (this.props.getAuditTypesAPIStatus === API_INITIAL) {
      this.props.getAuditTypesRequest?.();
    }
    if (this.props.getOBOsAPIStatus === API_INITIAL) {
      this.props.getOBOsRequest?.();
    }
  }

  savePanelSizes = () => {
    const leftPanel = document.getElementById("leftPanel");
    const centerPanel = document.getElementById("centerPanel");
    if (leftPanel != null) {
      localStorage.setItem("leftWidth", leftPanel.offsetWidth + "px");
    }
    if (centerPanel != null) {
      localStorage.setItem("centerWidth", centerPanel.offsetWidth + "px");
    }
  }

  componentWillUnmount = () => {
    this.props.onChangeDataEntryTab(1, false)
    this.props.resetForm()
    this.props.resetDataEntryState()
    this.savePanelSizes();
    // AC9 (Spec #34102 / F1d): don't let a pending auto-advance fire after this component is gone.
    if (this.quickEntryAutoAdvanceTimer) {
      clearTimeout(this.quickEntryAutoAdvanceTimer);
      this.quickEntryAutoAdvanceTimer = null;
    }
    // Round-2 review W-2: same reasoning as the auto-advance timer above - a pending
    // settle-guard must not fire after this component is gone, or a promise settles, the
    // finalize proceeds, and setState runs on an unmounted component.
    this.quickEntryWriteTimers.forEach(clearTimeout);
    this.quickEntryWriteTimers.clear();
    // AB#38014: same reasoning - a pending stuck-intake settle must not fire (and setState)
    // after this component is gone.
    if (this.quickEntryIntakeStuckTimer) {
      clearTimeout(this.quickEntryIntakeStuckTimer);
      this.quickEntryIntakeStuckTimer = undefined;
      this.quickEntryIntakeStuckTimerTransactionId = undefined;
    }
  }

  renderTabItems = () => {
    return (
      <div className="breadcrumDiv">
        <ul className="steps">
          {tabItems.map((item: tabItemModal, index: number) => {
            return this.state.active[index] ? (
              <li className="activeSelection"
                id={index.toString()}
                key={index}
                onClick={() => this.handleClick(item)}
              >
                {/* No inline colour -- li.activeSelection is themed in both
                    themes (_stepsbreadcrumb.scss / index.scss) and the anchor inherits
                    it. The inline light-surface blue used to win over the dark rule and
                    measured 1.95:1 on the #324048 active step. */}
                <a href="#!">{item.label}</a>
              </li>
            ) : (
              <li id={index.toString()} key={index} onClick={() => this.handleClick(item)}
                // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
                // eslint-disable-next-line no-restricted-syntax
                className={(this.props.transactionDetails?.requestPurpose?.typeID == DISCLOSURE_ACCOUNTING && (item.id === 3 || item.id === 4)) || (item.id > this.props.activeTabId + 1  && this.props.activeTabId != 2) ? 'disabled-tab' : ''} >
                {/* AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites). */}
                {/* eslint-disable-next-line no-restricted-syntax */}
                <a href="#!" className={(this.props.transactionDetails?.requestPurpose?.typeID == DISCLOSURE_ACCOUNTING && (item.id === 3 || item.id === 4)) || (item.id > this.props.activeTabId + 1 && this.props.activeTabId != 2)? 'disabled-tab-a' : ''}>{item.label}</a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  };

  /**
   * AC19: Quick Entry's step-tabs nav replaces the classic breadcrumb
   * (renderTabItems) above the center/right split. "Request Info" is the
   * only functional step in F1a's scope (it's the sole pane rendered);
   * Billing/Records render as disabled placeholders reserving the mockup's
   * layout until F1d (#34102) implements the Billing pane transition and a
   * later slice implements Records.
   */
  renderQuickEntryStepTabs = () => {
    const { quickEntryActiveStepTab: activeTab, quickEntryCommitCompletedDate, quickEntryTransactionCreated } = this.state;
    // Billing unlocks once Confirm-All commits; Records once the transaction is
    // created. (The temporary ?qeDebugUnlockTabs=1 URL bypass was removed now that
    // the Confirm-All round-trip works end to end - AB#34101/AB#34102.)
    // Spec #35135 (AC7): Disclosure Accounting has no Billing step at all - Classic
    // hard-disables tabs 3/4 for type 66 and completes via completeTransaction
    // alone. Without this clause the tab would unlock the moment Confirm All
    // committed (billingUnlocked keys off quickEntryCommitCompletedDate), letting a
    // specialist open a Billing pane that has no part in this type's flow.
    const isDisclosureAccounting = (this.props.formState?.values ?? {})[FormConstants.REQUEST_TYPE] === DISCLOSURE_ACCOUNTING;
    const billingUnlocked = Boolean(quickEntryCommitCompletedDate) && !isDisclosureAccounting;
    const recordsUnlocked = quickEntryTransactionCreated;

    const tabClassName = (tab: State["quickEntryActiveStepTab"], unlocked: boolean) =>
      `step-tab${activeTab === tab ? " is-active" : ""}${unlocked ? "" : " step-tab--disabled"}`;

    return (
      <nav className="step-tabs" aria-label="Request sections">
        <button
          type="button"
          className={tabClassName("requestInfo", true)}
          aria-current={activeTab === "requestInfo" ? "step" : undefined}
          onClick={() => this.setState({ quickEntryActiveStepTab: "requestInfo" })}
        >
          Request Info
        </button>
        <button
          type="button"
          className={tabClassName("billing", billingUnlocked)}
          aria-current={activeTab === "billing" ? "step" : undefined}
          disabled={!billingUnlocked}
          title={billingUnlocked ? undefined : "Available after Confirm All"}
          onClick={() => billingUnlocked && this.setState({ quickEntryActiveStepTab: "billing" })}
        >
          Billing
        </button>
        <button
          type="button"
          className={tabClassName("records", recordsUnlocked)}
          aria-current={activeTab === "records" ? "step" : undefined}
          disabled={!recordsUnlocked}
          title={recordsUnlocked ? undefined : "Available after the transaction is created"}
          onClick={() => recordsUnlocked && this.setState({ quickEntryActiveStepTab: "records" })}
        >
          Records
        </button>
      </nav>
    );
  };

  /** AC11 (Spec #34102 / F1d): opens the "Leave Quick Entry?" exit dialog. */
  onClickLeaveQuickEntry = () => {
    this.setState({ quickEntryShowLeaveModal: true });
  }

  /** "Stay in Quick Entry" - cancels with no data lost (AC11). */
  onCancelLeaveQuickEntry = () => {
    this.setState({ quickEntryShowLeaveModal: false });
  }

  /** "Switch to Classic Mode" - the one-way Classic-Mode-exit override (AC11/AC12). */
  onConfirmLeaveQuickEntry = () => {
    this.setState({ quickEntryShowLeaveModal: false });
    this.revertQuickEntryRecordsAndSensitiveInfo();
    // Bug fix (2026-07-29): same DOB/Name/EMPI gap as
    // onQuickEntryCreateAndContinueToRecordAttachment (see its comment for the
    // full mechanism, incl. why this reacts to its OWN getTransactionAttributes
    // completion via onSuccess rather than any transactionDetails change) -
    // re-fetch so Classic's right-pane form (patientDetailsAttributes) picks up
    // whatever patient link has actually been persisted so far, and defer
    // setClassicModeOverride until it lands so the classic form's first mount
    // doesn't initialize from the still-empty slice. A no-op if nothing was
    // ever persisted (the saga's patient branch just stays gated) - the mode
    // switch still applies once the (empty) re-fetch completes.
    // Round-3 review (David Heifetz): the saga fires onSuccess ONLY on the 2xx path,
    // inside its own try (Ducks:3914) - a non-2xx response, a thrown error, or a
    // cancelled generator all drop it, and the finally only increments a counter. So
    // deferring the mode switch to that callback made "Switch to Classic Mode"
    // SILENTLY DO NOTHING on any failed re-fetch: the modal closes and the specialist
    // is left in Quick Entry with no error and a dead button. The switch is the
    // specialist's explicit instruction and must always happen - the re-fetch only
    // decides WHEN. settleGuardedWrite (round-2 W-3) is the file's existing answer to
    // a saga callback that may never fire, so route through it and switch on its
    // settle, timeout included. Worst case on a failed re-fetch is the DOB/Name/EMPI
    // latch this defer exists to avoid, which a refresh recovers - strictly better
    // than stranding the specialist in a mode they asked to leave.
    void this.settleGuardedWrite<boolean>(false, settle => {
      this.props.getTransactionAttributes?.(this.props.transactionId, () => settle(true));
    }).then(() => {
      this.props.setClassicModeOverride?.(true);
    });
    // AB#34102 (F1d): record the intake-timing "switch" event (AuditTask 812).
    // Fire-and-forget - a failed audit write must never block the switch.
    try {
      exitToClassicIntakeApi(this.props.transactionId, Number((global as any).userID))
        .catch(() => { /* best-effort audit; ignore */ });
    } catch { /* ignore */ }
    // AB#35086 (direct user report): the History tab's audit trail data is ONLY ever
    // refreshed from three call sites inside PdfViewer.tsx (save/view/annotate) - never
    // on a tab switch or a Quick Entry -> Classic Mode switch. So the ExitToClassicIntake
    // write above landed correctly, but the History tab (if already mounted/fetched this
    // session) kept showing its stale pre-switch snapshot until some unrelated PdfViewer
    // action happened to refresh it. Explicitly refresh here too, same action PdfViewer
    // dispatches, so this specific switch is visible immediately without depending on an
    // unrelated trigger. Fire-and-forget, same reasoning as the audit write above.
    this.props.getAuditTrailData?.(this.props.transactionId);
  }

  /**
   * Bug fix (Spec #34102 / F1d, direct user report): "Switching to Classic
   * Mode should NOT carry over data entered in Quick Entry" - this is
   * explicit product intent (LeaveQuickEntryModal.tsx's own "clean slate"
   * copy: "Classic Mode opens as a clean slate - AI-extracted values are
   * not carried over"). Every OTHER Quick Entry field gets this for free:
   * RequestTypePurposeField/AuthorizationDateField/RequestDateField/
   * CaseNumberField/ClinicResponsibleField only ever write to the
   * DATA_ENTRY_FIELDS_FORM redux-form draft (formFieldHelpers.ts's
   * writeFieldToForm) - nothing persists that draft to the actual
   * transaction record until Confirm-All/Create Transaction, so
   * transactionDetails (and therefore Classic Mode, which reads it fresh
   * via DataEntryDetailsRightPane's own mapStateToProps initialValues) was
   * simply never touched by the abandoned Quick Entry session in the first
   * place.
   *
   * Records Requested/Sensitive Information don't get this for free: unlike
   * every other row, RecordsRequestedField.tsx/SensitiveInfoField.tsx
   * persist immediately via saveInformationToRelease/
   * saveAndUpdateSensitiveInfo (see each file's own doc comment - this was
   * done so each row's Confirmed status could read straight off the
   * server-confirmed value with no extra onQuickEntryFieldConfirmed
   * plumbing, not because the product actually wants these two fields
   * exempted from the clean-slate promise). Classic Mode reads that SAME
   * now-mutated transactionDetails.releaseInfo/sensitiveInfo directly, so it
   * faithfully - and, for this one boundary, wrongly - displays whatever
   * Quick Entry already wrote.
   *
   * Reverts the actual persisted record back to the pre-Quick-Entry-session
   * snapshot captured by captureQuickEntryOriginalSnapshotIfNeeded, rather
   * than deferring these two fields' persistence to Confirm-All to match the
   * other rows: Confirm-All's own payload (QuickEntryCorrections.ts) is an
   * AI-vs-specialist audit trail sent to a DIFFERENT endpoint
   * (commitQuickEntryApi), not a value-persistence channel for these fields -
   * deferring the writes without also building a way for them to ever reach
   * the server would risk silently losing them altogether on a NORMAL
   * successful Quick Entry commit, a materially worse outcome than this
   * leak. A snapshot-and-revert on the one exit path that needs it is the
   * narrower, safer fix; bypasses persistQuickEntryReleaseInfo's own
   * validateQuickEntryReleaseInfo gate deliberately - the snapshot is, by
   * definition, exactly what was already validly persisted before this
   * session touched it, so re-validating it here could only ever reject a
   * value the backend already accepted once.
   */
  revertQuickEntryRecordsAndSensitiveInfo = () => {
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const transactionDetails = this.props.transactionDetails;
    if (!transactionDetails) {
      return;
    }

    const originalReleaseInfo = this.state.quickEntryOriginalReleaseInfo;
    if (originalReleaseInfo) {
      const checkedReleaseIds = originalReleaseInfo.filter(item => item.checked).map(item => item.id);
      // A transaction that never had a release type checked before this Quick
      // Entry session (e.g. a brand-new transaction) has nothing to revert -
      // and the informationToRelease endpoint's own [Required, MinLength(1)]
      // on Releases rejects an empty array, turning this fire-and-forget
      // revert into a hard error on exit. Skip the call rather than send a
      // payload there's nothing to revert to.
      if (checkedReleaseIds.length > 0) {
        const { from, to } = getReleaseDateRange(originalReleaseInfo);
        this.props.saveInformationToRelease({
          organizationId: transactionDetails.facility.id,
          requestBufferId: transactionDetails.id,
          releases: checkedReleaseIds,
          from,
          to,
          // Left undefined rather than "" when the snapshot has none, so JSON.stringify drops the
          // key and the persisted description is untouched. "" would revert correctly, but the
          // snapshot itself is not trustworthy yet: captureQuickEntryOriginalSnapshotIfNeeded
          // reads props.transactionDetails raw (AB#39495), so an in-place A->B switch stamps A's
          // values as B's - and a "" would then DESTROY B's stored description. Send "" only once
          // that capture is identity-guarded (Mike Hamilton, PR !10721 round 4).
          requestComments: this.state.quickEntryOriginalRequestComments,
        });
      }
    }

    const originalSensitiveInfo = this.state.quickEntryOriginalSensitiveInfo;
    if (originalSensitiveInfo) {
      this.props.saveAndUpdateSensitiveInfo(buildSensitiveInfoRevertPayload(originalSensitiveInfo, this.props.transactionId));
    }
  }

  /**
   * AC5/AC7/AC8/AC10 (Spec #34102 / F1d): renders whichever Quick Entry
   * step-tab is currently active in the center/right split's right-hand
   * pane - the Request Info row list (unchanged from F1a), the new Billing
   * pane, or the new read-only Records pane.
   */
  /** True while the intake analysis is running (the fetch/trigger is in flight, or the server reports InProgress). */
  private isIntakeAnalysisRunning = (): boolean =>
    this.props.getIntakeIntelligenceStatus === API_FETCHING
    || this.props.requestIntakeIntelligenceStatus === API_FETCHING
    || this.props.requestAnalysis?.status === RequestAnalysisStatus.InProgress;

  /**
   * Bug fix (direct user report): true once intake analysis has reached ANY
   * terminal outcome - a real result to show (Completed), a definitive
   * extraction failure (Failed/RetryExceeded), or a service-level failure on
   * either fetch (API_FAILURE). The fetch-level failure counts as resolved
   * too - without it, a transient network/service failure that never
   * produces a requestAnalysis.status transition would leave
   * isQuickEntryAwaitingIntake() permanently true, hiding Request Info
   * behind the placeholder forever with no way in.
   */
  private isIntakeResolved = (): boolean =>
    this.props.requestAnalysis?.status === RequestAnalysisStatus.Completed
    || this.props.requestAnalysis?.status === RequestAnalysisStatus.Failed
    || this.props.requestAnalysis?.status === RequestAnalysisStatus.RetryExceeded
    || this.props.getIntakeIntelligenceStatus === API_FAILURE
    || this.props.requestIntakeIntelligenceStatus === API_FAILURE;

  /**
   * Bug fix (direct user report): true when Quick Entry has opened but
   * intake hasn't resolved one way or the other yet - no document uploaded,
   * analysis not yet triggered, or the documents/analysis fetch is still
   * loading. Gates the Request Info row list behind a placeholder (see
   * renderQuickEntryActiveStepPane) instead of showing empty, editable rows
   * before there's anything - AI-extracted or a clear failure - to react to.
   */
  private isQuickEntryAwaitingIntake = (): boolean =>
    !this.isIntakeResolved()
    && !this.isIntakeAnalysisRunning()
    // AB#38014: a confirmed stuck intake (document attached, nothing running, nothing resolved)
    // is reported as a retryable failure, so stop hiding the rows behind a placeholder that
    // tells the specialist to attach the document they already attached.
    && !this.state.quickEntryIntakeStuck;

  /**
   * AB#38014: watch for "a request document is attached but intake never started and never
   * resolved", and after a settle delay report it as the retryable intake failure it is.
   *
   * Called from componentDidUpdate. The settle delay matters: dispatching the extraction POST
   * sets API_FETCHING synchronously, so the candidate condition is legitimately true for a
   * brief instant in the normal flow, between the document appearing in documentsList and the
   * trigger firing. Only a condition that HOLDS is a real dead end. See intakeStuckGate.ts.
   */
  /**
   * AB#38014: the ONE definition of the stuck gate's inputs, read live from current props.
   *
   * Review round 3 (MJ3): these were previously built inline twice - once when arming the settle
   * timer and once inside the timer callback - and the two copies drifted. The fire-time copy
   * kept the raw isIntakeAnalysisRunning() (so the M2 ownership fix silently applied only at arm
   * time) and kept requiring documentsLoaded (so a documents refresh in flight at the exact
   * moment the timer fired made it bail without re-arming - the same mid-refresh fragility
   * shouldClearConfirmedIntakeStuck exists to prevent). One method, no drift.
   */
  private quickEntryIntakeStuckInputs = (): IntakeStuckGateInputs => ({
    quickEntryActive: this.isQuickEntryEligible(),
    documentsLoaded: this.props.getTransactionDocumentsAPIStatus === API_SUCCESS,
    hasRequestDocument: (this.props.documentsList ?? []).some(doc => doc.recType === DocTypes.REQ),
    intakeResolved: this.isIntakeResolved(),
    // Ownership-filtered, unlike isIntakeAnalysisRunning(), which reads the raw slice. The fetch
    // statuses are genuinely ours, but an InProgress status belonging to ANOTHER transaction's
    // analysis says nothing about this one - treating it as "running here" would blind the
    // backstop for as long as that foreign extraction lasts. Matches how foreignAnalysis is
    // already honoured for intakeResolved.
    intakeRunning: this.props.getIntakeIntelligenceStatus === API_FETCHING
      || this.props.requestIntakeIntelligenceStatus === API_FETCHING
      || this.ownedRequestAnalysis()?.status === RequestAnalysisStatus.InProgress,
    foreignAnalysis: this.isForeignAnalysis(),
  });

  private evaluateQuickEntryIntakeStuck = () => {
    const gateInputs = this.quickEntryIntakeStuckInputs();

    // A DEFINITIVE change (intake started, intake resolved for this transaction, or Quick Entry
    // is no longer the surface) tears down a confirmed stuck state and any pending settle.
    // Deliberately not `!isIntakeStuckCandidate(...)`: a documents refresh in flight makes the
    // candidate test false without meaning anything has been resolved, and treating that as a
    // teardown flipped the pane back to the placeholder mid-refresh. See intakeStuckGate.ts.
    if (shouldClearConfirmedIntakeStuck(gateInputs)) {
      if (this.quickEntryIntakeStuckTimer) {
        clearTimeout(this.quickEntryIntakeStuckTimer);
        this.quickEntryIntakeStuckTimer = undefined;
        this.quickEntryIntakeStuckTimerTransactionId = undefined;
      }
      if (this.state.quickEntryIntakeStuck) {
        this.setState({ quickEntryIntakeStuck: false });
        this.quickEntryIntakeStuckAnnouncedFor = undefined;
      }
      return;
    }

    // Already reported - nothing to do. Note a mid-refresh dip in documentsLoaded neither
    // cancels the countdown nor clears a confirmed state; the fire-time re-check below is what
    // confirms the condition genuinely held.
    if (this.state.quickEntryIntakeStuck) {
      return;
    }

    // Review round 3 (MJ2): a pending timer only blocks re-arming for the transaction it was
    // armed FOR. Previously any pending timer short-circuited this method, so switching
    // transactions while one was outstanding left the new transaction with no settle armed - and
    // when the old timer fired it bailed on the id mismatch without arming one either.
    if (this.quickEntryIntakeStuckTimer) {
      if (this.quickEntryIntakeStuckTimerTransactionId === this.props.transactionId) {
        return;
      }
      clearTimeout(this.quickEntryIntakeStuckTimer);
      this.quickEntryIntakeStuckTimer = undefined;
      this.quickEntryIntakeStuckTimerTransactionId = undefined;
    }

    if (!isIntakeStuckCandidate(gateInputs)) {
      return;
    }

    const transactionId = this.props.transactionId;
    this.quickEntryIntakeStuckTimerTransactionId = transactionId;
    this.quickEntryIntakeStuckTimer = setTimeout(() => {
      this.quickEntryIntakeStuckTimer = undefined;
      this.quickEntryIntakeStuckTimerTransactionId = undefined;
      // Re-check on fire: the settle window is long enough for the condition to have cleared,
      // and for the specialist to have moved to another transaction entirely.
      if (this.props.transactionId !== transactionId) {
        return;
      }
      // Same inputs as arm time - see quickEntryIntakeStuckInputs for why this must not be a
      // second inline copy.
      if (!isIntakeStuckCandidate(this.quickEntryIntakeStuckInputs())) {
        return;
      }
      this.setState({ quickEntryIntakeStuck: true });
      if (this.quickEntryIntakeStuckAnnouncedFor !== transactionId) {
        this.quickEntryIntakeStuckAnnouncedFor = transactionId;
        this.announceIntakeFailedRetryable();
      }
    }, INTAKE_STUCK_SETTLE_MS);
  };

  /**
   * AB#34102: keeps a persistent loading toast up for the whole extraction window and resolves it
   * to success/error, so the specialist always sees that AI processing is happening. Fires once per
   * fetch transition.
   *
   * AB#34102 originally showed this in Classic Mode too. AB#35101 reverses that: Classic Mode is
   * manual data entry, so it gets no analysis messages at all. AB#35091 splits the failure branch -
   * see intakeAnalysisOutcome.ts for both decisions and why terminal failures (and only terminal
   * failures) hand off to Classic Mode.
   */
  /**
   * AB#35121: is the analysis currently in the slice someone ELSE'S?
   *
   * The intake slice holds one analysis with no transaction key. Navigation clears it, but does not
   * cancel an extraction already in flight (POST and GET sit under separate takeLatest watchers), so
   * a response for the transaction just left can land while this one is on screen. Ownership comes
   * from the payload - RequestAnalysis carries facilityId + requestBufferId - so no instance state
   * and no fetch-transition bookkeeping is needed to decide it (reviewed on !9636, findings 3-5).
   *
   * False when no analysis is present: there is nothing to misattribute.
   */
  private isForeignAnalysis = (): boolean =>
    Boolean(this.props.requestAnalysis)
    && !analysisBelongsToTransaction(this.props.requestAnalysis, this.props.transactionId);

  /** The analysis ONLY when it belongs to the transaction on screen - see isForeignAnalysis. */
  private ownedRequestAnalysis = (): RequestAnalysis | undefined =>
    this.isForeignAnalysis() ? undefined : this.props.requestAnalysis;

  /**
   * The retryable intake-failure announcement.
   *
   * AB#35091: no longer claims Classic Mode is where you are - both options offered are things
   * the specialist can actually do from the Quick Entry pane they're still on.
   *
   * AB#38014: shared with the stuck-intake path (a request document attached but intake never
   * started or resolved) so the two report identically. A stuck extraction IS a failed
   * extraction from the specialist's point of view, and giving it its own bespoke wording or
   * affordance would mean two different vocabularies for the same dead end.
   */
  private announceIntakeFailedRetryable = () => {
    toast.error("The request document couldn't be analyzed. Re-attach the request document to try again, or use the Classic Mode button to enter the details manually.", { id: "intakeAnalysis", duration: 7000 });
  };

  private updateIntakeAnalysisToast = (prevProps: Props) => {
    const wasFetching = prevProps.getIntakeIntelligenceStatus === API_FETCHING
      || prevProps.requestIntakeIntelligenceStatus === API_FETCHING;
    const isFetching = this.props.getIntakeIntelligenceStatus === API_FETCHING
      || this.props.requestIntakeIntelligenceStatus === API_FETCHING;
    const outcome = classifyIntakeAnalysisOutcome({
      quickEntryActive: this.isQuickEntryEligible(),
      wasFetching,
      isFetching,
      fetchSucceeded: this.props.getIntakeIntelligenceStatus === API_SUCCESS
        || this.props.requestIntakeIntelligenceStatus === API_SUCCESS,
      hasExtractedData: this.props.requestAnalysis?.data != null,
      analysisStatus: this.props.requestAnalysis?.status,
      foreignAnalysis: this.isForeignAnalysis(),
      hasRequestDocument: (this.props.documentsList ?? []).some(doc => doc.recType === DocTypes.REQ),
      documentsLoaded: this.props.getTransactionDocumentsAPIStatus === API_SUCCESS,
    });
    switch (outcome) {
      case "suppressed":
        // AB#35101: no analysis messages in Classic Mode. Clearing rather than just skipping
        // covers switching to Classic mid-analysis - the loading toast is persistent (no
        // duration), so without this it would spin forever once the resolve branch stops running.
        toast.dismiss("intakeAnalysis");
        return;
      case "started":
        toast.loading("Analyzing the request document… this can take up to a minute or two.", { id: "intakeAnalysis" });
        return;
      case "succeeded":
        toast.success("Request document analyzed — review the extracted details.", { id: "intakeAnalysis", duration: 5000 });
        return;
      case "failedRetryable":
        this.announceIntakeFailedRetryable();
        return;
      case "failedTerminal":
        // AB#35091: retries are exhausted, so Quick Entry can never populate for this document.
        // Perform the hand-off the message promises instead of only describing it - same one-way
        // override "Leave Quick Entry" uses (AC11/AC12).
        toast.error("The request document couldn't be analyzed and can't be retried. Switched to Classic Mode - please enter the details manually.", { id: "intakeAnalysis", duration: 7000 });
        this.props.setClassicModeOverride?.(true);
        return;
      default:
        return;
    }
  };

  /**
   * AB#34102: inline "AI is analyzing" panel shown in the Quick Entry pane while extraction runs
   * (see isIntakeAnalysisRunning). Uses the shared LoadingSpinner + the Quick Entry card styling
   * so it matches the surrounding look/feel and reads correctly in dark mode. aria-live so assistive
   * tech announces the wait. The completion/failure result is toasted from componentDidUpdate.
   */
  renderQuickEntryAnalyzingPanel = () => (
    <div className="quick-entry-analyzing" role="status" aria-live="polite">
      <LoadingSpinner />
      <p className="quick-entry-analyzing__title">Analyzing the request document…</p>
      <p className="quick-entry-analyzing__subtitle">
        The AI is extracting the patient, requestor, and request details. This can take up to a
        couple of minutes — you can keep working elsewhere and come back.
      </p>
    </div>
  );

  /**
   * Bug fix (direct user report): Request Info's content used to be one of
   * several mutually-exclusive early returns in renderQuickEntryActiveStepPane,
   * so switching to Billing/Records and back UNMOUNTED it - taking
   * PatientInfoRow/RequestorInfoRow's local match-resolution state (and their
   * write-once refs) down with it. Their automated-match effect re-fires on
   * remount, so a row that had already resolved (e.g. picked one of several
   * candidates) went right back to "choose again" on return. Now Request
   * Info's content is ALWAYS mounted once first shown and only CSS-hidden
   * (renderQuickEntryActiveStepPane below) when another tab is active, so
   * switching tabs never touches this component tree. The one case a reset IS
   * wanted - a document replace, not a tab switch - is handled separately via
   * quickEntryIntakeGeneration (see its own doc comment on State).
   */
  renderQuickEntryRequestInfoPane = () => {
    // AB#34102: while AI extraction is running (e.g. right after a request document is
    // attached), show an inline analyzing panel instead of empty/placeholder rows so the
    // screen never looks broken or "done with no data" mid-extraction.
    if (this.isIntakeAnalysisRunning()) {
      return this.renderQuickEntryAnalyzingPanel();
    }
    // Bug fix (direct user report): before a document exists / intake hasn't
    // resolved one way or the other yet, hide the row list instead of showing
    // empty, editable rows with nothing to react to. See
    // isQuickEntryAwaitingIntake's own doc comment for why this doesn't
    // reintroduce the (deliberately removed) per-row awaitingDocument block.
    // Mirrors renderQuickEntryAnalyzingPanel's card treatment (same layout
    // classes/dark-theme handling), text only - there's nothing in flight to
    // wait on, just an action for the specialist to take.
    if (this.isQuickEntryAwaitingIntake()) {
      return (
        <div className="quick-entry-awaiting-document" role="status">
          <p className="quick-entry-awaiting-document__title">Add a request document to start Quick Entry</p>
          <p className="quick-entry-awaiting-document__subtitle">
            Once a request document is attached, the AI will extract the patient, requestor,
            and request details automatically.
          </p>
        </div>
      );
    }
    return (
      <QuickEntryFieldGroupList
        key={this.state.quickEntryIntakeGeneration}
        rows={this.getQuickEntryRows()}
        renderRowContent={this.renderQuickEntryRowContent}
        renderRowAdornment={(row) => (
          // AB#35066: this adornment now renders ONLY the transient extraction-
          // status affordance. Confidence moved to the left row-status icon and
          // grounding to the inline ≡ glyph (QuickEntryGroundingIcon), per the F1
          // mockup + TDD - the redundant confidence dot + "Source" button were
          // removed. See QuickEntryFieldConfidence.tsx header.
          <QuickEntryFieldConfidence
            row={row}
            status={this.props.requestAnalysis?.status}
          />
        )}
        onAcknowledgeLowConfidenceRow={this.onAcknowledgeQuickEntryLowConfidenceRow}
        // Review round 3 (Mike Hamilton, PR !10065): the CHECKBOX gets the raw ticked set and the
        // header TALLY gets the filtered one. Handing the filtered set to both made the control
        // display a different set from the one its onChange toggles, so on a row open for edit it
        // rendered unchecked, stayed unchecked however many times it was clicked, and the clicks
        // silently flipped state that only became visible once the edit closed.
        acknowledgedLowConfidenceIds={this.state.quickEntryAcknowledgedLowConfidenceIds}
        settledLowConfidenceIds={this.effectiveAcknowledgedRowIds()}
        selfResolvingLowConfidenceRowIds={this.quickEntrySelfResolvingRowIds()}
        footer={
          <QuickEntryActionFooter
            transactionId={this.props.transactionId}
            // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
            // eslint-disable-next-line no-restricted-syntax
            organizationId={this.props.transactionDetails?.facility?.id}
            requestContext={this.props.requestContext}
            resetForm={() => this.props.resetForm()}
            resetDataEntryState={() => this.props.resetDataEntryState()}
            healthSystemDataEntryCount={this.props.healthSystemDataEntryCount}
            actionCount={this.getQuickEntryOutstandingCount()}
            // AB#35149: dead while a confirmed Type/Purpose change is round-tripping. Until it
            // lands the rows shown are the old confirmed ones and the outstanding count is still
            // 0, so the button would otherwise read "Confirm All" and commit values that are about
            // to be replaced.
            disabled={this.state.quickEntryPurposeSyncing}
            onAction={this.onClickQuickEntryAction}
          />
        }
      />
    );
  }

  // AB#35095: QE's compare payload for the Duplicate Transaction Check popup, built
  // the SAME way Classic's getDuplicateCompare does (shared helper) from the shared
  // DATA_ENTRY_FIELDS_FORM values - display-only; the server does the matching.
  getQuickEntryDuplicateCompare = () =>
    buildDuplicateCompareTransaction(
      this.props.formState?.values ?? {},
      this.props.transactionId,
      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
      // eslint-disable-next-line no-restricted-syntax
      this.props.transactionDetails?.transactionStatus?.name,
    );

  renderQuickEntryActiveStepPane = () => {
    const activeTab = this.state.quickEntryActiveStepTab;
    // Spec #35135 (AC9a): Disclosure Accounting completes without ever entering the
    // Billing step, so the "Transaction created" card can't come from
    // QuickEntryBillingPane here. Render the SAME extracted card component the
    // billing pane renders (QuickEntryTransactionCreatedCard) - identical markup,
    // identical auto-advance affordance - in place of the row list.
    const isDisclosureAccounting = (this.props.formState?.values ?? {})[FormConstants.REQUEST_TYPE] === DISCLOSURE_ACCOUNTING;
    if (isDisclosureAccounting && this.state.quickEntryShowTransactionCreatedCard && activeTab === "requestInfo") {
      return (
        <div className="qe-billing-pane qe-billing-pane--txn-created">
          <QuickEntryTransactionCreatedCard
            requestId={this.props.transactionId}
            onNextQueueItem={this.onNextQueueItem}
          />
        </div>
      );
    }
    return (
      <>
        {/* AB#35095: Classic's Duplicate Transaction Check popup, reused verbatim.
          * It is self-connected (reads duplicateTransactions/cancelReasons and owns
          * its own hide/Mark-Duplicate/Continue outcomes), so it only needs the
          * compare payload + userId here. It self-gates on duplicateTransactions,
          * populated when the Billing-step entry fires checkDuplicateTransactions. */}
        <DuplicateTXPopup compareTransaction={this.getQuickEntryDuplicateCompare()} userId={global.userID} />
        {/* Always mounted once first shown (activeTab defaults to "requestInfo") - only
          * hidden via CSS when Billing/Records is active, never unmounted. See
          * renderQuickEntryRequestInfoPane's doc comment for why. height: 100%
          * is required here (bug fix, independent audit finding), not optional -
          * .quick-entry-analyzing/.quick-entry-awaiting-document use height:100%
          * to fill .data-entry-form-wrapper, which only resolves if EVERY
          * ancestor in the chain has an explicit height; without it here, this
          * wrapper's default height:auto collapses those panels to their
          * content height instead of filling the pane. (QuickEntryFieldGroupList's
          * .qe-shell is unaffected - it fills the same ancestor via
          * position:absolute, which doesn't depend on this chain.)
          *
          * AB#35065: this wrapper SCROLLS (overflowY:auto) so the analyzing /
          * awaiting-document cards (in-flow, min-height:100%) are always fully
          * visible - if the pane is shorter than the card's content it scrolls
          * instead of the text being clipped/pushed off-screen. minHeight: 0 is
          * REQUIRED and load-bearing: this div is a flex item of .data-entry-form-wrapper
          * (display:flex; flex-direction:column), and flex items default to
          * min-height:auto, which refuses to shrink below their content - so WITHOUT
          * minHeight:0 the wrapper just grows to the card's content and overflowY:auto
          * never triggers, letting the content spill out of the fixed-height
          * .request-content-wrapper (the "text disappears when the right pane is
          * resized small" bug). minHeight:0 lets it constrain to height:100% and
          * actually scroll. No effect on .qe-shell, which is position:absolute and
          * not laid out in this wrapper's flex/scroll flow. */}
        <div style={{ height: "100%", minHeight: 0, overflowY: "auto", display: activeTab === "requestInfo" ? undefined : "none" }}>
          {this.renderQuickEntryRequestInfoPane()}
        </div>
        {activeTab === "billing" ? (
          <QuickEntryBillingPane
            feeSchedules={this.props.feeSchedules ?? []}
            releaseMethods={this.props.releaseMethodOptions ?? []}
            initialFields={this.state.quickEntryBillingFields}
            releaseMethodResyncSignal={this.state.quickEntryReleaseMethodResyncSignal}
            billToRecordResyncSignal={this.state.quickEntryBillToRecordSignal}
            onFieldsChange={this.onQuickEntryBillingFieldsChange}
            onBack={this.onBackToQuickEntryFromBilling}
            onCreateTransaction={this.onQuickEntryCreateTransaction}
            onCreateAndContinue={this.onQuickEntryCreateAndContinueToRecordAttachment}
            transactionCreated={this.state.quickEntryShowTransactionCreatedCard ? { requestId: this.props.transactionId } : undefined}
            onNextQueueItem={this.onNextQueueItem}
            // AB#35095: Classic Mode billing feature-parity inputs.
            featureFlags={this.props.featureFlags}
            certificationTypes={this.props.certificationTypes}
            additionalChargeTypeOptions={this.props.additionalChargeType ? Object.values(this.props.additionalChargeType) as any : []}
            shippingServices={this.props.shippingServiceOptions ?? []}
            // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
            // eslint-disable-next-line no-restricted-syntax
            isInternalRequest={this.props.transactionDetails?.transactionRequest?.isInternalRequest}
            sendToAddress={this.getQuickEntryBillingSendToAddress()}
            // AB#37853 (Phase 13): show "Loading..." and hold the two defaulted controls disabled
            // while the post-Confirm-All re-fetch is in flight, so an empty dropdown is not
            // mistaken for "nothing is coming - pick one yourself".
            defaultsPending={this.state.quickEntryBillingDefaultsPending}
            // AB#38349: withhold the Download-needs-an-email warning while the pane's release
            // method is STILL THE SERVER'S and is derived from a DIFFERENT contact than the row now
            // shows - see isQuickEntryReleaseMethodStaleForPane. Display only; both creation gates
            // stand.
            releaseMethodStale={this.isQuickEntryReleaseMethodStaleForPane()}
          />
        ) : null}
        {activeTab === "records" ? (
          <QuickEntryRecordsPane summary={this.getQuickEntryRecordsSummary()} />
        ) : null}
        <RequestorContactModal
          show={this.state.requestorModalOpen}
          searchSignal={this.state.quickEntryRequestorSearchSignal}
          onClose={this.closeRequestorModal}
          rightPaneProps={{
            proceedBtnClick: this.props.proceedBtnClick,
            retrieveProtocol: this.props.retrieveProtocol,
            // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
            // eslint-disable-next-line no-restricted-syntax
            transactionDetails: this.props.transactionDetails,
            // AB#35289 (AC5): tell the reused classic RightPane whether the request is
            // Internal based on the LIVE redux form type, not the persisted
            // transactionRequest.isInternalRequest flag (QE defers type persistence to
            // Confirm All). Drives both the auto-search on modal open and the in-modal
            // Search button to filter requestors to Internal. Classic never sets this
            // (undefined) so it keeps using the persisted flag - byte-unchanged.
            liveInternalOverride: this.isLiveRequestTypeInternal(),
            // Spec #35136 (F1f): the live, not-yet-persisted Request Type so the
            // reused Classic search pane keys its DDS branch (search routing +
            // rqSiteCode param + RQ Site Code field) off what the specialist just
            // picked, not the stale persisted value.
            liveRequestType: this.props.formState?.values?.[FormConstants.REQUEST_TYPE],
            additionalChargeRecords: this.props.additionalChargeRecords,
            getFacilityFeeSchedules: this.props.getFacilityFeeSchedules,
            getFacilityReleaseMethods: this.props.getFacilityReleaseMethods,
            getFacilityShippingServices: this.props.getFacilityShippingServices,
            userHasMadeChanged: this.userHasMadeChanged,
            getQAPDIssues: this.props.getQAPDIssues,
            qaPDIssues: this.props.qaPDIssues,
            onResolveRequestorContact: this.onModalRequestorContactResolved,
            onAddNewRequestor: this.onModalAddNewRequestor,
            onModalRequestorSelected: this.onModalRequestorSelected,
            onModalContactSelected: this.onModalContactSelected,
            // AB#35116: seed the modal's classic search so it auto-runs on open and
            // shows the classic results grid (same popup as classic mode). What the
            // specialist typed in the row's inline boxes wins over the AI extraction -
            // and a box they cleared stays cleared (empty string, not a fallback), so
            // a removed fax is no longer resurrected and sent to the API.
            initialRequestorFax: this.state.quickEntryRequestorSearchKeys
              ? this.state.quickEntryRequestorSearchKeys.fax
              : this.props.requestAnalysis?.data?.requestorContactFax,
            initialRequestorEmail: this.state.quickEntryRequestorSearchKeys
              ? this.state.quickEntryRequestorSearchKeys.email
              : this.props.requestAnalysis?.data?.requestorContactEmail,
            // Spec #35136 (F1f) fix: same idea for DDS's Site Code field - undefined
            // (no inline search ran yet, e.g. the very first automated match) falls
            // back to undefined here too, so fetchAllSearchRecords's own fallback to
            // the form's current RQ Site Code takes over instead of blanking it.
            initialRequestorSiteCode: this.state.quickEntryRequestorSearchKeys?.siteCode,
            // AB#39478: undefined until an inline search runs, like siteCode above, so the
            // pane leaves its Advanced Search fields alone rather than blanking them.
            initialRequestorAddress: this.state.quickEntryRequestorSearchKeys?.address,
            initialRequestorZip: this.state.quickEntryRequestorSearchKeys?.zip,
            initialRequestorName: this.state.quickEntryRequestorSearchKeys?.requestorName,
            initialRequestorContactName: this.state.quickEntryRequestorSearchKeys?.contactName,
          }}
        />
        {this.state.assignContactOpen ? this.renderAssignContactModal() : null}
      </>
    );
  }

  handleSelectedTab = (selectedId: number) => {
    let active = this.state.active;
    active.forEach((element, inx) => {
      return selectedId === inx ? (active[inx] = true) : (active[inx] = false);
    });
    this.setState({ active: active });
  };
  handleNavigation = () => {
    this.setState({ tabClick: false });
    const id: number = this.props.activeTabId;
    this.handleSelectedTab(id - 1);
  };
  handleClick = (tabItem: tabItemModal) => {
    const values = this.props.formState?.values || { values: {} }
    sessionStorage.setItem("formValues", JSON.stringify(values))
      document.getElementsByClassName('right-pane')[0].scrollTo(0,0)
    if (tabItem.id < this.props.activeTabId) {
      this.setState({ tabClick: true })
      this.props.onChangeDataEntryTab(tabItem.id, true)
      this.handleSelectedTab(tabItem.id - 1)
      return null
    }

    if(this.props.activeTabId + 1 < tabItem.id){
      return null;
    }

    if (this.props.activeTabId === 1) {
      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
      // eslint-disable-next-line no-restricted-syntax
      this.props.getFacilityFeeSchedules(this.props.transactionDetails!.facility.id, this.props.transactionId)
      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
      // eslint-disable-next-line no-restricted-syntax
      this.props.getFacilityShippingServices(this.props.transactionDetails!.facility.id);
      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
      // eslint-disable-next-line no-restricted-syntax
      this.props.getFacilityReleaseMethods(this.props.transactionDetails!.facility.id, this.props.transactionId);
    } else if (this.props.activeTabId === 2) {
      this.props.setLastUsedRequestorInfo({
        requestorName: this.props.requestorDetails?.fullName,
        address1: this.props.requestorDetails?.requestorAddress.address1,
        address2: this.props.requestorDetails?.requestorAddress.address2,
        city: this.props.requestorDetails?.requestorAddress.city,
        state: this.props.requestorDetails?.requestorAddress.state,
        zip: this.props.requestorDetails?.requestorAddress.zipCode,
        firstName: this.props.requestorDetails?.requestorInfo?.firstName,
        lastName: this.props.requestorDetails?.requestorInfo?.lastName,
        email: this.props.requestorDetails?.requestorInfo?.email,
        phone: this.props.requestorDetails?.requestorInfo?.phone,
        fax: this.props.requestorDetails?.requestorInfo?.fax,
        requestorContactId: this.props.requestorDetails?.requestorInfo?.id,
        requestorId: this.props.requestorDetails?.requestorID,
        // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
        // eslint-disable-next-line no-restricted-syntax
        requestPurpose: this.props.transactionDetails?.requestPurpose,
        org: this.props.selectedFacilityDetails.facility.id,
        transactionId: this.props.transactionId
      });
      this.props.patchRequestorComplete && this.props.patchRequestorComplete(this.props.transactionId);
      this.props.getTransactionAttributes && this.props.getTransactionAttributes(this.props.transactionId); //if this is only being done to refresh the status, please delete
    }else if (this.props.activeTabId === 3) {

      this.props.patchBillingComplete && this.props.patchBillingComplete(this.props.transactionId);
    }

    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    if (this.props.activeTabId != 2 || this.props.transactionDetails?.requestPurpose?.typeID != DISCLOSURE_ACCOUNTING) {
      this.props.submitForm()
    }
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    let validations = localValidations(values, { activeTabId: this.props.activeTabId, transactionDetails: this.props.transactionDetails, feeSchedules: this.props.feeSchedules })
    ignoreFields.map(item => delete validations[item])
    this.props.stopSubmit(validations)
    const fieldErrorsCount = Object.keys(validations).length
    this.props.updateFormSyncErrors(validations)
    // Regression fix (Spec #34102 / F1d): RequestTypePurposeField/
    // AuthorizationDateField/RequestDateField/ClinicResponsibleField/
    // CaseNumberField no longer register a real redux-form <Field> (the F1a
    // extraction stopped wrapping them), so redux-form's own submit-touches-
    // every-registered-field behavior never reaches them - state.form[...]
    // .fields[name] simply doesn't exist for an unregistered name, so
    // meta.touched can never become true for them without this. touch()'s
    // TOUCH reducer sets fields.<name>.touched unconditionally (confirmed by
    // reading node_modules/redux-form/lib/createReducer.js) - registration
    // status doesn't gate it, only reading meta.touched does. Dispatched
    // directly (not via the this.props.touch wrapper, which forwards its
    // argument as ONE positional arg to redux-form's variadic touch(form,
    // ...fields) - passing an array there would nest it, not spread it).
    if (fieldErrorsCount) {
      this.props.dispatch!(touch(FormConstants.DATA_ENTRY_FIELDS_FORM, ...Object.keys(validations)))
    }
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    if (!fieldErrorsCount && this.props.transactionDetails?.requestPurpose?.typeID != DISCLOSURE_ACCOUNTING) {
      this.setState({ tabClick: true });
      this.props.onChangeDataEntryTab(tabItem.id, true);
      this.handleSelectedTab(tabItem.id - 1);
    }
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    else if (!fieldErrorsCount && this.props.transactionDetails?.requestPurpose?.typeID == DISCLOSURE_ACCOUNTING && (tabItem.id !== 3 && tabItem.id !== 4)) {
      this.setState({ tabClick: true });
      this.props.onChangeDataEntryTab(tabItem.id, true);
      this.handleSelectedTab(tabItem.id - 1);
    }
  };

  initialAPICalls = (transactionId: string) => {
    if (transactionId && this.props.selectedFacilityDetails && global.userID) {
      const organizationId = parseInt(transactionId.split("-")[0]);
      const requestBufferId = parseInt(transactionId.split("-")[1]);
      this.props.getFacilityAdditionalFieldsActionCreator?.(organizationId);
      this.props.getTransactionAttributes(this.props.transactionId);
      this.props.getFacilityFeeSchedules(organizationId, this.props.transactionId)
      this.props.getTransactionNotesRequest(this.props.transactionId)
      this.props.getRetrieveProtocol(this.props.transactionId)
      this.props.getAdditionalChargeType(organizationId)
      this.props.getRejectOptions(organizationId)
      this.props.getTransactionNoteTypes(organizationId)
      this.props.getDocumentSources(organizationId)
      this.props.getAdditionalChargeRecords(this.props.transactionId)
      this.props.getTransactionDocuments(this.props.transactionId)
      this.props.getFacilityShippingServices(organizationId)
      this.props.getFacilityReleaseMethods(organizationId, this.props.transactionId)
      this.props.getPHICodesRequest(organizationId)
      this.props.transactionCancellationReasons(organizationId)
      this.props.getSelectedPHICodes(this.props.transactionId)
      this.props.getUserGroups(organizationId)
      this.props.getDisclosureReasons(organizationId)
      this.props.getUserTasks(this.props.transactionId)
      if (this.props.featureFlags.FinalQAAccordions) {
        this.props.getEntityTypes();
        this.props.getReviewEntities(this.props.transactionId)
        this.props.getAssessmentResults(this.props.transactionId)
        this.props.getAIFeedback()
      }
      // NOTE: the intake-intelligence GET is intentionally NOT fired here. It is
      // only meaningful when a REQUEST document exists (there can be no prior
      // analysis without one), and documentsList hasn't loaded yet at this point.
      // Firing it unconditionally popped a misleading "Analyzing the request
      // document…" toast (and made a needless intake call) for new requests and
      // transactions with no request document. It is now triggered from
      // componentDidUpdate once documents load and only if a REQ doc is present.
      this.props.getRequestsAndPurposes(organizationId)
      this.props.getQAErrors()
      this.props.getQAIssues(this.props.transactionId)
      this.props.getQAPDIssues(this.props.transactionId)
      this.props.getOutboundTemplateRequest && this.props.getOutboundTemplateRequest()
      this.props.getAuditUsers?.(this.props.transactionId);
      if (this.props.featureFlags.AutoCertification) {
        this.props.getCertificationTypes();
      }
      this.props.getFacilityConfiguration(organizationId);
      this.props.getQAFeatureFlagsRequest();

      this.setState({ hasUserMadeAnyChanges: false })
    }
  }

  // Tracks which Quick Entry form fields we've already seeded from the current
  // extraction, so the seed runs once (never re-writing after a user edit/clear).
  private seededQeFields = new Set<string>();
  /**
   * AB#35146: the fields rehydrateQuickEntryFromTransaction actually wrote from the persisted
   * transaction, recorded SYNCHRONOUSLY as it writes them.
   *
   * componentDidUpdate calls rehydrate immediately before seedExtractedQuickEntryFields in ONE
   * pass, and rehydrate's writeFieldToForm updates the STORE only - React does not reassign props
   * mid-lifecycle, so the seed cannot see those writes in this.props.formState. This set, not the
   * form snapshot and not a re-derivation from transactionDetails, is how the seed knows a SAVED
   * value already won this load.
   *
   * Asking rehydrate what it wrote (rather than re-testing the same source fields) is deliberate:
   * an earlier revision keyed on requestPurpose.typeID, but rehydrate writes Purpose from
   * requestPurpose.id and typeID is "@deprecated Not set by the API in all cases"
   * (models/requestType.ts:21-24) - so a transaction whose saved purpose has dropped out of the
   * org catalog has a real id with typeID 0, the guard did not fire, and the AI Purpose overwrote
   * the saved one. Two writers deriving the same decision from different fields is the bug class;
   * one writer reporting a fact is not.
   *
   * Cleared with seededQeFields on a changed requestAnalysis, so a document REPLACE still re-seeds.
   */
  private quickEntryRehydratedFields = new Set<string>();
  // Separate guard for the Records Requested checkbox seed (checkbox Release[],
  // not a form field; seeded once the items load after type/purpose is chosen).
  private recordsRequestedSeeded = false;
  // AB#37856: the same guard for the Sensitive Information checkbox seed (SensitiveInfo[],
  // likewise not a form field; seeded once the questionnaire loads and Purpose resolves).
  private sensitiveInfoSeeded = false;
  // AB#37984 (issue 1, round-7 product decision): the same guard for the Audit type-based default.
  // Separate from sensitiveInfoSeeded because this one has NO precedence exception - Classic
  // authorizes every category the instant Request Type is Audit, full stop, and that rule wins
  // over the AI declaration seed AND a specialist's own manual answers. (An earlier revision let
  // the declaration seed stand this down; product review reversed that - Audit is unconditional.)
  private auditSensitiveInfoSeeded = false;
  // AB#35289 (AI-seeded purpose preview timing): the AI-seeded purpose whose read-only
  // Information-To-Release preview still needs to load, when the seed fired BEFORE
  // transactionDetails was present (onQuickEntryRequestPurposeChange early-returns on a null
  // transactionDetails, and the form-value seed one-shot is already burned, so without this the
  // records-requested / doc-type list stays empty until a manual re-pick). componentDidUpdate
  // fires it exactly once as soon as transactionDetails arrives, then clears this. null = nothing
  // pending. Re-armed on a fresh extraction (doc replace) alongside the other seed latches.
  private quickEntryAiPurposePreviewPending: number | null = null;
  // AB#35289 (reload/reopen preview): the purpose the read-only Information-To-Release preview was
  // last loaded for on THIS transaction, so the load fires at most once per (transaction, purpose)
  // and never loops. Set by onQuickEntryRequestPurposeChange (the single load path, whether reached
  // from the AI seed, the reopen block, or a manual Confirm); reset on transaction switch. This is
  // what lets the preview load on a RELOAD/REOPEN, where the type/purpose fields are already
  // populated (rehydrate) so seedRequestTypePurpose early-returns and never fires the load.
  private quickEntryPreviewLoadedPurpose: number | null = null;
  // Guards the intake-analysis GET so it is decided at most once per transaction
  // (see componentDidUpdate): set the first time this transaction's documents
  // have loaded, whether or not the GET actually fires. Holds the transactionId
  // it was decided for, so a transaction switch re-evaluates. A REQ document
  // attached LATER is handled by the extraction POST saga, not this load-GET.
  private intakeDecidedForTransactionId: string | undefined = undefined;
  // Resolves once the Confirm-All transaction persists (request-info fields PATCH,
  // create-new patient, requestor select/create) have all committed. The completion
  // step (persistQuickEntryBillingFields) awaits it before firing BillingComplete so
  // that step never reads a half-written transaction (Patient/BillToContact null).
  private quickEntryPersistPromise: Promise<boolean> | undefined = undefined;
  /**
   * AB#31605 (round-1 review CRITICAL-4). Settles once the DetailsComplete audit write
   * has finished, so the type-66 finalize can run strictly AFTER it rather than beside
   * it. Both used to hang off quickEntryPersistPromise and therefore resolved in the
   * same microtask drain, putting the two requests in flight together - and for
   * Disclosure Accounting the finalize is MoveToRPQ (INSERT tblRPQ + DELETE the
   * tblRequestBuffer row) while DetailsComplete INSERTs audit rows against that same
   * transaction. That is the opposite-lock-order shape that produced the reproduced
   * "Process ID N was deadlocked ... chosen as the deadlock victim" HTTP 400.
   *
   * Resolves on BOTH success and failure, deliberately: this sequences, it does not
   * gate. The audit event is traceability, not data, so a failed DetailsComplete must
   * not block a transaction from completing - the persist gate's own boolean is what
   * governs that.
   */
  private quickEntryDetailsCompletePromise: Promise<void> | undefined = undefined;
  /**
   * Round-2 review W-2/W-3: every settle-guard timer for the Confirm-All writes, held on
   * the instance so componentWillUnmount can clear them - matching
   * quickEntryAutoAdvanceTimer's pattern. A function-local timer fires after the component
   * is gone, settling a promise and letting the finalize dispatch and setState on an
   * unmounted component.
   */
  private quickEntryWriteTimers = new Set<ReturnType<typeof setTimeout>>();

  /**
   * AB#38014: settle timer for the stuck-intake detection (see intakeStuckGate.ts). Held on the
   * instance so componentWillUnmount can clear it and it can be restarted/cancelled as the
   * candidate condition comes and goes.
   */
  private quickEntryIntakeStuckTimer: ReturnType<typeof setTimeout> | undefined = undefined;

  /** Which transaction the pending settle timer above was armed for (review round 3, MJ2). */
  private quickEntryIntakeStuckTimerTransactionId: string | undefined = undefined;

  /** The transaction the stuck state was last announced for, so it is reported once, not per render. */
  private quickEntryIntakeStuckAnnouncedFor: string | undefined = undefined;

  /**
   * Wraps a callback-style Confirm-All write in a promise that is GUARANTEED to settle.
   *
   * Round-2 review W-3. Every one of these writes goes through a saga registered
   * `takeLatest`, and the sagas fire their callbacks only on completion - so a cancelled
   * generator (teardown on unmount or route change kills the root saga; a second dispatch
   * of the same action cancels the first) fires NEITHER callback and leaves a bare
   * `new Promise(resolve => dispatch(...))` unsettled forever. The consequences differ per
   * write and all are silent:
   *   - the disclosure write: the sequential writes barrier never resolves, so Confirm All hangs
   *     with no toast and no timeout.
   *   - the finalize: `quickEntryBillingSubmitting` is cleared ONLY in those callbacks, so
   *     it stays true and the in-flight guard at the top of
   *     completeQuickEntryDisclosureAccounting then blocks every retry for the rest of the
   *     session - strictly worse than a hang.
   *
   * `fallbackOnTimeout` is per-write on purpose: a gating write must time out to its
   * FAILURE value so completion aborts rather than proceeding on an unconfirmed write,
   * while the DetailsComplete audit write - which sequences but does not gate - times out
   * to success so a slow audit event cannot cost the specialist the transaction.
   */
  private settleGuardedWrite = <T,>(
    fallbackOnTimeout: T,
    invoke: (settle: (value: T) => void) => void,
  ): Promise<T> => new Promise<T>(resolve => {
    let settled = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    const settle = (value: T) => {
      if (settled) {
        return;
      }
      settled = true;
      if (timer !== undefined) {
        clearTimeout(timer);
        this.quickEntryWriteTimers.delete(timer);
      }
      resolve(value);
    };
    timer = setTimeout(() => settle(fallbackOnTimeout), QUICK_ENTRY_WRITE_SETTLE_TIMEOUT_MS);
    this.quickEntryWriteTimers.add(timer);
    invoke(settle);
  });

  // AB#31605 (re-save): guards so the create-new patient/requestor endpoints fire
  // AT MOST ONCE per create intent. Confirm-All can now be re-committed while still
  // in Quick Entry (the write-once freeze moved to intake completion), and the
  // Confirm-All persist re-runs on every re-save - re-firing createPatientRecordRequest
  // / createSendTo would create a DUPLICATE patient/requestor. "Select existing" and
  // the scalar/billing PATCHes are idempotent; only create-new is not, so it is
  // one-shot-guarded here. Reset to false by onCreatePatient/onCreateRequestor (a fresh
  // create-new intent re-arms the single fire).
  private quickEntryPatientCreateFired = false;
  private quickEntryRequestorCreateFired = false;
  // Bug fix (AB#31605): once-per-extraction guard for the fresh-extraction form
  // clear. A document replace's reset->FETCHING spans two componentDidUpdate
  // cycles (and either signal alone can trigger the clear), so this dedupes to a
  // single clear; it is re-armed when the extraction resolves (success/failure)
  // and on a transaction change.
  private quickEntryFreshExtractionHandled = false;

  componentDidUpdate(prevProps: Props, prevState: State) {
    // AB#38014: detect "document attached, intake never started or resolved" and report it as
    // a retryable intake failure once it has settled. Runs before the early returns below so a
    // stuck transaction is still noticed while other update paths short-circuit.
    this.evaluateQuickEntryIntakeStuck();
    if (this.props.intiaTxlSagaCallCount >= 18 && this.state.showLoadingSpinner) {
      this.setState({ showLoadingSpinner: false })
    }

    // AB#35289 (AC4 fix): QE eligibility depends on transactionDetails, which is still
    // loading at mount - re-attempt the Audit-option fetch once it (and the QE gate)
    // become available. Fetch-once is enforced by the API-status guard inside.
    this.fetchAuditFieldOptionsForQuickEntry();

    // AB#34102: after a request document is attached, AI extraction runs and can take
    // up to the extractor's ~100s timeout. Surface a persistent LOADING toast for that
    // whole window (so it never looks broken or idle) that resolves to success/error -
    // this works in BOTH Classic and Quick Entry because it's a global toast, not a
    // pane-specific element. Keyed on the in-flight fetch status (API_FETCHING), which
    // is the real "extraction running" signal; the inline Quick Entry panel below uses
    // the same signal.
    this.updateIntakeAnalysisToast(prevProps);

    // Spec #35136 (F1f), FR-4/AC-4: on a successful DDS barcode scan, populate the
    // Quick Entry DDS row's fields - mirroring Classic's own populate effect
    // (DataEntryDetailsRightPaneRequestorSection.tsx:75-95), bit-for-bit incl. the
    // 4-star SSN mask and the TX Site Code -> RQ Site Code mirror. Overwrites any
    // manually-typed values unconditionally, exactly as Classic does (no "only if
    // empty" guard). A failed scan writes nothing (FR-6, silent).
    this.populateQuickEntryDdsFromScan(prevProps);
    // AB#35149 purpose-sync is upstream's design, not this branch's: a
    // `quickEntryPurposeSyncing` boolean that disables Confirm All while the round-trip is in
    // flight (state at :634, gate at :1350/:3567/:3587, set/cleared at :3751/:3799/:3805). This
    // branch's earlier `quickEntryPurposeSyncBaseline` snapshot-and-resolve variant was dropped
    // wholesale in the feature merge - no references remain - so there is no second mechanism
    // here and nothing to reconcile.

    // AB#35095: bring Classic's duplicate-transaction check to Quick Entry. Classic
    // fires props.checkDuplicates(transactionId, caseNumber) on Billing-tab entry via
    // a useEffect keyed on activeTabId===3 (DataEntryDetailsRightPane 485-495). QE has
    // no tab-3 effect, so mirror it here: fire the SAME action when the QE step
    // transitions to "billing". Guarded to the transition (prev !== "billing") so it
    // fires once per entry, not every render. The server does the matching; a hit
    // populates duplicateTransactions and the shared <DuplicateTXPopup> below shows.
    //
    // AB#35120: the FIRST entry into Billing happens synchronously inside the same
    // Confirm-All success handler that starts quickEntryPersistPromise (the write that
    // lands this transaction's own patient/DOB/case number) WITHOUT awaiting it first -
    // see persistQuickEntrySelectionsToTransaction's call site. Firing the check straight
    // off this transition raced that write: the server looks up THIS transaction's own
    // patient/DOB/case number to know what to search for, and finds nothing if the
    // gate hasn't landed yet - confirmed live on RC (same URL, same params, 0 matches
    // before the gate settles, 5 matches moments later once it has). Chain it behind
    // quickEntryPersistPromise instead, same shape refreshBillingAfterConfirmAllOnce
    // already uses for the fee-schedule re-fetch below. On any LATER re-entry into
    // Billing, the promise is already settled, so the .then fires on the next
    // microtask with no user-visible delay - this only changes the first, racy entry.
    if (prevState.quickEntryActiveStepTab !== "billing" && this.state.quickEntryActiveStepTab === "billing") {
      const values = this.props.formState?.values ?? {};
      const caseNumber = values[FormConstants.CASE_NUMBER];
      const fireDuplicateCheck = () => this.props.checkDuplicateTransactions?.(this.props.transactionId, caseNumber);
      if (this.quickEntryPersistPromise) {
        this.quickEntryPersistPromise.then(fireDuplicateCheck, fireDuplicateCheck);
      } else {
        fireDuplicateCheck();
      }
      // AB#31605: the applicable fee-schedule list is purpose-dependent, and it used
      // to be refreshed inside onQuickEntryRequestPurposeChange - alongside the POST
      // that step no longer makes. Nothing reads state.feeSchedules until the Billing
      // step (QuickEntryBillingPane's Fee Schedule dropdown), so fetching on entry
      // here is equivalent and keeps the purpose-change handler free of I/O beyond
      // its own read-only preview. setDefault stays false: true re-dispatches
      // getTransactionAttributes (see the getFeeSchedules saga) and would loop.
      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
      // eslint-disable-next-line no-restricted-syntax
      const facilityId = this.props.transactionDetails?.facility?.id;
      if (facilityId) {
        this.props.getFacilityFeeSchedules(facilityId, this.props.transactionId);
      }
    }

    // Fetch any prior intake analysis ONCE per transaction, and only when a
    // REQUEST document actually exists - a transaction with no request document
    // (a brand-new request, or an existing one that was never sent a REQ doc)
    // has no analysis to retrieve, so calling intake would just fire a needless
    // request and pop the misleading "Analyzing the request document…" toast.
    // Gated on documents having loaded (API_SUCCESS) so documentsList reflects
    // THIS transaction, not a stale list from the one we navigated away from.
    // The attach flow triggers extraction separately (autoExtractOnRequestUpload).
    const intakeGate = this.intakeFetchGateInputs();
    if (
      isIntakeAnalysisDecisionReady(intakeGate)
      && this.intakeDecidedForTransactionId !== this.props.transactionId
    ) {
      // We now have enough loaded state to decide intake ONCE for this transaction.
      this.intakeDecidedForTransactionId = this.props.transactionId;
      if (shouldFetchExistingIntakeAnalysis(intakeGate)) {
        const [organizationId, requestBufferId] = this.props.transactionId!.split("-").map(part => parseInt(part, 10));
        this.props.getIntakeIntelligence(organizationId, requestBufferId);
      }
    }

    if (prevProps.activeTabId !== this.props.activeTabId && this.props.proceedBtnClick) {
      this.handleNavigation();
    }
    if (prevProps.transactionId !== this.props.transactionId) {
        // Spec #34102 (F1d): a fresh transaction must not inherit the previous
        // one's Quick Entry commit/billing/step-tab state - each is scoped to
        // its own RequestIntake row server-side, so carrying any of this over
        // would misrepresent the new transaction's real state. Also resets the
        // F1c (#34101) patient/requestor match state, which is likewise
        // transaction-scoped (the rows re-report it after re-extraction).
        if (this.quickEntryAutoAdvanceTimer) {
          clearTimeout(this.quickEntryAutoAdvanceTimer);
          this.quickEntryAutoAdvanceTimer = null;
        }
        // AB#31605 re-save: clear the one-shot create guards so the new transaction can
        // create-new fresh (defense-in-depth; onCreatePatient/onCreateRequestor also
        // re-arm them, and they're only consulted when resolution.mode === "create").
        this.quickEntryPatientCreateFired = false;
        this.quickEntryRequestorCreateFired = false;
        // AB#31605: re-arm the fresh-extraction clear guard for the new transaction.
        this.quickEntryFreshExtractionHandled = false;
        // AB#35289 (round-8): clear the AI-seeded purpose preview latch on a transaction switch.
        // Unlike the value-guarded seed latches (seededQeFields / recordsRequestedSeeded), this one
        // actively FIRES onQuickEntryRequestPurposeChange - a leak across transactions would load the
        // PRIOR transaction's purpose preview into the new one (visible on a reopen with no fresh
        // extraction). Co-located with the sibling one-shot ACTION guards above.
        this.quickEntryAiPurposePreviewPending = null;
        // AB#35289 (reload/reopen): re-arm the once-per-(tx,purpose) preview guard for the new
        // transaction so its own resolved purpose loads its preview (and the prior tx's doesn't leak).
        // Also re-enables one silent preview attempt for the next transaction.
        this.quickEntryPreviewLoadedPurpose = null;
        // AB#37984 (round-6 review, thread 53037): the Audit default's latch is per-transaction, but
        // was only re-armed on a change of requestAnalysis. That is enough for the analysis-driven
        // seed latches (sensitiveInfoSeeded / seededQeFields), which cannot burn unless an analysis
        // exists - but the Audit default has a second burn path, the manual Request Type dropdown,
        // which needs no analysis at all. This component stays mounted across a transaction switch,
        // so a specialist who picked Audit on one document-less transaction got nothing when they
        // picked Audit on the next.
        this.auditSensitiveInfoSeeded = false;
        this.setState(prevState => ({
          showLoadingSpinner: true,
          quickEntryReleaseInfo: null,
          // AB#31605: the preview is scoped to the purpose selected on THIS
          // transaction - a new transaction must fall back to its own releaseInfo
          // until/unless its purpose is changed.
          quickEntryReleaseInfoPreview: null,
          quickEntryReleaseComments: null,
          quickEntryServiceDateOverride: null,
          // AB#38460: transaction-scoped like the override it shadows - a new transaction must
          // not open with the previous one's rows still flagged invalid.
          quickEntryInvalidDates: {},
          quickEntrySensitiveInfo: null,
          // Spec #35135: the disclosure draft is transaction-scoped like every
          // sibling above - a new transaction must never inherit the previous
          // one's disclosure entry. (A mere request-type change within the SAME
          // transaction deliberately keeps the draft: the row simply stops being
          // applicable, nothing was written to the server, and toggling the type
          // back should not have silently destroyed what the specialist typed.)
          quickEntryDisclosureDraft: null,
          // Bumped (not reset to 0) so a switch straight from one transaction's
          // Quick Entry session to another's still forces Patient/Requestor to
          // remount fresh, same mechanism/reasoning as the document-replace
          // case above - a new transaction is at least as much "a new document"
          // as a replace within the same one.
          quickEntryIntakeGeneration: prevState.quickEntryIntakeGeneration + 1,
          quickEntryActiveStepTab: "requestInfo",
          quickEntryCommitCompletedDate: null,
          quickEntryTransactionCreated: false,
          quickEntryShowTransactionCreatedCard: false,
          quickEntrySubmitting: false,
          quickEntryBillingSubmitting: false,
          quickEntryShowLeaveModal: false,
          quickEntryBillingFields: { ...DEFAULT_QUICK_ENTRY_BILLING_FIELDS },
          quickEntryReleaseMethodResyncSignal: 0,
          quickEntryBillToRecordSignal: 0,
          quickEntryReleaseMethodPickedByOperator: false,
          quickEntryReleaseMethodDerivedForContactId: undefined,
          quickEntryAcknowledgedLowConfidenceIds: new Set(),
          quickEntryConfirmBlockedRowId: undefined,
          // AB#38014 (review round 2, M1): the stuck-intake report belongs to the transaction it
          // was raised for. Without this reset it survives the switch and renders empty editable
          // rows instead of the placeholder on the transaction just opened.
          quickEntryIntakeStuck: false,
          patientMatchState: DEFAULT_PATIENT_MATCH_STATE,
          requestorMatchState: DEFAULT_REQUESTOR_MATCH_STATE,
          // Clear the patient/requestor resolutions so a prior transaction's
          // matched/created values can never be persisted onto the one we just
          // navigated to.
          quickEntryPatientResolution: undefined,
          quickEntryRequestorResolution: undefined,
          // AB#39018: quickEntryModalRequestor (a classic requestor-grid pick) and
          // quickEntryAssignedContact are the same class of transaction-scoped state as the two
          // resolutions above, but were missing from this block. Left in place, the stale pick
          // is fed into RequestorInfoRow as `selectedRequestor` on the new transaction, which
          // both overwrites the Requestor fields with the previous transaction's data and
          // suppresses the new document's AI-driven auto-match.
          quickEntryModalRequestor: undefined,
          quickEntryAssignedContact: undefined,
          // AB#39018 (PR !10480 review, Mike Hamilton): same bug by another route - left unreset,
          // the previous transaction's inline requestor search keys seed the classic modal's
          // initialRequestorFax/Email/SiteCode (~line 2028-2038) instead of the new transaction's
          // own AI extraction.
          quickEntryRequestorSearchKeys: undefined,
          // AB#39018 (PR !10480 review, Mike Hamilton): a more severe variant of the same bug
          // class - these two are read as a PAIR by onQuickEntryEditCancel (~line 6240), so they
          // must be reset together. Left unreset, a row left open for [Edit] on the previous
          // transaction renders as still open on the new one, and Cancel there restores the
          // PREVIOUS transaction's snapshotted values into the new transaction's form/state.
          quickEntryEditingRowIds: new Set(),
          quickEntryEditSnapshots: {},
          // Bug fix (Spec #34102 / F1d, direct user report): each
          // transaction gets its own pre-Quick-Entry snapshot, captured
          // fresh by captureQuickEntryOriginalSnapshotIfNeeded below once
          // the new transaction's own transactionDetails arrives.
          quickEntrySnapshotTransactionId: null,
          quickEntryOriginalReleaseInfo: null,
          quickEntryOriginalRequestComments: undefined,
          quickEntryOriginalSensitiveInfo: null,
          // Bug fix (AB#31605): a new transaction gets its own reopen
          // rehydration from its own persisted transactionDetails, so re-arm the
          // guard here. (Deliberately NOT reset on a document replace below.)
          quickEntryRehydratedTransactionId: null,
          // Bug fix (AB#31605 review): a new transaction starts as a "reopen"
          // (prefer its persisted patient/requestor link) until a fresh
          // extraction fires for it - re-arm the fresh-extraction flag here.
          quickEntryFreshExtractionTransactionId: null,
        }))
        // AB#35146: an instance field, so it is reset here rather than in the setState above, and
        // it must be clear before the new transaction's own rehydrate runs - otherwise the prior
        // transaction's "rehydrate already won" fact would suppress this one's AI seed.
        this.quickEntryRehydratedFields = new Set();
        this.handleNavigation();
        this.initialAPICalls(this.props.transactionId)

    }

    this.captureQuickEntryOriginalSnapshotIfNeeded();
    // A new/replaced extraction resets the seed guards so its values re-seed
    // (Spec #34101 / F1c). AB#35121 (review finding 2 on !9636): only for an analysis that belongs
    // to THIS transaction. A late-landing response for the transaction just left would otherwise
    // re-arm seeding here and write that patient's case number, dates, clinic and type/purpose into
    // this transaction's form - the PHI-bearing consequence of the same unscoped-state defect, and a
    // worse outcome than the announcement this fix started with.
    if (prevProps.requestAnalysis !== this.props.requestAnalysis && !this.isForeignAnalysis()) {
      this.seededQeFields = new Set();
      // AB#35146: same cadence - a new/replaced extraction is allowed to beat the saved values,
      // so forget that rehydrate ever wrote them.
      this.quickEntryRehydratedFields = new Set();
      this.recordsRequestedSeeded = false;
      // AB#37856: re-arm the Sensitive Information seed for the new extraction, same
      // cadence as its Records Requested sibling above.
      this.sensitiveInfoSeeded = false;
      // AB#37984: re-arm the Audit default too - a replaced document can change the request type.
      this.auditSensitiveInfoSeeded = false;
      // AB#35289: re-arm the AI-seeded purpose preview latch for the new extraction.
      this.quickEntryAiPurposePreviewPending = null;
    }
    // Bug fix (direct user report + AB#31605 review): a new request document /
    // re-run intake must discard EVERYTHING from the prior document - AI-seeded,
    // MANUALLY entered, AND rehydrated-from-saved request-info - so only the NEW
    // extraction repopulates (clearQuickEntryDraftFields blanks every request-info
    // field, and resetting the seed guards above re-permits the fresh seed to
    // refill the now-empty fields; seed()'s own !values[field] guard never
    // overwrites a value still sitting there, which is why the clear is required).
    //
    // TWO trigger signals, because a document REPLACE nils requestAnalysis
    // (object -> undefined, via autoExtractOnRequestUpload -> resetIntakeIntelligence)
    // BUT a FIRST extraction over fields the specialist typed before any analysis
    // existed produces NO such transition (undefined -> undefined) - it only flips
    // requestIntakeIntelligenceStatus to API_FETCHING. Without the second signal
    // those manually-entered values persisted and shadowed the new extraction (the
    // reported bug). Neither signal is true on ordinary status progress or on the
    // initial reopen (which loads the PRIOR analysis via the GET path -
    // getIntakeIntelligenceStatus - and never flips the POST status to FETCHING).
    // The reset->FETCHING sequence spans two componentDidUpdate cycles, so an
    // instance guard (re-armed when the extraction resolves) keeps the clear to
    // exactly once per extraction.
    const requestAnalysisNilled = prevProps.requestAnalysis != null && this.props.requestAnalysis == null;
    const extractionStarted = prevProps.requestIntakeIntelligenceStatus !== API_FETCHING
      && this.props.requestIntakeIntelligenceStatus === API_FETCHING;
    if ((requestAnalysisNilled || extractionStarted) && !this.quickEntryFreshExtractionHandled) {
      this.quickEntryFreshExtractionHandled = true;
      // AB#35086: record the intake-timing "session started" event (AuditTask 814) -
      // ONLY on a genuinely first extraction (extractionStarted, not a document
      // replace - requestAnalysisNilled covers replaces separately) and ONLY when
      // Quick Entry itself is active, since requestIntakeIntelligenceStatus is
      // shared with Classic Mode's own manual Extract button. Fire-and-forget, same
      // shape as onClickLeaveQuickEntry's exitToClassicIntakeApi call - a failed
      // audit write must never block extraction.
      if (extractionStarted && !requestAnalysisNilled && this.isQuickEntryEligible()) {
        try {
          quickEntrySessionStartedApi(this.props.transactionId, Number((global as any).userID))
            .catch(() => { /* best-effort audit; ignore */ });
        } catch { /* ignore */ }
      }
      this.clearQuickEntryDraftFields();
      // AB#31605 re-save: a document replace discards the prior resolutions, so also
      // clear the one-shot create guards (defense-in-depth; onCreate* re-arms them).
      this.quickEntryPatientCreateFired = false;
      this.quickEntryRequestorCreateFired = false;
      // Bug fix (AB#31605, tester): Records Requested / Service Dates / Sensitive
      // Info are NOT redux-form fields, so clearQuickEntryDraftFields can't blank
      // them - and setting their overrides to `null` is the BUG: the getters then
      // fall back to the persisted transaction (the OLD doc's still-checked records
      // + saved sensitive info), which also makes the re-seed's `.some(checked)`
      // guard true so the new extraction never repopulates. Instead set overrides
      // that SUPERSEDE the persisted transaction with a CLEARED set: the current
      // option list all-unchecked/no-dates (an empty [] would fall through to the
      // server's checked values via mergeQuickEntryReleaseInfo, so it must be the
      // real id set unchecked), an empty sensitive list ([], not null - `??` only
      // falls back on null/undefined), and a cleared service-date range.
      const clearedReleaseInfo = (this.currentTransactionDetails()?.releaseInfo ?? [])
        .map(item => ({ ...item, checked: false, dateOfService: undefined, allDates: false }));
      // Sensitive Info's checkboxes ARE its data list (SensitiveInfoField renders one
      // per entry), so clear the specialist's ANSWERS by resetting every state to
      // NotMentioned - do NOT set [] (that removes the questionnaire entirely, i.e.
      // "the checkboxes aren't even there"). Same reset shape as clearedReleaseInfo.
      const clearedSensitiveInfo = (this.currentTransactionDetails()?.sensitiveInfo ?? [])
        .map(item => ({ ...item, stateID: SensitiveInfoRelease.NotMentioned }));
      this.setState(prevState => ({
        // Bug fix (AB#31605 review): a document replace / re-run intake IS a fresh
        // extraction - from here the Patient/Requestor rows must search off the NEW
        // extraction, not pre-resolve to the (now superseded) persisted link. Flag
        // this tx so preferPersistedMatch flips false.
        quickEntryFreshExtractionTransactionId: this.props.transactionId,
        // Bug fix (independent audit finding): a stale acknowledgment from the
        // old document, at the same rowId, would otherwise silently suppress
        // the Confirm-All review gate for the new document's re-extracted
        // value on that row - the transaction-change reset block already
        // clears this for the same reason; the document-replace case needs it
        // too.
        quickEntryAcknowledgedLowConfidenceIds: new Set(),
        // AB#38460 (David Heifetz, PR !10140 review): clear the invalid-date flags too, for the
        // identical reason as the acknowledgments above - a stale flag at the same rowId keeps the
        // OLD document's unusable text on screen (echoed back as invalidText), keeps forcing that
        // row NeedsEntry, and keeps blocking Confirm All for the NEW document. The only escape was
        // Cancel. Unconditional like the acknowledgment reset, not gated on requestAnalysisNilled
        // like the overrides below: an empty map is the neutral absence of a flag, so it cannot
        // shadow a fresh seed the way a superseding-empty override would.
        quickEntryInvalidDates: {},
        quickEntryConfirmBlockedRowId: undefined,
        quickEntryPatientResolution: undefined,
        quickEntryRequestorResolution: undefined,
        quickEntryIntakeGeneration: prevState.quickEntryIntakeGeneration + 1,
        // Bug fix (AB#31605 / user report - "records & sensitive blank on a fresh
        // intake"): the records / sensitive / service-date OVERRIDES are
        // superseding-empty ONLY to HIDE the PRIOR document's persisted values while
        // a REPLACEMENT extraction is in flight - i.e. a genuine doc replace / re-run
        // (requestAnalysisNilled). On a FIRST extraction there is no prior document to
        // hide, and these empty overrides would instead SHADOW the fresh server/seed
        // values: Records/Service-Date re-seed would fight the all-unchecked override,
        // and Sensitive Info would be blanked permanently by an empty [] override
        // (getQuickEntrySensitiveInfo reads `override ?? server`, and AB#37856's seed
        // waits for a non-empty questionnaire, so it would never fire either). So set
        // these ONLY on a doc replace; on a first extraction leave them as-is (null) and
        // let the normal server + AI-seed path populate. (AB#37856: this comment used to
        // assert Sensitive Info had NO AI seed path at all - it does now, and the same
        // shadowing argument is what still makes the doc-replace-only gate correct.)
        quickEntryReleaseInfo: requestAnalysisNilled ? clearedReleaseInfo : prevState.quickEntryReleaseInfo,
        // "" (cleared), not null (= "fall through to props") - null let the REPLACED document's
        // persisted description resurface, which is exactly what clearedReleaseInfo's explicit
        // all-unchecked array exists to prevent (Mike Hamilton, PR !10721).
        quickEntryReleaseComments: requestAnalysisNilled ? "" : prevState.quickEntryReleaseComments,
        quickEntryServiceDateOverride: requestAnalysisNilled ? { from: undefined, to: undefined, allDates: false } : prevState.quickEntryServiceDateOverride,
        quickEntrySensitiveInfo: requestAnalysisNilled ? clearedSensitiveInfo : prevState.quickEntrySensitiveInfo,
      }));
    }
    // Re-arm the once-per-extraction guard when the extraction resolves so the NEXT
    // document replace clears again.
    if (this.props.requestIntakeIntelligenceStatus === API_SUCCESS || this.props.requestIntakeIntelligenceStatus === API_FAILURE) {
      this.quickEntryFreshExtractionHandled = false;
    }
    // Bug fix (AB#31605): rehydrate the request-info fields from the persisted
    // transaction FIRST, then let the AI seed fill any field still empty. On a
    // plain reopen the re-fetched prior analysis is NOT a fresh extraction
    // (Precedence rule 3), so the SAVED value must win over it - hence rehydrate
    // runs before seedExtractedQuickEntryFields. On a document replace rehydrate
    // is a no-op (guarded once-per-transaction), so the fresh extraction's seed
    // is the only writer and old saved values are never resurrected (rule 2).
    this.rehydrateQuickEntryFromTransaction();
    this.seedExtractedQuickEntryFields();
    // AB#35289 (AI-seeded purpose preview timing): if the AI seed fired its purpose preview before
    // transactionDetails had loaded (onQuickEntryRequestPurposeChange early-returns on null, and the
    // seed one-shot is already burned), fire it now that transactionDetails is present. Cleared
    // immediately so it runs exactly once per extraction - no loop. Read-only preview; no persist.
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    if (this.quickEntryAiPurposePreviewPending != null && this.props.transactionDetails) {
      const pendingPurpose = this.quickEntryAiPurposePreviewPending;
      // Clear the latch SYNCHRONOUSLY, before the async dispatch below - this (not any
      // componentDidUpdate call count) is what guarantees the preview fires exactly once: a
      // re-entrant update sees the latch already null and skips.
      this.quickEntryAiPurposePreviewPending = null;
      this.onQuickEntryRequestPurposeChange(pendingPurpose);
    }

    // AB#35289 (reload/reopen): load the purpose-driven preview whenever a RESOLVED purpose is
    // present on the form (AI-seeded OR rehydrated on reopen/reload) and it hasn't loaded yet for
    // this (transaction, purpose) - decoupled from the fresh-empty seed gate, which early-returns on
    // reload because the fields are already populated. Gated to a SETTLED purpose (the type/purpose
    // row is NOT being edited) so a mid-edit dropdown change still does NOT load (AB#35149) - only a
    // committed/rehydrated purpose does. SILENT: this is an auto background load, so it must not gate
    // Confirm All (unlike an operator-initiated change). onQuickEntryRequestPurposeChange sets
    // quickEntryPreviewLoadedPurpose, so this fires once per purpose and never loops. transactionDetails
    // is present here (gated), so it fires now. Read-only (GET informationToRelease); no persist.
    if (
      this.isQuickEntryEligible()
      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
      // eslint-disable-next-line no-restricted-syntax
      && this.props.transactionDetails
      && !this.state.quickEntryEditingRowIds.has(REQUEST_TYPE_PURPOSE_ROW_ID)
    ) {
      const currentPurpose = Number((this.props.formState?.values ?? {})[FormConstants.PURPOSE_TYPE]);
      if (currentPurpose > 0 && this.quickEntryPreviewLoadedPurpose !== currentPurpose) {
        this.onQuickEntryRequestPurposeChange(currentPurpose, { silent: true });
      }
    }
    // AB#35088: seed Billing's Fee Schedule / Release Method from the transaction (Classic
    // parity) before the specialist reaches the billing tab, where the pane mounts.
    this.seedQuickEntryBillingDefaults();
    // AB#35088 (QA retest finding 2): strictly AFTER the seeder - the seeder owns the first
    // arrival, this owns a later server RECOMPUTATION of it (contact change).
    // AB#38349 round 2: BEFORE the resync - the resync can adopt a new value, and the stamp has to
    // describe the value that was on screen when the observation was made.
    this.trackQuickEntryReleaseMethodProvenance();
    this.resyncQuickEntryReleaseMethodFromTransaction();
    // AB#37981 round 2: strictly AFTER the seeder for the same reason - the seeder owns the first
    // arrival of a Bill To field, this owns a later server REWRITE of it.
    this.resyncQuickEntryBillToFromRecord();
    // AB#37853 (Phase 13): strictly AFTER the seeder - it is the seeder that moves the arrived
    // values into quickEntryBillingFields, which is what this reads to decide the defaults landed.
    this.clearQuickEntryBillingDefaultsPendingWhenLanded();
  }

  /**
   * Bug fix (Spec #34102 / F1d, direct user report): captures the
   * pre-Quick-Entry-session snapshot revertQuickEntryRecordsAndSensitiveInfo
   * reverts to on "Switch to Classic Mode" - see quickEntryOriginalReleaseInfo's
   * own doc comment on State for why a snapshot is needed at all. Fires from
   * every componentDidUpdate call but is a no-op once
   * quickEntrySnapshotTransactionId already matches the current
   * transactionId, so it only ever actually captures once per transaction,
   * as soon as transactionDetails first becomes available (componentDidMount
   * fires before the async transactionDetails fetch resolves, so the capture
   * can't happen there).
   */
  captureQuickEntryOriginalSnapshotIfNeeded = () => {
    // Bug fix (AB#39495): use the identity-guarded details, exactly as
    // rehydrateQuickEntryFromTransaction does at :2861 and for the same reason. This
    // is the WRITE path: unguarded it stored the OUTGOING transaction's releaseInfo /
    // comments / sensitiveInfo permanently labelled with the INCOMING transactionId,
    // which Switch to Classic then posted onto the wrong transaction. The existing
    // early return below precedes the setState, so a premature stale call is a clean
    // no-op that leaves the latch unarmed - the real capture still fires once the new
    // transaction's own details arrive. Do not latch before this check.
    const transactionDetails = this.currentTransactionDetails();
    if (!transactionDetails || this.state.quickEntrySnapshotTransactionId === this.props.transactionId) {
      return;
    }
    this.setState({
      quickEntrySnapshotTransactionId: this.props.transactionId,
      quickEntryOriginalReleaseInfo: transactionDetails.releaseInfo,
      quickEntryOriginalRequestComments: transactionDetails.requestComments,
      quickEntryOriginalSensitiveInfo: transactionDetails.sensitiveInfo,
    });
  }

  /**
   * Bug fix (AB#31605, direct user report): on a plain REOPEN of an in-progress
   * Quick Entry transaction (Confirm All already persisted Clinic / Request
   * Date / Case / Auth Date / Type-Purpose, but the request document was NOT
   * re-extracted), the request-info rows blanked - Quick Entry only ever seeded
   * them from the AI extraction (seedExtractedQuickEntryFields) and never read
   * them back from the persisted transactionDetails. This fills the EMPTY
   * request-info fields from the SAVED transaction, mirroring Classic Mode's
   * transactionDetails -> DATA_ENTRY_FIELDS_FORM initializer
   * (DataEntryDetailsRightPane) via the shared computeQuickEntryRehydration
   * mapper.
   *
   * Runs independent of requestAnalysis.status (the whole point - it works when
   * the AI re-read is unusable). Fires exactly once per transaction, on the
   * first componentDidUpdate after transactionDetails arrives, guarded by
   * quickEntryRehydratedTransactionId - the same one-per-transaction cadence as
   * captureQuickEntryOriginalSnapshotIfNeeded. The guard is re-armed on a
   * transactionId change but NOT on a document replace, so a mid-session replace
   * (which clears the form and re-extracts) is refilled only by the fresh AI
   * seed, never by the stale saved values. computeQuickEntryRehydration applies
   * the falsy write-once guard per field, so a specialist edit or an AI seed
   * already in the form is never overwritten.
   */
  rehydrateQuickEntryFromTransaction = () => {
    // Bug fix (AB#31605 review MAJOR-1): use the identity-guarded details so a
    // stale prior-transaction transactionDetails (it isn't cleared on an in-place
    // switch until the new fetch resolves) can neither latch the guard for the new
    // tx nor write the OLD tx's Clinic/Case/dates/Type-Purpose into the NEW tx's
    // shared form. A premature stale call is a clean no-op (below), so the correct
    // rehydrate still fires once the new tx's own details arrive.
    const transactionDetails = this.currentTransactionDetails();
    if (!transactionDetails || !this.props.dispatch || this.state.quickEntryRehydratedTransactionId === this.props.transactionId) {
      return;
    }
    this.setState({ quickEntryRehydratedTransactionId: this.props.transactionId });
    const pairs = computeQuickEntryRehydration(transactionDetails, this.props.formState?.values ?? {});
    // AB#35146: record BEFORE dispatching. The seed runs later in this same synchronous pass and
    // cannot observe these writes through props, so this set is its only reliable signal that the
    // persisted value already won.
    pairs.forEach(([field]) => this.quickEntryRehydratedFields.add(field));
    pairs.forEach(([field, value]) => writeFieldToForm(this.props.dispatch!, field, value));
  }

  /**
   * Bug fix (AB#35088): Fee Schedule and Release Method opened on "- Select -" on the
   * Quick Entry Billing pane, so the specialist had to re-pick values the transaction
   * already carried (the reporter's example showed Release Method as Digital Fax in the
   * Summary pane while the Billing dropdown sat empty).
   *
   * Root cause: Classic Mode seeds both from the transaction
   * (DataEntryDetailsRightPane: `useState(props.transactionDetails.feeSchedule?.id ?? 0)`,
   * and it passes `transactionDetails.releaseMethod?.id` down), but Quick Entry only ever
   * initialised `quickEntryBillingFields` to DEFAULT_QUICK_ENTRY_BILLING_FIELDS
   * (chargeForPostage only) and never read the transaction, so both dropdowns rendered
   * `value=""`.
   *
   * QuickEntryBillingPane takes `initialFields` into `useState` (mount-only) and only
   * mounts when the billing tab is active, so seeding the caller-owned state here is what
   * the pane picks up. Per-field nullish guard so a specialist's own pick (pushed up via
   * onFieldsChange) is never overwritten.
   *
   * CORRECTION (AB#37853). This comment used to add "well before the specialist reaches
   * Billing", and that assumption - defaults always land BEFORE the pane mounts - was load
   * bearing while being enforced by nothing but this prose. AB#35289 then invalidated it: its
   * one-shot post-Confirm-All re-fetch resolves asynchronously while Confirm All flips to the
   * Billing tab synchronously, so the pane now mounts FIRST and the seed arrives after. Do not
   * rely on seed-before-mount ordering. The pane re-syncs late arrivals itself via
   * mergeLateArrivingBillingFields, and that behaviour is pinned by tests rather than by a
   * comment - see quickEntryBillingDefaults.test.ts and QuickEntryBillingPane.test.tsx.
   *
   * The guard is tracked PER FIELD, not once per transaction (review finding on PR !9605).
   * `transactionDetails` is re-fetched during a session - getTransactionAttributes is
   * re-dispatched after several updates - so a payload can arrive carrying one of these two
   * values and not the other, with the missing one appearing on a later refetch. A single
   * per-transaction flag burned on the first pass regardless of whether anything was seeded,
   * so both "nothing seedable yet" and "only one of the two seeded" left the other field
   * permanently unseeded and the Sev-1 symptom intact. Recording which fields actually seeded
   * means each seeds exactly once, when its own value first shows up - while still making a
   * deliberate CLEAR stick, since a seeded field is never reconsidered.
   */
  private quickEntryBillingDefaultsSeededTxId: string | null = null;
  private quickEntryBillingDefaultsSeededFields = new Set<QuickEntryBillingDefaultField>();

  /**
   * AB#37981: the same per-field bookkeeping for the eleven Bill To fields, kept in its own set
   * because the two field groups arrive from DIFFERENT slices on different refetches
   * (transactionDetails vs requestorBillingDetails) and several Bill To fields are legitimately
   * blank forever - a shared set would let one group's "all seeded" short-circuit strand the other.
   */
  private quickEntryBillToSeededFields = new Set<QuickEntryBillToDefaultField>();
  /** AB#37981 round 2: the value the seeder actually WROTE into each Bill To field. Recorded rather
   *  than inferred, which is what lets the re-sync tell "still ours" from "the specialist has taken
   *  this over" without guessing. Per transaction, reset alongside the seeded set. */
  private quickEntryBillToWritten: QuickEntryBillToWrittenValues = {};
  /** The bill-to row each value above came from, PER FIELD. The seeder is row-blind, so after a
   *  requestor re-pick the ledger legitimately spans two rows - one id for the block could not
   *  represent that and let a mixed payer block through. See QuickEntryBillToWrittenRows. */
  private quickEntryBillToWrittenRows: QuickEntryBillToWrittenRows = {};

  /** AB#35289 (Internal billing parity): the transactionId for which the ONE-SHOT
   * post-Confirm-All billing re-fetch has already fired, so it never repeats (which would
   * feed the getTransactionAttributes loop the :1799-1803 comment warns about).
   *
   * AB#39265 narrows that scope limit. It still holds for the SELECTED value - the seeder's
   * "operator owns the field after the first seed" precedence (quickEntryBillingDefaults.ts)
   * keeps whatever is already seeded, by design - but no longer for the LIST, which a re-save
   * that changes the purpose must re-fetch. See refreshBillingAfterConfirmAllOnce. */
  private quickEntryBillingRefreshedForPurpose: string | null = null;


  /**
   * AB#35289 (Internal billing parity - confirmed Classic regression): Classic re-fetches
   * transactionDetails after every persist (purpose change fires getFacilityFeeSchedules +
   * getTransactionAttributes, DataEntryDetailsRightPane.tsx:1181-1184), so the backend-assigned
   * Internal courtesy fee schedule + the fresh isInternalRequest flow in and the Fee Schedule
   * dropdown populates and locks. Quick Entry deliberately opts out of that post-persist re-fetch
   * (componentDidUpdate keeps setDefault=false to avoid the loop - see :1799-1803), so after
   * Confirm All persists the Internal type and the backend assigns the courtesy schedule, the
   * client never pulls it: Fee Schedule stays empty and the lock reads the stale persisted flag.
   *
   * Fire ONE re-fetch here, AFTER the Confirm-All persist gate has resolved (the purpose - which
   * flips the type to Internal - is persisted LAST in that gate), with setDefault=true so
   * getFeeSchedules re-dispatches getTransactionAttributes. The existing seeder
   * (seedQuickEntryBillingDefaults -> computeQuickEntryBillingDefaults) then maps the refreshed
   * transactionDetails.feeSchedule -> fields.feeScheduleId, and the refreshed
   * transactionRequest.isInternalRequest locks the dropdown. No client-side courtesy assignment -
   * just the re-fetch QE opted out of.
   *
   * One-shot per transaction: guarded so it fires once off the Confirm-All completion and can
   * never be re-fired from componentDidUpdate (that is the infinite loop the :1799-1803 comment
   * warns about). It does NOT clobber the operator's billing draft - the seeder is per-field
   * once-per-transaction and only burns a field's flag on a NON-null seed, so the earlier empty
   * payload left feeScheduleId unseeded and this refreshed non-null value seeds cleanly.
   */
  /**
   * AB#37853 (Phase 13b): returns whether the re-fetch was actually DISPATCHED. On either early
   * return no request goes out, so nothing will ever arrive to clear the pending flag - the caller
   * uses this to clear it immediately rather than making the operator wait out the full timeout.
   */
  /**
   * AB#39265: keyed on the purpose the list is being fetched FOR, not on the transaction.
   * dbo.ROIS_FeeSchedule_sel filters the list by the transaction's RequestorTypeID, which
   * ROIS_spUTransactionRequestPurpose_upd derives from the persisted request purpose - so the
   * list is only correct for the purpose that was in the database when it was fetched. Keyed
   * per transaction, a re-save that changed the purpose found the guard already burned and kept
   * the first commit's list, with the newly applicable schedules missing from the dropdown for
   * the rest of the session.
   *
   * The form value is the right key rather than transactionDetails.requestPurpose: at this point
   * the purpose has just been written and nothing has re-fetched the transaction yet, so the prop
   * still holds the PREVIOUS purpose. This is the same value persistPurposeLast sent.
   *
   * Still loop-proof, which is what the one-shot was protecting: the re-fetch is a read and
   * cannot change the purpose, so the key is unchanged when getTransactionAttributes arrives.
   */
  private refreshBillingAfterConfirmAllOnce = (persistedPurposeId: number): boolean => {
    // Identity-guarded, like every other write in the gate: after a transaction switch the raw
    // prop can still hold the PREVIOUS transaction's details, which would dispatch the fetch
    // against the old facility and burn the current transaction's key.
    const facilityId = this.currentTransactionDetails()?.facility?.id;
    if (!facilityId) { return false; }
    // Never for Disclosure Event. ROIS_spUTransactionRequestPurpose_upd runs EXEC ROIS_RPQ_ins for
    // purpose 43, which migrates the transaction into tblRPQ and DELETEs the tblRequestBuffer row -
    // so there is nothing left to fetch a purpose-filtered list for, and ROIS_FeeSchedule_sel
    // excludes 43 rows outright. The same exclusion the API makes before re-running the
    // purpose-dependent defaults (TransactionsController, "Purpose 43 is excluded"). Keyed-on-the-
    // transaction this could never fire on a re-save; keyed on the purpose it can.
    if (persistedPurposeId === DISCLOSURE_EVENT) { return false; }
    const refreshKey = `${this.props.transactionId ?? ""}:${persistedPurposeId}`;
    if (this.quickEntryBillingRefreshedForPurpose === refreshKey) { return false; }
    this.quickEntryBillingRefreshedForPurpose = refreshKey;
    this.props.refreshBillingAfterConfirmAll?.(facilityId, this.props.transactionId);
    return true;
  }

  /**
   * AB#37853 (Phase 13): the timer that guarantees quickEntryBillingDefaultsPending cannot stick.
   * Also registered in quickEntryWriteTimers so componentWillUnmount clears it - otherwise it
   * fires after teardown and setStates on an unmounted component.
   */
  private quickEntryBillingDefaultsPendingTimer: ReturnType<typeof setTimeout> | null = null;

  /**
   * AB#37853 (Phase 13b): the transaction the pending flag was armed FOR.
   *
   * Tracked separately from quickEntryBillingRefreshedForPurpose rather than reusing it. The
   * flag is now armed at Billing ENTRY, which happens a full persist gate BEFORE the one-shot
   * re-fetch sets that field - so keying the transaction-switch clear off the one-shot's
   * bookkeeping cleared the flag instantly on the very first componentDidUpdate (its value is still
   * null at that point, which never matches the current transactionId). The two lifetimes are
   * genuinely different; giving the flag its own identity is what keeps them independent.
   */
  private quickEntryBillingDefaultsPendingTxId: string | null = null;

  /**
   * Marks the post-Confirm-All billing defaults as in flight.
   *
   * WHEN THIS IS ARMED (Phase 13b correction). At the moment Billing is ENTERED off Confirm All -
   * i.e. in the same setState that flips quickEntryActiveStepTab to "billing" - and NOT when the
   * re-fetch later fires. The pane mounts on that tab flip, but the request purpose has not
   * persisted yet, so isInternalRequest is still false and both controls render editable. The
   * Confirm-All persist gate then runs ~8 sequential writes, measured at roughly 10 SECONDS, before
   * the re-fetch is even dispatched. Arming at the re-fetch therefore covered only the tail of the
   * exposure and left a ~10s window in which the operator could start picking a value that was
   * about to populate itself - the exact wasted interaction this loading state exists to prevent.
   * Arming in the same setState as the tab flip is deliberate: it means there is no intermediate
   * render in which the pane is mounted and this flag is false.
   *
   * WHY COMPONENT-LOCAL STATE AND NOT REDUX. The fee-schedule slice stores no in-flight status
   * (AB#39575 added a failure case, but only to clear the slice, not to record pending/failed
   * status) - so the redux route would mean adding a status field, i.e. new shared surface
   * touching every consumer of that slice, to express something only Quick Entry's Billing pane reads.
   *
   * SCOPED TO THE CONFIRM-ALL ENTRY. Manual Billing navigation and the Back-to-Quick-Entry round
   * trip must never disable these controls - there is no pending fetch in those cases - so neither
   * the tab buttons nor the componentDidUpdate billing-entry hook arms this.
   *
   * CLEAR PATHS, because a stuck flag would recreate Bug 37853's own deadlock:
   *   1. success - the values landed (clearQuickEntryBillingDefaultsPendingWhenLanded);
   *   2. the persist gate rejected, or the re-fetch was never dispatched at all - cleared straight
   *      away by the caller rather than waiting out the ceiling;
   *   3. timeout - unconditional, and the ONLY path covering the saga's two SILENT exits (thrown
   *      error -> getFeeScheduleFailure, which no reducer handles; non-2xx without a throw -> no
   *      action dispatched at all). Also covers "no defaults were ever coming";
   *   4. transaction switch - the flag belongs to the transaction it was armed for.
   * Plus unmount, which clears the timer rather than the flag.
   *
   * IDEMPOTENT. Re-arming while already pending would abandon the first timer - it stays in
   * quickEntryWriteTimers and fires later, clearing the flag out from under a still-live window -
   * so an existing armed timer is left alone rather than restarted.
   */
  private beginQuickEntryBillingDefaultsPending = () => {
    if (this.quickEntryBillingDefaultsPendingTimer !== null) { return; }
    this.quickEntryBillingDefaultsPendingTxId = this.props.transactionId ?? null;
    this.setState({ quickEntryBillingDefaultsPending: true });
    const timer = setTimeout(
      () => this.endQuickEntryBillingDefaultsPending(),
      QUICK_ENTRY_BILLING_DEFAULTS_PENDING_TIMEOUT_MS,
    );
    this.quickEntryBillingDefaultsPendingTimer = timer;
    this.quickEntryWriteTimers.add(timer);
  }

  /** Idempotent: safe to call from any of the clear paths, in any order. */
  private endQuickEntryBillingDefaultsPending = () => {
    if (this.quickEntryBillingDefaultsPendingTimer !== null) {
      clearTimeout(this.quickEntryBillingDefaultsPendingTimer);
      this.quickEntryWriteTimers.delete(this.quickEntryBillingDefaultsPendingTimer);
      this.quickEntryBillingDefaultsPendingTimer = null;
    }
    this.quickEntryBillingDefaultsPendingTxId = null;
    if (this.state.quickEntryBillingDefaultsPending) {
      this.setState({ quickEntryBillingDefaultsPending: false });
    }
  }

  /**
   * Clear path 1 (success) and 3 (transaction switch). Called from componentDidUpdate right after
   * the seeder, since the seeder is what moves the arrived values into quickEntryBillingFields.
   *
   * Keys off the CALLER-OWNED fields rather than on the fee-schedule list, deliberately. The saga
   * dispatches GET_FEE_SCHEDULE_SUCCESS with the list and only THEN chains
   * getTransactionAttributes, and the values come from the refreshed transactionDetails - not from
   * the list. Clearing on the list arriving would drop the loading state while the dropdowns were
   * still empty, under-covering the exact window this phase exists to cover.
   *
   * Nullish (`!= null`), not falsy - a legitimately-0 id is an arrived value, matching
   * mergeLateArrivingBillingFields and computeQuickEntryBillingDefaults.
   */
  private clearQuickEntryBillingDefaultsPendingWhenLanded = () => {
    if (!this.state.quickEntryBillingDefaultsPending) { return; }
    // Clear path 4 - transaction switch. Compared against the flag's OWN armed-for transaction, not
    // the one-shot re-fetch's: the flag is armed at Billing entry, a whole persist gate before the
    // one-shot runs, so the one-shot's field is still null here and would never match.
    if (this.quickEntryBillingDefaultsPendingTxId !== (this.props.transactionId ?? null)) {
      this.endQuickEntryBillingDefaultsPending();
      return;
    }
    const fields = this.state.quickEntryBillingFields;
    if (fields.feeScheduleId != null && fields.releaseMethodId != null) {
      this.endQuickEntryBillingDefaultsPending();   // clear path 1
    }
  }

  private seedQuickEntryBillingDefaults = () => {
    const transactionDetails = this.currentTransactionDetails();
    if (!transactionDetails) {
      return;
    }
    // A transaction switch re-arms every field (the transaction-change reset also restores
    // DEFAULT_QUICK_ENTRY_BILLING_FIELDS, so the new transaction seeds from scratch).
    if (this.quickEntryBillingDefaultsSeededTxId !== this.props.transactionId) {
      this.quickEntryBillingDefaultsSeededTxId = this.props.transactionId ?? null;
      this.quickEntryBillingDefaultsSeededFields = new Set();
      this.quickEntryBillToSeededFields = new Set();
      this.quickEntryBillToWritten = {};
      this.quickEntryBillToWrittenRows = {};
    }
    // Review finding on PR !9605 (MINOR-4): the seeded-field bookkeeping must NOT happen inside the
    // setState updater. React 17 legacy mode invokes an updater once, so it worked - but an updater
    // that mutates instance state is impure, and if it were ever re-invoked (React 18 StrictMode,
    // update rebasing) the second pass would see the fields already in `alreadySeeded`, return null,
    // and DISCARD the state update - silently restoring the Sev-1 symptom. Compute first, then
    // record in the completion callback.
    const result = this.quickEntryBillingDefaultsSeededFields.size >= QUICK_ENTRY_BILLING_DEFAULT_FIELDS.length
      ? null   // every fee/release field already seeded - nothing further to do for this transaction
      : computeQuickEntryBillingDefaults(
        transactionDetails, this.state.quickEntryBillingFields, this.quickEntryBillingDefaultsSeededFields);
    // AB#37981: Bill To seeds in the SAME setState, chained off `result.next` rather than off
    // this.state. A second setState in this same componentDidUpdate tick would still read the
    // pre-seed this.state.quickEntryBillingFields and its object spread would clobber whatever the
    // first one wrote - the Fee Schedule / Release Method seed AB#35088 exists for.
    // Captured before the seed, so the row recorded against each seeded value is the row the value
    // was actually read from.
    const seedRecordRow = this.props.requestorBillingDetails?.requestorBillingID
      ?? this.props.requestorBillingDetails?.requestorBillingId;
    const billToResult = this.quickEntryBillToSeededFields.size >= QUICK_ENTRY_BILL_TO_DEFAULT_FIELDS.length
      ? null
      : computeQuickEntryBillToDefaults(
        this.props.requestorBillingDetails,
        transactionDetails.billToContact?.id,
        result?.next ?? this.state.quickEntryBillingFields,
        this.quickEntryBillToSeededFields,
        // AB#37981: the bill-to record's five CONTACT-derived columns are sparsely populated even
        // when the requestor's contact carries them, so the record alone leaves those five unseeded
        // - the reported "all other fields are being carried over" split, reported once for
        // phone/fax/email and again for the names. The live form is the fallback, and is the same
        // source both Classic's "Same as send to" and this component's own sendTo copy already read,
        // so the five agree by construction.
        this.quickEntryBillToContactFallback());
    const next = billToResult?.next ?? result?.next;
    if (!next) {
      return;
    }
    this.setState(
      { quickEntryBillingFields: next },
      () => {
        result?.seeded.forEach(field => this.quickEntryBillingDefaultsSeededFields.add(field));
        billToResult?.seeded.forEach(field => {
          this.quickEntryBillToSeededFields.add(field);
          // The VALUE, not just the key: the re-sync's ownership test compares against it.
          const wrote = billToResult.next[field];
          if (typeof wrote === "string") {
            this.quickEntryBillToWritten[field] = wrote;
            // ...and the row it came from, recorded in the same place at the same moment. Read from
            // the SAME record object the seed used, not from a later props read - the two claims
            // have to be about one instant or the ledger can say the block is from one row when it
            // is not, which is precisely how the atomicity guard was defeated.
            this.quickEntryBillToWrittenRows[field] = seedRecordRow;
          }
        });

      });
  }

  /**
   * AB#37981 QA retest (Renita Dorsey, 2026-08-21): the requestor's own phone / fax / email, for
   * the Bill To seed to fall back to when the transaction's bill-to record does not carry them.
   *
   * Reuses getQuickEntryBillingSendToAddressFromFormValues rather than reading the form again, so
   * this fallback and the "Same as send to" copy can never disagree about what the requestor's
   * contact currently is - and inherits its all-blank guard, which returns undefined so a
   * requestor that genuinely has no contact details seeds nothing rather than seeding "".
   *
   * These five - the contact-derived Bill To fields, which are also the five Classic mirrors on
   * blur. Organisation name and address come from a different table, seed reliably from the record,
   * and are excluded: widening further would risk showing a bill-to address that differs from the
   * record a later save persists.
   *
   * PII: read from props and handed straight to a pure function; never logged.
   */
  private quickEntryBillToContactFallback = (): QuickEntryBillToContactFallback | undefined => {
    const sendTo = getQuickEntryBillingSendToAddressFromFormValues(this.props.formState?.values);
    if (!sendTo) {
      return undefined;
    }
    // The requestor these details belong to, so the seeder can refuse to apply them to a bill-to
    // row that points at a different organisation. requestorDetails is the linked requestor, which
    // is exactly what the bill-to record's RequestorNameID is compared against; when it is absent
    // (no requestor linked yet) the gate finds no match and nothing is seeded, which is correct.
    return {
      firstName: sendTo.firstName,
      lastName: sendTo.lastName,
      phone: sendTo.phone,
      fax: sendTo.fax,
      email: sendTo.email,
      requestorNameId: this.props.requestorDetails?.requestorID,
    };
  };

  /**
   * AB#35088 (QA retest finding 2): the transaction the release-method resync last observed a
   * value for, and that value. Kept per transaction so an in-place transaction switch re-arms
   * (the first observation on the new transaction belongs to the seeder again).
   * `undefined` = not yet observed for this transaction.
   */
  private quickEntryReleaseMethodResyncTxId: string | null = null;
  /** AB#38349 round 2: the server release method id last OBSERVED, so a change can be told from a
   *  re-render. The provenance stamp moves only on a change - see quickEntryReleaseMethodDerivedForContactId. */
  private quickEntryReleaseMethodObservedId: number | null = null;
  /** AB#38349: the transaction the observation above belongs to, so the tracker re-arms itself
   *  rather than depending on another method's reset running first. */
  private quickEntryReleaseMethodProvenanceTxId: string | null = null;
  private quickEntryLastSeenReleaseMethodId: number | null | undefined = undefined;

  /**
   * AB#37981 round 2 (QA escalation, Tirumani Krishnasri 2026-08-26): adopt a change the SERVER made
   * to this transaction's bill-to record, which the once-per-field seeder refuses by construction.
   *
   * The rule, the two server writes it covers, the four guards, and why ownership is recorded rather
   * than inferred are all in computeQuickEntryBillToRecordResync. This is the lifecycle half: when to
   * run, and how to do so without fighting the seeder.
   */
  private resyncQuickEntryBillToFromRecord = () => {
    if (!this.isQuickEntryEligible()) {
      return;
    }
    const transactionDetails = this.currentTransactionDetails();
    if (!transactionDetails) {
      return;
    }
    // Same setState-updater discipline as the release-method resync, and for the same measured
    // reason: seedQuickEntryBillingDefaults has already QUEUED a setState in this very
    // componentDidUpdate pass, so `this.state.quickEntryBillingFields` is the PRE-seed object.
    // Computing from `prev` is what stops this resync's spread from dropping the seeder's writes.
    //
    // The written-values ledger is read outside the updater (it is instance state, and an updater
    // that touches instance state is impure - PR !9605 MINOR-4).
    //
    // Inside a batched componentDidUpdate the ledger can be one pass STALE, because the seeder's
    // completion callback has not run yet. That is harmless rather than fine-by-luck: the seeder
    // writes only fields that are still unset, and this re-sync touches only fields the ledger
    // already holds, so the two can never contend for the same field - and the seeder's own setState
    // guarantees a further pass in which the ledger is caught up. No test pins that, so it is stated
    // as reasoning rather than as a verified property.
    // EVERY input except `prev` is read HERE, not inside the updater. The updater runs at flush
    // time and must be a pure function of `prev`; quickEntryBillToContactFallback() reads the live
    // redux-form values and the ledger is instance state, so reading either from inside would make
    // it impure (PR !9605 MINOR-4) and its result depend on when React chose to run it. Same shape
    // as resyncQuickEntryReleaseMethodFromTransaction below, which hoists for the same reason.
    const written = this.quickEntryBillToWritten;
    const writtenRows = this.quickEntryBillToWrittenRows;
    const record = this.props.requestorBillingDetails;
    const billToContactId = transactionDetails.billToContact?.id;
    const contactFallback = this.quickEntryBillToContactFallback();
    // The values the updater decided to adopt, carried out to the completion callback. A LOCAL, not
    // an instance field: the updater still mutates nothing React can observe, and if React ever
    // re-invoked it the second pass overwrites this with the result computed from the `prev` that
    // actually lands - which is the one the ledger must record.
    let landed: QuickEntryBillToWrittenValues | null = null;
    this.setState(prev => {
      const result = computeQuickEntryBillToRecordResync(
        record, billToContactId, prev.quickEntryBillingFields, written, contactFallback, writtenRows);
      if (!result) {
        landed = null;
        return null;   // React's own bail-out: no re-render, so the componentDidUpdate loop ends
      }
      const adopted: QuickEntryBillToWrittenValues = {};
      result.adopted.forEach(field => {
        const value = result.next[field];
        if (typeof value === "string") {
          adopted[field] = value;
        }
      });
      landed = adopted;
      return {
        quickEntryBillingFields: result.next,
        // The bump and the new values land in ONE setState, so the pane can never see an adopted
        // value without the signal that authorizes it to override its own local state.
        quickEntryBillToRecordSignal: prev.quickEntryBillToRecordSignal + 1,
      };
    }, () => {
      // Advance the ledger to what we just wrote, so the next pass sees "the record still says what
      // we wrote". What this actually buys is the SECOND change: without it the ledger still holds
      // the pre-adoption value, so the ownership guard reads the value we ourselves just wrote as
      // "the specialist has taken this over" and the field freezes after one change. Two successive
      // contact edits, or a contact edit then a requestor re-pick, are both ordinary.
      //
      // Not the termination condition, which was the first guess and is wrong: the ownership guard
      // already terminates the componentDidUpdate loop on its own, because after an adoption
      // `current` no longer equals what was written. Recorded because mutation testing is what
      // established it - dropping this line does not make the signal climb.
      Object.assign(this.quickEntryBillToWritten, landed ?? {});
      // Advance the recorded ROW for every field now RECONCILED with the record - not merely the
      // adopted ones. A field the re-sync skipped because its value already matched still describes
      // the current row, and leaving its row behind was a real defect: `rowChanged` stayed true for
      // the rest of the transaction, so every later pass hit the all-or-none gate and was refused as
      // soon as any one column was blank. Two payers in the same State was enough to trigger it, and
      // a same-requestor re-save (a fresh row with identical content, so nothing is adopted) wedged
      // it without any change of payer at all.
      //
      // Deliberately OUTSIDE the `landed` check, because the no-adoption path is exactly where the
      // wedge formed. React still runs this callback when the updater returns null.
      billToFieldsReconciledWithRecord(
        this.props.requestorBillingDetails,
        billToContactId,
        this.state.quickEntryBillingFields,
        this.quickEntryBillToWritten,
        this.quickEntryBillToContactFallback(),
      ).forEach(field => {
        this.quickEntryBillToWrittenRows[field] = billToContactId;
      });
    });
  }

  /**
   * AB#38349 round 2: record WHICH CONTACT the server's release method was derived for.
   *
   * The stamp moves only when the observed release method actually CHANGES, and it records the
   * transaction's linked contact as it stands AT THAT MOMENT. That ordering is the whole point:
   * DetermineReleaseMethod computes the value from tblRequestBuffer.RequestorContactID, so the
   * contact linked when the value arrived IS the contact it describes. A later re-point of the link -
   * the Classic grid's optimistic client-side write - moves the link WITHOUT producing a new
   * release-method observation, so it deliberately leaves the stamp behind. That is what makes the
   * staleness test immune to it.
   *
   * THIS IS THE INFERENCE PATH, and it is a fallback rather than the primary writer (AB#38349 round
   * 3). It exists for release-method changes we did not ask for - a value that arrives only via
   * getTransactionAttributes, e.g. the Confirm-All purpose write's server-side SetToDefaultFeeSchedule
   * + DetermineReleaseMethod, where no client call site holds a contact id to attribute it to. Any
   * path that DOES know which contact the server derived a value for records it explicitly through
   * recordQuickEntryReleaseMethodProvenance instead, because this inference has two blind spots:
   *  - it reads the CLIENT's copy of the link, which lags the server on the create-contact paths
   *    (DEFECT 2 - see adoptServerReleaseMethod);
   *  - it only fires on a CHANGE of id, so a re-derive that returns the SAME answer leaves the stamp
   *    on the previous contact forever (DEFECT 1 - see persistQuickEntryRequestorResolution).
   * Neither is fixable from inside this method: the first needs a contact this method cannot see, the
   * second needs an event this method cannot observe.
   *
   * Terminates: the observed id is recorded BEFORE the setState, so an unchanged value returns
   * early on the next componentDidUpdate pass.
   */
  private trackQuickEntryReleaseMethodProvenance = () => {
    if (!this.isQuickEntryEligible()) {
      return;
    }
    const transactionDetails = this.currentTransactionDetails();
    if (!transactionDetails) {
      return;
    }
    // Re-arm on a transaction switch HERE, not somewhere that happens to run first (Mike Hamilton,
    // PR !10233). The reset used to live in resyncQuickEntryReleaseMethodFromTransaction's switch
    // block, which runs AFTER this in componentDidUpdate - so on an A->B switch where both carry the
    // SAME release method id (Download, Mail: not rare) this compared B's value against A's
    // observation, matched, early-returned, and never re-stamped for B. It self-healed on the next
    // pass and failed safe only because the transaction-change reset also clears the state stamp.
    // That is the same shape of defect this whole change is about, so it does not get to stay
    // transient.
    if (this.quickEntryReleaseMethodProvenanceTxId !== (this.props.transactionId ?? null)) {
      this.quickEntryReleaseMethodProvenanceTxId = this.props.transactionId ?? null;
      this.quickEntryReleaseMethodObservedId = null;
    }
    // FIX 3 (same review): `?? null` against a field that also starts at null, so "no release method
    // observed yet" and "no release method present" are the same value and the early return below
    // means what its comment says. Initialising to undefined made the first pass always stamp.
    const observed = transactionDetails.releaseMethod?.id ?? null;
    if (observed === this.quickEntryReleaseMethodObservedId) {
      return;   // no change, so the stamp still describes the value on screen
    }
    this.recordQuickEntryReleaseMethodProvenance(transactionDetails.sendToContact?.id, observed);
  }

  /**
   * AB#38349 round 3: WRITE the provenance stamp - the one place that does.
   *
   * Extracted from trackQuickEntryReleaseMethodProvenance so a call site that KNOWS which contact
   * the server derived a value for can say so directly, instead of the tracker inferring it from
   * `transactionDetails.sendToContact`. That inference is only sound when the client's copy of the
   * link is already current, and on the create-contact paths it is not (see
   * adoptServerReleaseMethod's `derivedForContactId` parameter).
   *
   * Three writes, and all three are load-bearing together:
   *  - the STAMP itself, which isQuickEntryReleaseMethodStaleForContact compares against the row;
   *  - `quickEntryReleaseMethodObservedId`, so the tracker treats this value as already observed and
   *    early-returns instead of re-stamping it with whatever the link says by then. Recorded
   *    SYNCHRONOUSLY, before the setState, which is also what terminates the componentDidUpdate loop;
   *  - `quickEntryReleaseMethodProvenanceTxId`, because the tracker re-arms (clearing the observed id)
   *    whenever that field does not match the current transaction. Without it, an explicit record made
   *    before the tracker has ever run on this transaction would be undone on the tracker's next pass.
   */
  private recordQuickEntryReleaseMethodProvenance = (
    derivedForContactId: number | undefined,
    releaseMethodId: number | null,
  ) => {
    this.quickEntryReleaseMethodProvenanceTxId = this.props.transactionId ?? null;
    this.quickEntryReleaseMethodObservedId = releaseMethodId;
    this.setState({ quickEntryReleaseMethodDerivedForContactId: derivedForContactId });
  }

  /**
   * AB#35088 (QA retest finding 2): adopt a release method the server recomputed from the
   * requestor contact (add an email / remove the fax -> Download), which the once-per-field
   * seeder cannot. See computeQuickEntryReleaseMethodResync for the mechanism and the Classic
   * parity argument.
   *
   * The last-seen value is recorded on EVERY observation, including the ones that change nothing -
   * that is what makes "changed since last seen" mean what it says, and what terminates the
   * componentDidUpdate loop after an adopting setState.
   */
  private resyncQuickEntryReleaseMethodFromTransaction = () => {
    const transactionDetails = this.currentTransactionDetails();
    if (!transactionDetails) {
      return;
    }
    if (this.quickEntryReleaseMethodResyncTxId !== (this.props.transactionId ?? null)) {
      this.quickEntryReleaseMethodResyncTxId = this.props.transactionId ?? null;
      this.quickEntryLastSeenReleaseMethodId = undefined;
    }
    // AB#35088 (David Heifetz, PR !9947 thread 53167): compute from the updater's `prev`, NOT from
    // `this.state`. seedQuickEntryBillingDefaults runs immediately before this in the same
    // componentDidUpdate pass and has already QUEUED a setState; `this.state` still holds the
    // pre-seed object, so a payload delivering a first-time feeSchedule together with a changed
    // releaseMethod had this resync spread the STALE fields and DROP the seeder's feeScheduleId
    // write. Measured on the old form: state landed as {chargeForPostage, releaseMethodId} with no
    // feeScheduleId.
    //
    // Said precisely, because the obvious worse story is not what happens: the drop did NOT survive
    // as an end state. The commit that lands the clobbering write runs componentDidUpdate again, and
    // React invokes componentDidUpdate BEFORE the previous commit's setState callbacks - so the
    // seeder re-ran while feeScheduleId was still absent from its seeded set and re-seeded the
    // value. An end-state test is therefore vacuous and none is claimed (see the sibling test file).
    // The fix lands because that self-repair is an accident of React's intra-commit ordering rather
    // than a design, and for an Internal request the Fee Schedule dropdown is disabled, so there
    // would be no operator escape if it ever stopped holding.
    //
    // `lastSeen` is captured BEFORE the instance field is advanced, because the updater runs later.
    // The instance-field bookkeeping stays OUTSIDE the updater (PR !9605 MINOR-4: an updater that
    // mutates instance state is impure and breaks if React ever re-invokes it).
    const lastSeen = this.quickEntryLastSeenReleaseMethodId;
    const incoming = transactionDetails.releaseMethod?.id;
    if (incoming != null) {
      this.quickEntryLastSeenReleaseMethodId = incoming;
    }
    // Same setState as the adoption, so the pane can never see the new value without the bump
    // that authorizes it (and vice versa). Returning null when there is nothing to adopt is
    // React's own bail-out, so this stays a no-op render-wise and the componentDidUpdate loop
    // still terminates.
    this.setState(prev => {
      const next = computeQuickEntryReleaseMethodResync(
        transactionDetails, prev.quickEntryBillingFields, lastSeen);
      return next ? {
        quickEntryBillingFields: next,
        quickEntryReleaseMethodResyncSignal: prev.quickEntryReleaseMethodResyncSignal + 1,
        // AB#38349 (review round 5): the displayed value is the SERVER's again, so the staleness
        // suppression is back in scope. Same setState as the adoption, for the same reason the
        // signal bump is here - the pane can never see the new value without the flags that
        // describe it. Mirrors QuickEntryBillingPane's own reset on the resync signal.
        quickEntryReleaseMethodPickedByOperator: false,
        // NOT the provenance stamp. Adopting a server value does not change WHICH CONTACT that value
        // was derived for - trackQuickEntryReleaseMethodProvenance already recorded that when the
        // value was observed. Clearing it here (an editing slip in the first cut of this fix, caught
        // in review) wiped the stamp on every adoption, so the predicate fell back to "no provenance"
        // and the red assertion could return - defeating the fix on its own success path.
      } : null;
    });
  }

  /**
   * transactionDetails ONLY when it belongs to the CURRENT transactionId - the
   * getTransactionAttributes saga builds the id as `${facility.id}-${id}`
   * (DataEntryDetailsDucks.ts) and never clears transactionDetails on a switch, so
   * during an in-place transaction switch props.transactionDetails still holds the
   * PRIOR tx until the new fetch resolves. Every consumer that writes the shared
   * form or the persisted-link pre-resolve from transactionDetails must go through
   * this so it can't act on another transaction's data (AB#31605 review MAJOR-1).
   */
  private currentTransactionDetails = (): TransactionDetails | undefined => {
    // AB#39495: this IS the guard - the one read that must be raw.
    // eslint-disable-next-line no-restricted-syntax
    return transactionDetailsMatchesId(this.props.transactionDetails, this.props.transactionId)
      // AB#39495: the guard's own return, already identity-checked above.
      // eslint-disable-next-line no-restricted-syntax
      ? this.props.transactionDetails
      : undefined;
  }

  /**
   * Spec #35136 (F1f), FR-4: write a successful DDS barcode scan's fields into the
   * shared form. Mirrors DataEntryDetailsRightPaneRequestorSection.tsx:75-95
   * bit-for-bit - only fires when readBarCodeDDSAPIStatus is API_SUCCESS and the
   * parsed result reference actually changed (the redux effect's own trigger), and
   * writes each present field unconditionally (no "only if empty" guard, matching
   * Classic). SSN is only ever written as the 4-star display mask; the raw/encrypted
   * value is never surfaced (see .claude/rules/hipaa-compliance.md). No DDS value is
   * logged - only writeFieldToForm calls.
   */
  private populateQuickEntryDdsFromScan = (prevProps: Props) => {
    // R3 (review): this runs on every componentDidUpdate regardless of Classic vs
    // Quick Entry mode. That is intentional and harmless: in Classic mode
    // DataEntryDetailsRightPaneRequestorSection ALSO writes these same fields from
    // the same scan result, so the two writes are identical and idempotent (both
    // write the parsed DDS values into the one shared DATA_ENTRY_FIELDS_FORM, keyed
    // on the same API_SUCCESS + changed-reference trigger). No mode guard is added
    // deliberately - gating on mode here would risk missing the scan in an edge
    // ordering, and a duplicate identical write costs nothing.
    if (!this.props.dispatch
      || this.props.readBarCodeDDSAPIStatus !== API_SUCCESS
      || prevProps.transactionDDS === this.props.transactionDDS) {
      return;
    }
    // Spec #35136 (F1f) fix: mirrors the (now-narrowed) guard on
    // DataEntryDetailsRightPaneRequestorSection's scan-repopulate effect - skip
    // whenever No Barcode has been explicitly touched AT ALL (checked true, or
    // explicitly unchecked false; redux-form's real untouched value is "", not
    // undefined), not just checked. Without this, a transactionDDS reference
    // change (a genuine new scan, or a spurious reference change from an
    // unrelated dispatch) rewrites the six barcode fields + RQ Site Code even
    // after the specialist has explicitly interacted with the checkbox.
    const rawNoBarcode = this.props.formState?.values?.[RequestorFormConstants.NO_BARCODE];
    if (rawNoBarcode !== undefined && rawNoBarcode !== "") {
      return;
    }
    const dds = this.props.transactionDDS;
    if (!dds) {
      return;
    }
    const write = (field: string, value: any) => writeFieldToForm(this.props.dispatch!, field, value);
    if (dds.rqid) {
      write(RequestorFormConstants.RQID, dds.rqid);
    }
    if (dds.txSiteCode) {
      write(RequestorFormConstants.TX_SITE_CODE, dds.txSiteCode);
      write(RequestorFormConstants.RQ_SITE_CODE, dds.txSiteCode);
    }
    if (dds.docReturnCode) {
      write(RequestorFormConstants.DOC_RETURN_CODE, dds.docReturnCode);
    }
    if (dds.ssn) {
      write(RequestorFormConstants.SSN, '***-**-****');
    }
    if (dds.docType) {
      write(RequestorFormConstants.DOC_TYPE, dds.docType);
    }
    if (dds.routingField) {
      write(RequestorFormConstants.ROUTING_FIELD, dds.routingField);
    }
  }

  /**
   * Seeds AI-extracted scalar values into the shared Quick Entry form once per
   * Completed extraction, so the rows DISPLAY the extracted value and the
   * transaction's final Save persists it. Does not overwrite an existing/edited
   * value (seed guard is set even when the write is skipped, so a later user
   * clear is never re-seeded). Conceptually F1a/F1b QE pre-fill; wired here
   * where the shared form + requestAnalysis both live.
   */
  private seedExtractedQuickEntryFields = () => {
    // AB#35121 (review finding 2 on !9636): seed ONLY from an analysis that belongs to the
    // transaction on screen. Gating the re-arm above is not sufficient on its own - on a render
    // where the latch is already clear, a late-landing response for another transaction would
    // otherwise seed that patient's values straight into this form.
    const analysis = this.ownedRequestAnalysis();
    if (analysis?.status !== RequestAnalysisStatus.Completed) {
      return;
    }
    const data = analysis.data;
    const values = this.props.formState?.values ?? {};
    const seed = (field: string, aiValue: any) => {
      if (!aiValue || this.seededQeFields.has(field)) {
        return;
      }
      this.seededQeFields.add(field);
      if (!values[field] && this.props.dispatch) {
        writeFieldToForm(this.props.dispatch, field, aiValue);
      }
    };
    seed(FormConstants.CASE_NUMBER, data?.caseNumber);
    seed(FormConstants.AUTHORIZATION_DATE, data?.authorizationDate);
    seed(FormConstants.REQUEST_DATE, data?.requestDate);
    // AB#35137 / AB#35144: both are already parsed into the read model, so seed them exactly
    // like the sibling dates. No AI seed for Request ID - it is an operational identifier,
    // not a value read off the request document.
    seed(FormConstants.RECEIVED_DATE, data?.receivedDate);
    seed(FormConstants.DUE_DATE, data?.dueDate);
    // seedRequestTypePurpose seeds the resolved Request Type and — ONLY when the API resolved a valid
    // child purpose (data.requestPurposeMapped present) — the Purpose. In the AB#35098 amber
    // "purpose-uncertain" case requestPurposeMapped is absent, so Purpose stays unselected and the
    // amber prompt drives the specialist to pick one. (Superset of the feature's inlined seeds: our
    // helper adds the paired seed-guard + the doc-replace falsy-guard fixes, AB#35083/35085.)
    this.seedRequestTypePurpose(data);
    this.seedClinicFromName(data?.clinicName);
    this.seedExtractedServiceDate();
    this.seedExtractedRecordsRequested();
    this.seedExtractedSensitiveInfo(data);
    // AB#37984 (round-7 product decision): called AFTER the declaration seed so it runs LAST and
    // wins - Audit unconditionally authorizes all five, overwriting whatever the declaration seed
    // (or a specialist's own earlier answer) just wrote. No exceptions, matching Classic exactly.
    this.seedAuditSensitiveInfo();
  };

  /**
   * Seeds the Request Type/Purpose row from the AI extraction's mapped ids
   * (requestTypeMapped/requestPurposeMapped, the real dropdown ids), as a
   * consistent PAIR. This is what every other AI field already did but this row
   * never did, which caused three bugs:
   *  - AB#35083: clicking [Edit] opened dropdowns bound to an empty form value,
   *    resetting them to "- Select -" instead of the current AI value.
   *  - AB#35074: the mapper had no live form value to prefer, so a correction
   *    reverted to the AI text after Confirm (see mapRequestTypePurposeToFieldGroupRow).
   *  - AB#35085: Service Date/Records Requested/Sensitive Info are gated by
   *    isQuickEntryRowApplicable on a Purpose value that only ever existed in the
   *    persisted transaction or the live form - never seeded from AI - so they
   *    were permanently stuck at "Not applicable yet" for an AI-driven request.
   *
   * Purpose is seeded ONLY alongside a freshly-seeded Type (never onto a Type the
   * specialist already chose) so the pair can never desync. Form-only write,
   * exactly like the other seeds - no transactions/purpose round-trip here; that
   * still fires from onQuickEntryRequestPurposeChange when the specialist actually
   * changes Purpose (unchanged persistence behavior). Guarded once via
   * seededQeFields; never overwrites an existing/edited value (!= null guard).
   */
  private seedRequestTypePurpose = (data?: RequestAnalysisData) => {
    const typeField = FormConstants.REQUEST_TYPE;
    const purposeField = FormConstants.PURPOSE_TYPE;
    // AB#35083: the Type/Purpose pairing rule lives in resolveRequestTypePurposeSeed so it
    // has a runnable check (this method is private on a class component whose enzyme mount
    // suites don't execute on this toolchain). Behaviour is unchanged - it returns null with
    // no resolved type, and omits Purpose when the extraction didn't map one, which is the
    // AB#35098 amber "purpose-uncertain" state where the specialist must pick.
    // AB#35076: the catalog AND the purpose's grounding are passed so the seed can VALIDATE the ids
    // rather than trust them. Nothing upstream does - ROIS reads the ids off the intake record
    // verbatim, and a purpose reaching us at all means the extraction asserted a successful
    // resolution (the write path nulls the id when it reports RequestPurposeUnmapped). QA's three
    // cases each substituted a VALID child of the right type, and the extracted text is no help
    // either because the API reports the resolved name there. The grounding is the honest signal:
    // InferredNoSource says the extraction found no source for the value in the document.
    const seed = resolveRequestTypePurposeSeed(
      data?.requestTypeMapped, data?.requestPurposeMapped, this.props.requestTypes,
      this.ownedRequestAnalysis()?.confidence?.requestPurpose);
    if (!seed || this.seededQeFields.has(typeField)) {
      return;
    }
    // AB#35146 (David Heifetz, 2026-08-12): the SAVED Type/Purpose must win on EVERY load
    // path, not just the one where the transaction happened to load first.
    //
    // This method decides against a SNAPSHOT of formState.values and burns a one-shot
    // latch. When the analysis resolved BEFORE transactionDetails arrived (the
    // reload/refresh path), that snapshot was empty: the guard below saw no Type, wrote the
    // AI value, and burned the latch. transactionDetails then landed, rehydrate ran - and
    // computeQuickEntryRehydration's own falsy write-once guard saw the AI value already in
    // the field and skipped it. Same transaction, DB value on one load and the AI value on
    // the next.
    //
    // Deferring until an identity-matched transactionDetails exists is necessary but NOT
    // sufficient, and the first revision of this fix was wrong for exactly that reason (review:
    // John James, 2026-08-13; now pinned by the "last write" test in
    // DataEntryDetails.typePurposeLoadPrecedence.test.tsx, which failed with the AI type as the
    // last write). componentDidUpdate calls rehydrateQuickEntryFromTransaction() and
    // seedExtractedQuickEntryFields() back to back in ONE synchronous pass, and details arriving
    // is the same condition that unlatches rehydrate - so both run on that tick. Both read
    // this.props.formState.values, and rehydrate's writeFieldToForm is a synchronous dispatch that
    // updates the STORE only: React does not reassign props mid-lifecycle, so the seed still sees
    // the PRE-rehydrate snapshot, finds the field empty and writes the AI value LAST. Deferral
    // just relocated the collision into a single tick.
    //
    // So ask rehydrate what it ACTUALLY WROTE, via quickEntryRehydratedFields, which it records
    // synchronously as it dispatches. One writer reporting a fact, instead of two writers deriving
    // the same decision from different fields.
    //
    // A previous revision derived it instead - `details.requestPurpose?.typeID` - and was wrong for
    // a whole class of transactions. rehydrate writes REQUEST_TYPE from requestPurpose.typeID but
    // PURPOSE_TYPE from requestPurpose.id (quickEntryRehydration.ts:157-158), and typeID is
    // "@deprecated Not set by the API in all cases" (models/requestType.ts:21-24): GetTransaction
    // fills it only while the saved purpose is still in the org's catalog. So { id: 3004, typeID: 0 }
    // is reachable, that guard did not fire, rehydrate wrote the saved Purpose, and the seed - on the
    // same stale snapshot - overwrote it with the AI Purpose. AB#35146's exact symptom, surviving for
    // precisely the transactions whose saved purpose has dropped out of the catalog.
    //
    // Document REPLACE still re-seeds: quickEntryRehydratedFields is cleared on a changed
    // requestAnalysis (same cadence as seededQeFields), so after a replace this branch does not fire
    // and the fresh extraction wins over the still-persisted old value - AB#35083/35085. Pinned by
    // the "after a document REPLACE" test.
    //
    // This deliberately does NOT depend on React batching. An earlier revision inferred "rehydrate
    // has not latched yet" from state written via setState, which only worked because React 17
    // defers that commit past the sibling seed call in the same pass; a synchronous state write or a
    // React 18 concurrent flush would have silently inverted it. An instance field recorded at write
    // time carries the fact directly and has no such dependency.
    if (!this.currentTransactionDetails()) {
      return;
    }
    if (this.quickEntryRehydratedFields.has(typeField) || this.quickEntryRehydratedFields.has(purposeField)) {
      // Burn BOTH latches: the answer is final for this load, so a later pass must not re-ask - and
      // must never seed Purpose on its own against the saved Type.
      this.seededQeFields.add(typeField);
      this.seededQeFields.add(purposeField);
      return;
    }
    const aiType = seed.requestType;
    // Mark both seeded together so Purpose never seeds on a later pass against a
    // Type the specialist has since chosen.
    this.seededQeFields.add(typeField);
    this.seededQeFields.add(purposeField);
    const values = this.props.formState?.values ?? {};
    // Falsy guard (matching the scalar seed() helper), NOT `!= null`: on a document
    // REPLACE, clearQuickEntryDraftFields writes REQUEST_TYPE/PURPOSE_TYPE = ""
    // (empty string, not undefined), and `"" != null` is true - so a `!= null`
    // guard would treat the cleared field as "already set" and never re-seed the
    // NEW extraction's Type/Purpose, reintroducing 35083/35085 for the replaced
    // doc. "" / 0 (0 === DEFAULT_DROPDOWN_VALUE "- Select -") / undefined are all
    // "no real value yet"; a real specialist-picked id (>0) is truthy and preserved.
    if (values[typeField] || !this.props.dispatch) {
      return; // don't overwrite an existing/edited Type
    }
    writeFieldToForm(this.props.dispatch, typeField, aiType);
    const aiPurpose = seed.requestPurpose;
    if (aiPurpose && !values[purposeField]) {
      writeFieldToForm(this.props.dispatch, purposeField, aiPurpose);
      // AB#35085 / user report ("Records Requested only shows the default three on an
      // AI-driven request"): the applicable record-type set is server-computed PER
      // PURPOSE and only loads once the backend is told the purpose (POST
      // transactions/purpose -> getTransactionAttributes refreshes
      // transactionDetails.releaseInfo). A MANUAL purpose pick fires that via
      // onQuickEntryRequestPurposeChange; an AI-SEEDED purpose was a form-only write,
      // so the release list stayed frozen at the generic default set the transaction
      // loaded with. Fire the SAME round-trip for the AI purpose so Records populates
      // fully, and re-arm the records seed so the AI-selected records re-check against
      // the fuller, purpose-driven list once it arrives. Guarded once-per-extraction by
      // seededQeFields above, so this fires exactly once (no getTransactionAttributes
      // loop: the re-entry hits the seededQeFields.has(typeField) early-return).
      //
      // Not gated to "fresh extraction": on a REOPEN, rehydrateQuickEntryFromTransaction
      // fills REQUEST_TYPE from the persisted transaction in an earlier pass, so by the
      // time this seed runs values[typeField] is set and the `if (values[typeField])
      // return` guard above bails out BEFORE reaching here - the round-trip only fires
      // when the purpose is genuinely AI-seeded (i.e. a real fresh extraction), so no
      // extra gate is needed (and the earlier fresh-extraction-id gate was unreliable:
      // it never got set when the extraction was already in flight before mount).
      this.recordsRequestedSeeded = false;
      this.loadAiSeededPurposePreview(aiPurpose);
    }
  };

  /**
   * AB#35289 (AI-seeded purpose preview timing): load the purpose-driven Information-To-Release
   * preview for an AI-seeded purpose. onQuickEntryRequestPurposeChange EARLY-RETURNS when
   * transactionDetails is null, and seedRequestTypePurpose has already burned its one-shot latch,
   * so when the extraction resolves BEFORE transactionDetails loads the preview never ran and the
   * records-requested / doc-type list stayed empty until a manual re-pick. Fire it now if
   * transactionDetails is present; otherwise record the purpose so componentDidUpdate fires it once
   * transactionDetails arrives. The preview is READ-ONLY (GET informationToRelease, no
   * transactions/purpose write), so deferring/retrying is safe and does not touch deferred-persist.
   */
  private loadAiSeededPurposePreview = (aiPurpose: number) => {
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    if (this.props.transactionDetails) {
      this.quickEntryAiPurposePreviewPending = null;
      this.onQuickEntryRequestPurposeChange(aiPurpose);
    } else {
      this.quickEntryAiPurposePreviewPending = aiPurpose;
    }
  };

  /**
   * Seeds the Clinic/Department row from the AI-extracted clinic NAME: resolves
   * the name to a clinic ID against discloseInstitutions (the form field holds an
   * id, not a name), then writes that id. Waits for the clinic list to load
   * before marking seeded, so an extraction that completes before the list is
   * fetched still seeds once the list arrives. No match (name not in the list) ->
   * left blank for manual entry.
   *
   * AB#35070: the id written is the institution's real `.id`, never its array index -
   * so seed, manual pick, display (find-by-id) and persistence (clinicdepartmentid)
   * all agree.
   */
  private seedClinicFromName = (clinicName?: string) => {
    const field = FormConstants.CLINIC_RESPONISBLE;
    if (!clinicName || this.seededQeFields.has(field)) {
      return;
    }
    // AB#35083: "not loaded yet" and "loaded, but this clinic isn't in the list" are
    // different answers and must be handled differently - the first is transient and has
    // to be retried, the second is final. This used to guard on `if (!di) return`, but
    // discloseInstitutions initialises to [] and an empty ARRAY IS TRUTHY, so an
    // extraction that beat the clinic-list fetch read as "loaded, no match": it burned
    // the one-shot seed against an empty list and every later retry short-circuited on
    // seededQeFields. The clinic never reached the form, so the row still showed the AI's
    // text (it reads requestAnalysis.data directly) while [Edit] opened the dropdown -
    // which binds to the form - on "- Select -".
    const target = resolveClinicSeedTarget(clinicName, this.props.discloseInstitutions);
    if (target.status === "notLoaded") {
      return; // clinic list not fetched yet - leave the seed unset and retry on a later update
    }
    // Loaded, so whatever we decide now is final: mark seeded even on noMatch, or we would
    // re-run this lookup on every subsequent update forever for a clinic that isn't listed.
    this.seededQeFields.add(field);
    const values = this.props.formState?.values ?? {};
    // Falsy guard, NOT `!= null` (see seedRequestTypePurpose): a document REPLACE
    // clears CLINIC_RESPONISBLE to "" via clearQuickEntryDraftFields, and `"" != null`
    // would block re-seeding the new extraction's clinic. "" / 0 / undefined are all
    // "no clinic yet"; a real clinic id (>0) is preserved.
    if (values[field] || !this.props.dispatch) {
      return;
    }
    if (target.status === "matched") {
      writeFieldToForm(this.props.dispatch, field, target.id);
    }
  };

  /**
   * Seeds the Quick Entry Service Date (From/To) rows from the AI extraction.
   * requestAnalysis.data.serviceDates carries the extraction's 3 From/To sets in
   * order, already filtered so empty pairs are dropped - so the first element
   * with BOTH ends is "set 1 if present, else set 2, else set 3". Writes through
   * the same persist path as a manual edit (buildReleaseInfoWithDateRange ->
   * persistQuickEntryReleaseInfo), waits for releaseInfo to load, seeds once, and
   * never overwrites an existing/edited range.
   */
  private seedExtractedServiceDate = () => {
    const field = "quickEntryServiceDate";
    if (this.seededQeFields.has(field)) {
      return;
    }
    const range = (this.props.requestAnalysis?.data?.serviceDates ?? []).find(d => d.from && d.to);
    if (!range) {
      return; // nothing extracted (leave unmarked so a replaced extraction can seed)
    }
    const releaseInfo = this.getQuickEntryReleaseInfo();
    if (releaseInfo.length === 0) {
      return; // wait until releaseInfo (the write target) loads - retry on a later update
    }
    this.seededQeFields.add(field);
    const current = this.getQuickEntryServiceDateRange();
    if (current.from || current.to || current.allDates) {
      return; // don't overwrite a user edit or an already-saved range
    }
    // AB#37853: coerce ONCE here, and use the coerced values for BOTH writes below.
    //
    // requestAnalysis is redux-PERSISTED and redux-persist JSON-round-trips the store, so on
    // rehydrate every Date in it comes back as an ISO STRING (see coerceDate's own doc comment).
    // Handing those straight on meant formatServiceDate called .toLocaleDateString on a string and
    // threw - crashing the QE rows on refresh.
    //
    // The persist write matters more than the display write: buildReleaseInfoWithDateRange feeds
    // releaseInfo, which is itself persisted, so raw strings could reach the SAVED record and not
    // just the screen. Both writes take the coerced values.
    const seededFrom = coerceDate(range.from);
    const seededTo = coerceDate(range.to);
    this.setState({ quickEntryServiceDateOverride: { from: seededFrom, to: seededTo, allDates: false } });
    this.persistQuickEntryReleaseInfo(buildReleaseInfoWithDateRange(releaseInfo, seededFrom, seededTo, false));
  };

  /**
   * Auto-checks the Records Requested items matching the AI-extracted info-release
   * selections. The extraction vocabulary is a CLOSED set - "Clinical", "Billing",
   * "Other" (Intake API PromptV7): Clinical/Billing map to the release item whose
   * name contains that word; "Other" maps to the id-31 free-text item. Waits for
   * the items to load (they only appear after Request Type & Purpose is chosen),
   * seeds once, and never overrides an existing selection. Persists via the same
   * path as a manual toggle - so with no service-date range yet it shows checked
   * locally and saves once dates exist (matches manual behavior).
   */
  private seedExtractedRecordsRequested = () => {
    if (this.recordsRequestedSeeded) {
      return;
    }
    const sections = this.props.requestAnalysis?.data?.infoReleaseSections ?? [];
    if (sections.length === 0) {
      return; // nothing extracted (leave unmarked so a replaced extraction can seed)
    }
    const releaseInfo = this.getQuickEntryReleaseInfo();
    if (releaseInfo.length === 0) {
      return; // items not loaded yet (appear after type/purpose) - retry on a later update
    }
    this.recordsRequestedSeeded = true;
    if (releaseInfo.some(item => item.checked)) {
      return; // respect an existing/edited selection
    }
    // Closed-vocabulary -> release-item-id mapping, shared with AB#35066's
    // isRecordsRequestedDocSourced (the grounding icon's "still exactly the AI
    // selection?" check) so the seed and that check can never drift apart.
    const matched = matchAiReleaseItemIds(sections, releaseInfo);
    if (matched.size === 0) {
      return;
    }
    const updated = releaseInfo.map(item => (matched.has(item.id) ? { ...item, checked: true } : item));
    this.persistQuickEntryReleaseInfo(updated);
  };

  /**
   * AB#37856: pre-authorizes the Sensitive Information categories the AI extraction
   * declared (requestAnalysis.data.sensitiveInfoDeclarations). Mirrors
   * seedExtractedRecordsRequested above piece for piece - once-only latch, return early
   * until the item list has loaded, never override an existing selection - because the two
   * fields are already symmetric on wire shape, parsing, effective-value getter, local
   * override state and deferred-to-Confirm-All persistence. Before this the value arrived
   * in the SPA and dead-ended: a document declaring HIV/AIDS or Mental Health rendered as
   * though nothing had been found, and the specialist re-read the document to re-derive
   * what the extraction already had.
   *
   * WRITES `quickEntrySensitiveInfo` STATE DIRECTLY, and must NEVER route through
   * SensitiveInfoField's applySensitiveInfoUpdate. Since 2026-08-12 the seed writes the same
   * fully-answered array that path's buildUpdatedSensitiveInfo would produce, so the reason is
   * no longer the STATES it computes - it is everything else that path does: it dispatches the
   * DISCLOSE_ALL / DONT_DISCLOSE_ANY form writes and the real persist, and it produces a row
   * indistinguishable from one a specialist filled in. Writing state directly keeps the seed a
   * PROPOSAL - local only, no dispatch, and paired with onEditQuickEntryRow below so the row
   * stays open for review until a human Confirms it. buildSensitiveInfoRevertPayload's own doc
   * comment documents the related pitfall for the revert path. The real save is Confirm All's
   * (persistQuickEntrySelectionsToTransaction).
   */
  private seedExtractedSensitiveInfo = (data?: RequestAnalysisData) => {
    if (this.sensitiveInfoSeeded) {
      return;
    }
    // AB#37856 (round-1 review S4): `data` is threaded in from the caller's
    // ownedRequestAnalysis() rather than re-read off this.props.requestAnalysis, so the
    // AB#35121 guarantee (never seed from an analysis belonging to another transaction) is
    // LOCAL to this method instead of resting on the caller happening to have gated first.
    // Same values today; the difference is that a future second call site cannot get it wrong.
    const declarations = data?.sensitiveInfoDeclarations ?? [];
    if (declarations.length === 0) {
      // Empty/absent declarations mean "not asserted", NEVER an authoritative "no
      // sensitive information" (Intake API security review, wave-35348-security.md:68) -
      // so write no state at all and leave the row requiring positive specialist
      // confirmation. Unmarked, so a replaced extraction can still seed.
      return;
    }
    // AB#37984 (round-15): mid transaction-switch, transactionDetails can briefly still be the
    // OUTGOING transaction's. Unguarded, this seed would write that stale record into
    // quickEntrySensitiveInfo as if it belonged to the incoming transaction, which falsifies
    // seedAuditSensitiveInfo's own "nothing session-local has touched it" signal below. Same fix as
    // that method's transactionDetailsMatchesId guard - checked before isQuickEntryRowApplicable,
    // which also reads raw transactionDetails and would otherwise stay open through the same window.
    // AB#39495: passed to transactionDetailsMatchesId - this is the identity check itself.
    // eslint-disable-next-line no-restricted-syntax
    if (!transactionDetailsMatchesId(this.props.transactionDetails, this.props.transactionId)) {
      return; // details belong to another transaction - cannot seed yet, latch stays armed
    }
    // No seed while the row isn't applicable - no resolved Purpose yet, or a Disclosure
    // Accounting (66) transaction that hides the row entirely. Checked BEFORE the latch is
    // burned so a missing Purpose only defers the seed; it fires once Purpose resolves.
    if (!this.isQuickEntryRowApplicable(SENSITIVE_INFO_ROW_ID)) {
      return;
    }
    const sensitiveInfo = this.getQuickEntrySensitiveInfo();
    if (sensitiveInfo.length === 0) {
      return; // questionnaire not loaded yet (it IS the write target) - retry on a later update
    }
    this.sensitiveInfoSeeded = true;
    if (sensitiveInfo.some(item => item.stateID !== SensitiveInfoRelease.NotMentioned)) {
      return; // a reopened/edited transaction's existing answers are never overridden
    }
    // Closed-vocabulary -> SensitiveInfoType-id mapping, shared with
    // isSensitiveInfoDocSourced (the status badge's "still exactly the AI selection?"
    // check) so the seed and that check can never drift apart.
    const matched = matchAiSensitiveInfoIds(declarations, sensitiveInfo);
    if (matched.size === 0) {
      return; // e.g. a "Disclosed"-only extraction: no category named, nothing to check
    }
    // AB#37856 (developer decision 2026-08-12): a declaring extraction answers the WHOLE
    // questionnaire - matched categories Authorized, every other category Prohibited - so the
    // specialist REVIEWS a filled-in list instead of clicking through the undeclared ones. The
    // earlier design wrote only the Authorized half and left the rest NotMentioned, which made
    // the row unconfirmable until the specialist answered the remainder by hand.
    //
    // Pre-filled is NOT the same as confirmed, and the difference is the whole safety argument:
    // these five answers are the AI's, so the row opens for review rather than landing Confirmed.
    // The two "not asserted" cases above are deliberately NOT swept into this - empty declarations
    // and a category-less "Disclosed" still seed nothing at all. Absent stays absent; only a
    // POSITIVE declaration answers the questionnaire.
    //
    // AB#37984 (round-7 product decision): this write is NOT final for an Audit request - Classic
    // authorizes every category the instant Request Type is Audit, no exceptions, so
    // seedAuditSensitiveInfo (called right after this method returns) unconditionally overwrites
    // whatever this seed just proposed once it sees Request Type = Audit. Nothing here needs to
    // know that in advance; it stays a normal, order-independent proposal.
    this.setState({
      quickEntrySensitiveInfo: sensitiveInfo.map(item => ({
        ...item,
        stateID: matched.has(item.id) ? SensitiveInfoRelease.Authorized : SensitiveInfoRelease.Prohibited,
      })),
    });
    // AB#35073's editing-set downgrade is exactly the state this row needs, so it is reused rather
    // than re-invented: getQuickEntryRows reports status NeedsEntry with isCompleteWhileEditing,
    // which (a) keeps the row counting as outstanding so Confirm All stays blocked until a human
    // accepts it, (b) leaves the row's OWN Confirm button enabled - isFieldGroupRowConfirmDisabled
    // exempts complete-while-editing rows - so one click accepts all five, and (c) renders the
    // checklist open, which is what "for review" means on screen. The specialist's Confirm exits
    // the set via onQuickEntryFieldConfirmed, and only then does the row read Confirmed and the
    // viewer's redaction gate open (see authorizedEntities in render).
    //
    // Called AFTER the write above, not merged into it, so the Cancel snapshot captures the seeded
    // values rather than the empty questionnaire they replaced.
    this.onEditQuickEntryRow(SENSITIVE_INFO_ROW_ID);
  };

  /**
   * AB#37984: Classic authorizes every Sensitive Information category, no exceptions, the instant
   * Request Type is Audit - `DataEntryDetailsRightPane.tsx`'s `onChangeRequestType`, on
   * `newType == AUDIT`, unconditionally maps all five to `checked: true` and persists, regardless
   * of any document declaration, any existing answer, or Purpose. This is Quick Entry's port of
   * that rule, and it is deliberately just as unconditional. The decision itself is a pure
   * function (auditSensitiveInfoDefaults.ts); this method is the wiring.
   *
   * Two call sites, both below: the AI-extraction arrival path (`seedExtractedQuickEntryFields`,
   * unforced - Quick Entry's type usually arrives from AI extraction rather than a dropdown
   * change, so it needs its own trigger) and the Request Type dropdown's own `onRequestTypeChange`
   * (forced - see `force` below). There is deliberately no Purpose-change call site: Classic's
   * cascade never reads `requestPurpose`, so neither does this, and a version of this method
   * that DID gate on a resolved Purpose caused a real bug - see the ADO history on AB#37984 for
   * the incident (declaration-seed race, repeat-switch, and the borrowed-visibility-gate misfire)
   * if you need the full blow-by-blow; the properties that came out of it are pinned below.
   *
   * `force`: Classic's cascade has no memory of having run before - a real dropdown change to
   * Audit re-authorizes all five even on the second or third time on the same transaction. The
   * `auditSensitiveInfoSeeded` latch exists so the AI-extraction path only seeds once and
   * retries-until-applicable rather than re-clobbering on every unrelated render; `force: true`
   * (passed only by the dropdown call site) bypasses that latch to model an actual change event.
   *
   * No Purpose gate: this used to also require `isQuickEntryRowApplicable` (a resolved Purpose) -
   * borrowed from the sibling AI declaration seed, itself Quick Entry's port of Classic's
   * `isVisibleSensitiveInfoToRelease`, a SECTION VISIBILITY check. Classic's write path is not
   * gated by that check; only the section's rendering is. Conflating them here meant `onChangeType`
   * resetting the live Purpose to 0 on every Type change (not just the first) could silently
   * suppress a re-authorization. Removing the gate is safe because every consumer of
   * `quickEntrySensitiveInfo` independently re-checks applicability (or the separate
   * editing-set/PHI-redaction gate) before doing anything visible, persisted, or unredacted with
   * it: `getQuickEntryRows`' `EmptyNotRequired` override, `persistQuickEntrySelectionsToTransaction`'s
   * own `isQuickEntryRowApplicable` check, and the `authorizedEntities` redaction gate's
   * `quickEntryEditingRowIds` check. A write while inapplicable is dormant until the row becomes
   * applicable again, then reads back correctly as pre-filled-and-open-for-review.
   *
   * AB#37984 (round-11/12, PR review - Nelson Omuto, John James, and an independent reviewer agent
   * all converged on this independently): a plain reopen of an ALREADY-Audit transaction is NOT
   * the same event as a fresh AI classification, even though both arrive through the unforced
   * AI-extraction-arrival path with `requestAnalysis.status === Completed` - "load the prior
   * analysis" (getIntakeIntelligence, fired on every mount that has a request document) and "a
   * document was just extracted" are indistinguishable by status alone. Precedence rule 3
   * (rehydrateQuickEntryFromTransaction's own docblock) says the SAVED value must win over a
   * re-fetched prior analysis on a plain reopen - and before this, nothing enforced that rule for
   * Sensitive Info specifically, so reopening an Audit transaction with deliberately-Prohibited
   * saved answers silently proposed all five Authorized on mount, no dropdown or Purpose
   * interaction required.
   *
   * TWO rejected fixes, both suggested independently and both wrong for the same class of reason -
   * worth recording so neither gets tried a third time:
   *
   * 1. `quickEntryRehydratedFields.has(REQUEST_TYPE)` (the signal seedRequestTypePurpose uses for
   *    the same problem). Wrong: the analysis-arrival reset block a few lines above this method's
   *    call site (componentDidUpdate, `prevProps.requestAnalysis !== this.props.requestAnalysis`)
   *    clears that set the instant the re-fetched prior analysis actually lands, and it clears it
   *    BEFORE rehydrate/this method run in the same pass. On the ordinary "open a saved Audit
   *    transaction from the queue" sequence - details land and rehydrate records the signal on one
   *    pass; the analysis GET resolves on a LATER pass and wipes the signal it just recorded before
   *    this method ever reads it. `seedRequestTypePurpose` survives the same reset only because it
   *    has a SECOND, independent guard (the plain `values[typeField]` falsy check) that does not
   *    depend on the set at all; this method had no equivalent.
   * 2. `quickEntryFreshExtractionTransactionId` (only set inside the genuine
   *    fresh-extraction/document-replace block, gated on `requestIntakeIntelligenceStatus` flipping
   *    to FETCHING - i.e. "was a NEW extraction witnessed this session"). Also wrong, for the
   *    opposite reason: that flag is set ONLY by `autoExtractOnRequestUpload`, fired from the
   *    document-ATTACH saga - a live upload action taken WHILE Quick Entry is open. In this
   *    workflow a document's extraction is normally produced by the separate Intake API pipeline
   *    well before a specialist ever opens the transaction; the ordinary queue-based flow (which is
   *    also the ORIGINAL bug's own repro) never witnesses a live upload/extraction transition at
   *    all. Gating on this signal would have silently reintroduced the QA-reported bug for the
   *    common case, not just failed to fix Nelson's.
   *
   * The signal that actually works does not try to infer WHEN or HOW the Completed status arrived
   * at all - both rejected attempts failed because they were timing/event signals, and timing is
   * exactly what varies unpredictably in production. Instead: has anything SESSION-LOCAL touched
   * Sensitive Info yet, and if not, what does the RAW PERSISTED record say right now.
   * `state.quickEntrySensitiveInfo` starts `null` and is populated by the first thing that seeds or
   * edits it (the AI declaration seed, a specialist's edit, or this method itself) - `== null` means
   * nothing session-local has happened. In that state, `currentTransactionDetails()?.sensitiveInfo`
   * (read directly, NOT through getQuickEntrySensitiveInfo, specifically to see the raw persisted
   * value rather than any override) is the true prior-session baseline: if it already holds a real
   * answer, Precedence rule 3 wins and this stands down; a genuinely untouched (all NotMentioned)
   * baseline lets it through unconditionally, matching the original QA repro exactly, independent of
   * whether the Completed status arrived via a live extraction or a reopen's re-fetch. A document
   * replace still re-seeds: componentDidUpdate's clearedSensitiveInfo block writes a REAL
   * (non-null) all-NotMentioned override into quickEntrySensitiveInfo before this runs, so `== null`
   * is false and this check never engages. The round-7 declaration-seed override also makes
   * quickEntrySensitiveInfo non-null before this runs, so Audit still overrides it - "no exceptions"
   * holds for anything that happened this session, up until this method first stands down (see
   * round-13 below). The forced (dropdown) path is UNAFFECTED by any of this: a specialist's real,
   * explicit pick of Audit always wins regardless of what was previously saved.
   *
   * AB#37984 (round-13, PR review): two follow-on bugs, both fixed below.
   * 1. The stand-down branch used to return without burning the latch, so a later session-local
   *    edit (the specialist ticking one box) re-armed it and re-clobbered. Fixed by burning the
   *    latch the moment stand-down is decided, not only when a proposal is written.
   * 2. During a transaction switch, `transactionDetails` can briefly still belong to the OUTGOING
   *    transaction while `transactionId` has already flipped. Left unguarded, that stale record
   *    could either get read as a real answer and wedge the latch off for the incoming transaction
   *    permanently, or (if untouched) get authorized onto the incoming transaction by mistake -
   *    the same cross-transaction clobber this fix exists to prevent, roles reversed. Fixed by the
   *    `transactionDetailsMatchesId` check below, which is `!force`-gated so an explicit dropdown
   *    pick is never suppressed by it.
   */
  private seedAuditSensitiveInfo = (force: boolean = false) => {
    if (this.auditSensitiveInfoSeeded && !force) {
      return;
    }
    // AB#39495: passed to transactionDetailsMatchesId - this is the identity check itself.
    // eslint-disable-next-line no-restricted-syntax
    if (!force && !transactionDetailsMatchesId(this.props.transactionDetails, this.props.transactionId)) {
      return; // transactionDetails belongs to another transaction - cannot decide yet, latch stays armed
    }
    if (!force
      && this.state.quickEntrySensitiveInfo == null
      && (this.currentTransactionDetails()?.sensitiveInfo ?? []).some(item => item.stateID !== SensitiveInfoRelease.NotMentioned)) {
      this.auditSensitiveInfoSeeded = true; // decided (stand down) - stays decided until a reset point re-arms it
      return; // nothing session-local has touched it yet, and the persisted baseline already has a real answer
    }
    // AB#37984 (round-7 product decision) x AB#39495. These two rules collide here, and the
    // resolution is deliberate: the FORCED path reads the questionnaire RAW.
    //
    // AB#37984 requires an explicit Audit pick to authorize all five categories immediately,
    // "no exceptions" - Classic does, and the forced path skips every identity guard above for
    // exactly that reason. AB#39495 guarded getQuickEntrySensitiveInfo(), which returns [] during
    // a stale-details window; computeAuditSensitiveInfoDefaults treats [] as "questionnaire not
    // loaded yet" and returns null, so routing the forced path through the guarded accessor
    // silently cancelled the specialist's explicit pick.
    //
    // Raw is correct here and is NOT a regression of AB#39495, on three counts:
    //   1. Reachable only by an explicit specialist action (the Request Type dropdown) against the
    //      transaction currently identified by props.transactionId - never from a render or an
    //      async arrival, which is where the stale-window bug lives.
    //   2. The list is used purely as a SHAPE TEMPLATE, and the shape is global, not per
    //      transaction or per facility. SensitiveInfoType (models/transaction.ts) is a closed enum
    //      of exactly five categories; there is no per-facility sensitive-category endpoint; and
    //      SensitiveInfoRelease.NotMentioned only means anything if unanswered categories are
    //      PRESENT in the list, which the saveSensitiveInfo reducer relies on - it merges by id
    //      and never adds or removes entries. So every transaction carries the same five.
    //   3. computeAuditSensitiveInfoDefaults overwrites every stateID with Authorized, so only
    //      ids and names are inherited - none of the outgoing transaction's ANSWERS can survive.
    // The unforced path keeps the guard; do not collapse these two branches.
    // eslint-disable-next-line no-restricted-syntax
    const questionnaire = force ? this.props.transactionDetails?.sensitiveInfo ?? [] : this.getQuickEntrySensitiveInfo();
    const proposed = computeAuditSensitiveInfoDefaults(
      (this.props.formState?.values ?? {})[FormConstants.REQUEST_TYPE],
      questionnaire,
    );
    if (proposed === null) {
      return; // not Audit, or the questionnaire has not loaded yet - latch stays unburned
    }
    this.auditSensitiveInfoSeeded = true;
    this.setState({ quickEntrySensitiveInfo: proposed });
    // Pre-filled is not confirmed, exactly as for the AI declaration seed above: the editing-set
    // downgrade keeps the row outstanding so Confirm All stays blocked until a human accepts it,
    // while leaving the row's own Confirm enabled so one click accepts all five. Called after the
    // write so the Cancel snapshot captures the seeded values - including, on a FORCED re-seed
    // after an unconfirmed hand-edit, the seed's values rather than that edit: onEditQuickEntryRow
    // preserves an existing snapshot instead of overwriting it, so Cancel after
    // pick-Audit -> hand-edit -> switch-away -> switch-back (no Confirm in between) restores the
    // FIRST seed's all-Authorized array, not the hand-edit and not the pre-Audit persisted values.
    this.onEditQuickEntryRow(SENSITIVE_INFO_ROW_ID);
  };

  requestorToast = () =>{
    toast("Requestor verification email has been sent", {id: "reqPopUp", duration: 5000})
    this.props.requestorVerificationEmailSentReset()

  }

  setIsEscalated = (state) => {
    this.props.updateBillingPaneFields && this.props.updateBillingPaneFields(
      {
        transactionId: this.props.transactionId,
        patientDataid: this.props.patientDetails?.id,
        userID: global.userID,
        isEscalated: state
      });
  }

  userHasMadeChanged = () => {this.setState({ hasUserMadeAnyChanges: true })}



















































  /**
   * AC1/AC2/AC3 (revised, AB#34098 - dev direction after manual testing):
   * Quick Entry is the DEFAULT for any eligible transaction, not a
   * Completed-status-only special case. Classic Mode is a deliberate,
   * rare opt-out (matching master-demo-v6's own framing - an explicit
   * "Switch to Classic Mode" button, not a routing fallback) - it must
   * show only when the user (or a genuine failure path, once F1d #34102
   * builds one) explicitly requests it, never just because extraction
   * hasn't finished yet. Eligibility is therefore just the three flags:
   * IntakeIntelligence (AI extraction capability on), the per-facility DB
   * toggle (facilityConfiguration.intakeIntelligenceEnabled - the SAME
   * gate DataEntryDetailsBody.tsx checks for the classic Extract button),
   * and the SEPARATE QuickEntry flag (gates the new UI itself, decoupled
   * from AI-extraction rollout). RequestAnalysis.status is NOT part of
   * this gate anymore - getQuickEntryRows()/mapRequestTypePurposeToFieldGroupRow
   * already degrade gracefully to NeedsEntry when there's no analysis data
   * yet, so Quick Entry's shell renders correctly regardless of extraction
   * status; showing Failed/RetryExceeded/InProgress states visually inside
   * the row list is F1b-rois's (#34100) confidence-state domain.
   */
  /**
   * Bug fix (Spec #34102 / F1d, direct product confirmation 2026-07-17):
   * only a transaction opened from the Data Entry queue is Quick-Entry-
   * eligible - Record Attachment/Record Validation/User Tasks/QA Review/
   * Facility Action Required all open in Classic Mode as normal, since
   * only Classic Mode's 4-tab layout has the Record Attachment tab those
   * later stages need. requestContext (state.landingPageState.requestContext,
   * set by Facility.tsx's/HealthOrgFacilityDetails.tsx's per-queue-column
   * click handlers) is how the home page tells this component which queue
   * a transaction was opened from: 2 = Data Entry, 3 = Record Attachment,
   * 4 = Record Validation, 5 = User Tasks, 6 = QA Review, 7 = Facility
   * Action Required, 8 = "Get Next QA Transaction" (header). 1 is the
   * default/reset value (LandingPageDucks.ts's initial state and
   * resetRequestContext()) - New Request never sets requestContext at all,
   * so it stays on this default, which must remain Quick-Entry-eligible
   * alongside 2 (both represent "this transaction is in the Data Entry
   * stage"). Every other value forces Classic Mode.
   */
  /** Inputs for the (pure, unit-tested) intake-fetch gate in intakeFetchGate.ts. */
  private intakeFetchGateInputs = (): IntakeFetchGateInputs => ({
    intakeIntelligenceEnabled: Boolean(this.props.featureFlags.IntakeIntelligence),
    hasUser: Boolean(global.userID),
    transactionId: this.props.transactionId,
    documentsLoaded: this.props.getTransactionDocumentsAPIStatus === API_SUCCESS,
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    transactionStatusId: this.props.transactionDetails?.transactionStatus?.id,
    documents: this.props.documentsList,
  })

  /**
   * AB#38014: delegates to the pure, unit-tested isQuickEntryEligibleFromInputs
   * (quickEntryEligibility.ts) - the SAME function uploadMultipleDocumentsSaga
   * re-reads live via select() at upload-completion time, so there is exactly
   * one implementation of the eligibility rule shared between render-time and
   * upload-completion-time checks.
   */
  isQuickEntryEligible = (): boolean => {
    return isQuickEntryEligibleFromInputs({
      intakeIntelligenceFlagEnabled: Boolean(this.props.featureFlags?.IntakeIntelligence),
      facilityIntakeIntelligenceEnabled: Boolean(this.props.facilityConfiguration?.intakeIntelligenceEnabled),
      quickEntryFlagEnabled: Boolean(this.props.featureFlags?.QuickEntry),
      classicModeOverride: Boolean(this.props.classicModeOverride),
      requestContext: this.props.requestContext,
      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
      // eslint-disable-next-line no-restricted-syntax
      transactionStatusId: this.props.transactionDetails?.transactionStatus?.id,
    });
  }

  /**
   * Only the Request Type/Purpose row is wired end-to-end in this Spec
   * (#34098 / F1a) - sibling Specs (F1b-rois #34100, F1c #34101, F3 #34099)
   * add their own rows against the FieldGroupRow contract in models/intake.ts.
   */
  /**
   * Row order mirrors master-demo-v6.html's own numbered sequence: Request
   * Type & Purpose, Service Date-From, Service Date-To, Records Requested,
   * Authorization Date, Request Date, Case Number, Clinic/Facility,
   * Sensitive Information. (Patient Info / Requestor Info / Provider-
   * Facility, the mockup's remaining 3 rows, are sibling-spec scope -
   * F1b-rois #34100 / F1c #34101 - not this Spec's contract.)
   */
  /**
   * Whether a row's prerequisite is currently satisfied. Direct user
   * feedback: the mockup's badge numbers are FIXED (never renumber based on
   * data state) - a row whose prerequisite isn't met yet stays in its fixed
   * slot, just non-interactive, rather than disappearing and shifting every
   * other row's number. getQuickEntryRows forces status to
   * EmptyNotRequired (tier 2 - excluded from outstanding/attention) for any
   * row this returns false for; renderQuickEntryRowContent renders it as a
   * disabled placeholder instead of the live control or Edit affordance.
   */
  isQuickEntryRowApplicable = (rowId: string): boolean => {
    const values = this.props.formState?.values ?? {};
    const requestType = values[FormConstants.REQUEST_TYPE];
    const requestPurpose = values[FormConstants.PURPOSE_TYPE];
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const facility = this.props.transactionDetails?.facility;

    switch (rowId) {
      case PATIENT_INFO_ROW_ID:
      case REQUESTOR_INFO_ROW_ID:
        // Patient/Requestor are MANDATORY rows that ALWAYS render (like Classic
        // Mode, where they always show) - they are never "not applicable yet".
        // Even when intake extraction hasn't loaded (no requestAnalysis.data),
        // the row must stay interactive so the specialist can search/create
        // manually - the row's awaitingDocument state now offers the inline
        // search (PatientInfoRow/RequestorInfoRow). Coalesce 2026-07-20: was
        // Boolean(requestAnalysis?.data), which turned a mandatory field into a
        // dead non-interactive placeholder whenever intake wasn't loaded.
        return true;
      case AUTHORIZATION_DATE_ROW_ID:
      case REQUEST_DATE_ROW_ID:
        // Mirrors the classic pane's own requestType != DISCLOSURE_ACCOUNTING gate.
        // Spec #35135 preserves this as-is (AC6, existing behavior) - the new
        // hiding work is the Service Date / Records / Sensitive Info trio below,
        // which already carried the same clause.
        return requestType !== DISCLOSURE_ACCOUNTING;
      // AB#35144: Classic hides Due Date for DISCLOSURE_ACCOUNTING (same gate as the two dates
      // above) and renders Request ID only when the facility opts in. Received Date needs no case -
      // Classic always renders it, so it falls through to `default: return true`.
      case DUE_DATE_ROW_ID:
        return requestType !== DISCLOSURE_ACCOUNTING;
      case REQUEST_ID_ROW_ID:
        return Boolean(facility?.useRequestID);
      case DISCLOSURE_INFO_ROW_ID:
        // Spec #35135 (AC1/AC2): the mirror image of the gates above - the
        // Disclosure Information composite row exists ONLY for request type 66.
        return requestType === DISCLOSURE_ACCOUNTING;
      case CLINIC_RESPONSIBLE_ROW_ID:
        return Boolean(facility?.useClinics || facility?.useDepartments);
      case PROVIDER_FACILITY_ROW_ID:
        // AB#38597: hidden again for now. AB#38161 made this row ALWAYS applicable (see history) so
        // it could show a "No provider specified" state ahead of Feature 3's extraction/persistence
        // work, which is still not wired up on this branch.
        //
        // UNRESOLVED, and the reason this is one line rather than a deletion: that "always
        // applicable" behaviour is Spec #34099 AC11, which that Spec calls a FEATURE 1 acceptance
        // criterion explicitly NOT gated by Feature 3 ("ships in v1.1b regardless of F3's August
        // scheduling"), and QA verified it on RC under AB#38161 the day before AB#38597 was filed.
        // AB#38597 asks for the opposite. Until a PO ruling lands on one of those two items, treat
        // this line as the reversible expression of AB#38597 and nothing more - flipping it back is
        // a one-line change, which is why the row, its mapper and its render seam all stay put.
        //
        // MERGE NOTE for feature/intake1.1bFeature3ProviderFacility -> this branch. That branch
        // added its OWN `case PROVIDER_FACILITY_ROW_ID: return true` arm at a different position in
        // this same switch. The FILE does conflict on that merge, but ~150 lines below here, in the
        // rows array; the two ARMS merge with no marker at all. Git keeps both, this one comes
        // first, so `false` wins and Feature 3's row renders nowhere. Duplicate case labels are
        // legal TypeScript and eslint's no-duplicate-case is only a "warn" here, in a file that
        // already reports a pre-existing error and 18 warnings, so nothing in the build says a word
        // about it. When resolving that merge, DELETE this arm rather than keeping both. If you
        // forget, the test that catches you is THIS branch's "the Provider/Facility row is hidden
        // (AB#38597)" - it merges in outside every conflict hunk, so it cannot be resolved away,
        // and it fails the moment Feature 3's row is meant to render.
        //
        // A structurally stronger alternative was considered and deliberately not taken here, to
        // keep this a one-line revert while the AC question above is open: drop this arm and hide
        // the row through a named AB#38597 set consulted by the visibleRows filter, the way
        // DISCLOSURE_ACCOUNTING_HIDDEN_ROW_IDS already works. Then the F3 merge yields no duplicate
        // arm to notice at all. Worth doing if this hide outlives the ruling.
        return false;
      case AUDIT_TYPE_ROW_ID:
      case ON_BEHALF_OF_ROW_ID:
        // Spec #35289 (AC1/AC2): the two Audit-only rows exist ONLY for Audit(53),
        // mirroring Classic's `requestType == AUDIT` gate (DataEntryDetailsRightPane.tsx:2107).
        return requestType === AUDIT;
      case SERVICE_DATE_FROM_ROW_ID:
      case SERVICE_DATE_TO_ROW_ID:
      case RECORDS_REQUESTED_ROW_ID:
      case SENSITIVE_INFO_ROW_ID:
        // Based on the classic pane's own isVisibleSensitiveInfoToRelease
        // gate (transactionDetails.requestPurpose?.id) - but classic mode
        // can rely on that persisted value alone because by the time its
        // Details tab renders, Type/Purpose was already saved from an
        // earlier tab. Quick Entry is single-screen: a Purpose picked live
        // (or AI-extracted but not yet saved) only exists in the redux-form
        // values, so the persisted check alone would leave these rows
        // permanently non-applicable during a fresh manual entry. OR in the
        // live value so they unlock as soon as Purpose is set.
        // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
        // eslint-disable-next-line no-restricted-syntax
        return Boolean(this.props.transactionDetails?.requestPurpose?.id || requestPurpose) && requestType !== DISCLOSURE_ACCOUNTING;
      default:
        return true;
    }
  }

  getQuickEntryRows = (): readonly FieldGroupRow[] => {
    const values = this.props.formState?.values ?? {};
    const requestType = values[FormConstants.REQUEST_TYPE];
    const requestPurpose = values[FormConstants.PURPOSE_TYPE];
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const facility = this.props.transactionDetails?.facility;
    const useClinics = Boolean(facility?.useClinics);
    // AB#35144 / AB#35137 - Classic's own gates for the three newly-added rows:
    //   Request ID    : rendered only when the facility opts in (facility.useRequestID)
    //   Due Date      : hidden for DISCLOSURE_ACCOUNTING request types
    //   Received Date : always rendered; required unless DISCLOSURE_ACCOUNTING. Classic also
    //                   ORs in facilityAdditionalFields.enableNonHIMReceivedDateRequired, which
    //                   Quick Entry does not receive as a prop - omitting it can only make the
    //                   row LESS blocking (never wrongly required), so it is a safe subset.
    const receivedDateRequired = requestType !== DISCLOSURE_ACCOUNTING;
    const dateRange = this.getQuickEntryServiceDateRange();
    const caseNumberRequired = requestType === DISABILITY_OR_SOCIAL_SECURITY || [3, 53].includes(requestType);

    // Spec #34101 (F1c), AC5/AC6/AC13: the numbered-list badge for Patient
    // Info / Requestor Info must reflect the REAL match result - green (single),
    // amber (multiple), red (no match / service unavailable), neutral
    // (awaiting document). The row components (PatientInfoRow/RequestorInfoRow,
    // mounted in renderQuickEntryRowContent) own the real search-lifecycle
    // state; they report it up via onMatchStateChange into
    // this.state.patientMatchState / requestorMatchState. Using that stored
    // state here (instead of the previous hardcoded isSearching placeholder,
    // which pinned the badge to amber/LowConfidence once keys existed) is the
    // whole point of the badge fix.

    // Fixed badge numbers matching master-demo-v6.html's own sequence -
    // never renumbered based on which rows are currently applicable (see
    // isQuickEntryRowApplicable's doc comment). Patient Info (1) and
    // Requestor Info (2) are prepended (Spec #34101 / F1c, AC15) - every
    // pre-existing row's fixed badge shifts +2.
    // Requestor Info row status. Base: the requestor match state, or amber
    // (LowConfidence + contact-required message) when a requestor is selected
    // without a contact (AB#35116 Phase 2).
    const requestorMatchRow: FieldGroupRow = this.isRequestorAmber()
      ? { ...mapRequestorInfoToFieldGroupRow(this.state.requestorMatchState, 3), status: FieldGroupRowStatus.LowConfidence, value: REQUESTOR_CONTACT_REQUIRED_MESSAGE, isAiPreSelected: false }
      : mapRequestorInfoToFieldGroupRow(this.state.requestorMatchState, 3);
    // Spec #35136 (F1f) L1: for a DDS transaction the barcode fields fold INTO this
    // row and carry AC-2 conditional-required pressure, so DDS incompleteness must
    // downgrade the row to NeedsEntry (outstanding -> blocks Confirm-All). See
    // applyDdsCompletenessToRequestorRow.
    const requestorInfoRow = applyDdsCompletenessToRequestorRow(requestorMatchRow, requestType, values);

    const rows: FieldGroupRow[] = [
      // Real match state lifted from PatientInfoRow/RequestorInfoRow (Spec
      // #34101 / F1c) via onMatchStateChange; DEFAULT_*_MATCH_STATE
      // (awaitingDocument) until each row reports its first derived state.
      mapPatientInfoToFieldGroupRow(this.state.patientMatchState, 1),
      // Spec #35136 (F1f): Request Type/Purpose now comes BEFORE Requestor Info
      // (badge 2 vs 3). The Requestor Info row's own content is request-type
      // dependent (the DDS barcode fields fold into it only for DDS), so the
      // specialist should pick Request Type/Purpose first. Row IDENTITY is
      // unchanged - only the display order/badge swaps (the list renumbers
      // badges by position, and nothing keys off a hardcoded badge number).
      mapRequestTypePurposeToFieldGroupRow(this.ownedRequestAnalysis()?.data, 2, false, {
        requestType,
        requestPurpose,
        requestTypes: this.props.requestTypes,
        // AB#35076: the extraction's own per-field verdict on the purpose. InferredNoSource means it
        // invented the value, which must not present as a confirmed row.
        // AB#37979: the type's grounding verdict as well as the purpose's - the row's amber tier is
        // now "in the dropdown but not grounded, OR more than one value considered" (Joe Widi).
      }, this.ownedRequestAnalysis()?.confidence?.requestPurpose,
         this.ownedRequestAnalysis()?.confidence?.requestType,
         // AB#38739 amendment: green once the specialist has settled the row. The RAW tick set minus
         // the editing set, not effectiveAcknowledgedRowIds - that helper filters on
         // isQuickEntryRowAcknowledgeable(row), and we are building the row here, so reading it would
         // be circular. The two agree on what matters: a row open for edit is not settled, so
         // reopening it with [Edit] drops it back to amber and it has to be confirmed again.
         this.state.quickEntryAcknowledgedLowConfidenceIds.has(REQUEST_TYPE_PURPOSE_ROW_ID)
           && !this.state.quickEntryEditingRowIds.has(REQUEST_TYPE_PURPOSE_ROW_ID)),
      // Spec #35135 (AC1): the Disclosure Accounting composite row sits directly
      // after Request Type/Purpose - it is the primary capture for that type, and
      // the five rows below it (Service Dates, Records, Auth/Request Date,
      // Sensitive Info) are all dropped for type 66 by the filter further down.
      // Its badge number collides with Service Date-From's fixed 4 ONLY on paper:
      // the two are mutually exclusive by request type, and QuickEntryFieldGroupList
      // renumbers the rendered list contiguously (1..N) regardless.
      mapDisclosureInfoToFieldGroupRow(this.getQuickEntryDisclosureDraft(), 4, this.props.selectedPHICodes),
      // AB#35116 Phase 2 (amber) + Spec #35136 (F1f) L1 (DDS completeness) - computed above.
      requestorInfoRow,
      mapServiceDateFromToFieldGroupRow(4, dateRange),
      mapServiceDateToToFieldGroupRow(5, dateRange),
      mapRecordsRequestedToFieldGroupRow(6, this.getQuickEntryReleaseInfo(), this.getQuickEntryReleaseComments()),
      // AB#35144 / AB#35137: Request ID, Received Date and Due Date were missing from Quick
      // Entry entirely. Placed to match CLASSIC MODE's own Details-tab render order (legacy
      // behavior, per direct instruction) rather than appended at the end - Classic renders
      // Type/Purpose -> Request ID -> Auth Date -> Request Date -> Received Date -> Due Date.
      // Inserting rather than appending shifts Case Number / Clinic / Sensitive Info from
      // 9/10/11 to 12/13/14; badge numbers stay FIXED per row (never recomputed from which
      // rows are currently applicable), which is the invariant this list documents above.
      mapRequestIdToFieldGroupRow(7, values[FormConstants.REQUEST_ID]),
      mapAuthorizationDateToFieldGroupRow(8, requestPurpose, values[FormConstants.AUTHORIZATION_DATE], this.props.requestAnalysis?.data?.authorizationDate),
      mapRequestDateToFieldGroupRow(9, values[FormConstants.REQUEST_DATE], this.props.requestAnalysis?.data?.requestDate),
      mapReceivedDateToFieldGroupRow(10, receivedDateRequired, values[FormConstants.RECEIVED_DATE], this.props.requestAnalysis?.data?.receivedDate),
      mapDueDateToFieldGroupRow(11, values[FormConstants.DUE_DATE], this.props.requestAnalysis?.data?.dueDate),
      mapCaseNumberToFieldGroupRow(12, caseNumberRequired, values[FormConstants.CASE_NUMBER], this.props.requestAnalysis?.data?.caseNumber),
      mapClinicResponsibleToFieldGroupRow(13, useClinics, values[FormConstants.CLINIC_RESPONISBLE], this.props.discloseInstitutions, this.props.requestAnalysis?.data?.clinicName),
      // AB#38735: the editing-set membership decides amber-vs-Confirmed inside the mapper now,
      // rather than arriving as the generic Confirmed-while-editing downgrade below (which no
      // longer fires for this row, since it never reports Confirmed while open).
      mapSensitiveInfoToFieldGroupRow(14, this.getQuickEntrySensitiveInfo(), this.state.quickEntryEditingRowIds.has(SENSITIVE_INFO_ROW_ID)),
      // Spec #35289 (AC1/AC3): the two Audit(53)-only rows. Both are required (only
      // rendered for Audit), so a blank value maps to NeedsEntry and blocks Confirm All
      // for free via the same outstanding-row gate Case Number / Clinic use. Manual-entry
      // only (Assumption A1): isAiPreSelected is always false - no AI extraction wired.
      mapAuditTypeToFieldGroupRow(15, values[FormConstants.AUDIT_TYPE], this.props.auditTypes),
      mapOnBehalfOfToFieldGroupRow(16, values[FormConstants.ON_BEHALF_OF], this.props.onBehalfOf),
      // AB#38161: APPENDED deliberately, because array order IS visual order - QuickEntryFieldGroupList
      // renumbers the rendered badges contiguously from the array index, so inserting mid-list would
      // shift the badge of every row below it. (The 17 passed here is nominal, matching the fixed
      // numbering this list already uses for conditional rows; the rendered badge is the index.)
      mapProviderFacilityToFieldGroupRow(17, PROVIDER_FACILITY_UNSCOPED),
    ];

    // Spec #35135 (AC2/AC6): rows that exist for exactly one request type are
    // OMITTED rather than shown as "Not applicable yet" placeholders.
    //   - Disclosure Information is dropped for every type except 66, so the
    //     standard flow is untouched (AC2).
    //   - For type 66 the request-type-gated rows are dropped, matching what
    //     Classic renders for a Disclosure Accounting transaction (its own
    //     `requestType != DISCLOSURE_ACCOUNTING ? <row> : null` gates). Auth
    //     Date / Request Date were ALREADY non-applicable for 66 before this
    //     Spec (isQuickEntryRowApplicable, unchanged - AC6 regression); they
    //     join the omission list so the pane doesn't show two dead placeholders
    //     next to three hidden siblings.
    // The fixed-badge placeholder convention still applies to every other row
    // (e.g. Clinic/Facility on a facility with no clinics) - only these
    // request-type-exclusive rows are filtered.
    const visibleRows = rows.filter(row => {
      if (row.id === DISCLOSURE_INFO_ROW_ID) {
        return this.isQuickEntryRowApplicable(row.id);
      }
      // Spec #35289 (AC2): the Audit(53)-only rows are OMITTED (not shown as
      // "Not applicable yet" placeholders) for every non-Audit request type, the
      // same treatment Disclosure Information gets above.
      if (row.id === AUDIT_TYPE_ROW_ID || row.id === ON_BEHALF_OF_ROW_ID) {
        return this.isQuickEntryRowApplicable(row.id);
      }
      // AB#38597: same OMITTED treatment - isQuickEntryRowApplicable now returns false for this
      // row, so without this branch it would fall through to the placeholder convention below and
      // still render as "Not applicable yet" instead of disappearing.
      if (row.id === PROVIDER_FACILITY_ROW_ID) {
        return this.isQuickEntryRowApplicable(row.id);
      }
      return !(requestType === DISCLOSURE_ACCOUNTING && DISCLOSURE_ACCOUNTING_HIDDEN_ROW_IDS.has(row.id));
    });

    const dateErrors = this.getQuickEntryDateErrors();

    // AB#35289 merge: captured (not returned directly) because the isDocSourced stamp below
    // consumes mappedRows - see the round-14/15 stamp at the end of this method.
    const mappedRows = visibleRows.map(row => {
      if (!this.isQuickEntryRowApplicable(row.id)) {
        return {
          ...row,
          status: FieldGroupRowStatus.EmptyNotRequired,
          value: null,
          isAiPreSelected: false,
        };
      }
      // AB#35073: a row the specialist has opened for edit (present in
      // quickEntryEditingRowIds) but has NOT yet Confirmed must keep counting as
      // outstanding. Its typed-in value can flip the mapper's status to Confirmed
      // (e.g. Service Date / Records Requested once a value exists), which used to
      // drop it out of BOTH the header "ready/attention" count
      // (QuickEntryFieldGroupList via isFieldGroupRowAttention) AND the Confirm-All
      // gate (getQuickEntryOutstandingCount via isFieldGroupRowOutstanding) - so
      // "Confirm All" lit up and committed with rows still sitting in unconfirmed
      // Edit state. Downgrading the status here (instead of forking the two shared
      // count helpers) keeps the header and the gate from ever drifting. Every
      // Quick Entry row exits edit mode only via an explicit Confirm click, which
      // removes it from the set (onQuickEntryFieldConfirmed), so this can't wedge.
      // Patient/Requestor rows run their own match-state flow and are never in this
      // set, so they're unaffected.
      // AB#35150: a date that fails Classic's rules (a future Authorization/Request/Received date,
      // an unparseable or out-of-range one) must not read as Confirmed. The mappers key purely on
      // "has a value", so before this a future date came back green and confirmable - the pickers'
      // maxDate only stops a CLICK, not a typed or AI-seeded value. NeedsEntry is the same lever
      // AB#35076 used: it keeps the row outstanding and disables its own Confirm button.
      // Deliberately NOT isCompleteWhileEditing - unlike the AB#35070 case below, this row is
      // genuinely not complete.
      //
      // AB#38463: this MUST be tested BEFORE the open-for-edit branch below, not after. Typing an
      // invalid date necessarily puts the row in quickEntryEditingRowIds, so when that branch ran
      // first it returned early with isCompleteWhileEditing: true - the exact flag
      // isFieldGroupRowConfirmDisabled exempts - and Confirm stayed clickable on a row carrying an
      // error. An errored row is never "complete while editing", so the error has to win.
      // AB#38460: an UNFINISHED entry ("99/99/999") carries no message yet - nagging mid-keystroke
      // is unhelpful - but it must still not be confirmable. Clicking Confirm never blurs (the
      // button preventDefaults its mousedown), so the blur check that would have caught it never
      // ran: Confirm stayed live, took the untouched previous value, and read to the specialist
      // as if it had silently cancelled their edit. Keyed off the pending text, not off the
      // message, so both the unfinished and the complete-but-unreal case are covered.
      if (dateErrors[row.id] || this.state.quickEntryInvalidDates[row.id] !== undefined) {
        return { ...row, status: FieldGroupRowStatus.NeedsEntry };
      }
      if (row.status === FieldGroupRowStatus.Confirmed && this.state.quickEntryEditingRowIds.has(row.id)) {
        // AB#35070: remember that this row IS complete and was downgraded only because it is open.
        // The Confirm button needs to tell that apart from a genuinely incomplete row (see
        // confirmDisabled in renderQuickEntryRowContent) - after the downgrade both read NeedsEntry.
        return { ...row, status: FieldGroupRowStatus.NeedsEntry, isCompleteWhileEditing: true };
      }
      return row;
    });

    // AB#35289: stamp isDocSourced on EVERY row so the STATUS BADGE shows the green "Confirmed" check
    // for an AI-sourced value. This matters for the Records Requested + two Service Date rows, whose
    // mappers hardcode isAiPreSelected=false (AB#35066 - they signal AI-sourcing via the inline
    // grounding icon, not the "AI pre-selected" chip), which otherwise painted a Confirmed AI-seeded
    // value blue "user-entered", contradicting that icon. isQuickEntryValueDocSourced compares the
    // current value to the AI set, so once the operator edits it to diverge the badge reverts to
    // "user-entered".
    //
    // Round-14 W1: stamped for ALL rows rather than an inline id triple, so isQuickEntryValueDocSourced's
    // `switch` is the SINGLE source of truth for which rows are doc-sourced (an id list here would drift
    // the moment a 4th row is added there, silently reintroducing the badge/grounding-icon divergence
    // this fixes). Behavior-identical for every other row: that method's `default` branch returns
    // row.isAiPreSelected, and the badge evaluates `isAiPreSelected || isDocSourced`, so it collapses to
    // isAiPreSelected exactly as before.
    //
    // Round-15 S1: this stamped value has TWO consumers - the status badge
    // (QuickEntryFieldGroupList.getQuickEntryRowIcon) and the inline grounding icon
    // (renderQuickEntryRowContent). Both read row.isDocSourced, so they consume one derived value per
    // render and structurally cannot disagree about whether a value is doc-sourced.
    //
    // Round-14 S2: a NON-APPLICABLE row was overridden above to a nulled value / EmptyNotRequired, so it
    // must not also claim to be doc-sourced - short-circuit to false to keep the row self-consistent.
    return mappedRows.map(row => ({
      ...row,
      isDocSourced: this.isQuickEntryRowApplicable(row.id) && this.isQuickEntryValueDocSourced(row),
    }));
  }

  /**
   * Classic's date-validation messages for the Quick Entry date rows, keyed by row id (AB#35150).
   * Read twice per render pass - once by getQuickEntryRows to downgrade an invalid row's status, and
   * once by renderQuickEntryRowContent to show the message under the field - so both come from one
   * evaluation and cannot disagree about whether a value is acceptable.
   *
   * Service Date From/To ARE included, contrary to my first pass. They do have future rules in
   * infoToReleaseValidiation, but buildReleaseInfoWithDateRange only writes `dateOfService` when BOTH
   * ends of the range are set and All Dates is off - so with just a FROM picked, or before any
   * records load, that validator finds no range and runs nothing. Validating each date straight from
   * the scratch range closes that. Ordering and the date-of-birth floor stay with
   * infoToReleaseValidiation, which still runs alongside this and owns them.
   *
   * CONTENT errors only - the "<field> is required." messages are dropped. Classic shows those
   * through redux-form's touched/blocked-Next flow, but Quick Entry has no touched state here, so
   * emitting them would paint a red "Request date is required." under every empty row the moment the
   * panel opens. Required-ness is already carried by the row's own red NeedsEntry status, which is
   * the convention these field components document ("Quick Entry has its own FieldGroupRowStatus
   * gating"). An empty field therefore yields "" and the mappers' existing empty -> NeedsEntry
   * handling stands unchanged.
   */
  getQuickEntryDateErrors = (): Readonly<Record<string, string>> => {
    const values = this.props.formState?.values ?? {};
    const requestType = values[FormConstants.REQUEST_TYPE];
    const serviceRange = this.getQuickEntryServiceDateRange();
    const whenPresent = (value: any, message: string) =>
      (value === undefined || value === null || value === "") ? "" : message;
    // AB#38460: an unreadable entry outranks every value-based rule below - there is no value to
    // apply them to. Without this the row fell back on the untouched range and reported nothing,
    // which is precisely how a typed 99/99/9999 disappeared without a word.
    //
    // Wording is Classic's own out-of-range message, NOT "Invalid date." - the one these rows
    // showed before and the one the reporter asked for. It is also the more useful of the two:
    // 99/99/9999 is out of range rather than merely unreadable, and this text says what range is
    // allowed. Kept identical to the string validateServiceDate already returns for a
    // SQL-overflow date (quickEntryDateValidation.ts) and to infoToReleaseValidiation's, so the
    // row, the field and Confirm All cannot word the same problem three ways.
    // AB#38460: one flag, consulted for all six rows, so they answer an unreadable entry the same
    // way. It outranks every value-based rule below because there is no usable value to apply
    // them to - and for the four form dates it also OUTLIVES the value, which is the point: the
    // mask emits a transient empty value while the specialist retypes, and reading the error off
    // the form alone made the message flicker away exactly when they were trying to fix it.
    // AB#38460: the MESSAGE appears once the entry is complete but unreal ("99/99/9999") - not
    // while it is still half-typed, which would nag on nearly every keystroke. Confirm is blocked
    // for both cases; that is handled in getQuickEntryRows, which keys off the pending text
    // itself rather than off this message.
    const invalid = this.state.quickEntryInvalidDates;
    const orInvalid = (rowId: string, message: string) => {
      const pending = invalid[rowId];
      if (pending === undefined) {
        return message;
      }
      // AB#38460 (David Heifetz, PR !10140 review). Two changes here.
      //
      // WHEN: a message now also appears for a half-finished entry once the specialist has left the
      // field (pending.committed, set only on blur). Gating purely on hasCompleteDateShape meant
      // "10/22/19" blurred to a red row with Confirm blocked and NOTHING explaining why - the exact
      // symptom AB#38460 was raised about, relocated to a different input. The shape gate still
      // applies while typing, so no nagging mid-keystroke.
      //
      // WHICH: an unreal-but-in-range day ("02/30/1996") is no longer told it falls outside
      // 1753-9999, which was simply false. isOutOfRangeDateEntry owns that distinction; anything
      // else unusable - unreal combination or unfinished - gets INVALID_DATE_MESSAGE, the same
      // wording InlineSearchForm and CreateEntityFormModal already use, so one input no longer
      // reads differently across surfaces.
      if (!pending.committed && !hasCompleteDateShape(pending.text)) {
        return message;
      }
      return isOutOfRangeDateEntry(pending.text) ? OUT_OF_RANGE_DATE_MESSAGE : INVALID_DATE_MESSAGE;
    };

    const fromError = orInvalid(SERVICE_DATE_FROM_ROW_ID, validateServiceDate(serviceRange.from, "FROM"));
    const toError = orInvalid(SERVICE_DATE_TO_ROW_ID, validateServiceDate(serviceRange.to, "TO"));
    const rangeErrors = (fromError || toError)
      ? { from: "", to: "" }
      : validateServiceDateRange(serviceRange.from, serviceRange.to);
    return {
      [AUTHORIZATION_DATE_ROW_ID]: orInvalid(AUTHORIZATION_DATE_ROW_ID, whenPresent(values[FormConstants.AUTHORIZATION_DATE],
        validateAuthorizationDate(values[FormConstants.AUTHORIZATION_DATE], values[FormConstants.PURPOSE_TYPE]))),
      [REQUEST_DATE_ROW_ID]: orInvalid(REQUEST_DATE_ROW_ID, whenPresent(values[FormConstants.REQUEST_DATE],
        validateRequestDate(values[FormConstants.REQUEST_DATE]))),
      // Same required-ness rule the row list already applies for this field.
      [RECEIVED_DATE_ROW_ID]: orInvalid(RECEIVED_DATE_ROW_ID, whenPresent(values[FormConstants.RECEIVED_DATE],
        validateReceivedDate(values[FormConstants.RECEIVED_DATE], requestType !== DISCLOSURE_ACCOUNTING))),
      [DUE_DATE_ROW_ID]: orInvalid(DUE_DATE_ROW_ID, whenPresent(values[FormConstants.DUE_DATE],
        validateDueDate(values[FormConstants.DUE_DATE]))),
      // Read from the scratch range the specialist is actually looking at, NOT from releaseInfo -
      // that is the whole point, since releaseInfo carries no range until both ends are picked.
      // AB#38463: From>To must be caught the moment both ends are set, same as every other
      // Service Date rule here - not just at Confirm All (infoToReleaseValidiation), which is
      // what let a reversed range sit green and "ready to confirm" until that later check.
      [SERVICE_DATE_FROM_ROW_ID]: fromError || rangeErrors.from,
      [SERVICE_DATE_TO_ROW_ID]: toError || rangeErrors.to,
    };
  }

  /**
   * Stable callbacks the Patient/Requestor rows call (via onMatchStateChange)
   * whenever their computed match state changes. Stored so getQuickEntryRows
   * can render the real badge icon. Stable class-method references (not inline
   * arrows) so the rows' report effect - keyed on status/confidence - doesn't
   * re-fire from a changing callback identity.
   */
  onPatientMatchStateChange = (patientMatchState: PatientMatchState) => {
    this.setState({ patientMatchState });
  }

  onRequestorMatchStateChange = (requestorMatchState: RequestorMatchState) => {
    this.setState({ requestorMatchState });
  }

  /**
   * Bug fix (direct user report): blanks every Quick-Entry-writable
   * DATA_ENTRY_FIELDS_FORM field so a document replace (see the
   * requestAnalysis-defined-to-undefined transition in componentDidUpdate)
   * starts genuinely fresh instead of leaving the old document's AI-seeded
   * or specialist-typed values sitting alongside the new extraction's
   * results. Reuses the exact field lists writePatientToForm/
   * writeRequestorToForm already enumerate below, plus the scalar fields
   * seedExtractedQuickEntryFields seeds - one source of truth per field,
   * not a second hand-maintained list. Request Type/Purpose's DISPLAYED
   * value is cleared here even though its own immediate persist
   * (onQuickEntryRequestPurposeChange) is untouched - deferring THAT is out
   * of scope; only Records Requested/Sensitive Info's persistence timing
   * was in scope for this fix, per direct instruction.
   */
  private clearQuickEntryDraftFields = () => {
    this.writeDataEntryFields([
      // The six request-info fields come from the shared QUICK_ENTRY_REQUEST_INFO_FIELDS
      // list so the clear can't drift out of sync with what rehydration/seed can
      // fill (AB#31605) - covers Request Type, Purpose, Clinic, Case Number,
      // Request Date, and Authorization Date whether AI-seeded, manually entered,
      // or rehydrated-from-saved.
      ...QUICK_ENTRY_REQUEST_INFO_FIELDS.map(field => [field, ""] as const),
      [FormConstants.PATIENT_NAME, ""],
      [FormConstants.PATIENT_MIDDLE_NAME, ""],
      [FormConstants.PATIENT_LAST_NAME, ""],
      [FormConstants.MRN_ID, ""],
      [FormConstants.EMPI_NUMBER, ""],
      [RequestorFormConstants.REQUESTOR_NAME, ""],
      [RequestorFormConstants.ADDRESS, ""],
      [RequestorFormConstants.ADDRESS2, ""],
      [RequestorFormConstants.CITY, ""],
      [RequestorFormConstants.STATE, ""],
      [RequestorFormConstants.ZIP, ""],
      [RequestorFormConstants.FIRST_NAME, ""],
      [RequestorFormConstants.LAST_NAME, ""],
      [RequestorFormConstants.EMAIL, ""],
      [RequestorFormConstants.PHONE_NUMBER, ""],
      [RequestorFormConstants.FAX_NUMBER, ""],
      [BillingFormconstants.SEND_TO_REQUESTOR_NAME, ""],
      [BillingFormconstants.SEND_TO_ADDRESS_LINE1, ""],
      [BillingFormconstants.SEND_TO_ADDRESS_LINE2, ""],
      [BillingFormconstants.SEND_TO_CITY, ""],
      [BillingFormconstants.SEND_TO_STATE, ""],
      [BillingFormconstants.SEND_TO_ZIP, ""],
      [BillingFormconstants.SEND_TO_FIRST_NAME, ""],
      [BillingFormconstants.SEND_TO_LAST_NAME, ""],
      [BillingFormconstants.SEND_TO_EMAIL_ADDRESS, ""],
      [BillingFormconstants.SEND_TO_PHONE, ""],
      [BillingFormconstants.SEND_TO_FAX, ""],
    ]);
    // DOB is Date-typed, not string (see writePatientToForm's own comment) - null, not "".
    this.props.dispatch && this.props.dispatch(change(FormConstants.DATA_ENTRY_FIELDS_FORM, FormConstants.DOB, null));
    // DISCLOSE_ALL_INFO/DONT_DISCLOSE_ANY_INFO are booleans derived from the
    // Sensitive Info checkboxes (SensitiveInfoField.tsx's applySensitiveInfoUpdate
    // writes them alongside the real save) - false, not "", to match their type.
    this.props.dispatch && this.props.dispatch(change(FormConstants.DATA_ENTRY_FIELDS_FORM, FormConstants.DISCLOSE_ALL_INFO, false));
    this.props.dispatch && this.props.dispatch(change(FormConstants.DATA_ENTRY_FIELDS_FORM, FormConstants.DONT_DISCLOSE_ANY_INFO, false));
  }

  /** Writes a set of [field, value] pairs into the shared data-entry redux-form so the transaction's final Save persists them (no DB write). */
  private writeDataEntryFields = (pairs: ReadonlyArray<readonly [string, string]>) => {
    pairs.forEach(([field, value]) =>
      this.props.dispatch && this.props.dispatch(change(FormConstants.DATA_ENTRY_FIELDS_FORM, field, value ?? "")),
    );
  }

  // Create New Patient (Spec #34101 (F1c), AC9 no-match path): the specialist
  // filled the create form (pre-filled from the extraction, then edited). Write
  // the values into the same data-entry fields the classic add-new-patient flow
  // uses so the transaction's final Save creates/persists the patient - this does
  // NOT hit any create API.
  // AC9: create-new (onCreatePatient) and resolve-existing (onSelectPatient) both
  // land the patient's identity in DATA_ENTRY_FIELDS_FORM the same way - the only
  // difference is the source (specialist-entered vs matched record). Share the
  // writer so the two paths can never drift.
  // Both paths write the identity into DATA_ENTRY_FIELDS_FORM (display + the
  // create-API payload source); additionally record HOW the row resolved so
  // Confirm All can persist it to the transaction (persistQuickEntrySelectionsToTransaction):
  // create-new -> createPatientRecordRequest; resolved-existing -> patientDataid.
  onCreatePatient = (values: PatientCreateValues) => {
    this.writePatientToForm(values);
    // Fresh create-new intent re-arms the one-shot create guard (AB#31605 re-save).
    this.quickEntryPatientCreateFired = false;
    this.setState({ quickEntryPatientResolution: { mode: "create" } });
  };

  onSelectPatient = (values: PatientCreateValues, patientId?: number) => {
    this.writePatientToForm(values);
    this.setState({ quickEntryPatientResolution: { mode: "select", patientId } });
  };

  writePatientToForm = (values: PatientCreateValues) => {
    this.writeDataEntryFields([
      [FormConstants.PATIENT_NAME, values.firstName],
      [FormConstants.PATIENT_MIDDLE_NAME, values.middleName],
      [FormConstants.PATIENT_LAST_NAME, values.lastName],
      // DOB is handled separately below - not through writeDataEntryFields.
      [FormConstants.MRN_ID, values.mrn],
      [FormConstants.EMPI_NUMBER, values.empi],
    ]);
    // FormConstants.DOB holds a Date OBJECT in the classic add-new-patient flow
    // (DataEntryDetailsRightPane writes `new Date(...)` and reads `.getTime()`).
    // writeDataEntryFields coerces to a string, so routing DOB through it would
    // put an "MM/DD/YYYY" string in a Date-typed field - a plausible `.getTime`
    // crash when a Quick-Entry-created patient is later read by the classic
    // consumers. Write a Date to match. `new Date("MM/DD/YYYY")` parses in LOCAL
    // time (correct calendar day); an ISO "YYYY-MM-DD" would parse as UTC and can
    // shift the DOB back a day in US timezones. Empty -> null (matches classic).
    this.props.dispatch
      && this.props.dispatch(change(
        FormConstants.DATA_ENTRY_FIELDS_FORM,
        FormConstants.DOB,
        values.dob ? new Date(values.dob) : null,
      ));
  }

  // Both paths write the requestor identity + SEND_TO_* mirrors into the form
  // (display); additionally record HOW the row resolved so Confirm All can link it to
  // the transaction: resolved-existing carries the matched requestor + contact ids
  // (-> sendToRequestorid / sendToRequestorContactid in the combined PATCH); create-new
  // is created + linked (+ its contact) via createQuickEntryRequestor, now that the
  // createSendTo endpoint returns the new requestor id.
  // AB#38938: `hadDbMatch` is REQUIRED (no default) - the same rule, and for the same reason, as
  // `source` on onSelectRequestor below. A default of `false` would be the PRE-EXISTING behaviour,
  // so a future caller that forgot it would silently reintroduce this bug rather than fail. The
  // only production caller (RequestorInfoRow, via the onCreateRequestor prop) always passes it,
  // and its prop type enforces that.
  onCreateRequestor = async (values: RequestorCreateValues, hadDbMatch: boolean) => {
    this.writeRequestorToForm(values);
    // Fresh create-new intent re-arms the one-shot create guard (AB#31605 re-save).
    this.quickEntryRequestorCreateFired = false;
    // A different requestor - any contact assigned to the previous one is gone.
    // AB#35289: a create-new is a deliberate operator action -> "manual" (never auto-reset).
    // AB#38938: both setState sites in this method must carry contactFromDocument - the second one
    // below replaces the whole resolution object, so setting it only here would lose it the moment
    // the new requestor's id came back.
    this.setState({
      quickEntryRequestorResolution: { mode: "create", source: "manual", contactFromDocument: !hadDbMatch },
      quickEntryAssignedContact: undefined,
    });
    // Classic creates the requestor the moment it's saved - it exists in the DB and
    // comes back in the next search. Do the same here (Randy 2026-07-24) instead of
    // holding the values in the form until Confirm All: the specialist saved a
    // requestor, so there should BE one. The values are passed explicitly because the
    // writeRequestorToForm dispatches above haven't reached formState yet this tick.
    // Recording the new id switches Confirm All to "already created" so it can't
    // insert a duplicate; on failure the id stays unset and Confirm All retries.
    const { requestorId } = await this.createQuickEntryRequestor({
      [RequestorFormConstants.REQUESTOR_NAME]: values.organization,
      [RequestorFormConstants.ADDRESS]: values.address1,
      [RequestorFormConstants.ADDRESS2]: values.address2,
      [RequestorFormConstants.CITY]: values.city,
      [RequestorFormConstants.STATE]: values.state,
      [RequestorFormConstants.ZIP]: values.zip,
      [RequestorFormConstants.FIRST_NAME]: values.contactFirstName,
      [RequestorFormConstants.LAST_NAME]: values.contactLastName,
      [RequestorFormConstants.EMAIL]: values.email,
      [RequestorFormConstants.PHONE_NUMBER]: values.phone,
      [RequestorFormConstants.FAX_NUMBER]: values.fax,
    });
    if (requestorId != null) {
      this.setState({ quickEntryRequestorResolution: { mode: "create", requestorId, source: "manual", contactFromDocument: !hadDbMatch } });
    }
  };


  // AB#35289 (round-6): `source` is REQUIRED (no default) - mirrors the row-side applyApiResult
  // invariant so a future caller omitting it is a compile error, not a silent "auto" that a
  // type->Internal flip would reset. The only caller (RequestorInfoRow) always passes it.
  onSelectRequestor = (values: RequestorCreateValues, requestorId: number | undefined, contactId: number | undefined, source: "auto" | "manual") => {
    this.writeRequestorToForm(values);
    this.setState(prev => ({
      // AB#35289: carry the resolution source (RequestorInfoRow reports "auto" for an AI
      // automated match, "manual" for a manual inline search / grid pick / rehydrated pick).
      quickEntryRequestorResolution: {
        mode: "select", requestorId, contactId, source,
        // AB#38938 (review round 2): CARRY the flag rather than rebuilding without it. Resolving
        // to an existing requestor does not un-decline a match: after decline -> create -> [Search]
        // -> pick from Classic's grid, the document's contact still belongs to the organisation
        // that was declined, and rebuilding this object dropped the suppression and pre-filled it
        // again on the very transaction just fixed.
        contactFromDocument: prev.quickEntryRequestorResolution?.contactFromDocument,
      },
      // Drop an assigned contact only when this is a DIFFERENT requestor. The row
      // re-reports the same resolution on re-render/rehydration, and clearing
      // unconditionally would make an assigned contact disappear from the row.
      quickEntryAssignedContact: requestorId !== this.getResolvedRequestorId()
        ? undefined
        : prev.quickEntryAssignedContact,
    }));
  };

  writeRequestorToForm = (values: RequestorCreateValues) => {
    this.writeDataEntryFields([
      [RequestorFormConstants.REQUESTOR_NAME, values.organization],
      [RequestorFormConstants.ADDRESS, values.address1],
      [RequestorFormConstants.ADDRESS2, values.address2],
      [RequestorFormConstants.CITY, values.city],
      [RequestorFormConstants.STATE, values.state],
      [RequestorFormConstants.ZIP, values.zip],
      [RequestorFormConstants.FIRST_NAME, values.contactFirstName],
      [RequestorFormConstants.LAST_NAME, values.contactLastName],
      [RequestorFormConstants.EMAIL, values.email],
      [RequestorFormConstants.PHONE_NUMBER, values.phone],
      [RequestorFormConstants.FAX_NUMBER, values.fax],
      [BillingFormconstants.SEND_TO_REQUESTOR_NAME, values.organization],
      [BillingFormconstants.SEND_TO_ADDRESS_LINE1, values.address1],
      [BillingFormconstants.SEND_TO_ADDRESS_LINE2, values.address2],
      [BillingFormconstants.SEND_TO_CITY, values.city],
      [BillingFormconstants.SEND_TO_STATE, values.state],
      [BillingFormconstants.SEND_TO_ZIP, values.zip],
      [BillingFormconstants.SEND_TO_FIRST_NAME, values.contactFirstName],
      [BillingFormconstants.SEND_TO_LAST_NAME, values.contactLastName],
      [BillingFormconstants.SEND_TO_EMAIL_ADDRESS, values.email],
      [BillingFormconstants.SEND_TO_PHONE, values.phone],
      [BillingFormconstants.SEND_TO_FAX, values.fax],
    ]);
  }

  /**
   * AB#35116 flow-back. The classic RightPane reports each EXPLICIT requestor
   * selection / contact assignment from the row-click event itself (deterministic,
   * synchronous - not a round-trip through redux requestorInfo, which lags the
   * assign-contact saga and isn't reset when a new requestor is picked). We set
   * the resolution live from that; contactId absent => amber (P2). No auto-assign:
   * contactId is only set when the user explicitly assigns a contact.
   */
  onModalRequestorContactResolved = (requestorId?: number, contactId?: number) => {
    // AB#35289: a modal resolve is a deliberate operator action -> "manual" (never auto-reset).
    // AB#38938 (review round 2): same reason as onSelectRequestor - carry the flag, do not rebuild
    // without it. This is the Classic-grid contact-resolution door.
    //
    // Read from `this.state` rather than a `prev` updater deliberately. The updater form changes
    // the setState CALL SHAPE, and AB#35289's test asserts this call's whole argument object to
    // pin `source: "manual"`; switching to a function would have made that assertion unfalsifiable
    // rather than adapting it. Nothing in this handler mutates the value being read, and the two
    // ways of reaching it (a create, then resolving a contact) are separate user actions in
    // separate ticks, so there is no batching window to lose.
    this.setState({
      quickEntryRequestorResolution: {
        mode: "select", requestorId, contactId, source: "manual",
        contactFromDocument: this.state.quickEntryRequestorResolution?.contactFromDocument,
      },
    });
  };

  closeRequestorModal = () => {
    this.setState({ requestorModalOpen: false });
  };

  /**
   * AB#35116: a row was picked in the classic results grid. Maps the flattened search
   * row onto the QE requestor row so it shows the SELECTED requestor (organization,
   * address, contact) in place of the AI-extracted guess, and closes the popup - the
   * pick is the answer to "which requestor?". The form/send-to writes ride the row's
   * existing onSelectRequestor path, driven by the identity we hand it here.
   */
  onModalRequestorSelected = (row: any) => {
    if (!row?.requestorId) {
      return; // "Add new Requestor" and contactless rows resolve elsewhere
    }
    // The popup stays OPEN: the pick assigns no contact (classic never auto-assigns, and
    // the classic search proc doesn't even return contact fields), so the row is amber
    // until one is assigned - and the contact grid that does that lives in this popup.
    this.setState({
      // New requestor picked - any contact assigned to the previous one no longer applies.
      quickEntryAssignedContact: undefined,
      quickEntryModalRequestor: {
        requestorId: row.requestorId,
        contactId: undefined,
        organization: row.requestorName ?? "",
        address1: row.requestorAddress?.address1 ?? "",
        address2: row.requestorAddress?.address2 ?? "",
        city: row.requestorAddress?.city ?? "",
        state: row.requestorAddress?.state ?? "",
        zip: row.requestorAddress?.zip ?? "",
        contactFirstName: row.firstName ?? "",
        contactLastName: row.lastName ?? "",
        email: row.email ?? "",
        phone: row.phone ?? "",
        fax: row.fax ?? "",
        eTransfer: Boolean(row.eTransfer),
        national: Boolean(row.national),
      },
    });
  };

  /**
   * AB#35116: a contact was assigned in the classic contact grid. Merges it onto the
   * selected requestor so the QE row shows the contact (name / phone / fax / email) -
   * and, with contactId now set, clears the amber "contact assignment required" gate.
   */
  onModalContactSelected = (contact: any) => {
    this.setState(prev => (prev.quickEntryModalRequestor ? {
      quickEntryModalRequestor: {
        ...prev.quickEntryModalRequestor,
        contactId: contact?.id,
        contactFirstName: contact?.firstName ?? "",
        contactLastName: contact?.lastName ?? "",
        phone: contact?.phone ?? "",
        fax: contact?.fax ?? "",
        email: contact?.email ?? "",
      },
    } : null));
  };

  /**
   * The requestor the row has resolved to, whichever way it resolved: a grid pick
   * (quickEntryModalRequestor), or an auto-match / create-new recorded on the
   * resolution. The resolution is checked first - after a create it is the ONLY place
   * the new requestor's id lands (createQuickEntryRequestor's response).
   */
  /**
   * AB#38938: the Add New Contact form's pre-fill.
   *
   * The extracted contact describes the requestor the DOCUMENT names. It is wrong to carry it
   * forward when the requestor on the row is not that one, and that is the case QA reported:
   * the AI matched a requestor, the specialist declined it and entered a new one, so the document's
   * contact belongs to the organisation they rejected. Every other route genuinely does carry it -
   * see shouldPrefillContactForm for the case-by-case reasoning.
   */
  /**
   * AB#38938 (review round 2): the element, extracted so a test can assert the props the modal is
   * ACTUALLY handed.
   *
   * The gate lives in assignContactPrefill, and the tests pinned its return value - but nothing
   * pinned the wiring, so replacing the spread below with the five literal `extracted*` props
   * (the pre-fix code, i.e. this bug reintroduced verbatim) passed the entire suite. The seam a
   * future edit will break is the spread, not the helper, so that is what has to be assertable.
   */
  renderAssignContactModal = () => (
    <AssignContactModal
      requestorId={this.getResolvedRequestorId()}
      onSelectContact={this.onAssignContactSelected}
      onCreateContact={this.onAssignContactCreated}
      onClose={() => this.setState({ assignContactOpen: false })}
      {...this.assignContactPrefill()}
    />
  );

  assignContactPrefill = () => {
    const data = this.props.requestAnalysis?.data;
    if (!shouldPrefillContactForm(this.state.quickEntryRequestorResolution)) {
      return {};
    }
    return {
      extractedContactFirstName: data?.requestorContactGivenName,
      extractedContactLastName: data?.requestorContactFamilyName,
      extractedEmail: data?.requestorContactEmail,
      extractedFax: data?.requestorContactFax,
      extractedPhone: data?.requestorContactPhone,
    };
  };

  getResolvedRequestorId = (): number | undefined =>
    this.state.quickEntryRequestorResolution?.requestorId ?? this.state.quickEntryModalRequestor?.requestorId;

  /** The contact currently pinned by the row's resolution, if the contact exists in the database. */
  getResolvedContactId = (): number | undefined =>
    this.state.quickEntryRequestorResolution?.contactId;

  /**
   * AB#38349: is the Billing pane's release method KNOWN to be stale with respect to the requestor
   * contact the Quick Entry row now shows?
   *
   * The pane's `missingContactEmailForDownload` warning combines two operands of different
   * vintages: `sendToAddress` is the LIVE redux-form value (writeContactToForm runs synchronously
   * on the pick) while `releaseMethodId` is server-derived - DetermineReleaseMethod computes it
   * from `tblRequestBuffer.RequestorContactID`, i.e. from `transactionDetails.sendToContact`. So
   * whenever the row's contact is not the transaction's linked contact, those operands describe
   * DIFFERENT contacts and any conclusion drawn from both at once is about a contact that is no
   * longer selected. That is precisely the reported symptom.
   *
   * DERIVED, not a flag with a timeout, and that is the load-bearing choice. On this path there is
   * no round trip to wait for: the 2026-08-24 measurement in saveRequestorContactNow's header shows
   * the contact PATCH does not re-point the link, so the getTransactionAttributes reconcile that
   * follows returns the SAME release method. A "save in flight" window would therefore expire and
   * re-show exactly the wrong warning it was meant to withhold.
   *
   * HOW LONG IT LASTS, stated plainly because review round 4 found the pane over-claiming it
   * (see RELEASE_METHOD_RECHECK_NOTE): this does NOT clear by itself. The only thing that re-points
   * the link is Confirm All (persistQuickEntryRequestorResolution's transactions/sendToContact), and
   * the Billing tab is reachable only AFTER a Confirm All has committed (billingUnlocked keys off
   * quickEntryCommitCompletedDate), so a contact changed from Billing stays stale until the operator
   * goes back and Confirms All again - which AB#31605 allows and the note now names. It can also
   * stick indefinitely if UpdateSendToRequestorContact re-points the link to a NEW id
   * (RequestorController.cs:399-403, the clone branch): sendToContact.id moves while the row's
   * resolution keeps the pre-clone id. Both are why the pane's stand-in note has to be true and
   * actionable on its own rather than promising a settlement - what it suppresses is one red
   * assertion, and it names both remedies in its place. Following the server's returned id into the
   * row's resolution would close the clone case, but that changes which contact Confirm All persists
   * and is out of scope here.
   *
   * FALSE when the row has resolved no contact: that is the ordinary case (nothing picked, or a
   * contact that only exists at Confirm All), and treating it as stale would suppress the warning
   * on every transaction. This reads the SAME id saveRequestorContactNow patches, so the display
   * rule and the adoption gate cannot disagree about which contact the row means.
   *
   * Known, accepted imprecision: onAssignContactCreated / createQuickEntryRequestor record the new
   * contact id immediately while the server has ALREADY linked it, so this reads true for the few
   * seconds until transactionDetails refreshes. It withholds a red message during a refresh that is
   * genuinely in flight, and clears itself; the create-time backstop still refuses.
   */
  private isQuickEntryReleaseMethodStaleForContact = (): boolean => {
    // AB#38349: TWO independent kinds of evidence that the release method on screen may not describe
    // the contact now selected. Either is enough, and taking the union is what keeps round 1's door
    // working while closing round 2's.
    //
    // (1) ROUND 1 - the row's contact is not the transaction's link. True while a contact has been
    //     picked but not yet persisted, which is the Quick Entry "Change Contact" popup path: the
    //     contact PATCH returns the id it was given, so the link does not move (measured on Dev-Test
    //     2026-08-27, ~1,500 samples, grey note throughout).
    //
    // (2) ROUND 2 - the value's PROVENANCE. The release method was derived for a contact other than
    //     the one now selected. This is the case (1) cannot see, because Confirm All posts
    //     transactions/sendToContact with the row's OWN contact: the link moves onto the row, the two
    //     ids in (1) become equal by construction, and (1) goes quiet while the displayed value is
    //     still the one derived for the previous contact. Measured on Dev-Test: 5.82s of Download
    //     plus the red assertion after Confirm All. The Classic contact grid defeats (1) the same
    //     way, writing both ids in one click.
    //
    //     ROUND 3 - what CLEARS (2), which is the half that was broken. The stamp used to move only
    //     when the observed release-method id CHANGED, so on a transaction where the server keeps
    //     re-deriving the SAME answer (an Internal request forces Download whatever the contact) it
    //     never moved again and this branch reported stale for the rest of the session. It is now
    //     moved explicitly by whoever asked the server - see recordQuickEntryReleaseMethodProvenance -
    //     so it clears on the answer rather than on a change in the answer.
    //
    // The union only ever ADDS suppression, and suppression here means showing a neutral note in
    // place of a red assertion - so the direction of any error is toward saying less, not asserting
    // something false. The over-suppression guards below and their tests bound it.
    const rowContactId = this.getResolvedContactId();
    const linkedContactId = this.currentTransactionDetails()?.sendToContact?.id;
    if (rowContactId != null && rowContactId !== linkedContactId) {
      return true;   // (1)
    }
    const derivedForContactId = this.state.quickEntryReleaseMethodDerivedForContactId;
    if (derivedForContactId == null) {
      return false;   // nothing server-derived observed, so there is no vintage to be stale
    }
    // Round 1's guard, kept deliberately: with nothing resolved on the row there is no second
    // vintage to compare against, and suppressing on a transaction the operator never touched would
    // withhold a warning that is simply correct. Falling back to the LINK here (the first cut did)
    // made the predicate answer a question about the link rather than about a selection - caught in
    // review, and it is why this returns rather than coalescing.
    if (rowContactId == null) {
      return false;
    }
    return derivedForContactId !== rowContactId;   // (2)
  }

  /**
   * AB#38349 (review round 5): what the Billing pane is actually told, which is narrower than
   * "stale for the row's contact".
   *
   * The suppression rests entirely on the two operands having different vintages, and that argument
   * holds only while the release method on screen is the SERVER's. Once the operator picks one in
   * the pane's dropdown it describes the contact on the row - same vintage as sendToAddress - so a
   * Download-without-an-email warning against it is simply correct and must not be replaced by a
   * note promising a re-check that would not change it.
   */
  private isQuickEntryReleaseMethodStaleForPane = (): boolean =>
    this.isQuickEntryReleaseMethodStaleForContact() && !this.state.quickEntryReleaseMethodPickedByOperator;

  /**
   * AB#38349: apply a release method the SERVER re-evaluated from the requestor contact it was just
   * given, instead of leaving the Billing pane on the pre-change one until the eight-call
   * getTransactionAttributes chain lands. Classic does exactly this for the same endpoints
   * (patchSendToRequestorContactSaga Ducks:4206-4226, createSendToContactSaga Ducks:4038-4043), so
   * this is parity, not a new rule. A null `releaseMode` means DetermineReleaseMethod declined to
   * re-derive at all - never "clear it", and never "re-derived and found no change": it returns the
   * value on every re-derive. See the DEFECT 2 note in the body for the two returns that produce it
   * (corrected in review round 4).
   *
   * `derivedForContactId` (AB#38349 round 3): the contact the caller KNOWS this value was derived
   * for. Optional, and omitting it keeps the old behaviour exactly - the provenance stamp is then
   * left to trackQuickEntryReleaseMethodProvenance's inference from the transaction's link. Pass it
   * wherever the server linked the contact before deriving, because there the inference is wrong;
   * see the DEFECT 2 note in the body.
   *
   * Guarded on the loaded option list because the setReleaseMethod reducer writes
   * `releaseMethod?.find(x => x.id == data)` UNCONDITIONALLY (Ducks:1140-1148): an id that list does
   * not carry - or an empty list, before getFacilityReleaseMethods answers - would write `undefined`
   * and blank the left pane's "Release Method: ..." line (DataEntryDetailsLeftPane.tsx:1431). Matched
   * with the reducer's own loose `==` so the guard cannot pass where the find fails. Every caller
   * still fires getTransactionAttributes afterwards, which covers the guarded-out case.
   *
   * REVIEW ROUND 2 (Major): the dispatch ALONE does not move the pane. It reaches
   * quickEntryBillingFields only through resyncQuickEntryReleaseMethodFromTransaction, which returns
   * null while quickEntryLastSeenReleaseMethodId is `undefined` ("first observation for this
   * transaction - the seeder owns it"). That field only advances on a NON-NULL
   * transactionDetails.releaseMethod, so on a transaction whose release method never arrived it is
   * still undefined at this point; and once the operator has picked a method by hand the seeder
   * cannot rescue it either, because it only fills a nullish value. The adopted value then landed in
   * redux and never reached Billing - permanently, not for one round trip: the getTransactionAttributes
   * that follows reports the same id, so incoming === lastSeen and the resync stays null forever.
   * Recording the transaction's CURRENT value as "seen" first (null when it has none) makes the
   * adoption a genuine CHANGE rather than a first observation, so the next resync pass adopts it.
   *
   * Deliberately NOT a direct write to quickEntryBillingFields. Routing through the resync keeps its
   * "an unchanged incoming value never overrides an operator's pick" rule, which a direct write would
   * break - and every caller can legitimately get back a value the transaction already had (editing a
   * contact's phone number re-runs DetermineReleaseMethod and returns the same answer).
   *
   * The arming is also why adoption has to be GATED rather than unconditional: it is exactly what
   * lets an adopted value override a release method the operator picked by hand, so it is only
   * correct where the server computed that value from the contact the transaction is linked to.
   * This method does NOT decide that - saveRequestorContactNow owns the one condition that does
   * (see its header for the measurement behind it), and the create paths are sound by construction
   * (RequestorDataAccessEf.CreateNewSendToContact assigns rb.SendToContact BEFORE
   * DetermineReleaseMethod reads it).
   */
  private adoptServerReleaseMethod = (
    releaseMode: number | null | undefined,
    derivedForContactId?: number,
  ) => {
    if (releaseMode != null && !this.props.releaseMethodOptions?.some(option => option.id == releaseMode)) {
      return;
    }
    // Only when transactionDetails belongs to THIS transaction - otherwise leave the resync
    // bookkeeping untouched (an in-place transaction switch must still re-arm on its own terms).
    //
    // PR !10141 review finding 3: the DISPATCH is gated on the same check, not just the bookkeeping.
    // transactionDetails is not cleared on an in-place switch, so mid-switch X->Y the details still
    // hold X; saveRequestorContactNow's caller-side gate implies they are loaded and current, but
    // the two create paths (onAssignContactCreated, createQuickEntryRequestor) have no equivalent,
    // so a create response landing during a switch could write `releaseMethod` onto the OUTGOING
    // transaction's record. Low impact - the getTransactionAttributes each caller fires next
    // overwrites it - but it is the same raw-vs-matched asymmetry currentTransactionDetails() exists
    // to close, so it is closed here rather than relied on being harmless.
    const transactionDetails = this.currentTransactionDetails();
    if (!transactionDetails) {
      return;
    }
    // AB#38349 round 3, DEFECT 2. Record the provenance from what the CALLER knows, rather than
    // leaving the tracker to infer it from the transaction's link. See ORDERING below for WHERE in
    // this method the record has to happen - it is not free to sit wherever reads best.
    //
    // The tracker reads `transactionDetails.sendToContact?.id`, which LAGS the server on both create
    // paths: RequestorDataAccessEf.CreateNewSendToContact assigns rb.SendToContact and SaveChanges
    // (RequestorDataAccessEf.cs:64-70) BEFORE DetermineReleaseMethod reads rb.RequestorContactID
    // (TransactionDataAccessEf.cs:107,140,144), so the returned `releaseMode` describes the NEW
    // contact - while setReleaseMethod's reducer (DataEntryDetailsDucks.ts:1140-1148) writes
    // `transactionDetails.releaseMethod` and leaves `sendToContact` on the OLD one until the
    // getTransactionAttributes reconcile lands. The tracker therefore stamped the OLD contact for a
    // value derived for the NEW one, and because the follow-up refresh reports the SAME id it never
    // re-stamped - the stamp stayed wrong for the rest of the session on that transaction.
    //
    // Recorded even when the release method is NOT adopted (`releaseMode == null`): a null answer means
    // DetermineReleaseMethod DECLINED to re-derive at all. CORRECTED in review round 4 - the earlier
    // wording named RequestCategoryGroupID 21 as one of the two causes, and that is wrong. Group 21
    // sets `output = Download` and falls through to the save and `return output`
    // (TransactionDataAccessEf.cs:132-135), so it can never produce null; it is the cause of the
    // SAME-ID case, which is a different thing and is handled where Confirm All posts the contact.
    //
    // The two returns that actually produce null are at TransactionDataAccessEf.cs:126-129:
    //  - `RequestPurposeId == 43` (a Disclosure Event) - contact-independent, the stored proc's
    //    "Printed locally" default is being preserved deliberately;
    //  - `StatusIndicatorID >= SentToDistribution` - NOT contact-independent. There the release method
    //    is frozen at whatever was last derived, for whichever contact was linked then, so recording
    //    "derived for the contact just asked about" is an assertion we cannot actually support.
    // Quick Entry never reaches that second one: everything here is gated on the data-entry stage,
    // StatusIndicatorID < 50 (isQuickEntryDataEntryStatus), and SentToDistribution is a post-QA status
    // above it. The constant's numeric value is not in this repo - it lives in the Verisma.Common
    // package - so the bound stated here is the one this file can actually verify.
    //
    // For the reachable cause the argument holds: a value that does not depend on the contact is not
    // stale for any contact, so the honest record is "derived for this one". The
    // not-in-the-loaded-options case above returns EARLIER and deliberately records nothing: there the
    // server did re-derive, we cannot show the answer, and claiming the value on screen describes the
    // new contact would be false.
    //
    // ORDERING (round 4, and it is load-bearing). React is on ^17.0.2 with a LEGACY root
    // (index.tsx:24 ReactDOM.render), so a setState from a post-`await` continuation - which is where
    // every caller of this method is - is NOT batched: it commits and runs componentDidUpdate before
    // the next statement. componentDidUpdate (:2273-2678) has no early return before its
    // unconditional trackQuickEntryReleaseMethodProvenance() call, so the tracker runs on that flush.
    //
    // So the record must NOT precede the dispatch when the id CHANGES. Recording first advances
    // `quickEntryReleaseMethodObservedId` to the new id while `transactionDetails.releaseMethod` still
    // holds the old one, and the flush's tracker then sees observed !== observedId, declines to stand
    // down, and re-stamps from the lagging `sendToContact` - destroying the explicit record it was
    // just given. Dispatching FIRST and recording after inverts that: the dispatch's own flush may
    // stamp by inference, and the record immediately overwrites it with the caller's contact while
    // setting observedId to the id now on screen, so every later pass early-returns.
    //
    // The `releaseMode == null` branch keeps recording BEFORE returning, and must: there is no
    // dispatch to order against, and observedId is set to the id already on screen, so the flush's
    // tracker compares equal and stands down. Same for a same-id re-derive.
    if (releaseMode == null) {
      if (derivedForContactId != null) {
        this.recordQuickEntryReleaseMethodProvenance(
          derivedForContactId,
          transactionDetails.releaseMethod?.id ?? null,
        );
      }
      return;
    }
    this.quickEntryReleaseMethodResyncTxId = this.props.transactionId ?? null;
    if (this.quickEntryLastSeenReleaseMethodId === undefined) {
      this.quickEntryLastSeenReleaseMethodId = transactionDetails.releaseMethod?.id ?? null;
    }
    this.props.setReleaseMethod?.(releaseMode);
    if (derivedForContactId != null) {
      this.recordQuickEntryReleaseMethodProvenance(derivedForContactId, releaseMode);
    }
  };

  /**
   * AB#35119 (reopened): save the requestor contact NOW rather than at Confirm All.
   *
   * Rules the specialist can only satisfy by editing the field they just left must fire against that
   * field. The reported one is the blacklisted email domain, enforced server-side in
   * RequestorController.UpdateSendToRequestorContact - which is the same endpoint Classic auto-saves
   * to on blur, so this is parity with Classic rather than a new behaviour.
   *
   * Deliberately a direct PATCH rather than the classic saga: the saga routes failures to
   * API_ERROR_STATE, which renders the full-page "Service is temporarily unavailable" banner. For a
   * correctable input problem that reads as an outage, so the message is caught here and shown ON the
   * row instead (quickEntryContactSaveError).
   *
   * Returns true when nothing needed saving OR the save succeeded, so callers can treat "no contact in
   * the database yet" as a non-failure - Confirm All's create path owns that case, and
   * buildSendToContactPatchParams refuses to build a params object without both ids (see its header:
   * a PATCH lacking transactionId would skip the server's validation entirely).
   *
   * AB#38349 - THE ADOPTION GATE. The endpoint's re-evaluated `releaseMode` is adopted only when
   * the contact this PATCH is about IS the contact the transaction is currently linked to
   * (`transactionDetails.sendToContact.id`). Otherwise it is a stale value describing some other
   * contact.
   *
   * That is MEASURED, not inferred. Run against Dev-Dev on 2026-08-24 with an authenticated
   * session, transaction 1000008-23717:
   *
   *   BEFORE  transactionDetails.sendToContact.id = 1006913113 (email, NO fax)
   *           transactionDetails.releaseMethod    = { id: 2, name: "Download" }
   *   PATCH   requestor/1006913096/updatesendtorequestorcontact?transactionId=1000008-23717
   *           (contact 1006913096 has an email AND a fax 610-555-0194 - a DIFFERENT contact)
   *        -> HTTP 200, body {"id":1006913096,"name":"Wallace Brubaker",...,"releaseMode":2}
   *   AFTER   transactionDetails.sendToContact.id = 1006913113  (UNCHANGED)
   *           transactionDetails.releaseMethod    = { id: 2, name: "Download" } (UNCHANGED)
   *
   * RequestorController.UpdateSendToRequestorContact re-points the transaction only when
   * `response.ID != requestorcontactid` (RequestorController.cs:399-404) and runs
   * DetermineReleaseMethod AFTER that. The proc returned the SAME id that was PATCHed, so no
   * re-point happened and DetermineReleaseMethod computed from the transaction's OLD linked contact
   * (TransactionDataAccessEf.cs:94-170). The returned `releaseMode` describes the contact the
   * transaction is STILL linked to - never the contact just supplied.
   *
   * ONE condition, not a per-call-site flag. This used to be an `options.adoptReleaseMethod`
   * opt-out passed false by onAssignContactSelected alone, which left the second caller adopting
   * unconditionally even though pre-Confirm-All its contact usually was not the linked one either
   * (Quick Entry re-points the link only at Confirm All, via persistQuickEntryRequestorResolution's
   * transactions/sendToContact). A stale value pushed into the pane can overwrite a release method
   * the operator picked by hand, and onQuickEntryCreateTransaction would then persist it.
   *
   * AB#38736 removed that second caller (onEditRequestor, with the Edit Requestor form), so
   * onAssignContactSelected is now the only one - the gate stays, since it states the rule the
   * measurement established rather than a fact about who calls this.
   */
  saveRequestorContactNow = async (values: NewContactValues): Promise<boolean> => {
    const patchedContactId = this.getResolvedContactId();
    const params = buildSendToContactPatchParams(
      patchedContactId,
      this.props.transactionId,
      values,
      this.props.formState?.values?.[FormConstants.REQUEST_TYPE],
    );
    if (!params) {
      return true;
    }
    this.setState({ quickEntryContactSaveError: undefined });
    try {
      const response = await patchRequest<{ releaseMode?: number | null }>(
        sendToContactPatchUrl(params, global.userID), {});
      // AB#38349: adopt the re-evaluated release method from THIS response, which is what Classic
      // does for the same endpoint (patchSendToRequestorContactSaga, DataEntryDetailsDucks.ts:4206-4226).
      // Throwing the response away left the pane's `fields.releaseMethodId` server-derived and stale
      // until the end of the Confirm-All getTransactionAttributes chain, while `sendToAddress` had
      // already moved to the new contact (writeContactToForm is synchronous) - so
      // QuickEntryBillingPane's missingContactEmailForDownload (:445-446, rendered :642) combined a
      // fresh contact with an old release method and warned about the contact just replaced.
      // See adoptServerReleaseMethod for the guard and the resync bookkeeping it needs.
      // The gate - see this method's header for the measurement it encodes. `patchedContactId` is
      // necessarily non-null here (buildSendToContactPatchParams refuses to build params without
      // it), so a transaction carrying no linked contact at all correctly fails the comparison.
      // AB#38349 round 3: the gate itself is what establishes the provenance, so it is passed
      // EXPLICITLY rather than left to the tracker's inference. On this one path the two agree by
      // construction (the gate is `patchedContactId === sendToContact.id`), so this is not a
      // behaviour change - it removes the dependence on an inference that is only accidentally
      // right here and is wrong on the create paths. See adoptServerReleaseMethod's DEFECT 2 note.
      if (patchedContactId === this.currentTransactionDetails()?.sendToContact?.id) {
        this.adoptServerReleaseMethod(response?.data?.releaseMode, patchedContactId);
      }
      // Keep the pane in step with anything ELSE the save changed server-side, exactly as the
      // classic path does - now a background reconcile rather than the only source of the release method.
      this.props.getTransactionAttributes?.(this.props.transactionId);
      return true;
    } catch (error) {
      const message = serverValidationMessage(error);
      this.setState({
        quickEntryContactSaveError: message
          ?? "Couldn't save the contact - please try again, or set it in Classic Mode.",
      });
      return false;
    }
  };

  /**
   * AB#35289 (source-flagged reset): CONFIRM-time trigger. Called ONLY from the type/purpose row's
   * Confirm (onClickEditModeConfirmButton), never on the dropdown change - the QE type/purpose
   * dropdown is a reversible PREVIEW (pick Internal then Cancel reverts via the F1c snapshot), so
   * resetting on change would wipe the requestor before the operator commits. Fires only when the
   * CONFIRMED type is Internal(21) AND the persisted request was NOT already Internal (a real
   * change to Internal) - the same "differs from persisted" shape shouldSyncRequestPurpose uses.
   * Re-confirming an already-Internal (persisted) row is not a change, so it does nothing. Runs
   * synchronously on confirm (consistent with the purpose round-trip, which is also not awaited);
   * the requestor re-search happens off the remount inside resetAutoRequestorForInternal.
   */
  private maybeResetRequestorOnConfirmedInternalType = () => {
    const confirmedType = Number((this.props.formState?.values ?? {})[FormConstants.REQUEST_TYPE]);
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const persistedInternal = Boolean(this.props.transactionDetails?.transactionRequest?.isInternalRequest);
    if (confirmedType === INTERNAL && !persistedInternal) {
      this.resetAutoRequestorForInternal();
    }
  };

  /**
   * AB#35289 (source-flagged reset): re-evaluate the requestor after a CONFIRMED change of the
   * request type to Internal (see maybeResetRequestorOnConfirmedInternalType for the trigger) -
   * but ONLY when it was an AI guess, preserving deliberate operator picks/creates and committed
   * (rehydrated) choices. Closes the gap where a single AI auto-matched (non-Internal) requestor
   * lingered on an Internal request and got stamped TypeOfRequestorID=5015.
   *
   * Reset when nothing is resolved yet OR the resolution came from an AI automated match
   * (source === "auto"): clear the requestor resolution / match state / assigned contact / modal
   * grid pick, and bump quickEntryRequestorResetGeneration to REMOUNT the Requestor row so its
   * automated-match effect re-runs - now sending typeOfRequestorID=5005 via the AC5 live-type
   * `search` filter, so the re-search returns Internal-only. Do NOTHING for a deliberate pick:
   * a manual/created/rehydrated resolution (source === "manual") or a modal grid pick held in
   * quickEntryModalRequestor (resolvedId defined, resolution source not "auto").
   */
  private resetAutoRequestorForInternal = () => {
    const resolvedId = this.getResolvedRequestorId();
    const source = this.state.quickEntryRequestorResolution?.source;
    if (resolvedId !== undefined && source !== "auto") {
      return; // deliberate pick / create / rehydrate - preserve it
    }
    this.setState(prev => ({
      requestorMatchState: DEFAULT_REQUESTOR_MATCH_STATE,
      quickEntryRequestorResolution: undefined,
      quickEntryModalRequestor: undefined,
      quickEntryAssignedContact: undefined,
      quickEntryRequestorResetGeneration: prev.quickEntryRequestorResetGeneration + 1,
    }));
  };

  /**
   * An EXISTING contact was picked in the Assign Contact popup. Shows it on the row
   * (shared with the classic panel's assign path) and records contactId on the
   * resolution, which is what clears the amber gate and makes Confirm All pin this
   * contact via transactions/sendToContact.
   *
   * AB#38349: this is the reported path, and the one the adoption gate in saveRequestorContactNow
   * exists for. The contact just picked is NOT the transaction's linked contact - Quick Entry
   * re-points that link only at Confirm All (persistQuickEntryRequestorResolution's
   * transactions/sendToContact) - so the PATCH's re-evaluated `releaseMode` is measured to come
   * back computed from the contact being REPLACED. See saveRequestorContactNow's header for the
   * live measurement; the gate refuses the adoption here on its own, with no flag from this caller.
   *
   * Adopting anyway would be actively harmful, not merely useless. adoptServerReleaseMethod ARMS the
   * resync (records the transaction's current value as "seen") so the adoption registers as a change,
   * which is what makes it reach Billing. On a transaction whose release method never arrived and
   * whose pane value the operator set by hand, that arming would let a value computed from the wrong
   * (or absent) contact overwrite a deliberate pick that previously stood - and Confirm All would
   * then persist it, because onQuickEntryCreateTransaction snapshots the pane's local fields.
   *
   * So getTransactionAttributes remains the only source of the release method on this path, and it
   * cannot be a correct one before the link moves. The user-visible consequence - the stale
   * "Requestor contact must have an email assigned for download delivery." warning - is therefore
   * fixed where it RENDERS rather than where it is computed: the pane is told the release method is
   * stale for the row's contact and shows a re-check affordance instead of asserting a validation
   * failure. See isQuickEntryReleaseMethodStaleForContact.
   */
  onAssignContactSelected = (contact: RequestorContact) => {
    const assigned: NewContactValues = {
      contactFirstName: contact.firstName ?? "",
      contactLastName: contact.lastName ?? "",
      email: contact.email ?? "",
      phone: contact.phone ?? "",
      fax: contact.fax ?? "",
    };
    this.onModalContactSelected(contact);
    this.writeContactToForm(assigned);
    this.setState(prev => ({
      assignContactOpen: false,
      quickEntryAssignedContact: assigned,
      quickEntryRequestorResolution: prev.quickEntryRequestorResolution
        ? { ...prev.quickEntryRequestorResolution, contactId: contact.id } as State["quickEntryRequestorResolution"]
        : prev.quickEntryRequestorResolution,
    }), () => {
      // AB#35119 (reopened): save the assignment NOW, not at Confirm All. In the setState callback
      // because saveRequestorContactNow reads the contact id off the resolution this call just set -
      // reading it before the state lands would find the PREVIOUS contact (or none) and either patch
      // the wrong record or silently skip the save.
      //
      // No adoption happens on this path: the gate inside saveRequestorContactNow sees that the
      // contact just picked is not the transaction's linked contact. See both headers.
      void this.saveRequestorContactNow(assigned);
    });
  };

  /**
   * A NEW contact was entered in the Assign Contact popup.
   *
   * Persists immediately rather than deferring to Confirm All, for the same reason
   * create-new-requestor does: the specialist saved a contact, so there should BE one.
   * It is also required for correctness - persistQuickEntryRequestorResolution
   * short-circuits mode==="create" once the requestor id is known, so a contact
   * assigned after the requestor was created would never be linked.
   *
   * The returned contactId goes onto the resolution, which both clears the amber gate
   * and steers Confirm All to the "pin this contact" branch - without it, Confirm All's
   * willLinkContact fallback would create the same contact a second time.
   */
  onAssignContactCreated = async (values: NewContactValues) => {
    const requestorId = this.getResolvedRequestorId();
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const transactionDetails = this.props.transactionDetails;
    this.writeContactToForm(values);
    this.onModalContactSelected({
      id: undefined,
      firstName: values.contactFirstName,
      lastName: values.contactLastName,
      phone: values.phone,
      fax: values.fax,
      email: values.email,
    });
    this.setState({ assignContactOpen: false, quickEntryAssignedContact: values });

    if (requestorId == null || !transactionDetails) {
      // No requestor in the DB yet (create-new hasn't been saved). The values are in the
      // form, so willLinkContact picks them up when the requestor is created.
      return;
    }
    try {
      const response = await post(`requestors/createSendToContact?userId=${global.userID}`, {
        organizationId: transactionDetails.facility.id,
        requestBufferId: transactionDetails.id,
        sendToRequestor: requestorId,
        firstName: values.contactFirstName || null,
        lastName: values.contactLastName || null,
        phone: values.phone || null,
        email: values.email || null,
        fax: values.fax || null,
      });
      const contactId = response?.data?.contactId;
      if (contactId != null) {
        this.onModalContactSelected({
          id: contactId,
          firstName: values.contactFirstName,
          lastName: values.contactLastName,
          phone: values.phone,
          fax: values.fax,
          email: values.email,
        });
        this.setState(prev => ({
          quickEntryRequestorResolution: prev.quickEntryRequestorResolution
            ? { ...prev.quickEntryRequestorResolution, contactId } as State["quickEntryRequestorResolution"]
            : prev.quickEntryRequestorResolution,
        }));
      }
      // AB#38349 (review round 1): the CREATE endpoint re-evaluates the release method exactly as the
      // PATCH one does - RequestorManager.CreateNewSendToContact calls the same
      // DetermineReleaseMethod and returns it as `ReleaseMode`
      // (Verisma.ROIS.API/Requestors/RequestorManager.cs:31-62) - and Classic's saga for THIS endpoint
      // consumes it (createSendToContactSaga, DataEntryDetailsDucks.ts:4038-4043). "Add new contact" in
      // the Assign Contact popup is the third contact-change entry point, so without this it kept the
      // stale-release-method window the other two just lost. Unlike the PATCH path this value is
      // computed from the RIGHT contact: RequestorDataAccessEf.CreateNewSendToContact assigns
      // rb.SendToContact BEFORE DetermineReleaseMethod reads rb.RequestorContactID.
      //
      // AB#38349 round 3, DEFECT 2 - and this is the path that defect was reported on. That same
      // ordering is exactly why the contact id has to be passed EXPLICITLY: the server has already
      // moved the link, so the value describes `contactId`, while the CLIENT's
      // transactionDetails.sendToContact still holds the contact being replaced until the refresh
      // below lands. Letting the tracker infer the stamp from that lagging field recorded the wrong
      // contact, permanently.
      this.adoptServerReleaseMethod(response?.data?.releaseMode, contactId ?? undefined);
      this.props.getTransactionAttributes?.(this.props.transactionId);
    } catch (error) {
      // Leave contactId unset: the row stays amber rather than claiming a contact the
      // transaction doesn't have.
      //
      // AB#35119: surface the SERVER's own validation message when it refused the save. The
      // blacklisted-email-domain rule lives on the server (NewSendContact ->
      // IContactValidator.IsDomainBlacklisted, returning a 400 naming the offending domain);
      // swallowing it here and toasting "please try again" gave advice that can never work for a
      // validation failure, so the specialist reasonably concluded the contact had saved.
      // Non-validation failures still get the generic retryable wording.
      toast.error(
        serverValidationMessage(error) ??
        "Couldn't save the contact - please try again, or set it in Classic Mode.",
      );
    }
  };

  /** The contact half of writeRequestorToForm - the requestor contact fields plus their SEND_TO_* mirrors. */
  writeContactToForm = (values: NewContactValues) => {
    this.writeDataEntryFields([
      [RequestorFormConstants.FIRST_NAME, values.contactFirstName],
      [RequestorFormConstants.LAST_NAME, values.contactLastName],
      [RequestorFormConstants.EMAIL, values.email],
      [RequestorFormConstants.PHONE_NUMBER, values.phone],
      [RequestorFormConstants.FAX_NUMBER, values.fax],
      [BillingFormconstants.SEND_TO_FIRST_NAME, values.contactFirstName],
      [BillingFormconstants.SEND_TO_LAST_NAME, values.contactLastName],
      [BillingFormconstants.SEND_TO_EMAIL_ADDRESS, values.email],
      [BillingFormconstants.SEND_TO_PHONE, values.phone],
    ]);
  };

  /**
   * AB#35116: "Add new Requestor" in the classic results grid. Closes the (chromeless)
   * classic host and opens the requestor row's own create-requestor modal - the classic
   * inline add-new form it would otherwise unlock isn't visible in that host. That modal is
   * prefilled from the extracted document only when no DB match was found (AB#38824,
   * createPrefill.ts); reaching it from a matched row opens it empty.
   */
  onModalAddNewRequestor = () => {
    this.setState(prev => ({
      requestorModalOpen: false,
      quickEntryCreateRequestorSignal: prev.quickEntryCreateRequestorSignal + 1,
    }));
  };

  /** Effective releaseInfo for Quick Entry: the optimistic override once the specialist has edited it this transaction, otherwise the server value. */
  getQuickEntryReleaseInfo = (): readonly Release[] => {
    // AB#35085: MERGE the optimistic local override onto the server option list
    // by id (not replace it) - so a later/purpose-driven release-item set from
    // getTransactionDetailsSuccess always surfaces (fixing the intermittent
    // "Records Requested doesn't fully populate"), while the specialist's
    // in-progress checked/date state is preserved. See mergeQuickEntryReleaseInfo.
    // AB#31605: when the specialist has changed Purpose this session, the applicable
    // option set is the read-only PREVIEW for that (still unpersisted) purpose, not
    // the transaction's own set - transactionDetails still reflects the old purpose
    // because Quick Entry no longer writes it on change. Falls back to the
    // transaction's set when no purpose change has happened.
    // currentTransactionDetails(), for the same AB#31605 reason as getQuickEntryReleaseComments
    // below - and this one is not a one-frame window: the doc-replace reset nulls the override,
    // so props are the source for the WHOLE of the next transaction's fetch, rendering A's
    // record types on B as Confirmed with a doc-sourced badge (Mike Hamilton, PR !10721 round 2).
    // Identity, not emptiness. Both overrides below are transaction-scoped state whose reset runs
    // in componentDidUpdate - AFTER this render - and mergeQuickEntryReleaseInfo returns `local`
    // verbatim when the server list is empty, so guarding only the props read still rendered the
    // PREVIOUS transaction's checked types on this one (Mike Hamilton, PR !10721 round 3).
    const details = this.currentTransactionDetails();
    if (!details) {
      return [];
    }
    const optionSet = this.state.quickEntryReleaseInfoPreview ?? details.releaseInfo ?? [];
    return mergeQuickEntryReleaseInfo(optionSet, this.state.quickEntryReleaseInfo);
  }

  /**
   * currentTransactionDetails(), not props.transactionDetails: props still hold the PRIOR
   * transaction during an in-place switch, so reading them directly rendered transaction A's
   * description on transaction B's pane until B's fetch landed (Mike Hamilton, PR !10721 - the
   * same AB#31605 identity guard clearedReleaseInfo already uses).
   */
  getQuickEntryReleaseComments = (): string | undefined => {
    const details = this.currentTransactionDetails();
    if (!details) {
      return undefined;
    }
    return this.state.quickEntryReleaseComments ?? details.requestComments;
  }

  /**
   * Effective sensitiveInfo for Quick Entry: the optimistic local override once the specialist has
   * edited it this transaction, otherwise the server value - see quickEntrySensitiveInfo's own doc
   * comment on State.
   *
   * It does NOT mirror getQuickEntryReleaseInfo any more: this one still reads
   * props.transactionDetails raw, so during an in-place transaction switch it serves the PRIOR
   * transaction's categories. Tracked as AB#39495, deliberately not fixed here.
   */
  getQuickEntrySensitiveInfo = (): readonly SensitiveInfo[] => {
    // Bug fix (AB#39495): identity-guarded, like rehydrateQuickEntryFromTransaction.
    // An Authorized category from the OUTGOING transaction would otherwise reach
    // quickEntrySensitiveInfoForAuth and suppress redaction on the INCOMING
    // transaction's document for the length of the stale window.
    return this.state.quickEntrySensitiveInfo ?? this.currentTransactionDetails()?.sensitiveInfo ?? [];
  }

  /**
   * Spec #35135: effective disclosure values for Quick Entry - the optimistic
   * local draft once the specialist has touched it this transaction, otherwise
   * whatever the transaction already has saved (so a reopened Disclosure
   * Accounting transaction shows its persisted disclosure instead of a blank
   * capture).
   *
   * Reads props.transactionDetails raw, so - like getQuickEntrySensitiveInfo and unlike
   * getQuickEntryReleaseInfo - it is NOT guarded against serving the prior transaction's
   * disclosure during an in-place switch. Tracked as AB#39495.
   */
  getQuickEntryDisclosureDraft = (): QuickEntryDisclosureDraft => {
    // Bug fix (AB#39495): identity-guarded - see getQuickEntrySensitiveInfo. Must ship
    // with the same guard in onQuickEntryDisclosureChange below: guarding only this
    // read makes the row render empty while the first edit still merges onto the
    // previous transaction's disclosure underneath.
    return this.state.quickEntryDisclosureDraft ?? disclosureDraftFromTransaction(this.currentTransactionDetails()?.disclosure);
  }

  /**
   * Spec #35135 (AC4): the ONLY disclosure mutation path while editing - a
   * setState-only optimistic echo. It deliberately performs NO I/O: Quick Entry
   * defers every write to Confirm All (see persistQuickEntrySelectionsToTransaction),
   * and a blur/change save here would reintroduce the "clean slate" leak that
   * removing inline persistence fixed. Merges onto the CURRENT effective draft so
   * the first edit doesn't discard values rehydrated from the transaction.
   */
  onQuickEntryDisclosureChange = (patch: Partial<QuickEntryDisclosureDraft>) => {
    // Updater form (not a read-then-write): several fields can be edited within
    // one React batch, and a stale read would drop all but the last patch.
    this.setState((prev) => ({
      quickEntryDisclosureDraft: {
        // Bug fix (AB#39495): read via `this.currentTransactionDetails()` - the guard
        // needs transactionDetails and transactionId off one consistent object. The
        // updater's second (`props`) parameter is deliberately NOT declared: reading
        // `props.transactionDetails` off it was this bug's fourth instance, and the
        // no-restricted-syntax rule only matches `this.props.…`, so a callback
        // parameter named `props` is invisible to it. Don't re-add the parameter.
        // The updater form stays for `prev` (see above), which is the only reason
        // it exists.
        ...(prev.quickEntryDisclosureDraft ?? disclosureDraftFromTransaction(this.currentTransactionDetails()?.disclosure)),
        ...patch,
      },
    }));
  }

  getQuickEntryPatientDob = (): Date | undefined => {
    const dobValue = this.props.formState?.values?.[FormConstants.DOB];
    return dobValue ? new Date(dobValue) : undefined;
  }

  /**
   * Same infoToReleaseValidiation the classic pane's own validateReleaseInformation
   * runs before every save - e.g. "either a date range or All Dates" fires
   * whenever only one of From/To is set. Exposed separately from
   * persistQuickEntryReleaseInfo so the two Service Date rows can render the
   * same errMsg the classic pane would show inline, instead of silently no-
   * op'ing while the specialist is mid-way through entering a range.
   */
  validateQuickEntryReleaseInfo = (releaseInfo: readonly Release[]) => {
    return infoToReleaseValidiation(releaseInfo, this.getQuickEntryPatientDob());
  }

  /**
   * The From/To/AllDates the specialist is currently looking at - the
   * scratch override once touched this transaction, otherwise whatever's
   * already saved on releaseInfo. See the quickEntryServiceDateOverride
   * State doc comment for why this can't just be re-derived from
   * getReleaseDateRange(releaseInfo) on every render.
   */
  getQuickEntryServiceDateRange = (): { from?: Date; to?: Date; allDates: boolean } => {
    const override = this.state.quickEntryServiceDateOverride;
    // AB#37853: coerce the OVERRIDE branch too - the choke point, not just the one writer that was
    // observed failing. getReleaseDateRange (the ?? branch) already coerces internally, so this
    // makes both branches return real Dates uniformly and covers every other writer into
    // quickEntryServiceDateOverride if any of them ever sees a redux-persist-rehydrated string.
    // Cheap: coerceDate returns a Date unchanged when it is already one.
    return override
      ? { from: coerceDate(override.from), to: coerceDate(override.to), allDates: override.allDates }
      : getReleaseDateRange(this.getQuickEntryReleaseInfo());
  }

  /** Validates the CURRENT scratch range against releaseInfo, the same combination persistQuickEntryReleaseInfo is about to try to save - so the errMsg shown while typing matches what would block (or allow) the save. */
  getQuickEntryServiceDateValidation = () => {
    const { from, to, allDates } = this.getQuickEntryServiceDateRange();
    const updated = buildReleaseInfoWithDateRange(this.getQuickEntryReleaseInfo(), from, to, allDates);
    return this.validateQuickEntryReleaseInfo(updated);
  }

  /**
   * Bug fix (direct user report): Records Requested used to persist
   * IMMEDIATELY on every checkbox/date/free-text change (saveInformationToRelease),
   * unlike every other Quick Entry row (a redux-form draft nothing persists
   * until Confirm All) - the root cause of two separate bugs: (1) a document
   * replace couldn't cleanly clear it (there was no local-only draft to
   * discard - the ACTUAL transaction record had already been written), and
   * (2) Classic Mode could see Quick Entry's in-progress answers before
   * Confirm All ran (the same "clean slate" leak the Switch-to-Classic-Mode
   * revert fix patches for that one exit path only). Now this is an
   * optimistic LOCAL echo only - getQuickEntryReleaseInfo() already reads
   * this state first, so the row's Confirmed status and displayed value are
   * unaffected. The actual persist moved to Confirm All
   * (persistQuickEntrySelectionsToTransaction below), which reuses the same
   * validation gate this method used to run inline.
   */
  persistQuickEntryReleaseInfo = (updated: readonly Release[], comments?: string) => {
    // Updater form, NOT a this.state read. Unchecking Other Documents fires the clear and the
    // item toggle from one event handler, so React batches them: a this.state read in the
    // second call saw the pre-clear comments and wrote the text straight back, and Confirm All
    // then persisted a description for a record type that was no longer requested
    // (Mike Hamilton, PR !10721). Per-keystroke lifting is what made that path common.
    // Resolved HERE, not inside the updater: the callback runs at flush time, so reading props
    // in it would resolve against whatever transaction had arrived by then - writing B's
    // description into the slice A is about to read, which is the bleed the identity guard
    // exists to stop (Mike Hamilton, PR !10721 round 2).
    // The write choke point is also where the identity guard has to bite. getQuickEntryReleaseInfo
    // returns [] when transactionDetails does not belong to this transaction, and both release
    // writers round-trip through it - so a write landing on such a frame would latch [] as the
    // session override. That is not an empty selection: mergeQuickEntryReleaseInfo overlays it
    // onto the server list and returns the server list verbatim, so the edit is silently lost
    // while releaseUntouchedThisSession flips to false (Mike Hamilton, PR !10721 round 4).
    // Guarded HERE rather than by moving the getter's guard down to the props read, which is the
    // placement round 3 rejected: merge returns `local` verbatim when the server list is empty,
    // so that version renders the PREVIOUS transaction's checked types for a frame.
    const details = this.currentTransactionDetails();
    if (!details) {
      return;
    }
    const persistedFallback = details.requestComments;
    this.setState(prev => ({
      quickEntryReleaseInfo: updated,
      quickEntryReleaseComments: comments ?? prev.quickEntryReleaseComments ?? persistedFallback ?? null,
    }));
  }

  onQuickEntryReleaseItemToggle = (itemId: number, checked: boolean) => {
    this.persistQuickEntryReleaseInfo(buildReleaseInfoWithItemToggle(this.getQuickEntryReleaseInfo(), itemId, checked));
  }

  onQuickEntryReleaseFreeTextChange = (text: string) => {
    this.persistQuickEntryReleaseInfo(this.getQuickEntryReleaseInfo(), text);
  }

  /**
   * AB#38460: records whether a date row's latest entry was text the picker could not read.
   *
   * The four redux-form dates call this alongside their own write, so their error comes from the
   * same place the two Service Date rows' does. It has to be separate from the form value: the
   * mask emits a transient empty value while the specialist types, which clears the form field
   * and, with it, the error message - so the warning disappeared the moment they touched the box
   * to fix it. The flag is not clobbered by that, so the message stays up until the entry is
   * actually corrected or the row leaves edit mode.
   *
   * An empty box is NOT an error (clearing a date is legitimate), so `undefined` clears the flag.
   */
  private recordQuickEntryDateEntry = (rowId: string, text?: string, committed = false) => {
    this.setState(prev => {
      // AB#38460: bail when nothing actually changed. This fires on EVERY keystroke, and a
      // re-render mid-typing resets the picker's displayed text - so a no-op setState here was
      // enough to make backspace look broken (the box snapped back to the stored value on the
      // render the state update caused). Returning null skips the render entirely.
      const existing = prev.quickEntryInvalidDates[rowId];
      if ((existing?.text ?? undefined) === text && (existing?.committed ?? false) === committed) {
        return null;
      }
      const next = { ...prev.quickEntryInvalidDates };
      if (text === undefined) {
        delete next[rowId];
      } else {
        next[rowId] = { text, committed };
      }
      return { quickEntryInvalidDates: next };
    });
  }

  /** The unusable text a date row is currently showing, if any - drives both its error and its displayed value. */
  private quickEntryInvalidTextFor = (rowId: string): string | undefined => this.state.quickEntryInvalidDates[rowId]?.text;

  /** which selects which end of the shared range this row owns - the OTHER end is read fresh from current state and carried through unchanged. */
  onQuickEntryServiceDateChange = (which: "from" | "to", rawValue?: Date | string) => {
    let date: Date | undefined = typeof rawValue === "string" ? new Date(rawValue) : rawValue;

    // AB#38460: reaching this handler at all means the entry was USABLE - unusable text now comes
    // through DateField's onInvalidText channel instead (see quickEntryInvalidDates), which never
    // touches the value. So any pending "unusable" mark for this end is stale and is dropped here.
    //
    // Keeping the two apart is what lets the bad text stay on screen: routing it through the
    // value made the picker re-sync and blank the box, and made Cancel look like it had lost the
    // previous date. The value only ever holds a real date or undefined, so nothing unusable can
    // be stored - an empty field stays empty, and Cancel restores a previous value through the
    // edit snapshot (QE_ROW_STATE_KEYS covers quickEntryServiceDateOverride for both rows).
    this.setState(prev => ({
      quickEntryInvalidDates: (() => {
        const nextInvalid = { ...prev.quickEntryInvalidDates };
        delete nextInvalid[which === "from" ? SERVICE_DATE_FROM_ROW_ID : SERVICE_DATE_TO_ROW_ID];
        return nextInvalid;
      })(),
    }));

    if (date && isNaN(date.getTime())) {
      date = undefined;
    }

    // NOTE (AB#38463): this handler deliberately does NOT normalize the value's time-of-day.
    // It accepts both shapes - a UTC-midnight AI value and a specialist pick - and normalizing
    // here would corrupt the former (local-midnight-ing a UTC-midnight instant moves it a day
    // back everywhere behind UTC). The picker's own output is normalized at the two DateField
    // call sites in renderQuickEntryRowContent instead, which is the only place a value is known
    // to be a specialist pick. See toLocalCalendarDayMidnight in formFieldHelpers.ts.

    // Picking an explicit date implicitly turns off "All Dates" - mirrors InfoToRelease.tsx's
    // changeFromDate/changeToDate. The transition itself is pure and unit-tested
    // (serviceDateAllDates.ts), so it stays in step with the All Dates checkbox below.
    const { from: nextFrom, to: nextTo, allDates: nextAllDates } =
      nextRangeForServiceDate(this.getQuickEntryServiceDateRange(), which, date);

    // Scratch echo first (always retains exactly what was picked, even
    // half a range) - see the quickEntryServiceDateOverride doc comment.
    this.setState({ quickEntryServiceDateOverride: { from: nextFrom, to: nextTo, allDates: nextAllDates } });

    this.persistQuickEntryReleaseInfo(buildReleaseInfoWithDateRange(this.getQuickEntryReleaseInfo(), nextFrom, nextTo, nextAllDates));
  }

  /**
   * Bug fix (AB#34852): "All Dates" for the Quick Entry Service Date rows.
   *
   * This reverses an earlier decision (recorded in renderQuickEntryRowContent's
   * SERVICE_DATE_FROM_ROW_ID case) to leave the control out because master-demo-v6's row
   * list has none. Requiring an explicit range meant a genuinely open-ended request - the
   * requestor asked for everything, with no date range - could not be entered in Quick Entry
   * at all and had to be taken to Classic Mode. Product confirmed 2026-07-29 that the
   * checkbox belongs in Quick Entry.
   *
   * Semantics mirror Classic's InfoToRelease.changeAllDates exactly, so the two panes cannot
   * disagree about what got saved: checking it clears both dates; unchecking it leaves the
   * (now empty) dates alone. The reverse direction already existed - picking a real date
   * clears the flag in onQuickEntryServiceDateChange above.
   *
   * One flag, both rows: the range is shared, and mapServiceDateFromTo/ToToFieldGroupRow both
   * already treat allDates as a value ("All Dates", status Confirmed), so either row's
   * checkbox satisfies both. Both are marked as edited so each shows its Confirm control,
   * same as picking a date on either one.
   */
  onQuickEntryAllDatesChange = (checked: boolean) => {
    const next = nextRangeForAllDates(this.getQuickEntryServiceDateRange(), checked);

    this.onEditQuickEntryRow(SERVICE_DATE_FROM_ROW_ID);
    this.onEditQuickEntryRow(SERVICE_DATE_TO_ROW_ID);
    this.setState({ quickEntryServiceDateOverride: { from: next.from, to: next.to, allDates: next.allDates } });
    this.persistQuickEntryReleaseInfo(
      buildReleaseInfoWithDateRange(this.getQuickEntryReleaseInfo(), next.from, next.to, next.allDates));
  }

  /** The shared "All Dates" control rendered on both Service Date rows (AB#34852). */
  renderQuickEntryAllDatesCheckbox = (allDates: boolean) => (
    <label className="qe-row__all-dates">
      <input
        type="checkbox"
        className="qe-row__all-dates-checkbox"
        checked={allDates}
        onChange={event => this.onQuickEntryAllDatesChange(event.currentTarget.checked)}
      />
      All Dates
    </label>
  )

  /**
   * AC9/AC10 (revised): N (outstanding rows) drives the morphing action
   * button, which lives in the Quick Entry panel's own footer
   * (QuickEntryActionFooter.tsx, mounted via QuickEntryFieldGroupList's
   * footer prop) per the mockup's .action-footer - not under the row list
   * itself, and not DataEntryDetailsLeftPane.tsx. Uses the
   * same isFieldGroupRowOutstanding definition QuickEntryFieldGroupList
   * itself would use, so the two never drift.
   */
  getQuickEntryOutstandingCount = (): number => {
    const rows = this.getQuickEntryRows();
    // effectiveAcknowledgedRowIds, not the raw set - a stale tick on a row that is no longer
    // acknowledgeable, or one reopened for edit, must not count as settled here.
    const acknowledged = this.effectiveAcknowledgedRowIds(rows);
    return rows.filter(row => isFieldGroupRowOutstanding(row, acknowledged)).length;
  }

  /**
   * AC2(c)/Business Rule 3 (Spec #34102 / F1d): the patient/requestor-confirmed
   * gate condition, now wired to F1c's (#34101) real match state lifted from
   * PatientInfoRow/RequestorInfoRow (matchState.ts). A row is "confirmed" when
   * it resolved to a single (green) match. A row with no keys to search on
   * (awaitingDocument -> EmptyNotRequired, e.g. no requestor fax/email extracted)
   * is not gating - it's not an outstanding match to resolve. matching / noMatch /
   * multiple(yellow) / serviceUnavailable all block until resolved to a single
   * match via the row's Edit modal (re-search).
   *
   * AC9 explicit resolution: the "Create New" path (F1c onCreatePatient/
   * onCreateRequestor) reports a match state with matched === true /
   * confidence === "single" (and userEntered === true), so a created row
   * satisfies the same "matched single" predicate below - no separate
   * resolved flag needed (F1c handoff §7.2: a userEntered created row IS
   * resolved; don't gate it out by matchMethod).
   */
  /**
   * AB#35116 Phase 2: a requestor is resolved (requestorId) but no contact
   * assigned (contactId absent) - the amber gate. Derived from the resolution
   * already bridged by onSelectRequestor. Assigning a contact sets contactId,
   * clearing amber.
   */
  isRequestorAmber = (): boolean => {
    const res = this.state.quickEntryRequestorResolution;
    if (!res) {
      return false;
    }
    if (res.mode === "select") {
      // Resolved existing requestor with no contact assigned - UNLESS the specialist
      // typed one into the requestor info (Randy 2026-07-24). A typed contact is a
      // contact: persistQuickEntryRequestorResolution creates it against this requestor
      // at Confirm All, exactly like the create-new path, so the row goes green rather
      // than nagging for an assignment that's already been made by hand.
      return res.requestorId != null && res.contactId == null
        && !willLinkContact(this.props.formState?.values ?? {});
    }
    // FR-4: a created requestor with no contact is also amber - amber == no contact
    // will be linked (shared predicate with createQuickEntryRequestor).
    // An assigned contactId settles it either way: the contact is already created and
    // linked against this requestor, so the row is green without waiting for the
    // writeContactToForm dispatches to land in formState.
    return res.contactId == null && !willLinkContact(this.props.formState?.values ?? {});
  }

  isPatientRequestorConfirmed = (): boolean => {
    const isMatchedSingle = (match: PatientMatchState | RequestorMatchState): boolean =>
      match.status === "matched" && match.confidence === "single";
    // The PATIENT is mandatory. awaitingDocument means extraction produced no
    // lastName+DOB search keys (PatientInfoRow: hasKeys === false) - the row is
    // non-interactive in that state, so treating it as "confirmed" (the prior
    // shared rule) let Confirm-All commit with NO patient ever resolved. Require
    // a single match (existing or created). If the patient can't be resolved in
    // Quick Entry, the specialist falls back to Classic Mode. (Coalesce
    // 2026-07-20: this differs from the optional requestor below - the earlier
    // shared helper reasoned only from the requestor's "no fax/email" case and
    // wrongly applied awaitingDocument->pass to the mandatory patient too.)
    const patientConfirmed = isMatchedSingle(this.state.patientMatchState);
    // The REQUESTOR is optional: awaitingDocument (no requestor fax/email
    // extracted) is a legitimate non-gating state (F1c handoff §7.2).
    const requestorConfirmed =
      this.state.requestorMatchState.status === "awaitingDocument"
      || isMatchedSingle(this.state.requestorMatchState);
    // AB#35116 Phase 2: an amber requestor (selected, no contact) is NOT confirmed -
    // blocks Confirm-All until a contact is assigned. Not acknowledge-satisfiable
    // (this gate is separate from the outstanding-row count).
    return patientConfirmed && requestorConfirmed && !this.isRequestorAmber();
  }

  /**
   * AC2/Business Rule 4 (Spec #34102 / F1d): the Confirm-All gate is
   * satisfied only when all three conditions hold - no outstanding
   * NeedsEntry/unacknowledged-LowConfidence rows (Rules 1-2), AND
   * patient/requestor confirmed (Rule 3). Rule 3 is NO LONGER a stub as of
   * the F1c (#34101) coalesce: isPatientRequestorConfirmed reads the real
   * F1c match state (patientMatchState/requestorMatchState).
   */
  isQuickEntryConfirmAllEnabled = (): boolean => {
    // AB#35149: the third condition is new - a Type/Purpose sync in flight disables Confirm All
    // outright. The round-trip is async, so until it lands the screen still shows the OLD confirmed
    // rows with an outstanding count of zero, and a specialist moving quickly could commit values
    // that were about to be replaced.
    return isConfirmAllEnabled(
      this.getQuickEntryOutstandingCount(),
      this.isPatientRequestorConfirmed(),
      this.state.quickEntryPurposeSyncing,
    );
  }

  /**
   * AC3/Business Rule 2 (Spec #34102 / F1d): acknowledging a LowConfidence
   * row adds its id to quickEntryAcknowledgedLowConfidenceIds - the row then
   * drops out of the outstanding count. No row mapper produces
   * LowConfidence yet (F1b-rois #34100's scope) - this is exercised directly
   * today (see DataEntryDetails.test.tsx Test 1.3) and wired through
   * QuickEntryFieldGroupList's optional acknowledge control for when a
   * sibling Spec's rows can actually reach that status.
   */
  onAcknowledgeQuickEntryLowConfidenceRow = (rowId: string) => {
    // Bug fix (AB#38158, defect 1): TOGGLE, not add. QuickEntryFieldGroupList renders a
    // CONTROLLED checkbox off this set, so an add-only handler made the tick permanent - React
    // re-rendered checked={true} on every subsequent change and the specialist could not take
    // back an acknowledgement they had made by mistake (the input carries no `disabled`, so it
    // read as a broken toggle). Unticking re-blocks Confirm All, which is the point of it.
    this.setState(prev => {
      const next = new Set(prev.quickEntryAcknowledgedLowConfidenceIds);
      if (!next.delete(rowId)) {
        next.add(rowId);
      }
      return {
        quickEntryAcknowledgedLowConfidenceIds: next,
        // The "Acknowledge is what clears this row" message (defect 2) has been answered once the
        // row is acknowledged, and is answered again by unticking - either way it is stale now.
        quickEntryConfirmBlockedRowId: prev.quickEntryConfirmBlockedRowId === rowId ? undefined : prev.quickEntryConfirmBlockedRowId,
      };
    });
  }

  onClickQuickEntryAction = () => {
    // AB#35149: belt to the footer's braces - the button is disabled while a purpose sync is in
    // flight, and this makes a stray call (keyboard, a stale handler) a no-op too.
    if (this.state.quickEntryPurposeSyncing) {
      return;
    }
    // Review round 3 (found while answering Mike Hamilton on PR !10065): effectiveAcknowledgedRowIds,
    // not the raw set. getQuickEntryOutstandingCount - which decides this button's label and whether
    // it reads "Confirm All" - uses the filtered set, so reading the raw set here let the two
    // disagree: with an acknowledged row reopened for edit the footer said "Next Action Required (1)"
    // while this find() saw nothing outstanding, fell through, and SUBMITTED the transaction.
    const rowsForAction = this.getQuickEntryRows();
    const outstanding = rowsForAction.find(row => isFieldGroupRowOutstanding(row, this.effectiveAcknowledgedRowIds(rowsForAction)));
    if (outstanding) {
      this.onJumpToQuickEntryRow(outstanding.id);
      return;
    }
    if (!this.isPatientRequestorConfirmed()) {
      return;
    }
    // AB#31605 (re-save): clicking Confirm All always (re-)submits while the
    // specialist is still in Quick Entry. Previously, once quickEntryCommitCompletedDate
    // was set this short-circuited to the Billing step (a workaround for the old
    // first-commit write-once, which made a second commit a no-op). Now re-commit is
    // allowed (server upserts while StatusIndicatorID < 50; create-new is one-shot
    // guarded), so a specialist who edited a value and clicked Confirm All again gets
    // it saved. onSubmitQuickEntry advances to Billing on success as before, so the
    // forward path still works when nothing changed (a harmless idempotent re-commit).
    this.onSubmitQuickEntry();
  }

  /**
   * AC11: mounts the SAME RequestTypePurposeField component the classic
   * RightPane Details tab uses for the Request Type/Purpose row, so both
   * views write into - and, for this component's own value display, read
   * from - the same DATA_ENTRY_FIELDS_FORM redux-form instance via the
   * shared writeFieldToForm helper. Sibling specs' rows fall through to
   * QuickEntryFieldGroupList's generic label/value display (this returns
   * undefined for any row id other than the Request Type/Purpose one).
   */
  /**
   * Marks a row as "actively being edited" - keeps isEditing true even
   * once row.status flips to Confirmed mid-edit, which is what keeps the
   * row open long enough for the explicit Confirm button (below, in
   * renderQuickEntryRowContent) to actually render and be clickable.
   *
   * Comment corrected (Spec #34102 / F1d, audit finding 2026-07-16): this
   * used to describe an auto-confirm-on-change design ("exits edit mode
   * automatically... rather than requiring a separate explicit 'confirm'
   * step") that predates this session's 11-commit state-machine saga and
   * was fully removed by 2c5e865/7a34280 - every row, with no exceptions,
   * now exits edit mode ONLY via an explicit Confirm click
   * (onQuickEntryFieldConfirmed below), never automatically on change.
   */
  // Maps a Quick Entry row to the DATA_ENTRY_FIELDS_FORM field(s) it edits, so
  // [Edit] can snapshot and Cancel can restore them.
  private static readonly QE_ROW_FORM_FIELDS: Readonly<Record<string, readonly string[]>> = {
    [REQUEST_TYPE_PURPOSE_ROW_ID]: [FormConstants.REQUEST_TYPE, FormConstants.PURPOSE_TYPE],
    [AUTHORIZATION_DATE_ROW_ID]: [FormConstants.AUTHORIZATION_DATE],
    [REQUEST_DATE_ROW_ID]: [FormConstants.REQUEST_DATE],
    [CASE_NUMBER_ROW_ID]: [FormConstants.CASE_NUMBER],
    [RECEIVED_DATE_ROW_ID]: [FormConstants.RECEIVED_DATE],
    [DUE_DATE_ROW_ID]: [FormConstants.DUE_DATE],
    [REQUEST_ID_ROW_ID]: [FormConstants.REQUEST_ID],
    [CLINIC_RESPONSIBLE_ROW_ID]: [FormConstants.CLINIC_RESPONISBLE],
    // Spec #35289: Audit(53) rows snapshot/restore their own form fields on Edit/Cancel.
    [AUDIT_TYPE_ROW_ID]: [FormConstants.AUDIT_TYPE],
    [ON_BEHALF_OF_ROW_ID]: [FormConstants.ON_BEHALF_OF],
  };

  // Bug fix (AB#35152): the sibling of QE_ROW_FORM_FIELDS for rows whose value does
  // NOT live in redux-form. Records Requested, Sensitive Information and the Service
  // Date pair were each moved to an optimistic-local State slice deferred to Confirm
  // All, which left them with nothing for Cancel to restore - the previous comment
  // here ("round-trip through the server and are not snapshot-revertable") described
  // a persistence model those rows had already grown out of, so Cancel silently kept
  // the edit. Listing their State keys makes Cancel work the same way on every row.
  //
  // Every slice below is replaced wholesale on change (setState with a fresh array /
  // object, never mutated in place), so snapshotting the reference is sufficient.
  private static readonly QE_ROW_STATE_KEYS: Readonly<Record<string, readonly (keyof State)[]>> = {
    [RECORDS_REQUESTED_ROW_ID]: ["quickEntryReleaseInfo", "quickEntryReleaseComments"],
    [SENSITIVE_INFO_ROW_ID]: ["quickEntrySensitiveInfo"],
    // Both date rows write the shared scratch override, and picking a complete range
    // also rebuilds releaseInfo - so cancelling either has to put both back.
    [SERVICE_DATE_FROM_ROW_ID]: ["quickEntryServiceDateOverride", "quickEntryReleaseInfo"],
    [SERVICE_DATE_TO_ROW_ID]: ["quickEntryServiceDateOverride", "quickEntryReleaseInfo"],
  };

  onEditQuickEntryRow = (rowId: string) => {
    const formFields = DataEntryDetails.QE_ROW_FORM_FIELDS[rowId] ?? [];
    const stateKeys = DataEntryDetails.QE_ROW_STATE_KEYS[rowId] ?? [];
    const formValues = this.props.formState?.values ?? {};
    this.setState(prev => {
      // AB#38460: already open with its snapshot taken - nothing to do. Every field's onChange
      // calls this on each keystroke, and the new Set below made that a state change every time;
      // the resulting render reset the picker's displayed text, so backspacing a digit snapped
      // back to the stored value. takeQuickEntryEditSnapshot was already a no-op in this case, so
      // skipping the render changes nothing else.
      if (prev.quickEntryEditingRowIds.has(rowId) && prev.quickEntryEditSnapshots[rowId]) {
        return null;
      }
      return {
      quickEntryEditingRowIds: new Set(prev.quickEntryEditingRowIds).add(rowId),
      // Bug fix (AB#35152): takeQuickEntryEditSnapshot keeps an EXISTING snapshot
      // rather than overwriting it. This method has two callers - the row's [Edit]
      // button and every field's own onChange (which is what keeps a row from
      // unmounting mid-edit once its status flips to Confirmed) - and the onChange
      // one fires after the field has already written the new value. Re-capturing
      // there snapshotted the edit itself, so Cancel "restored" whatever the
      // specialist had just typed. For free-text Case Number that meant every single
      // keystroke, which is why QA saw Cancel do nothing at all there.
      quickEntryEditSnapshots: {
        ...prev.quickEntryEditSnapshots,
        [rowId]: takeQuickEntryEditSnapshot(prev.quickEntryEditSnapshots[rowId], formFields, stateKeys, formValues, prev),
      },
      };
    });
  }

  onQuickEntryFieldConfirmed = (rowId: string) => {
    this.setState(prev => {
      if (!prev.quickEntryEditingRowIds.has(rowId)) {
        return null;
      }
      const next = new Set(prev.quickEntryEditingRowIds);
      next.delete(rowId);
      // Bug fix (AB#35152): drop the snapshot as the row leaves edit mode. The
      // once-only capture above means a leftover snapshot would be reused by the
      // NEXT [Edit] on this row, so Cancel would revert past the value the
      // specialist had already confirmed in between.
      const { [rowId]: _discarded, ...remainingSnapshots } = prev.quickEntryEditSnapshots;
      return {
        quickEntryEditingRowIds: next,
        quickEntryEditSnapshots: remainingSnapshots,
        // AB#38460: a row leaving edit mode has no unusable text on screen any more - Cancel has
        // just restored the snapshot, and Confirm is unreachable while the flag is set. Left set,
        // the row would stay red for a value the specialist can no longer see and (because the
        // flag outranks every value-based rule) could never be confirmed again. Both exits route
        // through here, and clearing by row id is a no-op for the rows that never set one.
        quickEntryInvalidDates: (() => { const rest = { ...prev.quickEntryInvalidDates }; delete rest[rowId]; return rest; })(),
        // AB#38460 (David Heifetz, PR !10140 t54570): bump the row's picker remount key HERE and
        // nowhere else. This is the one place a row leaves edit mode, and the only moment the
        // picker has to be made to forget the text it is showing.
        quickEntryDateResyncKeys: { ...prev.quickEntryDateResyncKeys, [rowId]: (prev.quickEntryDateResyncKeys[rowId] ?? 0) + 1 },
      };
    });
  }

  /**
   * Bug fix (Spec #34102 / F1d, direct user report): "Classic Mode shows the
   * full list of record types requested when applicable, but Quick Entry
   * always shows only the default three." Root cause confirmed by reading
   * DataEntryDetailsRightPane.tsx's own onChangeRequestPurpose/
   * updateRequestPurpose (unchanged by this fix) and its saga
   * (getTransactionAttributes -> DataEntryDetailsDucks.ts's
   * getTransactionAttributes generator, which re-dispatches
   * getTransactionDetailsSuccess with a FRESH transactionDetails - including
   * a releaseInfo re-computed by the backend for the new Purpose): the set
   * of applicable/full record types in transactionDetails.releaseInfo is
   * server-computed per Purpose, not a static list. Classic Mode's
   * RequestTypePurposeField call site notifies the backend of a Purpose
   * change (POST transactions/purpose) and then refreshes transactionDetails
   * via getTransactionAttributes. Quick Entry's own call site
   * (renderQuickEntryRowContent's REQUEST_TYPE_PURPOSE_ROW_ID case) never
   * did either - the F1a extraction wired onRequestPurposeChange to only
   * exit edit mode (onQuickEntryFieldConfirmed), dropping this side effect
   * entirely. So Quick Entry's releaseInfo/mapRecordsRequestedToFieldGroupRow
   * stayed frozen at whichever small generic set the transaction loaded
   * with before any Purpose was ever picked - the reported "default three".
   *
   * Deliberately does NOT reproduce Classic Mode's fee-schedule-conflict
   * dialog (RightPane's own invalidatedFeeSchedules flow) - Quick Entry
   * hasn't reached its separate Billing step yet when this row is edited, so
   * there is no already-selected fee schedule that could be invalidated;
   * clearFeeOk: false is always the correct, no-conflict-possible value here.
   */
  onQuickEntryRequestPurposeChange = async (newPurpose: number, opts?: { silent?: boolean }) => {
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const transactionDetails = this.props.transactionDetails;
    if (!transactionDetails) {
      return;
    }
    // AB#35289 (reload/reopen preview): record the purpose the preview is now loading for, so the
    // once-per-(transaction, purpose) reopen block below doesn't re-fire it (and neither does a
    // manual Confirm that already loaded the same purpose). Set on EVERY load path - this is the
    // single point that owns the guard. Reset on transaction switch.
    this.quickEntryPreviewLoadedPurpose = newPurpose;

    // AB#35149 (re-implemented against the preview - see below): capture the record-type
    // set the specialist is looking at NOW, before the change, so we can decide whether
    // their selections survive the switch. Compared by id against the new purpose's
    // preview once it lands. getQuickEntryReleaseInfo() already reflects any prior
    // preview this session, so this is the set actually on screen.
    const previousOptionSet = this.getQuickEntryReleaseInfo();

    // AB#35149: mark the sync in flight SYNCHRONOUSLY, before the await. This disables
    // Confirm All (isQuickEntryConfirmAllEnabled) for the whole fetch window - until the
    // preview lands the rows on screen are still the OLD purpose's and the outstanding
    // count is still 0, so a specialist moving quickly could otherwise commit a set that
    // is about to be replaced. Cleared when the preview resolves or fails.
    // AB#31605: this is now an in-flight MARKER only. It used to hold a releaseInfo
    // baseline that a componentDidUpdate handler compared against a REFETCHED transaction;
    // there is no longer a POST or a refetch, so the comparison is done inline below and
    // this just gates the button.
    //
    // AB#35289: `silent` skips this gate for an AUTO preview load (reload/reopen) - the operator
    // did NOT initiate a purpose change, so Confirm All must NOT be disabled while the background
    // preview loads. Only an OPERATOR-initiated change (manual Confirm) gates Confirm All, matching
    // the AB#35149 intent (guard against confirming DURING a change the specialist just made).
    if (!opts?.silent) {
      this.setState({ quickEntryPurposeSyncing: true });
    }

    // AB#31605: READ-ONLY. This used to POST transactions/purpose and then refetch
    // the whole transaction, purely because ROIS_InformationToRelease_sel derived the
    // applicable record types from the PERSISTED purpose. Three things were wrong
    // with that, all fixed by previewing instead:
    //
    //   1. It wrote to the server from an unconfirmed dropdown selection, the one
    //      exception to Quick Entry's defer-everything-to-Confirm-All contract.
    //   2. ROIS_spUTransactionRequestPurpose_upd runs "IF @RequestPurpose = 43 EXEC
    //      ROIS_RPQ_ins", and 43 is DISCLOSURE_EVENT - so selecting Disclosure Event
    //      copied the transaction into tblRPQ, set StatusIndicatorID to 100/110 and
    //      DELETEd the tblRequestBuffer row. A one-way table migration, from a
    //      dropdown.
    //   3. The refetch replaced transactionDetails wholesale, re-running
    //      isQuickEntryDataEntryStatus() (< 50). 100/110 fail it, so
    //      isQuickEntryEligible() went false and Classic rendered mid-session - the
    //      reported "I changed the purpose and got thrown into Classic view".
    //
    // Purpose now persists only in the Confirm-All gate, where every other Quick
    // Entry write already lives (persistQuickEntrySelectionsToTransaction, which
    // already had this write behind a skip-guard). getFacilityFeeSchedules moved to
    // the Billing-step entry effect in componentDidUpdate - the fee-schedule list is
    // purpose-dependent but nothing reads it until Billing.
    try {
      const optionSet = await releaseInfoPreviewApi(this.props.transactionId, global.userID, newPurpose);
      // AB#35149 (re-implemented against the preview, AB#31605): the applicable record-type
      // set is server-computed per Purpose, but purposes often share a set - and re-picking
      // record types that are still valid is busywork. Drop the specialist's selections
      // (quickEntryReleaseInfo = null) ONLY when the set genuinely changed; otherwise keep
      // them - mergeQuickEntryReleaseInfo overlays the local checked-state by id onto the
      // new option list, so a still-valid pick survives. optionSetsEqual === false means
      // definitely different; true or undefined (either side unloaded) -> keep, since there
      // is then nothing to preserve or nothing to safely clear. This replaces base's old
      // componentDidUpdate comparison, which depended on a refetch that no longer happens.
      if (opts?.silent) {
        // AB#35289 (round-10 S1): a SILENT background reopen load must be NON-DESTRUCTIVE. Only
        // populate the available purpose-driven option set (the preview) for DISPLAY. Do NOT run the
        // setChanged reconciliation - clearing the operator's persisted/rehydrated record-type
        // selections, forcing RECORDS_REQUESTED back into edit, or disabling Confirm All with NO
        // operator action would be data loss on a mere facility-config / persisted-set divergence.
        // Only an OPERATOR-initiated (non-silent) purpose CHANGE reconciles/clears selections.
        this.setState({ quickEntryReleaseInfoPreview: optionSet });
      } else {
        const setChanged = optionSetsEqual(previousOptionSet, optionSet) === false;
        this.setState(prev => ({
          quickEntryReleaseInfoPreview: optionSet,
          // Set genuinely changed: drop the stale selections AND (AB#35073) put Records
          // Requested back into the editing set so it counts as outstanding and Confirm All
          // stays disabled until the specialist has actually looked at the reloaded record
          // types. Reusing the editing set (rather than a parallel "needs re-review" flag)
          // keeps the header's attention tally and the Confirm All gate from disagreeing.
          // Set unchanged: keep the specialist's picks untouched.
          quickEntryReleaseInfo: setChanged ? null : prev.quickEntryReleaseInfo,
          quickEntryEditingRowIds: setChanged
            ? new Set(prev.quickEntryEditingRowIds).add(RECORDS_REQUESTED_ROW_ID)
            : prev.quickEntryEditingRowIds,
          quickEntryPurposeSyncing: false,
        }));
      }
    } catch {
      if (opts?.silent) {
        // AB#35289 (round-10 S2 / round-11): the operator initiated nothing, so DON'T show an error
        // toast for a failed background load - passive/log-only. No syncing to release (the silent
        // path never set it). Cap the silent load at ONE attempt: leave quickEntryPreviewLoadedPurpose
        // LATCHED (it was set to newPurpose before the await) so a failed silent load does NOT re-fire
        // on subsequent componentDidUpdate cycles - no unbounded GET-per-update storm on a
        // persistently down/slow endpoint. An OPERATOR-initiated (non-silent) purpose change/Confirm
        // is a DIRECT call and still fires regardless of the latch, so the specialist can force a
        // fresh attempt; a transaction switch re-enables one silent attempt for the next tx.
        console.warn("Quick Entry: background record-type preview load failed.");
      } else {
        // Operator-initiated change: surface it instead of failing silently - otherwise the
        // record-type set stays stale with no feedback. Nothing to roll back: no write was attempted.
        // Release the in-flight marker so Confirm All is not left disabled for the session.
        this.setState({ quickEntryPurposeSyncing: false });
        toast.error("Couldn't load the record types for that purpose - please try again.");
      }
    }
  }

  // Cancel an in-progress [Edit] (Spec #34101 / F1c): restore the snapshot value(s)
  // and exit edit mode without keeping the changes.
  //
  // Bug fix (AB#35152): also restores the State-backed slices (QE_ROW_STATE_KEYS), so
  // Records Requested / Sensitive Information / the Service Date rows revert too -
  // previously only the redux-form half was put back and those rows kept the edit.
  onQuickEntryEditCancel = (rowId: string) => {
    const fields = DataEntryDetails.QE_ROW_FORM_FIELDS[rowId] ?? [];
    const stateKeys = DataEntryDetails.QE_ROW_STATE_KEYS[rowId] ?? [];
    const snapshot = this.state.quickEntryEditSnapshots[rowId];
    const form = snapshot?.form ?? {};
    if (this.props.dispatch) {
      fields.forEach(f => writeFieldToForm(this.props.dispatch!, f, form[f]));
    }
    // Only when a snapshot actually exists: with none, `snapshot.state` would be an
    // empty object and every key would restore as undefined, wiping the row instead
    // of leaving it alone.
    if (snapshot && stateKeys.length > 0) {
      const restored: any = Object.fromEntries(stateKeys.map(key => [key, snapshot.state[key]]));

      // AB#38460: the two Service Date rows share ONE state slice, so a blanket restore of it
      // reverted the OTHER row too - cancelling "Service Date - To" blanked "Service Date - From"
      // and reopened it for edit, because To's snapshot had been taken before From was filled in.
      // Restore only the end this row owns and keep the other end as it currently stands; the row
      // being cancelled is the only one whose edit is being abandoned.
      //
      // allDates is shared and either row can toggle it, so it is part of the edit being
      // undone - but it comes from the snapshot's EFFECTIVE range, not the raw slice.
      if (rowId === SERVICE_DATE_FROM_ROW_ID || rowId === SERVICE_DATE_TO_ROW_ID) {
        const snapshotOverride = snapshot.state.quickEntryServiceDateOverride as { from?: Date; to?: Date; allDates: boolean } | null;

        // AB#38460 (David Heifetz, PR !10140 review): resolve a NULL snapshot through releaseInfo
        // before splitting the ends.
        //
        // The slice is null until the specialist first touches a Service Date, which is the
        // ordinary state for an AI-seeded or reopened transaction - there the displayed value
        // comes from releaseInfo via getQuickEntryServiceDateRange's fallback. Reading the
        // override directly gave undefined for that case, and because the object literal below is
        // ALWAYS non-null while getQuickEntryServiceDateRange only tests the override for
        // truthiness, the fallback could never fire again: Cancel permanently shadowed the row's
        // releaseInfo value with undefined and forced allDates false.
        //
        // Worse than a display bug - a non-null override also flips releaseUntouchedThisSession
        // false, so Confirm All takes the persist path and writes the cleared end back.
        //
        // Resolving through getReleaseDateRange(snapshot.state.quickEntryReleaseInfo) - already in
        // QE_ROW_STATE_KEYS for both rows, so it is in the snapshot - restores what the row was
        // actually showing. Simply skipping the merge when the snapshot is null is NOT equivalent:
        // that reintroduces the sibling-clobber this block exists to prevent, whose own test also
        // starts from a null snapshot.
        const snapshotRange = snapshotOverride
          ?? getReleaseDateRange(
            // The snapshot slice is itself null when nothing had touched Records Requested either,
            // so fall through to the SERVER option set - NOT getQuickEntryReleaseInfo(), which
            // merges the live slice and by now carries the very edit being cancelled
            // (onQuickEntryServiceDateChange writes it through persistQuickEntryReleaseInfo).
            // Reading it here would restore the edit instead of undoing it. The server set does
            // not change mid-edit, so reading it now is the same as reading it at snapshot time.
            (snapshot.state.quickEntryReleaseInfo as readonly Release[] | null)
              ?? this.state.quickEntryReleaseInfoPreview
              // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
              // eslint-disable-next-line no-restricted-syntax
              ?? this.props.transactionDetails?.releaseInfo
              ?? []);
        const currentRange = this.getQuickEntryServiceDateRange();
        restored.quickEntryServiceDateOverride = {
          from: rowId === SERVICE_DATE_FROM_ROW_ID ? snapshotRange?.from : currentRange.from,
          to: rowId === SERVICE_DATE_TO_ROW_ID ? snapshotRange?.to : currentRange.to,
          allDates: snapshotRange?.allDates ?? false,
        };
      }

      this.setState(restored as unknown as Pick<State, keyof State>);
    }
    this.onQuickEntryFieldConfirmed(rowId);
  }

  /**
   * AB#35066: whether a Quick Entry row's CURRENT value is doc-sourced (equals the
   * AI-extracted value, unedited) - the gate for the per-value grounding icon. Most
   * rows' mappers already carry this as FieldGroupRow.isAiPreSelected; the three rows
   * whose mappers never receive the AI value (Records Requested + the two Service Date
   * rows - seeded via a different path) are compared against requestAnalysis.data here,
   * so their isAiPreSelected stays false and the "AI pre-selected" chip is unchanged.
   * The composite Request Type/Purpose row is decided PER SUB-VALUE at its own render
   * case (resolveRequestTypePurposeGrounding), not here.
   */
  isQuickEntryValueDocSourced = (row: FieldGroupRow): boolean => {
    const data = this.props.requestAnalysis?.data;
    switch (row.id) {
      case SERVICE_DATE_FROM_ROW_ID:
        return serviceDateDocSourced(data?.serviceDates, this.getQuickEntryServiceDateRange()).from;
      case SERVICE_DATE_TO_ROW_ID:
        return serviceDateDocSourced(data?.serviceDates, this.getQuickEntryServiceDateRange()).to;
      case RECORDS_REQUESTED_ROW_ID:
        return isRecordsRequestedDocSourced(data?.infoReleaseSections ?? [], this.getQuickEntryReleaseInfo());
      // AB#37856: the fourth row whose mapper hardcodes isAiPreSelected=false. Without this
      // case a seeded-and-accepted Sensitive Information row painted the blue "user-entered"
      // badge - exactly the bug AB#35289 closed for Records Requested. There is no inline
      // grounding icon to agree with here (the producer never grounds this field), so the
      // badge is the only doc-sourced signal the row has.
      //
      // AB#37856 (security review M1): reads the OWNERSHIP-GATED analysis rather than `data`
      // above, so this and the corrections payload cannot disagree about which analysis is
      // authoritative. Display-only on its own, but a foreign analysis painting a green
      // "from the document" badge would vouch for a value that document never asserted. The three
      // pre-existing cases above keep the raw read - not this fix's diff to widen.
      case SENSITIVE_INFO_ROW_ID:
        return isSensitiveInfoDocSourced(this.ownedRequestAnalysis()?.data?.sensitiveInfoDeclarations ?? [], this.getQuickEntrySensitiveInfo());
      default:
        return row.isAiPreSelected;
    }
  }

  renderQuickEntryRowContent = (row: FieldGroupRow) => {
    const values = this.props.formState?.values ?? {};
    const requestType = values[FormConstants.REQUEST_TYPE];
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const facility = this.props.transactionDetails?.facility;
    // Bug fix (AB#31605): identity-guarded details for the persisted-link
    // pre-resolve (never build a match from a stale prior-tx transactionDetails),
    // and the reopen-vs-fresh signal. A plain reopen (no fresh extraction this
    // session) prefers the persisted patient/requestor link over re-searching the
    // stale re-fetched AI keys; a fresh extraction (doc replace / re-run intake)
    // flips this so the new extraction drives the search instead.
    const guardedTransactionDetails = this.currentTransactionDetails();
    const freshExtraction = this.state.quickEntryFreshExtractionTransactionId === this.props.transactionId;
    // Whether transactionDetails has loaded for THIS tx (so the persisted-link
    // status is known) and whether the transaction's initial fetches (incl. the
    // patient/requestor detail fetch) have settled. intiaTxlSagaCallCount >= 18 is
    // the same "initial load done" heuristic this component already uses to drop
    // the loading spinner (see componentDidUpdate). Used only to RELEASE the
    // reopen hold (MINOR-B wedge) - the race hold (MINOR-A) is driven by the
    // deterministic link-status-known signal, independent of this count.
    const linkStatusKnown = Boolean(guardedTransactionDetails);
    const initialLoadSettled = this.props.intiaTxlSagaCallCount >= 18;
    const persistedPatientMatch = buildPersistedPatientMatch(guardedTransactionDetails, this.props.patientDetails);
    const patientMatchGate = resolvePersistedMatchGate({
      freshExtraction,
      hasLink: !!guardedTransactionDetails?.patient?.id,
      linkStatusKnown,
      persistedMatchResolved: !!persistedPatientMatch,
      loadSettled: initialLoadSettled,
    });
    const persistedRequestorMatch = buildPersistedRequestorMatch(guardedTransactionDetails, this.props.requestorDetails);
    const requestorMatchGate = resolvePersistedMatchGate({
      freshExtraction,
      hasLink: !!guardedTransactionDetails?.sendToRequestor?.id,
      linkStatusKnown,
      persistedMatchResolved: !!persistedRequestorMatch,
      loadSettled: initialLoadSettled,
    });

    // Row badge numbers are fixed (master-demo-v6.html's own sequence never
    // shifts) - direct user feedback after comparing against the actual
    // demo: rows whose prerequisite isn't met yet (e.g. Purpose not picked,
    // Disclosure Accounting type, no Clinic/Department config) stay visible
    // in their fixed slot rather than being hidden/renumbered; they're just
    // non-interactive until the prerequisite is satisfied. getQuickEntryRows
    // already forces status to EmptyNotRequired for these so they're
    // correctly excluded from the outstanding/attention counts.
    if (!this.isQuickEntryRowApplicable(row.id)) {
      return (
        <div className="qe-row__body">
          <div className="qe-row__label">{row.label}</div>
          <div className="qe-row__value qe-row__value--disabled">Not applicable yet</div>
        </div>
      );
    }

    // Patient Info / Requestor Info (Spec #34101 / F1c) always render their
    // own live content - unlike the other rows below, they don't use the
    // isEditing label/value+Edit-button split (the Edit affordance opens
    // MatchModal instead, self-managed inside each row component).
    if (row.id === PATIENT_INFO_ROW_ID) {
      const data = this.props.requestAnalysis?.data;
      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
      // eslint-disable-next-line no-restricted-syntax
      const facilityId = this.props.transactionDetails?.facility?.id ?? 0;
      return (
        <PatientInfoRow
          extractedLastName={data?.patientFamilyName}
          extractedFirstName={data?.patientGivenName}
          extractedDob={data?.patientDateOfBirth ? toDisplayDob(new Date(data.patientDateOfBirth).toISOString().substring(0, 10)) : undefined}
          search={(keys) => patientSearchApi({ facilityId, userId: global.userID ?? 0, ...keys }).then(response => response.data)}
          // Bug fix (AB#31605 reopen): on a plain reopen, pre-resolve the row from
          // the transaction's persisted patient link (built from the identity-
          // guarded transactionDetails.patient + the auto-fetched patient record)
          // and suppress the automated search so it doesn't re-search off stale AI
          // keys. preferPersistedMatch is false once a fresh extraction fires, so a
          // real re-extraction still drives the search + match.
          persistedMatch={persistedPatientMatch}
          preferPersistedMatch={patientMatchGate.prefer}
          awaitingPersistedMatch={patientMatchGate.awaiting}
          onMatchStateChange={this.onPatientMatchStateChange}
          onCreatePatient={this.onCreatePatient}
          onSelectPatient={this.onSelectPatient}
          fieldGroundings={this.props.requestAnalysis?.fieldGroundings}
          onRevealGrounding={this.onRevealQuickEntryGrounding}
          onGroundingUnavailable={this.onQuickEntryGroundingUnavailable}
        />
      );
    }
    if (row.id === REQUESTOR_INFO_ROW_ID) {
      const data = this.props.requestAnalysis?.data;
      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
      // eslint-disable-next-line no-restricted-syntax
      const facilityId = this.props.transactionDetails?.facility?.id ?? 0;
      const ddsSiteCodeForRow = resolveDdsSiteCode(
        requestType,
        Boolean(this.currentTransactionDetails()?.sendToRequestor?.id),
        values,
      );
      // Spec #35136 (F1f): for a DDS (Disability/Social Security) transaction, the
      // barcode field set belongs with the requestor information - it precedes the
      // requestor search in Classic (RequestorContactPanel renders DDS fields, then
      // Case Number, then the search), and RQ Site Code feeds the search directly.
      // So the DDS fields render ahead of the requestor content in THIS row rather
      // than as a separate row, mirroring Classic's single continuous panel.
      const showDdsFields = requestType === DISABILITY_OR_SOCIAL_SECURITY;
      // Bug fix (direct dev report, AB#35136 follow-up): the DDS fields and the requestor
      // search used to render as TWO SIBLING children of this row's content slot, which
      // is a display:flex ROW (QuickEntryFieldGroupList.scss .qe-row) - so they landed
      // SIDE BY SIDE instead of stacked, unlike Classic Mode (RequestorContactPanel),
      // which renders the barcode fields, then a divider, then a full-width requestor
      // search below - both under ONE "Requestor Info" heading, since both are Requestor
      // Info. `.qe-row__dds-group` takes over the flex-row slot instead (same flex: 1 1
      // auto/min-width: 0 .qe-row__body already used) and stacks its own children in a
      // column: one heading, the plain (unboxed) barcode fields, a divider, then this row's
      // search - full width, one above the other. Non-DDS requests are untouched - this
      // wrapper only exists when showDdsFields is true.
      const requestorInfoRow = (
        <RequestorInfoRow
          // AB#35289 (source-flagged reset): keyed on the requestor reset generation so a
          // type->Internal reset REMOUNTS just this row, re-firing its automated-match effect
          // (which re-searches with the Internal type filter via the AC5 `search` closure). The
          // patient row is untouched (unlike the pane-wide quickEntryIntakeGeneration key).
          key={`requestor-${this.state.quickEntryRequestorResetGeneration}`}
          // Direct dev report: for DDS, the group wrapper below renders ONE
          // "Requestor Info" heading above both the barcode fields and this
          // row's search - this row's own internal heading would duplicate it.
          showLabel={!showDdsFields}
          extractedFax={data?.requestorContactFax}
          extractedPhone={data?.requestorContactPhone}
          extractedEmail={data?.requestorContactEmail}
          extractedName={data?.requestorName}
          extractedAddress1={data?.requestorAddress1}
          extractedCity={data?.requestorCity}
          extractedAddress2={data?.requestorAddress2}
          extractedState={data?.requestorState}
          extractedZip={data?.requestorZipCode}
          extractedContactFirstName={data?.requestorContactGivenName}
          extractedContactLastName={data?.requestorContactFamilyName}
          // AB#35289 (AC5): scope the auto-match search to Internal requestors
          // (typeOfRequestorID=5005) when the LIVE-selected request type is Internal,
          // even though QE hasn't persisted the type yet. Non-Internal => omitted =>
          // unfiltered (mirrors Classic).
          search={(keys) => requestorSearchApi({
            facilityId,
            userId: global.userID ?? 0,
            ...keys,
            typeOfRequestorID: this.isLiveRequestTypeInternal() ? TypeOfRequestorID.INTERNAL : undefined,
          }).then(response => response.data)}
          // AB#39052 (Ali Moll, PR !10513 thread 56655): the requestor search is
          // requestor-level and returns a contact ID without its demographics, so the row
          // reads them by id for the ONE contact it resolves to. Mapped to the row's field
          // names here, at the boundary, so the row never sees the Contact record's shape.
          resolveContact={(contactId) => requestorContactApi(contactId).then(contact => (contact ? {
            contactFirstName: contact.firstName ?? "",
            contactLastName: contact.lastName ?? "",
            email: contact.email ?? "",
            phone: contact.phone ?? "",
            fax: contact.fax ?? "",
          } : undefined))}
          // Bug fix (AB#31605 reopen): on a plain reopen, pre-resolve the row from
          // the transaction's persisted requestor link (identity-guarded
          // sendToRequestor/sendToContact + the auto-fetched, id-matched requestor
          // record) and suppress the automated search so it doesn't re-search off
          // stale AI keys. preferPersistedMatch is false once a fresh extraction
          // fires. The builder returns undefined until the FULL matching record is
          // loaded, so the row shows a transient matching state rather than
          // freezing a blank address/contact into the send-to form (AB#35081).
          persistedMatch={persistedRequestorMatch}
          preferPersistedMatch={requestorMatchGate.prefer}
          awaitingPersistedMatch={requestorMatchGate.awaiting}
          // Spec #35136 (F1f): for DDS, hand the barcode's RQ Site Code to the row
          // so its automated-search effect keys the SAME /requestor-search endpoint
          // on siteCode and resolves inline (no modal), exactly like the fax/email
          // intake match. Only for DDS, and not when a saved requestor link already
          // owns the row (reopen); undefined otherwise so non-DDS is untouched.
          ddsSiteCode={ddsSiteCodeForRow}
          isDdsRequest={requestType === DISABILITY_OR_SOCIAL_SECURITY}
          currentDdsSiteCode={values[RequestorFormConstants.RQ_SITE_CODE]}
          onMatchStateChange={this.onRequestorMatchStateChange}
          onCreateRequestor={this.onCreateRequestor}
          contactSaveError={this.state.quickEntryContactSaveError}
          onSelectRequestor={this.onSelectRequestor}
          onOpenRequestorModal={(keys) => this.setState(prev => ({
            requestorModalOpen: true,
            quickEntryRequestorSearchKeys: keys,
            // Counter, not a boolean: every Search must re-run the classic search, even
            // on unchanged keys (it keys the pane's remount - see RequestorContactModal).
            quickEntryRequestorSearchSignal: (prev.quickEntryRequestorSearchSignal ?? 0) + 1,
          }))}
          onAssignContact={() => this.setState({ assignContactOpen: true })}
          assignedContact={this.state.quickEntryAssignedContact}
          createOpenSignal={this.state.quickEntryCreateRequestorSignal}
          selectedRequestor={this.state.quickEntryModalRequestor}
          fieldGroundings={this.props.requestAnalysis?.fieldGroundings}
          onRevealGrounding={this.onRevealQuickEntryGrounding}
          onGroundingUnavailable={this.onQuickEntryGroundingUnavailable}
        />
      );
      if (!showDdsFields) {
        return requestorInfoRow;
      }
      return (
        <div className="qe-row__dds-group">
          <div className="qe-row__label">Requestor Info</div>
          <div className="qe-row__dds">
            <DdsFieldsGroup values={values} dispatch={this.props.dispatch!} />
          </div>
          <hr className="qe-row__dds-divider" />
          {requestorInfoRow}
        </div>
      );
    }

    // Spec #35135 (AC1): Disclosure Information is a COMPOSITE row - like
    // Patient/Requestor above (and unlike the scalar rows below) it always renders
    // its own live multi-field content rather than the read-only value + Edit /
    // edit + Confirm split. Editing is local state only; the write happens at
    // Confirm All (see onQuickEntryDisclosureChange).
    if (row.id === DISCLOSURE_INFO_ROW_ID) {
      return (
        <QuickEntryDisclosureRow
          draft={this.getQuickEntryDisclosureDraft()}
          disclosureReasons={this.props.disclosureReasons ?? []}
          phiCodes={this.props.selectedPHICodes ?? []}
          onChange={this.onQuickEntryDisclosureChange}
        />
      );
    }

    // AB#38161 (PRD v2.10 line 136): the "No provider specified" state, and nothing else.
    // allowEntry={false} renders the notice ALONE with no inputs - Feature 3's extraction, editing
    // and persistence are deferred to August (#33165 / Spec #34099), so there is nowhere for an
    // entered value to go, and an editable field whose value is discarded on reopen is worse than
    // no field at all.
    //
    // Returned BEFORE the isEditing gate below, like the Patient / Requestor / Disclosure rows.
    //
    // Corrected after review: an earlier version of this comment claimed the gate would give the
    // row a permanently visible Confirm button. It would not - measured, not inferred. Falling
    // through renders no button at all, because the gate's switch has no arm for this row id and
    // returns undefined, so QuickEntryFieldGroupList renders its own generic label/value markup
    // and row.value already reads "No provider specified".
    //
    // What the early return actually buys, and why it stays:
    //   1. ProviderFacilityField renders at all. It is the seam Feature 3's PR (!9593) plugs into;
    //      without this call site the component is unreachable on this branch and F3's conflict
    //      would land somewhere else, which is the opposite of what this extraction is for.
    //   2. role="status" on the notice. The generic <span> path has no live region, and this pane
    //      updates in place as an extraction lands, so a screen reader is told nothing.
    // Feature 3's PR moves this into the switch below, where an editable group with a commit path
    // needs the Confirm button that arm provides.
    //
    // AB#38597 update: point 1 above no longer holds TODAY. The row is filtered out of visibleRows,
    // so this block is unreachable on this branch and nothing fails if it is deleted. It is kept
    // anyway because it is the seam Feature 3 plugs into, and it becomes live again the moment
    // isQuickEntryRowApplicable stops returning false for this row - at which point point 1 and the
    // role="status" argument in point 2 both apply again. Its only test is skipped alongside, so
    // whoever merges feature/intake1.1bFeature3ProviderFacility must un-skip "the Provider/Facility
    // row renders through ProviderFacilityField, as a live region" when the row comes back, or the
    // seam returns unguarded. (That is the one of the three skipped tests that covers THIS block;
    // the other two exercise the generic label/value path and would pass through the fallthrough.)
    if (row.id === PROVIDER_FACILITY_ROW_ID) {
      return (
        <div className="qe-row__body">
          <div className="qe-row__label">{row.label}</div>
          <div className="qe-row__value">
            <ProviderFacilityField
              values={PROVIDER_FACILITY_UNSCOPED}
              noProviderSpecified
              allowEntry={false}
              onChange={PROVIDER_FACILITY_NO_CAPTURE}
            />
          </div>
        </div>
      );
    }

    // Bug fix (AB#38158, defect 3b): an acknowledged row SETTLES. Acknowledgement is the only exit
    // an ungrounded (amber) row has - its status is computed from grounding, so no amount of
    // confirming can make it Confirmed - and until now ticking the box changed nothing on screen:
    // the field kept rendering, "Not verified against the document" kept showing, and an
    // acknowledged row was pixel-identical to an unacknowledged one apart from the tick. Settling
    // collapses it to the same read-only display a Confirmed row gets (value + the statusExplanation
    // ⓘ, which still records that the value was never verified) with [Edit] to reopen, and the
    // Acknowledge checkbox stays rendered so it can be unticked. The row's STATUS is deliberately
    // untouched: it must not read as AI-confirmed, and status drives the sort tier.
    // Scoped to rows the Acknowledge control is actually offered on (LowConfidence and not
    // self-resolving) - a patient/requestor multiple-match row resolves by picking a candidate.
    const isSettledByAcknowledgement = this.isQuickEntryRowAcknowledgeable(row)
      && this.state.quickEntryAcknowledgedLowConfidenceIds.has(row.id);
    const isEditing = (row.status !== FieldGroupRowStatus.Confirmed && !isSettledByAcknowledgement)
      || this.state.quickEntryEditingRowIds.has(row.id);

    if (!isEditing) {
      const fieldGroundings = this.props.requestAnalysis?.fieldGroundings;
      // AB#35066: reuse the SAME reveal/no-source handlers the per-row confidence
      // affordance uses (QuickEntryFieldConfidence's onRevealGrounding/onNoSource),
      // so the per-value ≡ icon scrolls to source where grounding exists and degrades
      // to the informational no-source path where it doesn't - never a hard error.
      const editButton = (
        <div className="qe-row__action">
          <button type="button" className="qe-btn" onClick={() => this.onEditQuickEntryRow(row.id)}>Edit</button>
        </div>
      );
      switch (row.id) {
        case REQUEST_TYPE_PURPOSE_ROW_ID: {
          // AB#35066: the composite row carries TWO values, each with its own
          // doc-sourced state - split the read-only display into Type / Purpose so the
          // grounding icon can be decided (and shown) per sub-value, matching the v6
          // mockup (icon next to "Legal" AND next to "Litigation / Civil").
          const tp = resolveRequestTypePurposeGrounding(this.props.requestAnalysis?.data, {
            requestType,
            requestPurpose: values[FormConstants.PURPOSE_TYPE],
            requestTypes: this.props.requestTypes,
          });
          const hasSplit = Boolean(tp.typeLabel || tp.purposeLabel);
          return (
            <>
              <div className="qe-row__body">
                <div className="qe-row__label">{row.label}</div>
                <div className="qe-row__value">
                  {hasSplit ? (
                    <>
                      {tp.typeLabel ? (
                        <span className="qe-row__value-part">
                          {tp.typeLabel}
                          {tp.typeDocSourced ? (
                            <QuickEntryGroundingIcon
                              field="requestType"
                              label="Request Type"
                              fieldGroundings={fieldGroundings}
                              onReveal={this.onRevealQuickEntryGrounding}
                              onUnavailable={this.onQuickEntryGroundingUnavailable}
                            />
                          ) : null}
                        </span>
                      ) : null}
                      {tp.purposeLabel ? (
                        <span className="qe-row__value-part">
                          {tp.purposeLabel}
                          {tp.purposeDocSourced ? (
                            <QuickEntryGroundingIcon
                              field="requestPurpose"
                              label="Request Purpose"
                              fieldGroundings={fieldGroundings}
                              onReveal={this.onRevealQuickEntryGrounding}
                              onUnavailable={this.onQuickEntryGroundingUnavailable}
                            />
                          ) : null}
                        </span>
                      ) : null}
                    </>
                  ) : (
                    <span className="qe-row__value-part">{row.value}</span>
                  )}
                  {/* AB#35075: the Request Type/Purpose row renders its own collapsed markup (split
                      Type/Purpose lines), so the generic statusExplanation ⓘ in QuickEntryFieldGroupList
                      never reached it - the specialist had to click Edit to learn why the row was amber. */}
                  {row.statusExplanation ? (
                    <span
                      className="qe-row__status-info"
                      title={row.statusExplanation}
                      role="img"
                      aria-label={row.statusExplanation}
                    >&#9432;</span>
                  ) : null}
                  {row.isAiPreSelected ? <span className="qe-chip--ai">AI pre-selected</span> : null}
                </div>
              </div>
              {editButton}
            </>
          );
        }
        case AUTHORIZATION_DATE_ROW_ID:
        case REQUEST_DATE_ROW_ID:
        case CASE_NUMBER_ROW_ID:
        case RECEIVED_DATE_ROW_ID:
        case DUE_DATE_ROW_ID:
        case REQUEST_ID_ROW_ID:
        case CLINIC_RESPONSIBLE_ROW_ID:
        case AUDIT_TYPE_ROW_ID:
        case ON_BEHALF_OF_ROW_ID:
        case SERVICE_DATE_FROM_ROW_ID:
        case SERVICE_DATE_TO_ROW_ID:
        case RECORDS_REQUESTED_ROW_ID:
        case SENSITIVE_INFO_ROW_ID: {
          /* AB#38128: doc-sourced is necessary but not sufficient - the glyph must also be able to
             RESOLVE. Records Requested and Sensitive Information map to contract fields the producer
             never grounds, and Received Date / Due Date map to no contract field at all, so on those
             four the glyph could only ever render the no-grounding variant and report "No source
             location is available for this field." on a value the extraction did produce. The status
             badge still carries their provenance.

             Two terms, not one, and the order matters. rowCanBeGrounded is the fast path, but it
             mirrors the producer's App Configuration scope rather than code, so a config widening
             would otherwise silently hide a glyph that had started working - with no error and no log
             line. Letting a live FieldGrounding win makes the gate self-correcting: if the payload
             contains a location for this field, we render regardless of what the denylist believes.

             Read off the STAMPED isDocSourced rather than re-calling isQuickEntryValueDocSourced, so
             the badge and this inline glyph consume the SAME derived value within a render and cannot
             disagree. The row reaching here is always the stamped one: getQuickEntryRows feeds
             QuickEntryFieldGroupList (the only renderRowContent wiring), and its numberedRows spread
             preserves the flag. */
          const groundingIcon = row.isDocSourced
            && (rowCanBeGrounded(row.id)
              || findFieldGrounding(fieldGroundings, confidenceKeyForRow(row.id))) ? (
            <QuickEntryGroundingIcon
              field={confidenceKeyForRow(row.id)}
              label={row.label}
              fieldGroundings={fieldGroundings}
              onReveal={this.onRevealQuickEntryGrounding}
              onUnavailable={this.onQuickEntryGroundingUnavailable}
            />
          ) : null;
          return (
            <>
              <div className="qe-row__body">
                <div className="qe-row__label">{row.label}</div>
                {/* AB#35066: value + ≡ icon + "AI pre-selected" chip must sit on
                    ONE line (wrapping only when genuinely tight). The base
                    .qe-row__value is a plain block, so the block value-part filled
                    the line and pushed the icon/chip below regardless of pane
                    width - the --inline modifier makes this a flex row. Scoped to
                    these scalar rows so the composite Type/Purpose row (stacks its
                    sub-values) and the Records/Sensitive table rows are untouched.
                    The icon stays nested in the value-part so "value ≡" travels as
                    a unit - except on the display-parts path below, where it is a
                    sibling of the parts for the reason stated there. */}
                <div className="qe-row__value qe-row__value--inline">
                  {/* AB#39380: a specialist-typed addendum renders in its own element, beside the
                      record type it describes and outside every element the provenance signals
                      decorate - isDocSourced is computed from the checked release items and cannot
                      see typed text, so a glyph sharing its element would vouch for a string it
                      never examined (Mike Hamilton, PR !10721 rounds 2 and 3). Parts, not one
                      trailing note: appended to the whole value it read as belonging to whichever
                      type came last. */}
                  {row.displayParts ? (
                    <>
                      {/* One record type per LINE while a description is on screen, rather than
                          the usual comma-separated line: the description is a clamped box of up
                          to 2,000 characters, so anything following it on the same line was
                          pushed onto a line of its own and started it with the separator -
                          ", History and Physical" (measured against the compiled stylesheet).
                          Same one-per-line shape as the read-only Records pane. */}
                      <span className="qe-row__value-parts">
                        {row.displayParts.map((part, index) => (
                          <span className="qe-row__value-line" key={`${index}-${part.text}`}>
                            <span className="qe-row__value-part">{part.text}</span>
                            {part.note ? (
                              <span className="qe-row__value-note" title={part.note}>
                                {/* Non-breaking: the note is its own clamped box, and a box
                                    strips a leading ordinary space - "Other- films". */}
                                {`\u00a0- ${part.note}`}
                              </span>
                            ) : null}
                          </span>
                        ))}
                      </span>
                      {groundingIcon}
                    </>
                  ) : (
                    <span className="qe-row__value-part">
                      {row.value}
                      {groundingIcon}
                    </span>
                  )}
                  {row.isAiPreSelected ? <span className="qe-chip--ai">AI pre-selected</span> : null}
                </div>
              </div>
              {editButton}
            </>
          );
        }
        default:
          return undefined;
      }
    }

    let field: React.ReactNode;
    switch (row.id) {
      case REQUEST_TYPE_PURPOSE_ROW_ID:
        field = (
          <RequestTypePurposeField
            requestTypes={this.props.requestTypes}
            value={requestType}
            purposeValue={values[FormConstants.PURPOSE_TYPE]}
            isAiPreSelected={row.isAiPreSelected}
            // Amber / purpose-uncertain (TDD §11): API resolved a type but the purpose was
            // present-yet-not-a-valid-child. The field self-suppresses once a purpose is picked.
            purposeUncertain={this.props.requestAnalysis?.data?.requestPurposeUncertain}
            // AB#35075: the second type the document also supported, shown as the amber hint's label
            // and named in its tooltip. Purpose appended only when the secondary resolved one too
            // (a type-only suggestion is still useful).
            secondaryTypeLabel={this.resolveSecondaryTypeLabel()}
            secondaryPresent={this.props.requestAnalysis?.data?.secondaryRequestTypeMapped != null
              || Boolean(this.props.requestAnalysis?.data?.secondaryRequestType)}
            // AB#37979 (David Heifetz, PR !9995 Important 3): the same verdict the row's amber tier is
            // computed from, passed to the field so the REASON is visible. statusExplanation cannot
            // reach this row - QuickEntryFieldGroupList renders that only in its default markup and
            // this row supplies renderRowContent - so the field surfaces it, exactly as AB#35075 does.
            // Read from ownedRequestAnalysis so a stale analysis from another transaction cannot leak
            // a hint onto this one, matching the mapper call above.
            typeUngrounded={this.ownedRequestAnalysis()?.confidence?.requestType === GroundingState.InferredNoSource}
            // The free-text purpose the AI extracted (e.g. "Attorney") — shown in the amber hint's
            // tooltip to explain WHY it's uncertain (not a valid purpose for the resolved type).
            extractedPurpose={this.props.requestAnalysis?.data?.requestPurpose}
            // Type not an exact catalog match: show the AI free text in red (non-selectable). True when
            // the analysis completed and extracted a request type that didn't resolve to a catalog id.
            extractedType={this.props.requestAnalysis?.data?.requestType}
            typeNotExact={this.props.requestAnalysis?.status === RequestAnalysisStatus.Completed
                && Boolean(this.props.requestAnalysis?.data?.requestType)
                && (this.props.requestAnalysis?.data?.requestTypeMapped === undefined
                    || this.props.requestAnalysis?.data?.requestTypeMapped === null)}
            dispatch={this.props.dispatch!}
            // Bug fix (Spec #34102 / F1d, direct user report): this no
            // longer also calls onQuickEntryFieldConfirmed - auto-confirming
            // the instant Purpose changed left the row's Confirm button
            // pattern below inconsistent (Type alone never confirmed, since
            // it has no onRequestTypeChange wiring at all, while Purpose
            // alone always did) and meant Purpose couldn't be corrected a
            // second time without re-opening the row. The explicit Confirm
            // button in this row's qe-row__action slot (below) is now the
            // ONLY way this row exits edit mode - matches every other
            // non-auto-confirm row (Case Number, Request Date, Service
            // Date, Records Requested, Sensitive Info). Still runs the real
            // backend Purpose-change round-trip (onQuickEntryRequestPurposeChange) -
            // that side effect is independent of exiting edit mode.
            //
            // Bug fix (Spec #34102 / F1d, direct user report - "no confirm
            // unless you type in, and then click to edit again"): a fresh
            // NeedsEntry row never got added to quickEntryEditingRowIds
            // before now, since neither onRequestTypeChange (never wired at
            // all) nor onRequestPurposeChange called onEditQuickEntryRow -
            // unlike CaseNumberField's onCaseNumberChange, which does this
            // for exactly the same reason (see its own comment). So the
            // instant both dropdowns held valid values, row.status flipped
            // to Confirmed while the Set still didn't have this row's id -
            // isEditing's OR (`row.status !== Confirmed || ...has(id)`)
            // went false on BOTH halves in the same render, skipping the
            // Confirm-button state entirely and jumping straight to the
            // read-only "Edit" view. Only explicitly re-opening via Edit
            // (which does add the id to the Set) ever showed Confirm.
            // Calling onEditQuickEntryRow on every change closes that gap.
            onRequestTypeChange={(newType) => {
              this.onEditQuickEntryRow(row.id);
              // Spec #35136 (F1f), Business Rule 3 / AC-3: mirror Classic's
              // onChangeRequestType barcode trigger (DataEntryDetailsRightPane.tsx:
              // 1134-1137) - when DDS is picked AND exactly one REQ document exists,
              // fire the scan. Gated ONLY on request type + REQ-doc count, never on
              // any Quick Entry / Intake Intelligence feature flag (the DDS barcode
              // reader is independent of the AI-extraction trigger).
              const reqDocs = (this.props.documentsList ?? []).filter(el => el.id.includes('REQ'));
              if (reqDocs.length === 1 && newType === DISABILITY_OR_SOCIAL_SECURITY) {
                this.props.readBarCodeDDSRequest?.(reqDocs[0].id);
              }
              // AB#37984 (issue 1): mirror Classic's other onChangeRequestType cascade - Audit
              // authorizes every Sensitive Information category. Deferred a tick because the new
              // type is written to the form by the shared field component, and this reads it back
              // from formState rather than trusting the argument, so the two cannot disagree.
              //
              // Round-2 review S-2: registered in quickEntryWriteTimers so componentWillUnmount
              // clears it, exactly like the auto-advance and settle-guard timers - the specialist
              // can pick a type and leave in the same tick (queue navigation, tab change), and a
              // callback that survives the unmount calls setState on a dead component.
              //
              // AB#37984 (round-8, repeat-switch parity): forced. This IS the real dropdown change
              // event Classic's own cascade is wired to, which has no "already did this" memory -
              // picking Audit a second time on the same transaction re-clobbers just as the first
              // time did. Passing force=true bypasses the once-per-transaction latch so this call
              // site alone matches that; the AI-extraction arrival path does not force.
              //
              // AB#37984 (round-15): a queue-navigation click before this tick fires must not let
              // the pending write land on whatever transaction is on screen by then.
              const pickedForTransactionId = this.props.transactionId;
              const auditSeedTimer = setTimeout(() => {
                this.quickEntryWriteTimers.delete(auditSeedTimer);
                if (this.props.transactionId !== pickedForTransactionId) {
                  return; // navigated away before this pick's deferred write ran - do not write onto a different transaction
                }
                this.seedAuditSensitiveInfo(true);
              }, 0);
              this.quickEntryWriteTimers.add(auditSeedTimer);
            }}
            // AB#35149: this used to also fire onQuickEntryRequestPurposeChange on every change,
            // while the row was still open. That POSTs the purpose, discards Records Requested and
            // refreshes transactionDetails - resetting other rows before the specialist had
            // confirmed anything, with Cancel powerless because it had already happened. The
            // round-trip moved to this row's Confirm (see onClickEditModeConfirmButton).
            onRequestPurposeChange={() => {
              this.onEditQuickEntryRow(row.id);
              // AB#37984 (round-6 review, thread 53036) ORIGINALLY called seedAuditSensitiveInfo()
              // here too: picking Audit before Purpose found isQuickEntryRowApplicable's gate shut
              // and deferred, and nothing else re-ran the seed. Round 9 removed that gate from
              // seedAuditSensitiveInfo entirely - Classic's cascade never depended on Purpose either
              // - so the deferral this call site existed to catch can no longer happen; the Type
              // change site now authorizes immediately regardless of Purpose.
              //
              // Removed (round 10, independent review finding M1) rather than left as a no-op: an
              // UNFORCED call here is a genuine hazard on any OTHER path into this handler.
              // auditSensitiveInfoSeeded only burns when a proposal is actually produced, so on a
              // reopened Audit transaction with saved answers and no fresh extraction (the latch
              // starts false and the AI-extraction path never runs without a Completed analysis),
              // the unforced call read as "first attempt" rather than "retry" and would silently
              // overwrite the specialist's saved Sensitive Info answers the moment they changed
              // Purpose from Internal to External Audit or back - a normal, unrelated action that
              // must not touch a different row's saved data.
            }}
            quickEntryCompact
          />
        );
        break;
      case AUTHORIZATION_DATE_ROW_ID:
        // Bug fix (Spec #34102 / F1d, direct user report - "authorization
        // date is having auto confirm, instead of waiting for the button"):
        // the previous fix kept this row's mockup-derived "auto-confirm on
        // fresh entry" behavior and only guarded the RE-edit case. Direct,
        // repeated user feedback overrides that mockup reading: every row
        // should behave identically, always waiting for the explicit
        // Confirm click, with no auto-confirming exception at all. Removed
        // the conditional onQuickEntryFieldConfirmed call entirely; now
        // just marks the row as being edited on first change, matching
        // every other row's pattern (e.g. Request Date/Case Number).
        field = (
          <AuthorizationDateField
            value={values[FormConstants.AUTHORIZATION_DATE]}
            requestPurposeId={values[FormConstants.PURPOSE_TYPE]}
            visible
            meta={{ touched: true, error: this.getQuickEntryDateErrors()[AUTHORIZATION_DATE_ROW_ID] }}
            dispatch={this.props.dispatch!}
            onAuthorizationDateChange={() => this.onEditQuickEntryRow(row.id)}
            invalidText={this.quickEntryInvalidTextFor(row.id)}
            resyncKey={this.state.quickEntryDateResyncKeys[row.id] ?? 0}
            onInvalidText={(text, committed) => { if (text !== undefined) { this.onEditQuickEntryRow(row.id); } this.recordQuickEntryDateEntry(row.id, text, committed); }}
          />
        );
        break;
      case REQUEST_DATE_ROW_ID:
        // Bug fix (Spec #34102 / F1d, direct user report): no longer calls
        // onQuickEntryFieldConfirmed on change - see the identical reasoning
        // on REQUEST_TYPE_PURPOSE_ROW_ID's onRequestPurposeChange above. The
        // explicit Confirm button below is now this row's only exit.
        //
        // Bug fix (Spec #34102 / F1d, direct user report - same "no confirm
        // unless you type in, and then click to edit again" bug as Request
        // Type/Purpose): this had NO onChange wiring at all, so a fresh
        // NeedsEntry row never got added to quickEntryEditingRowIds before
        // its status flipped to Confirmed on the first picked date - see
        // the identical root-cause writeup on REQUEST_TYPE_PURPOSE_ROW_ID's
        // onRequestTypeChange above.
        field = (
          <RequestDateField
            value={values[FormConstants.REQUEST_DATE]}
            visible
            meta={{ touched: true, error: this.getQuickEntryDateErrors()[REQUEST_DATE_ROW_ID] }}
            dispatch={this.props.dispatch!}
            onRequestDateChange={() => this.onEditQuickEntryRow(row.id)}
            invalidText={this.quickEntryInvalidTextFor(row.id)}
            resyncKey={this.state.quickEntryDateResyncKeys[row.id] ?? 0}
            onInvalidText={(text, committed) => { if (text !== undefined) { this.onEditQuickEntryRow(row.id); } this.recordQuickEntryDateEntry(row.id, text, committed); }}
          />
        );
        break;
      // AB#35137: Received Date. Required-ness mirrors Classic (see getQuickEntryRows).
      case RECEIVED_DATE_ROW_ID:
        field = (
          <ReceivedDateField
            value={values[FormConstants.RECEIVED_DATE]}
            required={requestType !== DISCLOSURE_ACCOUNTING}
            meta={{ touched: true, error: this.getQuickEntryDateErrors()[RECEIVED_DATE_ROW_ID] }}
            dispatch={this.props.dispatch!}
            // Same reasoning as the sibling date rows: mark the row manually-edited on the
            // first change so the explicit Confirm button is this row's only exit.
            onReceivedDateChange={() => this.onEditQuickEntryRow(row.id)}
            invalidText={this.quickEntryInvalidTextFor(row.id)}
            resyncKey={this.state.quickEntryDateResyncKeys[row.id] ?? 0}
            onInvalidText={(text, committed) => { if (text !== undefined) { this.onEditQuickEntryRow(row.id); } this.recordQuickEntryDateEntry(row.id, text, committed); }}
          />
        );
        break;
      // AB#35144: Due Date. `visible` is already enforced by the row-list filter, so it is
      // passed as true here - this case only renders for a row that survived that filter.
      case DUE_DATE_ROW_ID:
        field = (
          <DueDateField
            value={values[FormConstants.DUE_DATE]}
            visible
            meta={{ touched: true, error: this.getQuickEntryDateErrors()[DUE_DATE_ROW_ID] }}
            dispatch={this.props.dispatch!}
            onDueDateChange={() => this.onEditQuickEntryRow(row.id)}
            invalidText={this.quickEntryInvalidTextFor(row.id)}
            resyncKey={this.state.quickEntryDateResyncKeys[row.id] ?? 0}
            onInvalidText={(text, committed) => { if (text !== undefined) { this.onEditQuickEntryRow(row.id); } this.recordQuickEntryDateEntry(row.id, text, committed); }}
          />
        );
        break;
      // AB#35144: Request ID. Free-text like Case Number, so it marks the row edited on the
      // first keystroke rather than on blur (same reasoning as CASE_NUMBER_ROW_ID below).
      case REQUEST_ID_ROW_ID:
        field = (
          <RequestIdField
            value={values[FormConstants.REQUEST_ID]}
            visible
            dispatch={this.props.dispatch!}
            onRequestIdChange={() => this.onEditQuickEntryRow(row.id)}
          />
        );
        break;
      case CASE_NUMBER_ROW_ID: {
        const caseNumberRequired = requestType === DISABILITY_OR_SOCIAL_SECURITY || [3, 53].includes(requestType);
        // Bug fix (Spec #34102 / F1d, direct user report): onCaseNumberBlur
        // used to call onQuickEntryFieldConfirmed on every blur, so clicking
        // away from the input (e.g. straight to another row) silently
        // exited edit mode before the specialist ever saw/used the Confirm
        // button - "Case number should stay editable until the confirm
        // button is pressed" (live user report). Removed entirely; the
        // explicit Confirm button below is now this row's only DELIBERATE
        // exit. onCaseNumberChange (fires on every keystroke, unlike
        // onCaseNumberBlur) marks the row as manually-edited from the very
        // first character instead - Case Number is the one row here backed
        // by free-text typing rather than an atomic dropdown/date-picker
        // selection, so its own row status (mapCaseNumberToFieldGroupRow)
        // flips to Confirmed the instant ANY character exists, well before
        // the specialist is done typing. Without this, isEditing would
        // recompute false on that first keystroke (status is Confirmed, and
        // nothing had added this row to quickEntryEditingRowIds yet) and
        // silently unmount this very input out from under the specialist -
        // the same "stuck/kicked-out mid-edit" bug class, just arriving via
        // status instead of via a premature confirm callback.
        field = (
          <CaseNumberField
            value={values[FormConstants.CASE_NUMBER]}
            required={caseNumberRequired}
            dispatch={this.props.dispatch!}
            onCaseNumberChange={() => this.onEditQuickEntryRow(row.id)}
          />
        );
        break;
      }
      case CLINIC_RESPONSIBLE_ROW_ID:
        // Bug fix (Spec #34102 / F1d, direct user report): same reasoning as
        // AUTHORIZATION_DATE_ROW_ID above - dropped the auto-confirm-on-
        // fresh-entry exception entirely for consistency with every other
        // row. Always waits for the explicit Confirm click now.
        field = (
          <ClinicResponsibleField
            value={values[FormConstants.CLINIC_RESPONISBLE]}
            useClinics={Boolean(facility?.useClinics)}
            useDepartments={Boolean(facility?.useDepartments)}
            discloseInstitutions={this.props.discloseInstitutions}
            dispatch={this.props.dispatch!}
            onClinicResponsibleChange={() => this.onEditQuickEntryRow(row.id)}
          />
        );
        break;
      case AUDIT_TYPE_ROW_ID:
        // Spec #35289 (AC1): Audit(53) dropdown, buffered like Clinic - the value
        // rides DATA_ENTRY_FIELDS_FORM and only persists at Confirm All (AC4). Waits
        // for the explicit Confirm click via onEditQuickEntryRow (same as every row).
        field = (
          <AuditTypeField
            value={values[FormConstants.AUDIT_TYPE]}
            auditTypes={this.props.auditTypes}
            dispatch={this.props.dispatch!}
            onAuditTypeChange={() => this.onEditQuickEntryRow(row.id)}
          />
        );
        break;
      case ON_BEHALF_OF_ROW_ID:
        field = (
          <OnBehalfOfField
            value={values[FormConstants.ON_BEHALF_OF]}
            onBehalfOf={this.props.onBehalfOf}
            dispatch={this.props.dispatch!}
            onOnBehalfOfChange={() => this.onEditQuickEntryRow(row.id)}
          />
        );
        break;
      case SERVICE_DATE_FROM_ROW_ID: {
        // Bug fix (Spec #34102 / F1d, direct user report - "some fields
        // still have the as-soon-as-you-select-something-close-it
        // behavior"): a systematic audit after three rounds of per-field
        // reports found this row (and Service Date To, Records Requested,
        // Sensitive Info below) never got the onEditQuickEntryRow fix
        // Request Type/Purpose, Request Date, and Case Number already got.
        // This row's status IS driven by the lifted quickEntryReleaseInfo
        // (persistQuickEntryReleaseInfo's own optimistic-local setState),
        // not a local form value, but that doesn't change the actual bug:
        // on a FRESH row, picking a date flips row.status to Confirmed on
        // the very next render while quickEntryEditingRowIds still never
        // had this row's id (nothing called onEditQuickEntryRow) - isEditing
        // goes false on both halves at once, same as every other instance
        // of this bug, skipping the Confirm-button state entirely. This row
        // is NOT one of the two documented no-button exceptions
        // (Authorization Date, Clinic/Facility), so it needs this call.
        // Bug fix (AB#34852): the "All Dates" checkbox now renders here (and on the To row).
        // It was previously left out because master-demo-v6's row list has no such control,
        // which made an open-ended request - no date range at all - unenterable in Quick Entry;
        // product reversed that on 2026-07-29. See onQuickEntryAllDatesChange for the
        // semantics, which mirror Classic's InfoToRelease so the panes can't disagree. Picking
        // a real date still clears the flag via onQuickEntryServiceDateChange.
        const { from, to, allDates } = this.getQuickEntryServiceDateRange();
        const fromValidation = this.getQuickEntryServiceDateValidation();
        const dateErrors = this.getQuickEntryDateErrors();
        field = (
          <div className="qe-row__service-date">
            <DateField
              label="Service Date - From"
              invalidText={this.quickEntryInvalidTextFor(row.id)}
              resyncKey={this.state.quickEntryDateResyncKeys[row.id] ?? 0}
              onInvalidText={(text, committed) => { if (text !== undefined) { this.onEditQuickEntryRow(row.id); } this.recordQuickEntryDateEntry(row.id, text, committed); }}
              placeholder="mm/dd/yyyy"
              errMsg={dateErrors[SERVICE_DATE_FROM_ROW_ID] || fromValidation.errors.from || fromValidation.errors.items}
              // AB#38460: same display-only normalization the four form dates use. An AI-seeded
              // value is UTC midnight, and the picker formats with LOCAL getters - so west of
              // Greenwich it rendered the PREVIOUS day in edit mode (04/01 showed as 03/31) even
              // though the collapsed row read correctly, because formatServiceDate branches on
              // isUtcMidnightDate and this did not. toDisplayDate rebuilds a UTC-midnight value
              // from its UTC parts so the local read lands on the right day, and passes a
              // specialist-picked value straight through. Display only - the write path still
              // normalizes through toLocalCalendarDayMidnight in onChange below.
              value={toDisplayDate(from)}
              minDate={DEFAULT_MIN_DATE}
              // AB#38460 (David Heifetz, PR !10140): normalize the BOUND the same way as the value
              // two lines up. Leaving it raw made the two disagree: with an AI-seeded To of 04/05 at
              // UTC midnight, the To row displayed 04/05 while this maxDate resolved to 04/04 20:00
              // local, so the From calendar DISABLED 04/05 - and From == To is a legal single-day
              // range, so the specialist simply could not pick it. Before the value was normalized
              // both were raw and agreed; wrong but self-consistent.
              maxDate={toDisplayDate(to) ?? new Date()}
              onChange={(value) => {
                this.onEditQuickEntryRow(row.id);
                // AB#38463: normalize HERE, where the value is known to be a specialist pick -
                // the picker carries the previous value's time-of-day, which on a US Eastern
                // host makes a picked day land on the NEXT day's UTC midnight. See
                // toLocalCalendarDayMidnight; deliberately not done inside the handler, which
                // also accepts AI-shaped UTC-midnight values.
                this.onQuickEntryServiceDateChange("from", value instanceof Date ? toLocalCalendarDayMidnight(value) : value);
              }}
            />
            {this.renderQuickEntryAllDatesCheckbox(allDates)}
          </div>
        );
        break;
      }
      case SERVICE_DATE_TO_ROW_ID: {
        // Same fix as Service Date From above - see that case's comment. Both rows carry the
        // checkbox and share one flag, so either can set it (AB#34852).
        const { from, to, allDates } = this.getQuickEntryServiceDateRange();
        const toValidation = this.getQuickEntryServiceDateValidation();
        const dateErrors = this.getQuickEntryDateErrors();
        field = (
          <div className="qe-row__service-date">
            <DateField
              label="Service Date - To"
              invalidText={this.quickEntryInvalidTextFor(row.id)}
              resyncKey={this.state.quickEntryDateResyncKeys[row.id] ?? 0}
              onInvalidText={(text, committed) => { if (text !== undefined) { this.onEditQuickEntryRow(row.id); } this.recordQuickEntryDateEntry(row.id, text, committed); }}
              placeholder="mm/dd/yyyy"
              errMsg={dateErrors[SERVICE_DATE_TO_ROW_ID] || toValidation.errors.to || toValidation.errors.items}
              // Same normalization as the From row above (AB#38460).
              value={toDisplayDate(to)}
              // Same normalization as the From row's maxDate above (AB#38460).
              minDate={toDisplayDate(from) ?? DEFAULT_MIN_DATE}
              maxDate={new Date()}
              onChange={(value) => {
                this.onEditQuickEntryRow(row.id);
                // Same normalization as the From row above (AB#38463).
                this.onQuickEntryServiceDateChange("to", value instanceof Date ? toLocalCalendarDayMidnight(value) : value);
              }}
            />
            {this.renderQuickEntryAllDatesCheckbox(allDates)}
          </div>
        );
        break;
      }
      case RECORDS_REQUESTED_ROW_ID: {
        // Same fix as Service Date From above (see that case's comment) -
        // neither the checkbox toggle nor the free-text change ever marked
        // this row as being edited before now.
        const releaseInfo = this.getQuickEntryReleaseInfo();
        const checkboxItems: CheckboxItem[] = releaseInfo.map(item => ({
          id: item.id,
          state: item.checked ? SensitiveInfoRelease.Authorized : SensitiveInfoRelease.NotMentioned,
          label: item.name,
        }));
        field = (
          <CheckboxList
            items={checkboxItems}
            checkboxHeader="RETRIEVE"
            labelHeaders={["RECORD TYPE"]}
            onChange={(itemId, checked) => {
              this.onEditQuickEntryRow(row.id);
              this.onQuickEntryReleaseItemToggle(itemId, checked);
            }}
            className="checkboxSection"
            freeText={this.getQuickEntryReleaseComments()}
            hasFreeText={(item) => item?.id === OTHER_DOCUMENTS_RELEASE_ID}
            onChangeFreeText={(text) => {
              this.onEditQuickEntryRow(row.id);
              this.onQuickEntryReleaseFreeTextChange(text);
            }}
            // The row collapses on Confirm, so a click straight from the box to
            // Confirm would otherwise discard text that never blurred.
            liftFreeTextOnChange
            freeTextMaxLen={2000}
            allowUncheck
          />
        );
        break;
      }
      case SENSITIVE_INFO_ROW_ID:
        // Same fix as Service Date From above (see that case's comment) -
        // saveAndUpdateSensitiveInfo never marked this row as being edited
        // before now.
        //
        // Bug fix (direct user report): Sensitive Info used to persist
        // IMMEDIATELY on every checkbox change (this.props.saveAndUpdateSensitiveInfo),
        // the same "not deferred to Confirm All like every other row" issue
        // Records Requested had (see persistQuickEntryReleaseInfo's own doc
        // comment) - a document replace couldn't cleanly clear it, and
        // Classic Mode could see in-progress answers before Confirm All ran.
        // Now this stores an optimistic LOCAL echo instead of dispatching the
        // real save - SensitiveInfoField's onChange -> applySensitiveInfoUpdate
        // -> buildSensitiveInfoUpdatePayload already computes `InfoList` as
        // the FULL new array (every item, not just the one that changed:
        // SensitiveInfoField.tsx's buildSensitiveInfoUpdatePayload), so it can
        // be read back into SensitiveInfoModel[] directly with no change to
        // SensitiveInfoField.tsx itself - Classic Mode's own mount of the same
        // component (DataEntryDetailsRightPane.tsx) is untouched. The actual
        // persist moves to Confirm All (persistQuickEntrySelectionsToTransaction
        // below), reusing buildSensitiveInfoRevertPayload to build the same
        // payload shape from a full snapshot array.
        field = (
          <>
            {/* AB#38735 (decision 13): say WHY the row is amber, right above the ticks it is
                talking about. Gated on the stamped row.isDocSourced - the same derived value the
                status badge reads (see the round-15 S1 note on the stamp in getQuickEntryRows),
                which for this row is isSensitiveInfoDocSourced: true only while the current
                Authorized set is still exactly the extraction's. Edit any category and the hint
                goes, because the answers are no longer the AI's. */}
            {row.status === FieldGroupRowStatus.LowConfidence && row.isDocSourced ? (
              <p className="qe-row__unverified-hint">{QUICK_ENTRY_SENSITIVE_INFO_UNVERIFIED_HINT}</p>
            ) : null}
            <SensitiveInfoField
              data={this.getQuickEntrySensitiveInfo()}
              transactionId={this.props.transactionId}
              dispatch={this.props.dispatch!}
              visible
              saveAndUpdateSensitiveInfo={(data) => {
                this.onEditQuickEntryRow(row.id);
                this.setState({
                  quickEntrySensitiveInfo: data.InfoList.map(entry => ({ id: entry.id, name: entry.name, stateID: entry.stateID })),
                });
              }}
            />
          </>
        );
        break;
      default:
        return undefined;
    }

    // Bug fix (Spec #34102 / F1d, direct user report): re-opening an
    // already-Confirmed row via "Edit" and changing a value left it stuck in
    // edit mode with no way to save/exit - qe-row__action rendered an empty
    // div here, and the only way out relied on each individual field's
    // onChange callback happening to call onQuickEntryFieldConfirmed (e.g.
    // RequestTypePurposeField only ever wired Purpose's onChange, never
    // Type's - changing Type alone, which also resets Purpose back to its
    // placeholder, left the row stuck with no visible affordance at all).
    // The mockup handoff (master-demo-v6-standalone-src.html's own
    // enterEditMode/confirmEdit functions) originally read as showing this
    // Confirm button for every row EXCEPT Authorization Date/Clinic-Facility
    // (which it renders with an empty action slot on a fresh NeedsEntry row).
    // Direct, repeated user feedback overrode that: those two auto-confirmed
    // instead of waiting for the button, which read as inconsistent with
    // every other row. There is no exception anymore - every row, including
    // Authorization Date/Clinic-Facility, marks itself as being edited on
    // first change (see each row's own case above) and only ever exits edit
    // mode via this explicit Confirm click.
    //
    // Clicking Confirm calls onQuickEntryFieldConfirmed(row.id) - but ONLY
    // once row.status is actually Confirmed. If the row's own required
    // value is still incomplete (row.status is still NeedsEntry - e.g.
    // Request Type was changed but Purpose hasn't been re-picked yet),
    // isEditing's other half of the OR (`row.status !== Confirmed`) already
    // keeps the row open regardless of this click, so Confirm can never
    // dismiss an incomplete row on its own - clicking it on an empty/
    // untouched row is a harmless no-op, not a dead click.
    //
    // Bug fix (Spec #34102 / F1d, direct user report - "I want the confirm
    // button show at the start, not just after a selection"): this used to
    // be conditional (row.status !== NeedsEntry || the Set has this row's
    // id), which hid the button on a genuinely fresh/untouched row until
    // the first change added it to the Set. We're already inside the
    // isEditing branch by this point in the function, so the button is now
    // unconditional - always visible for the whole time a row is being
    // edited, from the very first render, on every row with no exceptions.
    // AB#38158 (defect 2): true when Acknowledge - not Confirm - is what clears this row, and it
    // has not been acknowledged yet.
    // AB#38158 (defect 2), widened in review round 2: true when Confirm is not what clears this row.
    // Two shapes - the acknowledgeable row that has not been ticked yet, and the self-resolving row
    // that is waiting on a Purpose. Both leave Confirm live but inert, which is the reported symptom.
    const needsAcknowledgement = this.isQuickEntryRowAcknowledgeable(row)
      && !this.state.quickEntryAcknowledgedLowConfidenceIds.has(row.id);
    // AB#38735: Sensitive Information is self-resolving, but unlike the Purpose amber its Confirm
    // DOES clear the row - as soon as every category is answered, which is precisely the
    // condition the mapper turns into Confirmed once the row leaves the editing set. Without
    // this term a successful Confirm would still latch quickEntryConfirmBlockedRowId, and the
    // "not every category is answered" message would then appear unprompted the next time the
    // specialist reopened the row with [Edit].
    const confirmClearsSensitiveInfoRow = row.id === SENSITIVE_INFO_ROW_ID
      && isSensitiveInfoResolved(this.getQuickEntrySensitiveInfo());
    const needsSelfResolution = row.status === FieldGroupRowStatus.LowConfidence
      && this.quickEntrySelfResolvingRowIds().has(row.id)
      && !confirmClearsSensitiveInfoRow;
    const confirmCannotClearRow = needsAcknowledgement || needsSelfResolution;
    const onClickEditModeConfirmButton = () => {
      // AB#35073 interaction fix: getQuickEntryRows now downgrades a complete row that
      // is still open for edit (in quickEntryEditingRowIds) to NeedsEntry so it counts
      // as outstanding until Confirmed. That means row.status here is NeedsEntry for
      // exactly the rows the specialist is trying to confirm, so the old
      // `if (row.status === Confirmed)` guard made every Confirm click a no-op
      // (regression - "Confirm buttons do nothing"). Just clear the editing flag:
      // onQuickEntryFieldConfirmed only acts if the row is actually in the editing set,
      // and once it's cleared getQuickEntryRows stops downgrading it, so a genuinely
      // complete row resolves to Confirmed and exits edit mode, while a genuinely
      // incomplete row stays open via isEditing's `row.status !== Confirmed` half
      // (Confirm on an incomplete row remains a safe no-op, per this row's design).
      //
      // AB#38739 fallout (AB#38683): SETTLE an acknowledgeable amber row, or Confirm does nothing.
      //
      // isEditing below is `row.status !== Confirmed && !isSettledByAcknowledgement`, so clearing the
      // editing flag is only enough for a row that can REACH Confirmed. AB#38739 made Confirmed
      // unreachable for Request Type/Purpose, so from that change on this handler cleared the flag,
      // isEditing recomputed true, and the row re-opened - an enabled Confirm button that did nothing,
      // on every transaction, beside an Acknowledge checkbox that did the work. The comment on
      // confirmButton above already names this failure: "a live-looking button that does nothing reads
      // as broken."
      //
      // Confirming and acknowledging are the same act for these rows - "I have looked at this" - so
      // Confirm writes the same state the checkbox toggles. The checkbox is controlled off that set,
      // so it renders ticked afterwards and the specialist can still take it back; the two controls
      // agree instead of competing. Scoped to rows the Acknowledge control is actually offered on,
      // so a NeedsEntry row is untouched (it must be filled, never dismissed) and a patient/requestor
      // multiple-match row still resolves by picking a candidate.
      const justSettled = this.isQuickEntryRowAcknowledgeable(row)
        && !this.state.quickEntryAcknowledgedLowConfidenceIds.has(row.id);
      if (justSettled) {
        this.setState(prev => {
          const next = new Set(prev.quickEntryAcknowledgedLowConfidenceIds);
          next.add(row.id);
          return { quickEntryAcknowledgedLowConfidenceIds: next };
        });
      }
      // AB#35149: the Purpose backend round-trip happens HERE, not on change. It refreshes
      // transactionDetails and re-derives the record-type list, so firing it mid-edit reset other
      // rows before the specialist had confirmed anything - and Cancel could not undo it. Guarded
      // on the purpose actually differing from the one persisted on the transaction, so opening
      // this row and confirming without touching it costs nothing. Deliberately not awaited:
      // Confirm should close the row immediately, as it always has.
      if (row.id === REQUEST_TYPE_PURPOSE_ROW_ID
        // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
        // eslint-disable-next-line no-restricted-syntax
        && shouldSyncRequestPurpose(values[FormConstants.PURPOSE_TYPE], this.props.transactionDetails?.requestPurpose?.id)) {
        this.onQuickEntryRequestPurposeChange(values[FormConstants.PURPOSE_TYPE]);
      }
      // AB#35289 (source-flagged reset): re-evaluate an AI-guessed requestor when THIS confirm
      // commits a change of the request type to Internal. On the row's Confirm (not on change),
      // so a preview-then-Cancel never triggers it. See maybeResetRequestorOnConfirmedInternalType.
      if (row.id === REQUEST_TYPE_PURPOSE_ROW_ID) {
        this.maybeResetRequestorOnConfirmedInternalType();
      }
      this.onQuickEntryFieldConfirmed(row.id);
      // Bug fix (AB#38158, defect 2): say why the row stayed open. Everything above still runs -
      // this adds the missing feedback, it does not take the button away. An acknowledge-only row
      // cannot be closed by Confirm (isEditing re-derives from row.status, and grounding-driven
      // amber never becomes Confirmed), so without this the click was silent and the button read
      // as broken.
      // AB#38739 fallout (AB#38683): do not say "Acknowledge is what clears this row" on a click that
      // just cleared it. confirmCannotClearRow is computed at RENDER time, before this click, so on an
      // acknowledgeable row it is still true here even though the settle above has now resolved it -
      // and AB#38158's whole point was that the message must be accurate. Everything AB#38158 covers
      // is untouched: a self-resolving row waiting on a Purpose still gets the message, because
      // confirming genuinely cannot supply one.
      this.setState({
        quickEntryConfirmBlockedRowId: (confirmCannotClearRow && !justSettled) ? row.id : undefined,
      });
    };
    // Coalesce (F1c #34101 + F1d #34102): Confirm keeps F1d's status guard
    // (onClickEditModeConfirmButton); Cancel is F1c's snapshot-revert, shown only
    // when [Edit] was explicitly opened (showEditActions). onMouseDown +
    // preventDefault so the click fires BEFORE the field blur auto-confirms and
    // unmounts the buttons (F1c's blur-safe pattern).
    const showEditActions = this.state.quickEntryEditingRowIds.has(row.id);
    // AB#35067 (WCAG 2.1 keyboard operability): the mouse path uses onMouseDown +
    // preventDefault (fires before the field blur can auto-confirm/unmount the
    // buttons - F1c's blur-safe pattern), but onMouseDown never fires for keyboard
    // activation, so Enter/Space did nothing and a keyboard-only specialist could
    // not confirm/cancel a row (blocking the keyboard-only workflow AC). Add an
    // onKeyDown that activates on Enter/Space. Mouse fires onMouseDown, keyboard
    // fires onKeyDown - disjoint paths, so no double-activation. preventDefault on
    // Space also stops the page from scrolling.
    const activateOnKey = (handler: () => void) => (e: React.KeyboardEvent<HTMLButtonElement>) => {
      if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
        e.preventDefault();
        handler();
      }
    };
    // AB#35070: a row that is genuinely missing its required value cannot be confirmed, and the
    // button now SAYS so instead of silently doing nothing. Clicking Confirm on such a row was
    // always a no-op (isEditing's `row.status !== Confirmed` half re-opens it immediately), but a
    // live-looking button that does nothing reads as broken - and on the Clinic row it read as
    // worse than that, because before the sentinel fix it appeared to confirm an empty value.
    //
    // Scoped to NeedsEntry: LowConfidence and EmptyNotRequired rows keep the button they had, since
    // those are acknowledgeable/optional rather than incomplete. isCompleteWhileEditing excludes the
    // rows AB#35073 downgrades purely for being open - they are complete and must stay confirmable.
    const confirmDisabled = isFieldGroupRowConfirmDisabled(row);
    const confirmButton = (
      <>
        <button type="button" className="qe-btn" disabled={confirmDisabled} aria-disabled={confirmDisabled} onMouseDown={(e) => { e.preventDefault(); if (!confirmDisabled) { onClickEditModeConfirmButton(); } }} onKeyDown={activateOnKey(() => { if (!confirmDisabled) { onClickEditModeConfirmButton(); } })}>Confirm</button>
        {showEditActions ? <button type="button" className="qe-btn" onMouseDown={(e) => { e.preventDefault(); this.onQuickEntryEditCancel(row.id); }} onKeyDown={activateOnKey(() => this.onQuickEntryEditCancel(row.id))}>Cancel</button> : null}
        {/* AB#38158 (defect 2): the validation message the reporter said was missing. role="alert"
            announces it to a screen reader without moving focus, matching the row's other hints.
            Gated on confirmCannotClearRow as well as the id (review finding): the id is only
            cleared by acknowledging THIS row, by confirming another, or by a transaction/document
            reset, so on the id alone the message outlived the state that justified it. Changing
            the Request Type resets PURPOSE_TYPE to 0 (RequestTypePurposeField.onChangeType), which
            drops the row to NeedsEntry - no Acknowledge checkbox, Confirm now disabled - and the
            specialist was left being told to tick a control that is no longer on screen. */}
        {confirmCannotClearRow && this.state.quickEntryConfirmBlockedRowId === row.id ? (
          <span className="qe-row__confirm-blocked" role="alert">
            {needsAcknowledgement ? QUICK_ENTRY_ACKNOWLEDGE_REQUIRED_MESSAGE
              : row.id === SENSITIVE_INFO_ROW_ID ? QUICK_ENTRY_SENSITIVE_INFO_REQUIRED_MESSAGE
                : QUICK_ENTRY_PURPOSE_REQUIRED_MESSAGE}
          </span>
        ) : null}
      </>
    );

    // Bug fix (Spec #34102 / F1d, direct user report): Records Requested and
    // Sensitive Info render a tall multi-item checklist, not a single compact
    // control - the standard qe-row__action slot vertically centers Confirm
    // beside the WHOLE row, which for these two puts it floating mid-list
    // instead of at a sensible reading position after the list. For these
    // two rows only, render Confirm inline below the list content instead of
    // in the side action slot; every other row keeps the standard side slot.
    const confirmBelowContent = row.id === RECORDS_REQUESTED_ROW_ID || row.id === SENSITIVE_INFO_ROW_ID;

    return (
      <>
        <div className="qe-row__body">
          <div className="qe-row__label">{row.label}</div>
          <div className={confirmBelowContent ? "qe-row__value qe-row__value--scrollable" : "qe-row__value"}>
            {field}
            {confirmBelowContent ? (
              <div className="qe-row__action--bottom">{confirmButton}</div>
            ) : null}
          </div>
        </div>
        <div className="qe-row__action">
          {confirmBelowContent ? null : confirmButton}
        </div>
      </>
    );
  }

  /**
   * AC9: scrolls the outstanding row into view when the morphing action
   * button reads "Next Action Required (N)". Mirrors the existing
   * scrollIntoView pattern in DataEntryDetailsRightPane.tsx (its own
   * `scrollTo` effect), just keyed off data-row-id instead of a DOM id since
   * QuickEntryFieldGroupList's rows aren't individually id'd elements.
   */
  onJumpToQuickEntryRow = (rowId: string) => {
    document.querySelector(`[data-row-id="${rowId}"]`)?.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  /**
   * AC6 (Spec #34100 / F1b-rois, D2 per PRD 2026-07-01): reveal a clicked field's source region.
   * CLICK-TO-REVEAL (PRD 7b / TDD Risk 2): scroll the PdfViewer to the source page AND draw a
   * transient bounding-box highlight over the located span. Permanent HIGHLIGHTS-ON-LOAD remain
   * out of scope for v1.1b (PRD 7b); this on-click overlay is the "grounding overlay" the TDD's
   * F1.4 / line 66 (`scrollToField`) describe, driven by the grounding's normalized bbox
   * (x/y/w/h) that already rides the DTO. Page-jump reuses the v1.1a setPageNumber seam; the
   * highlight rides its own SET_GROUNDING_HIGHLIGHT seam so the scroll-reset never clears it.
   * Only the ~5 located date fields carry coordinates in v1.1b (App-Config gate) — every other
   * field is the PRD no-source case and routes to onQuickEntryGroundingUnavailable instead.
   */
  onRevealQuickEntryGrounding = (grounding: FieldGrounding) => {
    this.props.setPageNumber(grounding.pageNumber, this.props.currentFile);
    this.props.setGroundingHighlight(grounding);
  }

  /**
   * AC7 (no-source variant): a field with no grounding shows an informational toast and does not
   * scroll — the v1.1a fallback when FieldGroundings is empty/absent (locatedGate OFF). Also clears
   * any prior on-click highlight so a no-source click doesn't leave a stale overlay behind.
   */
  onQuickEntryGroundingUnavailable = () => {
    this.props.setGroundingHighlight(undefined);
    toast("No source location is available for this field.");
  }

  /**
   * AC4 (Spec #34102 / F1d): builds the Confirm-All bulk-commit payload from
   * the current Quick Entry row state. Excludes rows that aren't currently
   * applicable (isQuickEntryRowApplicable false - e.g. Service Date/Records/
   * Sensitive Info before a Purpose is picked) - those rows carry nothing
   * meaningful to correct yet. See QUICK_ENTRY_ROW_FIELD_NAMES' doc comment
   * for why aiValue is null for every row except Request Type/Purpose today.
   */
  /**
   * DocumentType for every correction (PRD `prd-intake-intelligence-v1_1b`
   * §6b event table, "Field correction logged" row - document_type is
   * required on every correction event, not the open question this Spec's
   * own Assumptions section originally flagged it as). Quick Entry always
   * operates on the attached REQUEST document - same DocTypes.REQ lookup
   * DataEntryDetailsBody.tsx already uses
   * (`props.documentsList.find(doc => doc.recType === DocTypes.REQ)`). null
   * only in the defensive case where no REQ document is attached at all
   * (shouldn't happen once Quick Entry is reachable, but this must not
   * fabricate a document type that isn't actually there).
   */
  getQuickEntryDocumentType = (): string | null => {
    const requestDocument = this.props.documentsList?.find(doc => doc.recType === DocTypes.REQ);
    return requestDocument ? DocTypes.REQ : null;
  }

  getQuickEntryCorrectionPayloads = (): readonly QuickEntryCorrectionPayload[] => {
    const rows = this.getQuickEntryRows();
    const values = this.props.formState?.values ?? {};
    const analysisData = this.props.requestAnalysis?.data;
    // AB#37856 (security review M1): the sensitive-category aiValue reads the OWNERSHIP-GATED
    // analysis, NOT the raw prop above. The intake slice holds one analysis with no transaction
    // key and navigation does not cancel an in-flight extraction, so a response for transaction A
    // can be in the slice while B is on screen (AB#35121). This is the consumer that PERSISTS, so
    // an ungated read commits A's declared sensitive categories as B's AiValue on B's
    // intake-correction row - a cross-record attribution of 42 CFR Part 2 category assertions
    // between two patients' requests. Scoped to this branch's own read: aiRequestType /
    // aiRequestPurpose above have the same defect, predate this change, and are a separate
    // follow-up rather than a widened diff (change-discipline.md).
    const ownedAnalysisData = this.ownedRequestAnalysis()?.data;
    const hasAiTypePurpose = analysisData?.requestTypeMapped !== undefined && analysisData?.requestTypeMapped !== null;
    const aiRequestType = hasAiTypePurpose ? (analysisData?.requestType ?? String(analysisData?.requestTypeMapped)) : null;
    const aiRequestPurpose = hasAiTypePurpose ? (analysisData?.requestPurpose ?? null) : null;
    const selectedType = this.props.requestTypes?.find(t => t.id === values[FormConstants.REQUEST_TYPE]);
    const selectedPurpose = selectedType?.requestPurpose.find(p => p.id === values[FormConstants.PURPOSE_TYPE]);
    const documentType = this.getQuickEntryDocumentType();

    const settledRowIds = this.effectiveAcknowledgedRowIds(rows);

    const inputs: QuickEntryCorrectionInput[] = [];
    rows.forEach(row => {
      if (!this.isQuickEntryRowApplicable(row.id)) {
        return;
      }
      const fieldNames = QUICK_ENTRY_ROW_FIELD_NAMES[row.id];
      if (!fieldNames) {
        // Spec #35135 (AC10): this is also what keeps the Disclosure Information
        // row out of the corrections payload - it has no FieldIdentifier mapping
        // because it is not an AI-extracted field (no aiValue, no confidence).
        // Disclosure persists through its own write in the Confirm-All gate
        // instead; "not in corrections" and "still persisted" are both true.
        return;
      }
      fieldNames.forEach((fieldName, index) => {
        const isTypePurposeRow = row.id === REQUEST_TYPE_PURPOSE_ROW_ID;
        // AB#37856: the second row with real AI wiring. It used to submit aiValue: null with
        // the row's own "N of 5 authorized" SUMMARY as the SpecialistValue, so the
        // correction-feedback layer read every specialist answer as unprompted manual work
        // with no AI value to compare against - and Business Rule 8's accepted-vs-edited
        // distinction could never fire for it. Both values now come from the shared mappers
        // in SensitiveInfoField, which order categories identically so an accepted, unedited
        // seed compares EQUAL. No new field name is registered (this row was already in
        // QUICK_ENTRY_ROW_FIELD_NAMES), so the AnalysisFieldMapper 400 class of bug that
        // removed the Service Date names cannot recur here.
        const isSensitiveInfoRow = row.id === SENSITIVE_INFO_ROW_ID;
        // AB#38683. Every AI-extracted field now carries its aiValue, in the same form as
        // the specialist value below. Previously only the two rows above did, so for the
        // dates, Case Number, Clinic and Records Requested the payload said "the AI
        // extracted nothing" - Business Rule 8's accepted-vs-edited test could never fire
        // and the commit recorded every accepted value as a specialist change. Ali Moll,
        // PR !10280. The values were always available on the analysis payload; they were
        // simply not being read.
        const aiValue = isTypePurposeRow ? (index === 0 ? aiRequestType : aiRequestPurpose)
          : isSensitiveInfoRow ? buildSensitiveInfoAiCorrectionValue(ownedAnalysisData?.sensitiveInfoDeclarations ?? [], this.getQuickEntrySensitiveInfo())
            : fieldName === "AuthorizationDate" ? toAiIsoDate(ownedAnalysisData?.authorizationDate)
              : fieldName === "RequestDate" ? toAiIsoDate(ownedAnalysisData?.requestDate)
                : fieldName === "ReceivedDate" ? toAiIsoDate(ownedAnalysisData?.receivedDate)
                  : fieldName === "DueDate" ? toAiIsoDate(ownedAnalysisData?.dueDate)
                    : fieldName === "CaseNumber" ? (ownedAnalysisData?.caseNumber ?? null)
                      : fieldName === "ClinicName" ? (ownedAnalysisData?.clinicName ?? null)
                        : fieldName === "InfoReleaseSections"
                          ? buildRecordsRequestedAiCorrectionValue(
                            ownedAnalysisData?.infoReleaseSections ?? [], this.getQuickEntryReleaseInfo())
                          : null;
        const rawValue = isTypePurposeRow
          ? (index === 0 ? (selectedType?.name ?? null) : (selectedPurpose?.name ?? null))
          : isSensitiveInfoRow ? buildSensitiveInfoSpecialistCorrectionValue(this.getQuickEntrySensitiveInfo())
            : row.value;
        // 🟡 AB#34102: date fields carry a display string ("July 16, 2026") in
        // row.value - normalize to ISO for the committed SpecialistValue.
        const value = QUICK_ENTRY_DATE_FIELD_NAMES.has(fieldName) ? toIsoDateCorrectionValue(rawValue) : rawValue;
        inputs.push({
          fieldName,
          aiValue,
          status: row.status,
          // AB#38739 fallout (AB#38683): a row the specialist SETTLED by acknowledging has been
          // reviewed, and `status === Confirmed` can no longer say so for Request Type/Purpose.
          // Without this, ValueAccepted is permanently NULL and ConfidenceStateAtEdit permanently
          // 'LowConfidence' for the two fields the classification feature exists to measure.
          // effectiveAcknowledgedRowIds (not the raw tick set) so a row reopened for edit, or one
          // that has stopped being acknowledgeable, does not count as settled - the same definition
          // both counters and both display paths read.
          settled: settledRowIds.has(row.id),
          value,
          // No "clear to blank" affordance exists on any Quick Entry row in this
          // cut, so explicitlyCleared is always false here (decision AB#34102,
          // 2026-07-20: do NOT synthesize a heuristic - it would corrupt the
          // ""-vs-NULL audit distinction). Business Rule 10's "" path in
          // QuickEntryCorrections.ts stays forward-compatible scaffolding for a
          // sibling Spec that adds the clear-to-blank UI.
          explicitlyCleared: false,
          documentType,
        });
      });
    });

    return buildQuickEntryCorrections(inputs);
  }

  /**
   * AC4/AC5/AC6 (Spec #34102 / F1d): the real Confirm-All submission,
   * replacing F1a's placeholder toast.
   *
   * AB#31605 (re-save): the only client guard now is quickEntrySubmitting (an
   * in-flight double-click guard). It NO LONGER short-circuits on
   * quickEntryCommitCompletedDate — a specialist still in Quick Entry may Confirm
   * All again to save changed data. The server proc (ROIS_QuickEntryCommit_upd)
   * now allows re-commit (upsert) while the transaction is still in the data-entry
   * stage (StatusIndicatorID < 50) and rejects only once finalized — that's the
   * authoritative guard; the create-new patient/requestor persistence is
   * one-shot-guarded (quickEntry{Patient,Requestor}CreateFired) so a re-save
   * doesn't duplicate created records.
   */
  onSubmitQuickEntry = () => {
    if (this.state.quickEntrySubmitting) {
      return;
    }
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const organizationId = this.props.transactionDetails?.facility?.id ?? parseInt(this.props.transactionId.split("-")[0], 10);
    const requestBufferId = parseInt(this.props.transactionId.split("-")[1], 10);
    const corrections = this.getQuickEntryCorrectionPayloads();

    // F1c AC16: send the resolved patient/requestor match outcome so the commit
    // persists it on the intake row (matchMethod + count come straight from the
    // lifted match state; not PHI - a method label + a candidate count).
    const matchSummary: QuickEntryMatchSummaryPayload = {
      patientMatchMethod: this.state.patientMatchState.matchMethod,
      patientMatchCount: this.state.patientMatchState.matchCount,
      requestorMatchMethod: this.state.requestorMatchState.matchMethod,
      requestorMatchCount: this.state.requestorMatchState.matchCount,
    };

    this.setState({ quickEntrySubmitting: true });
    this.props.commitQuickEntry?.(
      organizationId,
      requestBufferId,
      corrections,
      (completedDate?: string) => {
        // The commitQuickEntry round-trip (ROIS_QuickEntryCommit_upd) records the
        // AI-vs-specialist correction audit on tblRequestIntakeData ONLY - it does
        // not write the confirmed values onto the transaction record. Quick Entry
        // otherwise defers these request-info fields to Confirm All (unlike Classic
        // Mode's per-field autosave), so without this call auth date / request date /
        // case number / clinic never reach the transaction and Record Attachment /
        // Classic Mode read them back blank. Persist them here through the SAME
        // UpdateTransaction path Classic uses (see helper) now that the commit has
        // succeeded (so a 409 double-submit doesn't redundantly re-write them).
        //
        // Keep the promise so the completion step (persistQuickEntryBillingFields)
        // can await it before firing BillingComplete/MoveToRPQ - otherwise completion
        // can read an uncommitted transaction and the Transaction.Patient /
        // BillToContact getters throw "returned null".
        // AB#39265: one verdict record per gate run, owned by this commit alone.
        const purposeVerdict: QuickEntryPurposeVerdict = { persistedPurposeId: null };
        this.quickEntryPersistPromise = this.persistQuickEntrySelectionsToTransaction(purposeVerdict);
        // AB#35289 (Internal billing parity): once the persist gate resolves (purpose - the
        // type flip to Internal - persists LAST in it), pull the backend-assigned courtesy
        // fee schedule + fresh isInternalRequest via a ONE-SHOT re-fetch QE otherwise opts out
        // of. Do NOT serialize this behind the DetailsComplete write chained below: it is a READ
        // (getFeeSchedules + getTransactionAttributes GETs), and by the time this .then runs the
        // purpose write that migrates a type-43 buffer into tblRPQ has already completed (it
        // persists last in the awaited gate), so there is no buffer-vs-RPQ lock to contend for.
        // See refreshBillingAfterConfirmAllOnce.
        // AB#37853 (Phase 13b): the pending flag armed below spans this whole gate. Both failure
        // shapes are cleared here rather than left to the timeout - if the re-fetch is never
        // dispatched (no facility id, or the one-shot already burned) or the gate itself rejects,
        // nothing will ever arrive to clear the flag, and making the operator wait out the full
        // ceiling for a knowable failure is exactly the stuck-controls experience this must avoid.
        //
        // AB#39265: correct the list for the purpose THIS gate actually left in the database.
        //
        // `!ok` is redundant today - the gate returns before it touches the verdict when the
        // drain fails, so persistedPurposeId is already null on that path - and no test can
        // exercise it. It stays because removing it would make this caller depend silently on an
        // invariant that lives several hundred lines away in another function. Noted so a
        // mutation run does not read its survival as a coverage gap.
        // `persistedPurposeId` is null when nothing was persisted - an earlier write failed, or
        // the purpose write was rolled back with a 409 - and in that case re-fetching would pull
        // the same list back and burn the key for a purpose that is not stored, leaving the next
        // Confirm All (the one that does persist it) with no correction at all.
        //
        // AB#39265 (David Heifetz, PR !10691): both arms belong to THIS gate only. Gates overlap -
        // a second Confirm All can start before the first drains, since the in-flight guard keys
        // on quickEntrySubmitting, which the tab flip has already cleared - and before the verdict
        // existed this `.then` always dispatched, so it always returned true and never cleared the
        // flag. Now a null verdict clears it, which from the FIRST gate would unlock Fee Schedule
        // and Release Method against the pre-purpose list for the rest of the second gate, and
        // beginQuickEntryBillingDefaultsPending no-ops while the timer is live so nothing re-arms.
        // That is the window this file calls silent data loss, not a cosmetic regression.
        //
        // Identity comparison rather than a counter: the field holds the newest gate's promise, so
        // "I am no longer it" is exactly the condition for standing down. The newer gate owns both
        // the correction and the flag.
        const thisGate = this.quickEntryPersistPromise;
        const gateSuperseded = () => this.quickEntryPersistPromise !== thisGate;
        thisGate
          .then(ok => {
            if (gateSuperseded()) { return; }
            if (!ok || purposeVerdict.persistedPurposeId == null
                || !this.refreshBillingAfterConfirmAllOnce(purposeVerdict.persistedPurposeId)) {
              this.endQuickEntryBillingDefaultsPending();
            }
          })
          .catch(() => { if (!gateSuperseded()) { this.endQuickEntryBillingDefaultsPending(); } });
        // AB#35086 (parity fix): Confirm-All is Quick Entry's "data entry done" moment -
        // the equivalent of Classic Mode leaving its Details tab, which fires
        // patchDetailsComplete (DataEntryDetailsRightPane). Quick Entry never called it,
        // so the data-entry-stage audit event (EnteredDetails, existing task ids - no new
        // AuditTask enum) was missing for QE transactions, breaking task-timing/traceability.
        // Fire the SAME existing action here so QE emits it exactly as Classic does.
        // AB#31605 (re-save): fire ONLY on the FIRST commit. Classic emits DetailsComplete
        // exactly once, and it INSERTs audit rows (TaskID 19 + 35) with no de-dupe, so
        // re-firing on every re-save would duplicate the audit trail and break the Classic
        // parity this call exists for. At this point state.quickEntryCommitCompletedDate
        // still holds the PRE-commit value (the setState below hasn't applied): null on the
        // first commit, set on every re-save - so this runs exactly once per session.
        // (A dedicated QE-specific "Confirm All" AuditTask event is a separate follow-up
        // pending Ali's enum sign-off - see master-spec-bug-batch-31605.md 35086 notes.)
        //
        // AB#31605 (deadlock fix): CHAINED off the persist gate rather than fired
        // alongside it. This used to run concurrently with
        // persistQuickEntrySelectionsToTransaction, which was harmless while every
        // gate write was a narrow single-row update. It stopped being harmless once
        // the Purpose write moved to the END of that gate: for purpose 43 (Disclosure
        // Event) it runs ROIS_RPQ_ins, which INSERTs into tblRPQ and DELETEs the
        // tblRequestBuffer row, so the two requests took locks on the same
        // transaction in opposite order. Reproduced 2026-07-28 - detailscomplete came
        // back HTTP 400 "Process ID 58 was deadlocked on lock resources ... chosen as
        // the deadlock victim". Serializing the audit write after the data writes
        // removes the contention, and it also matches Classic, where DetailsComplete
        // fires on LEAVING the Details tab - after the data has landed, not during.
        //
        // The flag is captured SYNCHRONOUSLY here on purpose: state.quickEntryCommitCompletedDate
        // still holds the PRE-commit value at this point, but the setState below applies
        // before this promise resolves. Reading it inside the .then() would see the
        // post-commit value and silently skip the audit event on every first commit.
        const shouldEmitDetailsComplete = !this.state.quickEntryCommitCompletedDate;
        if (shouldEmitDetailsComplete) {
          // AB#31605 (round-1 review CRITICAL-4): the promise is RETAINED so the type-66
          // finalize can await it. Previously this was fire-and-forget off the same
          // persist promise the finalize awaits, so both resolved in one microtask drain
          // and the two requests contended for locks on the same transaction row.
          //
          // Resolves rather than rejects on failure - see quickEntryDetailsCompletePromise.
          // A toast would be noise for an audit event the specialist cannot act on.
          this.quickEntryDetailsCompletePromise = this.quickEntryPersistPromise
            .then(() => new Promise<void>(resolve => {
              // TIMEOUT IS LOAD-BEARING, not defensive padding: without it the promise can
              // never settle, the await below hangs forever, and the transaction silently
              // never finalizes - no error, no feedback.
              //
              // The real reason it can fail to settle is TEARDOWN, not takeLatest
              // (round-2 review W-1 corrected this). Unmount or a route change kills the
              // root saga and fires NEITHER callback. takeLatest cancellation
              // (DETAILS_COMPLETE_SAGA, services/sagas/index.js) needs a SECOND dispatch of
              // that action, and there are only two dispatch sites - Quick Entry (once per
              // session, guarded by shouldEmitDetailsComplete) and Classic's tab-leave,
              // which needs the specialist ejected into Classic mid-commit. Reachable, but
              // narrow; teardown is the path that actually matters.
              //
              // Resolving rather than rejecting is deliberate: this promise SEQUENCES the
              // finalize behind the audit write, it does not gate on it. Losing the
              // ordering beats losing the transaction.
              //
              // RESIDUAL RACE, stated rather than hidden (round-2 W-1): on timeout the
              // in-flight DetailsComplete PATCH is NOT cancelled, so the finalize proceeds
              // alongside it and the original MoveToRPQ-versus-audit-INSERT lock collision
              // becomes possible again. A round-trip exceeding the timeout means a
              // contended database, which is exactly when that collision matters. This is a
              // documented degradation, not a clean fix - the fallback is precisely
              // pre-fix behavior, so it is not a regression, but it is not a guarantee
              // either.
              //
              // Resolves immediately when the prop is absent (round-2 S-2): a missing
              // patchDetailsComplete otherwise costs the full timeout before the finalize,
              // which is a 10-second mystery for whoever next writes a test.
              if (!this.props.patchDetailsComplete) {
                resolve();
                return;
              }
              // Fallback TRUE: this write sequences the finalize behind the audit event, it
              // does not gate on it - a slow or cancelled audit write must not cost the
              // specialist the transaction.
              this.settleGuardedWrite<boolean>(true, settle => {
                this.props.patchDetailsComplete!(this.props.transactionId, () => settle(true), () => settle(true));
              }).then(() => resolve());
            }))
            .catch(() => undefined);
        }
        // Spec #35135 (AC9, Business Rule 6): Disclosure Accounting has no Billing
        // step (Classic hard-disables tabs 3/4 for type 66), so Confirm-All success
        // routes straight to completion instead of the Billing pane. Every other
        // request type keeps the existing route.
        const isDisclosureAccounting = (this.props.formState?.values ?? {})[FormConstants.REQUEST_TYPE] === DISCLOSURE_ACCOUNTING;
        // AB#37853 (Phase 13b): arm the Billing pane's loading state HERE, atomically with the tab
        // flip that mounts the pane - not later when the re-fetch fires. The persist gate kicked
        // off above runs ~8 sequential writes (~10s measured) before that re-fetch is dispatched,
        // and throughout it the purpose is still unpersisted, so isInternalRequest reads false and
        // both controls render editable. Arming inside this same setState guarantees there is no
        // render in which the pane is mounted and the flag is false.
        //
        // Only on the branch that actually routes to Billing: Disclosure Accounting has no Billing
        // step, and manual navigation / Back-to-Quick-Entry never come through here at all.
        //
        // AB#35088 (QA retest, second finding) — WHAT WAS TRIED HERE AND WHY IT WAS REVERTED.
        // An earlier revision of this branch armed the flag ONLY for an Internal request, on the
        // premise that nothing is in flight for any other type. That premise is FALSE, and the
        // narrowing was withdrawn (John James, PR !9996). Two facts, both verifiable a few hundred
        // lines below and on the server:
        //
        //   1. The Confirm All purpose write sends `clearFeeOk: firstCommit` AND
        //      `reapplyPurposeDefaults: firstCommit` (see persistPurposeLast) with NO request-type
        //      gate, and the API answers by calling SetToDefaultFeeSchedule(overwriteExisting: true)
        //      plus DetermineReleaseMethod for any purpose except 43. So the server really does
        //      clear and reassign both values on a standard-type first commit.
        //   2. clearQuickEntryBillingDefaultsPendingWhenLanded ends the pending state as soon as both
        //      ids are non-null and runs on EVERY componentDidUpdate. So if the two values had
        //      already been seeded when Billing mounted — which is what the narrowing claimed — the
        //      flag would clear immediately and the 8-18 SECONDS QA measured could never have
        //      happened. The measured window is itself evidence the values were not there yet.
        //
        // Unarming it therefore replaced 8-18s of "Loading..." with 8-18s of "- Select -" (verbatim
        // this bug's own Sev-1 Actual Result) with both controls EDITABLE — and because
        // computeQuickEntryBillingDefaults only seeds a field whose current value is null, a pick
        // made in that window permanently suppressed the server-assigned default. Silent data loss,
        // not a cosmetic regression.
        //
        // So the flag stays armed for every type that routes to Billing. QA's complaint is that the
        // wait "reads as empty", and that is addressed in QuickEntryBillingPane by making the
        // in-flight state say so, not by removing the guard that keeps the operator out of controls
        // which are about to be overwritten. Shortening the wait itself means resequencing the
        // persist gate (~8 serialized writes, serialized to fix a real deadlock) and is deliberately
        // NOT attempted here.
        //
        // Only on the branch that actually routes to Billing: Disclosure Accounting has no Billing
        // step, and manual navigation / Back-to-Quick-Entry never come through here at all.
        if (!isDisclosureAccounting) {
          this.beginQuickEntryBillingDefaultsPending();
        }
        this.setState({
          quickEntrySubmitting: false,
          quickEntryCommitCompletedDate: completedDate || new Date().toISOString(),
          quickEntryActiveStepTab: isDisclosureAccounting ? this.state.quickEntryActiveStepTab : "billing",
        });
        if (isDisclosureAccounting) {
          this.completeQuickEntryDisclosureAccounting();
        }
      },
      () => {
        // AC6/Test 5.2: 409 - write-once guard already tripped. Distinct
        // message from the generic failure below.
        this.setState({ quickEntrySubmitting: false });
        toast.error("Quick Entry for this request has already been submitted.");
      },
      () => {
        // 404 - no intake record exists for this transaction (combo af935bf
        // backend outcome, coalesced with F1d's client). Distinct, actionable
        // message: extraction never produced a record to commit against, so
        // the specialist should re-run intake / use Classic Mode rather than
        // retry a commit that will keep 404ing. Tab stays on Request Info.
        this.setState({ quickEntrySubmitting: false });
        toast.error("No intake data found for this request - it may not have been analyzed yet. Try re-attaching the request document, or switch to Classic Mode.");
      },
      () => {
        // Test 5.1: generic network/server failure - entered values are
        // untouched (this.getQuickEntryRows() re-derives from unchanged
        // props/form state) and the tab stays on Request Info.
        this.setState({ quickEntrySubmitting: false });
        toast.error("Could not submit Quick Entry - please try again.");
      },
      matchSummary,
    );
  }

  /**
   * Persists everything Quick Entry DEFERS to Confirm All onto the actual transaction
   * record, through the SAME UpdateTransaction path Classic Mode uses
   * (updateBillingPaneFields -> PATCH transactions/{id}/update -> ROIS_Transaction_upd
   * family). Covers the request-info fields (authorization date, request date, case
   * number, clinic/responsible) AND the resolved-existing patient/requestor links
   * (patientDataid / sendToRequestorid + sendToRequestorContactid).
   *
   * Why this is needed: Quick Entry intentionally does NOT autosave these per-field the
   * way Classic does - it only writes them to the DATA_ENTRY_FIELDS_FORM redux draft and
   * batches persistence to Confirm All. The Confirm-All commit (commitQuickEntry ->
   * ROIS_QuickEntryCommit_upd) records the AI-vs-specialist correction audit on
   * tblRequestIntakeData but does NOT write the transaction tables, so without this call
   * these fields never reach the record that Classic Mode / Record Attachment read -
   * they'd open blank. (Request type/purpose still persists through its own immediate
   * call, onQuickEntryRequestPurposeChange, untouched by this bug fix - deferring THAT
   * was out of scope. Records Requested and Sensitive Info used to be immediate too, but
   * per direct instruction now defer here as well - see persistQuickEntryReleaseInfo's
   * and the SENSITIVE_INFO_ROW_ID case's own doc comments for why.)
   *
   * ONE combined dispatch, deliberately: updateBillingFieldsSaga is registered
   * takeLatest, so firing several updateBillingPaneFields in the same tick would cancel
   * all but the last saga task - the earlier PATCHes reach the server but their
   * getTransactionAttributes reload is skipped, leaving the just-confirmed values stale
   * in the client. Bundling matches Classic too (autosaveBillingPaneField always carries
   * patientDataid alongside the changed field in a single call). Mirrors that helper's
   * exact keyName/value mapping: clinic/patient/requestor ids as-is; case number as-is;
   * dates via getMomentDate, skipping empty/invalid/SQL-overflow values. userID is
   * required or UpdateTransaction 500s (Validate -> CurrentUserId).
   *
   * The create-new patient path is a DIFFERENT action (createPatientRecordRequest, no
   * takeLatest collision) handled separately below. Create-new requestor is not
   * persisted yet - see createQuickEntryPatient's sibling note and
   * plan-quick-entry-txn-persistence-31605.md.
   */
  persistQuickEntrySelectionsToTransaction = (purposeVerdict?: QuickEntryPurposeVerdict): Promise<boolean> => {
    const values = this.props.formState?.values ?? {};
    const payload: Record<string, any> = {
      transactionId: this.props.transactionId,
      userID: global.userID,
    };

    const caseNumber = values[FormConstants.CASE_NUMBER];
    if (caseNumber != null && caseNumber !== "") {
      payload.caseNumber = caseNumber;
    }

    const clinic = values[FormConstants.CLINIC_RESPONISBLE];
    if (clinic != null && clinic !== "") {
      payload.clinicdepartmentid = clinic;
    }

    // Spec #35289 (AC4/AC9): Audit Type / On Behalf Of persist ONLY at Confirm All,
    // never on field edit. They ride THIS transaction-detail PATCH (Option A -
    // updateBillingPaneFields -> UpdateTransaction), which is pushed onto `writes`
    // below and therefore runs INSIDE the Promise.all barrier, strictly BEFORE the
    // last-chained purpose persist - so the buffer/transaction row still exists when
    // they are written. Backend /update maps auditType -> @RequestForAuditType and
    // onBehalfOf -> @OnBehalfOf. Only sent for Audit(53) so no non-Audit PATCH grows.
    if (Number(values[FormConstants.REQUEST_TYPE]) === AUDIT) {
      const auditType = values[FormConstants.AUDIT_TYPE];
      if (auditType != null && auditType !== "" && Number(auditType) > 0) {
        payload.auditType = auditType;
      }
      const onBehalfOf = values[FormConstants.ON_BEHALF_OF];
      if (onBehalfOf != null && onBehalfOf !== "" && Number(onBehalfOf) > 0) {
        payload.onBehalfOf = onBehalfOf;
      }
    }

    // AB#37982: an un-edited AI-extracted date is a Date at UTC midnight (models/intake.ts's
    // tryParseDate) - getMomentDate renders it LOCALLY, which in any timezone BEHIND UTC is the
    // day before. Read those on their own UTC calendar day instead; every other value (a
    // specialist-picked/typed Date, or a string) keeps going through getMomentDate exactly as
    // before - see isUtcMidnightDate's docblock for the shared invariant with
    // formatShortFieldGroupDate's row-summary fix.
    const addDate = (formField: string, key: string) => {
      const value = values[formField];
      const formatted =
        value instanceof Date && !isNaN(value.getTime()) && isUtcMidnightDate(value)
          ? utcMidnightDateToMMDDYYYY(value)
          : getMomentDate(value);
      if (formatted && formatted !== "Invalid date" && isDateNotSqlOverflow(formatted)) {
        payload[key] = formatted;
      }
    };
    addDate(FormConstants.AUTHORIZATION_DATE, "authdate");
    addDate(FormConstants.REQUEST_DATE, "requestDate");
    // AB#35137 / AB#35144: same UpdateTransaction path, using Classic's exact keyNames
    // (autosaveBillingPaneField mapping: "receiveddate" / "duedate" / "requestid").
    addDate(FormConstants.RECEIVED_DATE, "receiveddate");
    addDate(FormConstants.DUE_DATE, "duedate");

    const requestId = values[FormConstants.REQUEST_ID];
    if (requestId != null && String(requestId).trim() !== "") {
      payload.requestid = String(requestId).trim();
    }

    // The resolved-existing patient link (patientDataid) rides THIS request-info PATCH.
    // It's safe here (not the fire-and-forget path it once was) because this PATCH is in
    // the awaited gate below - the completion step waits for it before BillingComplete, so
    // there's no read-before-commit race AND no takeLatest collision with the billing
    // PATCH (they run sequentially via the gate). Persisting it at Confirm All (not
    // billing) also means it survives a Confirm All -> bail-to-Classic without completing,
    // matching where the requestor link persists. The requestor uses its own send-to
    // endpoints (the /update PATCH ignores requestor ids).
    // AB#35071: resolved through resolveConfirmedPatientId rather than read straight off
    // quickEntryPatientResolution. That state was the id's ONLY channel - set once by
    // PatientInfoRow's write-once onSelectPatient effect, and cleared by two separate reset paths
    // (transaction change, fresh extraction) - and the old
    // `mode === "select" && patientId != null` guard then dropped the link SILENTLY. Proven
    // against the database: PatientDataID NULL on a transaction whose Confirm All PATCH landed and
    // whose every other field (CaseNumber, purpose, auth date) persisted, with the row reporting a
    // single match. The resolver falls back to the match state (reported on every change) and to
    // any link already on the transaction, so no single missed hop loses the patient.
    const patient = this.state.quickEntryPatientResolution;
    const patientLink = resolveConfirmedPatientId(patient, this.state.patientMatchState, this.currentTransactionDetails());
    if (patientLink.status === "resolved") {
      payload.patientDataid = patientLink.patientId;
    } else if (patientLink.status === "unresolved") {
      // The specialist confirmed a patient and we cannot link it. Completing anyway is the bug
      // itself - the transaction lands with no patient and Name/DOB read blank on every later view,
      // with nothing having warned anyone. Fail loudly and let them re-pick instead.
      toast.error("Couldn't save the patient on this request - please re-select the patient and try again.");
      return Promise.resolve(false);
    }

    // Each write resolves to a success boolean (never rejects) so the completion step
    // (persistQuickEntryBillingFields) can (a) await ALL of them before firing
    // BillingComplete/MoveToRPQ - which reads the transaction and would otherwise throw
    // "Transaction.Patient/BillToContact returned null" on an uncommitted record - and
    // (b) ABORT completion if any prerequisite persist failed, rather than proceeding
    // into a guaranteed completion NRE.
    // AB#35135 dev-testing follow-on (deadlock reproduced 2026-07-31): these are THUNKS,
    // not started promises, so the barrier at the end of this method can run them strictly
    // one-at-a-time. The request-info PATCH (ROIS_Transaction_upd) and the requestor
    // send-to (ROIS_TansactionRequestorNameID_upd) both UPDATE the same tblRequestBuffer
    // row; started together (the old writes.push(fn()) + Promise.all) they deadlock - SQL
    // 1205 -> API 999 "chosen as the deadlock victim" HTTP 400. The Purpose/Disclosure/PHI
    // writes were already serialized for this exact reason (see their comments below); this
    // closes the one concurrent pair that fix missed.
    const writes: Array<() => Promise<boolean>> = [];

    const hasFields = Object.keys(payload).some(k => k !== "transactionId" && k !== "userID");
    if (hasFields) {
      writes.push(() => new Promise<boolean>(resolve =>
        this.props.updateBillingPaneFields?.(payload, true, () => resolve(true), () => resolve(false))));
    }

    if (patient?.mode === "create") {
      // create-new patient is a separate endpoint (createPatientRecordRequest).
      writes.push(() => this.createQuickEntryPatient());
    }
    // Requestor (select or create) persists through the send-to endpoints, not the PATCH.
    writes.push(() => this.persistQuickEntryRequestorResolution());

    // Bug fix (AB#31605 reopen-rehydration): persist the current Request
    // Type/Purpose so a plain reopen can rehydrate it from the transaction
    // (rehydrateQuickEntryFromTransaction reads transactionDetails.requestPurpose).
    // Quick Entry otherwise wrote Type/Purpose ONLY through
    // onQuickEntryRequestPurposeChange, which fires only when the specialist
    // actually CHANGES Purpose - an AI-seeded or unchanged Type/Purpose was never
    // persisted, so it blanked on reopen. Uses the SAME endpoint + payload shape
    // onQuickEntryRequestPurposeChange used to use (POST transactions/purpose,
    // requestPurposeId = the PURPOSE_TYPE dropdown id; the backend derives the
    // type from the purpose). Skipped when it already matches the persisted value
    // so we don't double-persist. Deliberately does NOT fire
    // getTransactionAttributes - this runs inside the awaited Confirm-All gate and a
    // mid-commit reload would clobber the just-confirmed form draft.
    //
    // AB#31605: this is now the ONLY place Quick Entry persists Purpose. The
    // dropdown handler is read-only (it previews the record types instead), so the
    // skip-guard below no longer short-circuits on a real change - it fires, which
    // is the intended behavior.
    //
    // *** ORDERING IS LOAD-BEARING - THIS MUST RUN LAST. ***
    // ROIS_spUTransactionRequestPurpose_upd runs "IF @RequestPurpose = 43 EXEC
    // ROIS_RPQ_ins", and 43 is DISCLOSURE_EVENT. ROIS_RPQ_ins copies the transaction
    // into tblRPQ and then DELETEs the tblRequestBuffer row. Every other write in
    // this gate targets that buffer row, so any of them still in flight when this
    // one lands would be writing to a row that no longer exists.
    //
    // It is therefore NOT part of `writes`: it must run strictly AFTER the entire
    // writes barrier has settled (it migrates then DELETEs the buffer row every write
    // targets) AND only when those writes succeeded. It is chained after the barrier at
    // the end of this method instead. (Same reason it can't simply be moved lower in
    // this function body.)
    //
    // BEST-EFFORT / NON-GATING (AB#31605 review MINOR-1): resolves TRUE even on
    // failure so a transient purpose-POST error can't abort Confirm-All completion
    // (before that fix an unchanged/AI-seeded purpose was never persisted and
    // completion still succeeded - this convenience write must not regress that).
    // A failure surfaces a toast rather than silently blocking.
    // Uses the identity-guarded details so it never persists a purpose against a
    // stale prior-transaction id.
    const purposeTd = this.currentTransactionDetails();
    const purposeId = Number(values[FormConstants.PURPOSE_TYPE]);
    //
    // Bug fix (AB#37853, D3 + D2's client half). FIRST COMMIT ONLY, for both flags:
    //
    // clearFeeOk was hardcoded false, which means an invalidated fee schedule made the DAL roll
    // the purpose write back entirely and raise a 409 - and the catch below swallowed everything
    // into one toast while still resolving true, so Confirm All reported success on a transaction
    // whose purpose was never written. Sending true lets the write commit; safe ONLY because
    // reapplyPurposeDefaults reassigns whatever gets cleared, so the transaction is never left with
    // no fee schedule at all (which QuickEntryBillingPane's creation gate would block on outright).
    // This is why D3 must not ship ahead of D2.
    //
    // reapplyPurposeDefaults asks the API to re-run the purpose-dependent defaults now that the
    // purpose is finally persisted - see the endpoint's own comment. Scoped to the first commit
    // because at that point the Billing pane has not mounted yet, so no operator pick can exist to
    // clobber; on a re-save the operator may have chosen a fee schedule by hand and we must leave it.
    const firstCommit = !this.state.quickEntryCommitCompletedDate;
    const persistPurposeLast: (() => Promise<boolean>) | null =
      purposeTd && purposeId > 0 && purposeId !== (purposeTd.requestPurpose?.id ?? 0)
        ? () => {
          const purposeBody: RequestPurposeUpdate = {
            organizationId: purposeTd.facility.id,
            requestBufferId: purposeTd.id,
            requestPurposeId: purposeId,
            clearFeeOk: firstCommit,
            reapplyPurposeDefaults: firstCommit,
          };
          return post(`transactions/purpose?userId=${global.userID}`, purposeBody)
            .then(() => true)
            .catch((error: any) => {
              // Split so a residual 409 NAMES the conflicting fee schedules instead of hiding
              // behind the generic message - the endpoint already returns them as the response
              // body. Fee-schedule names only: never patient or requestor data
              // (.claude/rules/hipaa-compliance.md).
              const conflicting: string[] = error?.response?.status === HttpResponse.Conflict
                ? ((error.response.data as NameIdPair<number>[] | undefined) ?? [])
                  .map(feeSchedule => feeSchedule?.name)
                  .filter((name): name is string => Boolean(name))
                : [];
              toast.error(conflicting.length > 0
                ? `Couldn't save the request type/purpose - it conflicts with the fee schedule ${conflicting.join(", ")}. Please re-open the transaction and correct the fee schedule before finalizing.`
                : "Couldn't save the request type/purpose - please re-open the transaction and confirm it before finalizing.");
              // AB#39265: resolves FALSE now, and that is still NON-GATING - the gate maps this
              // to `{ ok: true, persistedPurposeId: null }` below, so completion proceeds exactly
              // as AB#31605 review MINOR-1 requires while the fee-schedule correction learns that
              // the purpose never landed. Making the GATE fail here would reverse that decision;
              // Classic's interactive conflict dialog must not be ported into a batch gate.
              return false;
            });
        }
        : null;

    // Bug fix (direct user report): Records Requested - deferred here instead of
    // persisting immediately (see persistQuickEntryReleaseInfo's own doc comment).
    // null means untouched this session - nothing to persist, the transaction's
    // existing value stands. Reuses the exact validation gate + payload shape
    // persistQuickEntryReleaseInfo used to run inline before it deferred. Skips
    // the call entirely when nothing's checked - same as the Switch-to-Classic-
    // Mode revert fix - because the backend's [Required, MinLength(1)] on
    // Releases can't represent zero; there is no way to persist "cleared" through
    // this endpoint, full stop.
    // AB#35085 (review Minor 1): persist the MERGED list, not the raw local
    // override, so what saves matches what's displayed (getQuickEntryReleaseInfo).
    // Preserves the "null = untouched this session -> skip persist" semantics; the
    // merge only affects WHICH options are considered, dropping any id no longer in
    // the server's applicable set so a hidden/checked-but-removed record type can't
    // be phantom-persisted.
    // AB#37995: pay out the range the specialist is LOOKING AT (getQuickEntryServiceDateRange,
    // i.e. the quickEntryServiceDateOverride the two Service Date rows render) rather than the
    // second copy of it carried as `dateOfService` on the release items. The two copies can
    // diverge - the AI's date seed and records seed run in one componentDidUpdate pass and the
    // records seed's setState overwrites the date seed's - and when they do, this guard dropped
    // the write and took the checked RECORD TYPES with it, since both ride the same call. With no
    // override the two are equal, so this is behavior-preserving wherever they agree.
    //
    // Both scratch slices count as "touched": the Service Date rows write only the override, so
    // quickEntryReleaseInfo alone reads as untouched after a Cancel on Records Requested (whose
    // snapshot nulls that shared slice, not the override) or a purpose reconciliation that nulls
    // it by design (AB#35149). With both null there is nothing to persist.
    //
    // Also gated on the row still being applicable, like the Sensitive Info write below:
    // Disclosure Accounting hides Records Requested and both Service Date rows while
    // seedExtractedRecordsRequested has no request-type gate, so type 66 can reach here with
    // items checked and no range on screen to correct.
    const releaseUntouchedThisSession =
      this.state.quickEntryReleaseInfo == null && this.state.quickEntryServiceDateOverride == null;
    const releaseInfo = releaseUntouchedThisSession ? null : this.getQuickEntryReleaseInfo();
    if (releaseInfo != null && this.isQuickEntryRowApplicable(RECORDS_REQUESTED_ROW_ID)) {
      const shownRange = this.getQuickEntryServiceDateRange();
      const reconciled = buildReleaseInfoWithDateRange(releaseInfo, shownRange.from, shownRange.to, shownRange.allDates);
      const checkedReleaseIds = reconciled.filter(item => item.checked).map(item => item.id);
      const releaseValidation = this.validateQuickEntryReleaseInfo(reconciled);
      if (checkedReleaseIds.length > 0 && !releaseValidation.display_error) {
        const { from, to } = shownRange;
        // AB#37995: resolve on the SAGA's outcome, not on the dispatch returning - a rejected POST
        // otherwise reported success. Same onSuccess/onError shape as the billing PATCH above.
        //
        // THROUGH settleGuardedWrite, not a bare Promise (David Heifetz, PR !9999). A bare promise
        // here can settle ONLY from the two saga callbacks, and updateInformationToReleaseSaga is
        // registered takeLatest (services/sagas/index.js) - it fires onSuccess after two yields and
        // onError only from its catch, so a CANCELLED generator fires neither. Cancellation is
        // reachable: revertQuickEntryRecordsAndSensitiveInfo dispatches the same action type via
        // onConfirmLeaveQuickEntry, and the Classic Mode button carries no in-flight guard. Pressing
        // Confirm All and then Switch to Classic Mode while this POST is in flight left the promise
        // unsettled forever - the sequential drain stalled, persistDisclosureLast and
        // persistPurposeLast never ran, and quickEntryBillingSubmitting latched true, so Create
        // Transaction did nothing for the rest of the session with no toast and no timeout.
        //
        // Before this bug's round-4 change the promise resolved synchronously, so cancellation was
        // harmless - the hang is new here, which is why it is fixed here. settleGuardedWrite is what
        // the disclosure write below already uses for the identical reason, and its timeout fallback
        // is FALSE: an unsettled release write must fail the commit rather than let completion
        // proceed as though the records had been saved.
        writes.push(() => this.settleGuardedWrite<boolean>(false, settle => {
          try {
            this.props.saveInformationToRelease({
              // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
              // eslint-disable-next-line no-restricted-syntax
              organizationId: this.props.transactionDetails?.facility?.id ?? 0,
              // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
              // eslint-disable-next-line no-restricted-syntax
              requestBufferId: this.props.transactionDetails?.id ?? 0,
              releases: checkedReleaseIds,
              from,
              to,
              // otherDocumentsNote, not a fourth copy of its rule: it is the one predicate the
              // row, the Records pane and this write share, so "is there a description" cannot
              // diverge between what is displayed and what is stored (Mike Hamilton, PR !10721
              // round 3). It trims - "   " renders blank and must not be stored - and returns
              // nothing when id 31 is unchecked, so a reopened transaction's persisted
              // description is not written back for a type nobody asked for, which the display
              // (correctly) hides and the specialist could then neither see nor remove.
              requestComments: otherDocumentsNote(reconciled, this.getQuickEntryReleaseComments()) ?? "",
            }, () => settle(true), () => {
              toast.error("Couldn't save Records Requested - please retry before creating the transaction.");
              settle(false);
            });
          } catch {
            settle(false);
          }
        }));
      } else if (checkedReleaseIds.length > 0) {
        // AB#37995: fail closed rather than skip silently, as createQuickEntryPatient does for an
        // unsaveable patient. Reachable because getQuickEntryDateErrors leaves the date-of-birth
        // floor to infoToReleaseValidiation (range ordering moved to getQuickEntryDateErrors
        // itself under AB#38463, but the DOB floor is still Confirm-All-only), so Confirm All
        // stays enabled while this gate rejects. NOT extended to the nothing-checked case above:
        // that skip is deliberate (the endpoint's [Required, MinLength(1)] cannot represent
        // "cleared") and is already held by that row's own NeedsEntry status blocking Confirm All.
        writes.push(() => {
          // AB#38463 (Nelson Omuto, PR !10139 review): every failure that can reach this branch is
          // a Service Date one, so it says so once and does not name a second field group.
          //
          // The earlier version claimed errors.items meant "Records Requested", and that was wrong
          // on both halves. infoToReleaseValidiation only puts the "At least one of the records"
          // clause in errors.items when NOTHING is checked - which this branch's own
          // `checkedReleaseIds.length > 0` guard excludes. The one items value that can arrive here
          // is "Either a date range or 'All Dates' must be selected.", which is a Service Date
          // problem. And because display_error is the sum of all three, arriving here with
          // from/to empty FORCES items to be that string - so the old "Records Requested" label was
          // wrong 100% of the times it could render, while the tail simultaneously said Service
          // Date. The message contradicted itself.
          const { from, to, items } = releaseValidation.errors;
          const reason = from || to || items;
          // The tail only adds something when the reason does not already point at the range.
          const tail = reason === items ? "" : " Please correct the Service Date range before creating the transaction.";
          toast.error(`Couldn't save Service Date - ${reason}${tail}`);
          return Promise.resolve(false);
        });
      }
    }

    // Bug fix (direct user report): Sensitive Info - deferred here instead of
    // persisting immediately (see the SENSITIVE_INFO_ROW_ID case's own doc
    // comment). null means untouched this session - nothing to persist.
    // buildSensitiveInfoRevertPayload already builds the right payload shape
    // from a full snapshot array (as opposed to buildSensitiveInfoUpdatePayload,
    // which expects an update-delta) - reused here for exactly that reason.
    // Fire-and-forget like every other saveAndUpdateSensitiveInfo call site -
    // this prop has never had a success/failure callback.
    //
    // AB#37856 (round-1 review C1): ALSO gated on the row still being applicable, exactly as
    // the Disclosure write below gates on its own row. `!= null` alone was sufficient only
    // while the override could not become non-null without the specialist clicking a visible
    // checkbox. The AI seed breaks that assumption: a transaction seeded as some other type
    // and then corrected to Disclosure Accounting drops this row from the list entirely
    // (DISCLOSURE_ACCOUNTING_HIDDEN_ROW_IDS) WITHOUT clearing the override, because a
    // request-type change within one transaction deliberately keeps drafts (see the
    // transaction-change reset block's own comment). The row then stopped counting as
    // outstanding, Confirm All became reachable, and this write persisted the AI's
    // authorizations for a row the specialist never saw.
    //
    // Gating here rather than clearing the override on inapplicability: clearing would also
    // destroy a MANUALLY entered answer on a switch to 66 and back, which is the very thing
    // keeping drafts across a type change exists to avoid. A row this request type has no
    // Sensitive Information questionnaire for should simply never be persisted - the same
    // rule Classic applies by not rendering it at all.
    if (this.state.quickEntrySensitiveInfo != null && this.isQuickEntryRowApplicable(SENSITIVE_INFO_ROW_ID)) {
      writes.push(() => new Promise<boolean>(resolve => {
        try {
          this.props.saveAndUpdateSensitiveInfo(buildSensitiveInfoRevertPayload(this.state.quickEntrySensitiveInfo!, this.props.transactionId));
          // AB#35086: audited right alongside the real save, same as Classic's
          // own applySensitiveInfoUpdate call site - Quick Entry bypasses that
          // shared function (its real persist is deferred to here, not the
          // per-checkbox onChange), so the audit call has to be repeated here too.
          this.props.putAuditTransactionSensitiveInfo(this.props.transactionId, buildSensitiveInfoAuditMessage(this.state.quickEntrySensitiveInfo!));
          resolve(true);
        } catch {
          resolve(false);
        }
      }));
    }

    // Spec #35135 (AC4a/AC4b/AC5): the ONE Disclosure Accounting write. Contributed
    // ONLY when the row is applicable (request type 66) AND the draft passes the
    // same validity gate Classic runs inline on blur (Reason + a present,
    // parseable, non-SQL-overflow Date) - an incomplete draft contributes nothing
    // rather than a rejected call. Uses Classic's existing action -> saga -> API
    // path with the payload built by the shared
    // generateUpdateDisclosureInformationObject; no new endpoint.
    //
    // NOT pushed onto `writes` - it runs strictly AFTER the barrier, for the same
    // reason the Purpose write does. See persistDisclosureLast below.
    //
    // HIPAA: the payload carries PHI-bearing free text (protocol name/number,
    // special notes) - it is never logged here, and it travels through the same
    // updateDisclosureInformationAPI boundary Classic uses.
    // Runs AFTER the Promise.all(writes) barrier - see the chain at the end of this
    // method. Null when the row is not applicable or the draft is incomplete.
    let persistDisclosureLast: (() => Promise<boolean>) | null = null;

    const disclosureDraft = this.getQuickEntryDisclosureDraft();
    if (this.isQuickEntryRowApplicable(DISCLOSURE_INFO_ROW_ID) && isDisclosureDraftComplete(disclosureDraft, this.props.selectedPHICodes)) {
      const disclosurePayload = buildDisclosureUpdatePayload(disclosureDraft, this.props.transactionId);
      // ORDERING IS LOAD-BEARING - this write MIGRATES THE TRANSACTION, exactly like the
      // Purpose write below (verified against the proc bodies 2026-07-29).
      //
      // ROIS_spUTransactionDisclosureEvent_upd takes its ELSE branch whenever no tblRPQ
      // row exists yet - which is every new Quick Entry transaction - and that branch
      // runs `exec ROIS_RPQ_ins`. ROIS_RPQ_ins does
      // `INSERT INTO tblRPQ (...) SELECT ... FROM tblRequestBuffer` and then
      // `DELETE FROM tblRequestBuffer`.
      //
      // So it does not merely contend with the writes above - it SNAPSHOTS the row they
      // are writing and then removes it. Running concurrently, if this one commits first:
      //   1. the snapshot copies the STALE tblRequestBuffer values into tblRPQ, and
      //   2. the request-info PATCH's ROIS_Transaction_upd then updates ZERO rows -
      //      silently, because that proc returns `SELECT @RequestBufferID` regardless of
      //      rowcount.
      // The specialist's entered request-info is lost twice over, with no error anywhere.
      // This is the same mechanism as the deadlock reproduced on 2026-07-28; that fix
      // serialized the Purpose write and missed this second ROIS_RPQ_ins caller.
      // (PR 9603 review thread 50527 should-fix #2 / round-2 W-4.)
      //
      // The PHI writes below stay in `writes`: ROIS_RPQ_ins never touches
      // tblReqItemReqBufferLink, and tblRPQ preserves RequestBufferID, so those rows stay
      // correctly keyed across the migration and are safe on either side of it.
      //
      // Still settle-guarded with a FALSE fallback (round-2 W-3):
      // UPDATE_DISCLOSURE_INFORMATION_SAGA is takeLatest, so a cancelled generator fires
      // neither callback. Falling back to false keeps this write GATING - a disclosure
      // record that may not have been written must abort the finalize, not wave it through.
      persistDisclosureLast = () => this.settleGuardedWrite<boolean>(false, settle =>
        this.props.updateDisclosureInformation?.(disclosurePayload, () => settle(true), () => settle(false)));

      // AB#35135 follow-up: PHI codes. Required (>= 1) for Disclosure Accounting, the
      // same rule Classic enforces via localValidations' type-66 branch.
      //
      // DIFFED, not re-sent: phidisclosed is a per-code PATCH with a delete flag
      // rather than a set-replace, so only CHANGED codes are written - no redundant
      // churn on the PHIDisclosed audit table. An untouched draft diffs to [] and
      // contributes nothing, which is what makes an unmodified reopen a no-op.
      //
      // Called through phiDisclosedApi (a direct services/Network PATCH) rather than
      // the updatePHIDisclosed action: that saga is registered with takeLatest, which
      // cancels the in-flight run when the next action of the same type arrives, so
      // dispatching a loop of them would silently keep only the last write.
      //
      // The whole set collapses to ONE Promise<boolean> on `writes`: awaited before
      // the finalize, resolving false if any single code failed so completion aborts
      // rather than finalizing a partially-recorded disclosure.
      //
      // SEQUENTIAL, not Promise.all (security review, AB#35135): every one of these
      // PATCHes writes tblPHIDisclosed rows for the SAME (OrganizationID,
      // RequestBufferID), and they sit inside the same Confirm-All barrier as the
      // disclosure update and the request-info PATCH - which target that same
      // transaction row. Fanning them concurrently is the identical contention shape
      // that produced the reproduced "Process ID N was deadlocked on lock resources
      // ... chosen as the deadlock victim" HTTP 400 the Purpose write was moved to
      // fix (see persistPurposeLast below). One at a time costs a few hundred
      // milliseconds on a handful of codes and removes the contention entirely.
      const phiChanges = diffPhiCodeSelections(disclosureDraft, this.props.selectedPHICodes);
      if (phiChanges.length > 0) {
        const transactionId = this.props.transactionId;
        writes.push(() =>
          phiChanges.reduce(
            // Each link runs only after the previous PATCH settled. `allOk` carries the
            // running result so ONE failure makes the whole set resolve false (aborting
            // completion) while still attempting the remaining codes - a half-recorded
            // disclosure must not be silently finalized.
            (chain, change) => chain.then(allOk =>
              phiDisclosedApi(transactionId, global.userID, change.requestedItemID, change.isDelete)
                .then(() => allOk)
                .catch(() => false)),
            Promise.resolve(true),
          ).catch(() => false));
      }
    }

    // AB#31605: the Purpose write runs strictly AFTER every other write above has
    // settled - see persistPurposeLast's own comment for why. For purpose 43
    // (Disclosure Event) the backend migrates the transaction into tblRPQ and DELETEs
    // the tblRequestBuffer row that all the writes above target, so overlapping it
    // with them would mean writing to a row that is being deleted underneath.
    //
    // Chained AFTER the barrier rather than added to `writes` because it must run once
    // the whole barrier has settled and only if it succeeded - a migrating write must
    // not overlap or precede the buffer-row writes it snapshots and then deletes.
    //
    // Non-gating: it resolves true even on failure (MINOR-1), so it cannot turn an
    // otherwise-successful commit into a failure. And it is skipped entirely when the
    // prerequisite writes failed, since there is no point migrating a transaction
    // whose data did not land.
    // Both migrating writes run after the barrier, in this order:
    //
    //   sequential writes     every write that targets tblRequestBuffer or its children
    //   -> disclosure         GATING - snapshots tblRequestBuffer into tblRPQ, deletes it
    //   -> purpose            non-gating - also calls ROIS_RPQ_ins (purpose 43)
    //
    // Disclosure propagates its boolean, so a failed disclosure write aborts completion
    // (AC4b, fail-closed). Purpose does not - it resolves true even on failure.
    //
    // Disclosure before Purpose is deliberate: whichever runs first performs the
    // migration, and the second finds the tblRPQ row already present and returns early
    // (ROIS_RPQ_ins's own IF EXISTS guard). Putting disclosure first means the
    // NonHIMGeneralInfoID it creates is carried into tblRPQ by the migration rather than
    // needing the separate update path.
    // AB#35135 dev-testing follow-on: run the writes strictly SEQUENTIALLY (was
    // Promise.all) so no two overlap on the tblRequestBuffer row - closes the
    // request-info-PATCH vs requestor-send-to deadlock reproduced 2026-07-31. Every
    // thunk still runs (no short-circuit) and the booleans are AND-ed, identical to the
    // old .every(Boolean); they simply no longer hold row locks at the same time.
    return writes
      .reduce(
        (acc, step) => acc.then(prevOk => step().then(ok => prevOk && ok)),
        Promise.resolve(true),
      )
      .then(ok => (ok && persistDisclosureLast ? persistDisclosureLast() : ok))
      .then(ok => {
        // AB#39265: record WHICH purpose this gate left in the database - that is what the
        // fee-schedule list has to be fetched for. See QuickEntryPurposeVerdict.
        if (!ok) {
          return ok;   // an earlier write failed, so persistPurposeLast never ran
        }
        if (!persistPurposeLast) {
          // Not contributed: the transaction already carries this purpose. Report ITS value, not
          // the form's - the form can have moved on since, and only the database matters here.
          if (purposeVerdict) { purposeVerdict.persistedPurposeId = Number(purposeTd?.requestPurpose?.id) || 0; }
          return ok;
        }
        // The snapshot `purposeId` is what the POST carries, taken when the gate was BUILT. The
        // operator can change the purpose during the ~8 serialized writes, so re-reading the form
        // afterwards would name a purpose this gate never sent.
        return persistPurposeLast().then(written => {
          if (purposeVerdict && written) { purposeVerdict.persistedPurposeId = purposeId; }
          return true;   // non-gating, exactly as before
        });
      });
  }

  /**
   * Create-new patient at Confirm All (F1c no-match path): createPatientRecordRequest
   * creates AND links the patient (the endpoint carries transactionId). Values come
   * from the DATA_ENTRY_FIELDS_FORM draft writePatientToForm set, matching the exact
   * shape Classic's createPatientRecordRequest sends.
   *
   * Guarded exactly like Classic's own create (DataEntryDetailsRightPane): require
   * first name AND last name AND a parseable DOB at/after 1900-01-01. The create form's
   * DOB is free text, so an unparseable DOB would otherwise reach createPatientRecordAPI
   * as moment(...).format() === "Invalid date" in the URL and fail; an empty first name
   * would send firstname= blank. Matching Classic's guard prevents a malformed create
   * rather than silently corrupting/500ing.
   *
   * Bug fix (AB#35068/AB#35071 investigation): this is only reached when
   * quickEntryPatientResolution.mode === "create" - i.e. the specialist
   * explicitly used "No Match - Create New" and clicked Save. A guard failure
   * here therefore means the specialist's entered patient is NOT being
   * created/linked, which previously resolved(true) silently - the Confirm-All
   * persist gate (persistQuickEntryBillingFields) saw "no failure" and let
   * Billing/completion proceed as if the patient had been saved, leaving the
   * transaction with no patient link at all (blank Patient Name/DOB on
   * reopen) and no feedback telling the specialist anything was wrong. Now
   * surfaces an error toast and resolves(false) so the gate aborts completion
   * instead of lying about success.
   */
  private createQuickEntryPatient = (): Promise<boolean> => {
    // AB#31605 re-save: the patient was already created + linked on a prior commit
    // this session; re-firing would create a DUPLICATE. Skip (treat as success).
    // onCreatePatient re-arms this for a fresh create-new intent.
    if (this.quickEntryPatientCreateFired) {
      return Promise.resolve(true);
    }
    const values = this.props.formState?.values ?? {};
    const firstName = values[FormConstants.PATIENT_NAME];
    const lastName = values[FormConstants.PATIENT_LAST_NAME];
    const dob = values[FormConstants.DOB];
    // AB#38499: the floor was here; the CEILING was missing, and that asymmetry is the defect.
    // An OCR'd or mistyped DOB above 2079-06-06 (01/01/2091 for 1991 is the reported case) passed
    // this check, reached ROIS_PatientData_ins, and overflowed the smalldatetime column. The 400 that
    // came back was routed to API_ERROR_STATE, which renders the full-page "Service is temporarily
    // unavailable" dialog and aborts the Confirm All commit - a correctable typo presented as an
    // outage. The merged search-side fix made this MORE reachable, not less: "No match found" is now
    // the signposted route to "No Match - Create New".
    const dobOutOfStorableRange = dob instanceof Date && !isNaN(dob.getTime())
      && (dob < STORABLE_DOB_MIN || dob > STORABLE_DOB_MAX);
    const dobValid = dob instanceof Date
      ? !isNaN(dob.getTime()) && !dobOutOfStorableRange
      : Boolean(dob);
    if (!firstName || !lastName || !dobValid) {
      // Say WHICH bound failed. The generic message sent the specialist looking for a missing name
      // when the real problem was a year they can see and fix.
      toast.error(dobOutOfStorableRange
        ? "Couldn't save the new patient - the date of birth must be between 01/01/1900 and 06/06/2079. Please correct it before creating the transaction."
        : "Couldn't save the new patient - first name, last name, and a valid date of birth are required. Please retry before creating the transaction.");
      return Promise.resolve(false);
    }
    // AB#31605 re-save: arm the one-shot guard SYNCHRONOUSLY, before dispatch - not in
    // the async success callback. quickEntrySubmitting is cleared in the commit callback
    // while this create is still in flight (not awaited), so a fast second Confirm All
    // could re-run this persist before the success callback ran and dispatch a SECOND
    // create (duplicate patient). Setting the flag now closes that window; reset it on
    // failure so a genuinely failed create can be retried.
    this.quickEntryPatientCreateFired = true;
    // Resolve true on success / false on failure (the saga now calls onError on
    // non-2xx/throw) so the completion gate can abort rather than complete into an NRE.
    // getTransactionAttributes reload is dispatched by the saga on success.
    return new Promise<boolean>(resolve => {
      this.props.createPatientRecordRequest?.({
        transactionId: this.props.transactionId,
        [FormConstants.PATIENT_NAME]: firstName,
        [FormConstants.PATIENT_MIDDLE_NAME]: values[FormConstants.PATIENT_MIDDLE_NAME] || "",
        [FormConstants.PATIENT_LAST_NAME]: lastName,
        [FormConstants.DOB]: dob,
        [FormConstants.EMPI_NUMBER]: values[FormConstants.EMPI_NUMBER] || "",
        [FormConstants.MRN_ID]: values[FormConstants.MRN_ID] || "",
      }, () => resolve(true), () => { this.quickEntryPatientCreateFired = false; resolve(false); });
    });
  }

  /**
   * Persists the requestor at Confirm All through the SAME send-to endpoints Classic
   * uses - NOT the transactions/{id}/update PATCH, which ignores the requestor/contact
   * ids by design. "create" delegates to createQuickEntryRequestor.
   *
   * "select" (existing match) goes through transactions/sendToRequestor FIRST, then
   * transactions/sendToContact:
   *  - sendToRequestor (ROIS_TansactionRequestorNameID_upd) sets the send-to requestor
   *    AND creates the bill-to: it inserts a tblRequestorBilling row from the requestor
   *    and stamps RequestorBillingID on the transaction. This is the "bill-to same as
   *    send-to" default Classic gets for free - WITHOUT it, Transaction.BillToContact is
   *    null and a billingTypeId==1 transaction can't be billed / NREs on read.
   *    sendToContact (SetSendToContact) does NOT create a bill-to, so it can't stand in.
   *  - sendToContact then pins the SPECIFIC matched contact (sendToRequestor resolves a
   *    default/blank contact); it leaves the bill-to from step 1 intact.
   * clearFeeOk: true - no fee schedule is selected before the Billing step, so nothing
   * can be invalidated; sidesteps Classic's 409 conflict dialog. Routed through the
   * Network boundary (credentialed) per security.md §SSRF; a failure toasts rather than
   * dropping silently.
   */
  private persistQuickEntryRequestorResolution = async (): Promise<boolean> => {
    const resolution = this.state.quickEntryRequestorResolution;
    if (!resolution) {
      return true;
    }
    if (resolution.mode === "create") {
      // Already created (and linked as send-to) when the specialist saved it - creating
      // again here would insert a duplicate requestor.
      if (resolution.requestorId != null) {
        return true;
      }
      return (await this.createQuickEntryRequestor()).ok;
    }

    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const transactionDetails = this.props.transactionDetails;
    if (!transactionDetails) {
      return true;
    }
    const organizationId = transactionDetails.facility.id;
    const requestBufferId = transactionDetails.id;
    const values = this.props.formState?.values ?? {};
    try {
      if (resolution.requestorId != null) {
        // Sets the send-to requestor AND creates the bill-to (= send-to) default.
        await post(`transactions/sendToRequestor?userId=${global.userID}`, {
          organizationId,
          requestBufferId,
          sendToRequestorId: resolution.requestorId,
          clearFeeOk: true,
        });
        if (resolution.contactId != null) {
          // Pin the specific matched contact (sendToRequestor resolved a default one).
          const contactResponse = await post<{ releaseMode?: number | null }>(
            `transactions/sendToContact?userId=${global.userID}`, {
              organizationId,
              requestBufferId,
              contactId: resolution.contactId,
            });
          // AB#38349 round 3, DEFECT 1. THIS is the answer the old design was missing.
          //
          // The stamp used to move only when the OBSERVED release-method id CHANGED, and that
          // channel cannot tell "the server re-derived and got the same answer" (not stale) from
          // "the server has not answered yet" (stale) - both look like no change. On an Internal
          // request (RequestCategoryGroupID 21, TransactionDataAccessEf.cs:132-135) Download is
          // forced regardless of contact, so NO contact swap ever changes the id: the stamp froze on
          // the first contact and the pane rendered RELEASE_METHOD_RECHECK_NOTE - whose text promises
          // a re-check "when you Confirm All" - permanently, having permanently withheld the accurate
          // red message. With disableReleaseMethod true on an Internal request the note's own remedy
          // is impossible and quickEntryReleaseMethodPickedByOperator is unreachable, so there was no
          // operator escape either.
          //
          // No round-trip signal is needed to fix that, because THIS endpoint already answers the
          // question directly. TransactionsController.SetSendToContact (:749-760) returns
          // `{ releaseMode }` from RequestorManager.SetSendToContact, which SaveChanges the new
          // RequestorContactID (RequestorDataAccessEf.cs:110-116) and only THEN runs
          // DetermineReleaseMethod (RequestorManager.cs:69-70) - so the returned value is derived for
          // `resolution.contactId`, the contact this POST just linked, same ordering the create
          // endpoint relies on. The response was being discarded; consuming it records the provenance
          // for the right contact whether or not the id moved.
          //
          // Deliberately NOT gated on the id having changed, and that is the entire fix.
          this.adoptServerReleaseMethod(contactResponse?.data?.releaseMode, resolution.contactId);
        } else if (willLinkContact(values)) {
          // No contact was assigned from the grid, but the specialist typed one into the
          // requestor info - create it against this requestor, the same way the
          // create-new path does. This is what makes the non-amber (green) row honest:
          // the contact the row shows is the contact the transaction gets.
          await post(`requestors/createSendToContact?userId=${global.userID}`, {
            organizationId,
            requestBufferId,
            sendToRequestor: resolution.requestorId,
            firstName: values[RequestorFormConstants.FIRST_NAME] || null,
            lastName: values[RequestorFormConstants.LAST_NAME] || null,
            phone: values[RequestorFormConstants.PHONE_NUMBER] || null,
            email: values[RequestorFormConstants.EMAIL] || null,
            fax: values[RequestorFormConstants.FAX_NUMBER] || null,
          });
        }
      } else if (resolution.contactId != null) {
        // No requestor id but a contact id (unexpected for a real match) - at least set
        // the contact; this alone won't create a bill-to.
        const contactResponse = await post<{ releaseMode?: number | null }>(
          `transactions/sendToContact?userId=${global.userID}`, {
            organizationId,
            requestBufferId,
            contactId: resolution.contactId,
          });
        // AB#38349 round 3, DEFECT 1: same endpoint, same provenance argument as the branch above.
        // Handled here too so the fix does not depend on which branch a resolution happens to take.
        this.adoptServerReleaseMethod(contactResponse?.data?.releaseMode, resolution.contactId);
      } else {
        return true;
      }
      this.props.getTransactionAttributes?.(this.props.transactionId);
      return true;
    } catch {
      toast.error("Couldn't link the requestor - please try again, or set it in Classic Mode.");
      return false;
    }
  }

  /**
   * Create-new requestor at Confirm All (F1c no-match path). Two chained steps, the
   * same ones Classic performs (just across separate interactions there):
   *  1. POST requestor/createSendTo (via the Network boundary, NOT a raw fetch as
   *     Classic's inline createNewRequestor uses - security.md §SSRF: credentialed,
   *     same reasoning as onQuickEntryRequestPurposeChange) with the org+address the
   *     create form captured. The endpoint now RETURNS the new requestor id
   *     (backend change this session) so we can...
   *  2. ...create the send-to CONTACT under it (createSendToContact) when any contact
   *     field was entered - impossible before, since the create endpoint returned no id.
   * clearFeeOk: true - Quick Entry creates the requestor BEFORE the Billing step, so no
   * already-selected fee schedule can be invalidated (same reasoning as the purpose
   * change); this sidesteps Classic's 409 fee-conflict dialog, which has no place here.
   * Values come from the requestor form fields writeRequestorToForm set. Guarded on the
   * org+address the create form itself requires; a network failure toasts rather than
   * silently dropping the requestor.
   */
  /**
   * `explicitValues` (form-shaped) is used by the save-time create, whose
   * writeRequestorToForm dispatches haven't reached formState yet; Confirm All's
   * fallback path reads formState as before. Returns the new requestor id so the
   * caller can mark the resolution as already-created (no duplicate at Confirm All).
   */
  private createQuickEntryRequestor = async (explicitValues?: any): Promise<{ ok: boolean, requestorId?: number }> => {
    // AB#31605 re-save: the requestor was already created + linked on a prior commit
    // this session; re-firing would create a DUPLICATE. Skip (treat as success).
    // onCreateRequestor re-arms this for a fresh create-new intent.
    if (this.quickEntryRequestorCreateFired) {
      return { ok: true };
    }
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const transactionDetails = this.props.transactionDetails;
    if (!transactionDetails) {
      return { ok: true };
    }
    const values = explicitValues ?? this.props.formState?.values ?? {};
    const organizationId = transactionDetails.facility.id;
    const requestBufferId = transactionDetails.id;

    // Mirror Classic's create guard - org name + full address are required.
    //
    // Bug fix (AB#35064/AB#35071 investigation): this is only reached when
    // quickEntryRequestorResolution.mode === "create" - i.e. the specialist
    // explicitly used "No Match - Create New" and clicked Save. Previously a
    // guard failure here resolved(true) ("no failure"), so the Confirm-All
    // persist gate let Billing/completion proceed as if the requestor had
    // been created, leaving the transaction with no send-to requestor at all
    // and no feedback telling the specialist anything was wrong. Now surfaces
    // an error toast and resolves(false) so the gate aborts completion.
    if (
      !values[RequestorFormConstants.REQUESTOR_NAME]
      || !values[RequestorFormConstants.ADDRESS]
      || !values[RequestorFormConstants.CITY]
      || !values[RequestorFormConstants.STATE]
      || !values[RequestorFormConstants.ZIP]
    ) {
      toast.error("Couldn't save the new requestor - organization name and a full address are required. Please retry before creating the transaction.");
      return { ok: false };
    }

    // AB#31605 re-save: arm the one-shot guard before the create posts (symmetric with
    // createQuickEntryPatient) so a concurrent re-save can't dispatch a second create;
    // reset on failure so a genuinely failed create can be retried.
    this.quickEntryRequestorCreateFired = true;
    try {
      const body = generateSendToRequestorObject(values, organizationId, requestBufferId, true);
      // Spec #35289 (AC6): pass the already-resolved request type so the backend
      // derives the requestor-type-code from it directly, rather than reading the
      // transaction's purpose - which is NOT yet persisted at this point in the
      // Confirm-All barrier (the purpose write is chained last, after this create).
      // Additive/optional: omitted (undefined) when no request type is resolved, in
      // which case the backend falls back to its tx-derived path exactly as today.
      //
      // AB#35289 (create-new coverage gap): read the request type from the LIVE redux
      // form (formState), NEVER from `values`. On the save-time create-new path
      // (onCreateRequestor -> modal "Add new Requestor" / AC9 "No Match - Create New"),
      // `values` is an explicit requestor bag of RequestorFormConstants.* (org/address/
      // contact) that OMITS FormConstants.REQUEST_TYPE - so reading it there yielded
      // Number(undefined) => unset => the backend fell back to its tx-purpose path and
      // stamped the default requestor type (5015) instead of Internal (5005) on an
      // Internal transaction. The Confirm-All caller passes no bag, so `values` already
      // WAS formState there - reading formState directly is equivalent for it (no regression).
      const resolvedRequestTypeId = Number((this.props.formState?.values ?? {})[FormConstants.REQUEST_TYPE]);
      if (resolvedRequestTypeId > 0) {
        body.resolvedRequestTypeId = resolvedRequestTypeId;
      }
      const response = await post(`requestor/createSendTo?userId=${global.userID}`, body);
      const requestorId = response?.data?.requestorId;

      const firstName = values[RequestorFormConstants.FIRST_NAME];
      const lastName = values[RequestorFormConstants.LAST_NAME];
      const phone = values[RequestorFormConstants.PHONE_NUMBER];
      const email = values[RequestorFormConstants.EMAIL];
      const fax = values[RequestorFormConstants.FAX_NUMBER];
      if (requestorId != null && willLinkContact(values)) {
        // AWAITED (not a fire-and-forget dispatch) so a contact failure lands in the
        // catch below instead of leaving the requestor created without its contact
        // (which would read back as a null BillToContact).
        const contactResponse = await post(`requestors/createSendToContact?userId=${global.userID}`, {
          organizationId,
          requestBufferId,
          sendToRequestor: requestorId,
          firstName: firstName || null,
          lastName: lastName || null,
          phone: phone || null,
          email: email || null,
          fax: fax || null,
        });
        // AB#38349 (review round 2): the FOURTH operator entry point, and it POSTs the same
        // createSendToContact endpoint whose re-evaluated `ReleaseMode` the other three now adopt.
        // Round 1 left it alone on the reading that this method is barrier-internal; it is not -
        // onCreateRequestor (the requestor row's Create modal submit, RequestorInfoRow onCreateSubmit)
        // calls it directly, outside any barrier, so an operator saving a new requestor whose contact
        // has a fax and no email saw exactly the reported symptom: Billing still on Download, warning
        // "Requestor contact must have an email assigned for download delivery." with both create
        // buttons disabled, about a contact the server had already moved to Digital Fax.
        //
        // Placed after an ALREADY-awaited POST and before the existing getTransactionAttributes, so
        // the barrier's write ordering (the SQL 1205 chaining above) is unchanged; the Confirm-All
        // caller reaches it too and simply gets the same value sooner than its own refresh would.
        //
        // AB#38349 round 3, DEFECT 2: same explicit-provenance argument as onAssignContactCreated -
        // this POSTs the same endpoint, which links the contact before deriving, so the returned
        // value describes the contact the response names and NOT the (still unrefreshed) client-side
        // link the tracker would have inferred from.
        this.adoptServerReleaseMethod(
          contactResponse?.data?.releaseMode,
          contactResponse?.data?.contactId ?? undefined,
        );
      }
      // Refresh so the just-created send-to requestor/contact shows in the pane and
      // is what Classic Mode / Record Attachment read.
      this.props.getTransactionAttributes?.(this.props.transactionId);
      return { ok: true, requestorId };
    } catch (error) {
      // Failed - re-arm so a retry (or a later re-save) can create it.
      this.quickEntryRequestorCreateFired = false;
      // AB#35119 (review MAJOR-2): this path posts the SAME createSendToContact endpoint with an
      // email, so the reported bug reproduced here too - a blacklisted domain 400s with the domain
      // named, and the bare catch replaced it with "please try again", which reads as a transient
      // glitch and leaves the specialist believing it saved. Same extractor as the contact path.
      toast.error(
        serverValidationMessage(error) ??
        "Couldn't save the new requestor - please try again, or set it in Classic Mode.");
      return { ok: false };
    }
  }

  /** Business Rule 13 (Spec #34102 / F1d): lifts the Billing pane's entered fields up so they survive a Back-to-Quick-Entry round trip. */
  /**
   * AB#35075: the advisory second candidate's display label, resolved from the CATALOG by the persisted
   * ids (tblRequestIntakeData 160035/160036) so it survives a plain reopen, falling back to the raw
   * contract names which only exist on a fresh extraction. Undefined when there is no candidate.
   */
  private resolveSecondaryTypeLabel = (): string | undefined => {
    const data = this.props.requestAnalysis?.data;
    if (!data) {
      return undefined;
    }
    const type = this.props.requestTypes?.find(t => t.id === data.secondaryRequestTypeMapped);
    if (type) {
      const purpose = type.requestPurpose.find(p => p.id === data.secondaryRequestPurposeMapped);
      return [type.name, purpose?.name].filter(Boolean).join(" / ") || undefined;
    }
    return [data.secondaryRequestType, data.secondaryRequestPurpose].filter(Boolean).join(" / ") || undefined;
  }

  /**
   * Bug fix (AB#38158): is Acknowledge the control that clears this row? True for an amber row the
   * generic Acknowledge checkbox is actually rendered on - QuickEntryFieldGroupList's own condition
   * (LowConfidence, not in the self-resolving set), read here so the row body and the checkbox
   * cannot disagree about which rows acknowledgement applies to.
   */
  private isQuickEntryRowAcknowledgeable = (row: FieldGroupRow): boolean => {
    return row.status === FieldGroupRowStatus.LowConfidence
      && !this.quickEntrySelfResolvingRowIds().has(row.id);
  }

  /**
   * The acknowledged ids that should COUNT as settled right now, as opposed to the raw set of ids
   * the specialist has ever ticked. Review round 2 (John James, PR !10065) - the raw set was handed
   * straight to both counters while the two display paths already filtered it through
   * isQuickEntryRowAcknowledgeable, so "acknowledged" meant two different things in one component.
   *
   * An id drops out here when either is true:
   *
   *  1. The row is no longer acknowledgeable. A row can stop being acknowledgeable while its id
   *     stays in the set - change Request Type and back without re-picking a purpose and the row
   *     returns to LowConfidence as SELF-RESOLVING with PURPOSE_TYPE = 0. The Acknowledge control
   *     is not rendered on a self-resolving row, so the tick could not be taken back, and the
   *     counters were treating the stale tick as a settled row: the header read "All ready to
   *     submit" beside the row's own "Purpose Type is required.", Confirm All was offered, and
   *     persistQuickEntrySelectionsToTransaction skips the purpose write when purposeId is 0 - so
   *     the transaction submitted with no purpose persisted at all.
   *
   *  2. The row is open for edit. AB#35073's downgrade-to-NeedsEntry guard only fires on a
   *     Confirmed row, so a LowConfidence row reopened with [Edit] was neither downgraded nor
   *     outstanding: Confirm All stayed lit over a value the specialist was part-way through
   *     changing, which is exactly what that guard exists to prevent.
   *
   * Both counters and both display paths read this, so the definition exists once.
   */
  private effectiveAcknowledgedRowIds = (rows?: readonly FieldGroupRow[]): ReadonlySet<string> => {
    const acknowledged = this.state.quickEntryAcknowledgedLowConfidenceIds;
    if (acknowledged.size === 0) {
      return acknowledged;
    }
    const effective = new Set<string>();
    for (const row of rows ?? this.getQuickEntryRows()) {
      if (acknowledged.has(row.id)
        && this.isQuickEntryRowAcknowledgeable(row)
        && !this.state.quickEntryEditingRowIds.has(row.id)) {
        effective.add(row.id);
      }
    }
    return effective;
  }

  /**
   * AB#35098 keeps Request Type/Purpose OUT of the acknowledgeable set because its amber means a
   * REQUIRED purpose is missing - that must be filled, never dismissed (PR !9560).
   *
   * AB#35075 introduces a SECOND, different reason for the same row to be amber: the document
   * supported two plausible types. That one is genuinely dismissible - the purpose IS set and valid,
   * and the alternative is advisory. Critically, it is NOT self-resolving: it clears only when the
   * specialist EDITS away from the AI values, so when the AI's primary is correct (the common case)
   * there is nothing to edit and the row would be an unclearable amber blocking Confirm All.
   *
   * So the row is acknowledgeable ONLY when its amber is the secondary-candidate kind, which is
   * exactly when a purpose is already selected. AB#35098's guarantee is untouched: with no purpose,
   * the row stays self-resolving and cannot be acknowledged away.
   */
  /**
   * AB#37979 (David Heifetz, PR !9995 — Critical). The rule is "is this row's amber still resolvable
   * by picking a purpose", and it is keyed on PURPOSE_TYPE alone.
   *
   * It used to also require `hasSecondary`, which was correct while the ONLY amber this row could
   * carry was AB#35075's secondary-candidate note. This change adds a second amber (an ungrounded
   * type, GroundingState.InferredNoSource) that has nothing to do with a secondary candidate — so on
   * that path the row stayed in the self-resolving set, got NO Acknowledge checkbox
   * (QuickEntryFieldGroupList: the checkbox renders only when the id is absent from this set), stayed
   * outstanding, and Confirm All could never enable. The specialist's only exits were to leave a
   * wrong Type, leave a wrong Purpose, or bail to Classic — re-picking the correct values does not
   * help, because the edit predicates need the ids to DIFFER. The transaction was uncompletable.
   *
   * Keying on `purposeSelected` alone is both the fix and the simpler rule: if a purpose is already
   * selected and the row is STILL amber, then picking a purpose is not what clears it, whatever the
   * cause — so the specialist needs the Acknowledge affordance. And while PURPOSE_TYPE is unset the
   * row stays self-resolving, which is the guarantee the original comment above the set exists for:
   * Acknowledge must not be able to enable Confirm All with no purpose chosen.
   *
   * This strictly widens the previous behaviour — every case that lifted before (which required
   * purposeSelected too) still lifts.
   */
  private quickEntrySelfResolvingRowIds = (): ReadonlySet<string> => {
    const values = this.props.formState?.values ?? {};
    // AB#38739 fallout (AB#38683): read the AI's purpose as well as the live form's.
    //
    // This predicate exists for AB#35098's amber - "a valid Type resolved but no valid Purpose" -
    // which "must be filled, never dismissed". AB#35076 then moved that state to RED (NeedsEntry),
    // and a red row is not acknowledgeable anyway (isQuickEntryRowAcknowledgeable requires
    // LowConfidence), so the live-form-only check has outlived the state it was guarding.
    //
    // It became actively harmful with AB#38739. A row with a usable AI pair is amber now whether or
    // not the form has been seeded yet, and while the form's purpose was still unset this predicate
    // held the row SELF-RESOLVING: no Acknowledge control rendered, Confirm could not settle it, and
    // the row blocked Confirm All with nothing the specialist could do about it. Reading the AI's own
    // mapped purpose closes that window - the row is self-resolving only when there is genuinely no
    // purpose from either source, which is exactly when it is red.
    const purposeSelected = Boolean(values[FormConstants.PURPOSE_TYPE])
      || this.ownedRequestAnalysis()?.data?.requestPurposeMapped != null;
    if (!purposeSelected) {
      return QUICK_ENTRY_SELF_RESOLVING_ROW_IDS;
    }
    const next = new Set(QUICK_ENTRY_SELF_RESOLVING_ROW_IDS);
    next.delete(REQUEST_TYPE_PURPOSE_ROW_ID);
    return next;
  }

  onQuickEntryBillingFieldsChange = (fields: QuickEntryBillingFields) => {
    this.setState(prev => ({
      quickEntryBillingFields: fields,
      // AB#38349 (review round 5): the pane pushes fields up through this callback ONLY from its
      // own edit handlers - its two effects (the late-arriving-defaults merge and the resync
      // adoption) write local state without calling it. So a releaseMethodId that differs from the
      // one this parent last handed down came from the operator's dropdown, and from then on the
      // displayed value describes the contact on the row rather than the transaction's linked one.
      // Sticky: editing any other billing field afterwards must not un-say it. Cleared only by an
      // adopting resync (below) or a transaction switch.
      quickEntryReleaseMethodPickedByOperator: prev.quickEntryReleaseMethodPickedByOperator
        || fields.releaseMethodId !== prev.quickEntryBillingFields.releaseMethodId,
    }));
  }

  /** AC8/Business Rule 13 (Spec #34102 / F1d): returns to Request Info with no re-submission of the bulk commit. */
  onBackToQuickEntryFromBilling = () => {
    this.setState({ quickEntryActiveStepTab: "requestInfo" });
  }

  /**
   * AC9/Business Rule 12 (Spec #34102 / F1d): persists the billing fields
   * via the existing updateBillingPaneFields ("UpdateTransaction") action,
   * THEN calls the existing patchBillingComplete ("BillingComplete") action -
   * order matters, billing fields must land before the completion signal
   * fires (Test 2.12) - no new creation endpoint (Assumption: CreateTransaction
   * already ran at the pre-existing "New Request" click, before Quick Entry
   * ever loaded; see this Spec's Technical Design/Assumptions).
   *
   * Bug fix (Spec #34102 / F1d, direct user report 2026-07-17): this
   * previously fired both dispatches back-to-back and called onPersisted()
   * immediately, without waiting for either to actually succeed - "order
   * matters" was only ever true of the DISPATCH order (which Test 2.12
   * checked), not the underlying API calls' completion order, since the two
   * dispatches trigger independent sagas with no synchronization between
   * them. Unlike Classic Mode's own Billing tab (which autosaves each field
   * on its own onChange, giving updateBillingPaneFields's save minutes of
   * real time to land before the specialist ever reaches the completion
   * click), Quick Entry defers everything to this one moment - so
   * BillingComplete/MoveToRPQ could actually complete on the server before
   * UpdateTransaction's save did, promoting the transaction to the next
   * queue stage without its billing fields actually saved yet. Now
   * genuinely sequenced via updateBillingPaneFields's own onSuccess callback
   * (new, optional, defaults to a no-op for every other pre-existing
   * caller - see that action creator's own comment), and onPersisted() only
   * fires once BOTH calls have actually succeeded; either failing surfaces
   * an error toast instead of silently proceeding.
   */
  persistQuickEntryBillingFields = async (fields: QuickEntryBillingFields, onPersisted: () => void) => {
    if (this.state.quickEntryBillingSubmitting) {
      return;
    }
    this.setState({ quickEntryBillingSubmitting: true });

    // Gate: wait for the Confirm-All transaction persists (request-info fields + patient
    // link, create-new patient, requestor select/create) to COMMIT before firing the
    // billing PATCH + BillingComplete/MoveToRPQ, which READ the transaction - otherwise
    // completion reads a half-written record and the Transaction.Patient / BillToContact
    // getters throw "returned null". The gate resolves to false if any prerequisite
    // persist FAILED; in that case abort completion (don't promote a transaction whose
    // patient/requestor never landed) and surface it, rather than proceeding into a
    // guaranteed BillingComplete NRE.
    if (this.quickEntryPersistPromise) {
      const persistOk = await this.quickEntryPersistPromise;
      if (!persistOk) {
        this.setState({ quickEntryBillingSubmitting: false });
        toast.error("Some request details couldn't be saved - please retry before creating the transaction.");
        return;
      }
    }

    // Bug fix (2026-07-29, second pass): fetch patientDetailsAttributes for the
    // just-linked patient NOW, before patchBillingComplete's MoveToRPQ call below
    // moves this transaction's status out of Quick Entry's eligible range. render()
    // switches from the Quick Entry UI to the classic DataEntryDetailsRightPane
    // (~line 5182) the instant isQuickEntryEligible() goes false, and THAT check
    // depends on transactionStatus alone - not on when this function calls
    // setClassicModeOverride. patchBillingComplete changes the status; several
    // OTHER sagas in this exact billing flow (e.g. updateBillingPaneFieldsSaga)
    // independently re-fetch transactionDetails as a side effect, so as soon as
    // ANY of them picks up the new status, the classic pane mounts immediately -
    // regardless of classicModeOverride. Because that pane's
    // reduxForm(keepDirtyOnReinitialize, destroyOnUnmount:false) NEVER clears its
    // state across mounts, if it EVER mounts even once while patientDetailsAttributes
    // is still the pre-linked empty slice, DOB/Name/EMPI latch dirty=empty
    // permanently - no later fetch, however correctly sequenced, can undo it.
    // Awaiting the fetch here, before anything that can move the status, guarantees
    // patientDetailsAttributes is already correct at that pane's very first
    // possible mount, mirroring the same invariant a normal Classic reopen gets for
    // free from its own `!transactionDetails` loading gate (render() ~5107).
    // Round-3 review (David Heifetz): as a bare `new Promise(resolve => dispatch(...))`
    // this hung Confirm-All FOREVER whenever the saga dropped its callback - onSuccess
    // fires only on the 2xx path inside the saga's try (Ducks:3914), so a non-2xx, a
    // thrown error, or a cancelled generator left this await unsettled with no toast and
    // no timeout. That is precisely the failure settleGuardedWrite was written for
    // (round-2 W-3, see its docblock); this call site simply predated it.
    //
    // The fallback PROCEEDS rather than aborts, unlike the gating writes above: this await
    // is a sequencing guarantee against a UI-state latch, not a data-integrity gate, so a
    // stalled re-fetch must not cost the specialist the transaction. If it times out the
    // worst case is the DOB/Name/EMPI latch described above, which a refresh recovers.
    await this.settleGuardedWrite<boolean>(false, settle => {
      this.props.getTransactionAttributes?.(this.props.transactionId, () => settle(true));
    });

    // AB#35095: Quick Entry now owns the full Classic billing set, so completion
    // must persist through the SAME existing Classic save actions Classic uses -
    // no brand-new endpoint (bug-workflow parity). Each field group has its own
    // action/endpoint; they are fanned in and ALL awaited before patchBillingComplete
    // fires, preserving the read-before-commit race fix (completion reads the
    // transaction, so every billing write must land first).
    const autoCertification = Boolean(this.props.featureFlags?.AutoCertification);
    const selectedFeeSchedule = (this.props.feeSchedules ?? []).find(fs => fs.id === fields.feeScheduleId);
    const additionalChargesEnabled = selectedFeeSchedule?.billingTypeId === 1;

    // AB#39575: never persist a fee schedule id the specialist was never actually offered -
    // same membership test QuickEntryBillingPane's feeScheduleIdOnOffer uses
    // (QuickEntryBillingPane.tsx:487); that pane only disables the control, it doesn't stop a
    // stale `fields` snapshot from reaching this save path. Applies uniformly, including the
    // Internal-locked case AB#39265 deferred a decision on, as a hard block rather than a
    // silent write or a silent drop - Fee Schedule is required, and either produces an
    // un-billable transaction.
    if ((this.props.feeSchedules ?? []).length === 0) {
      this.setState({ quickEntryBillingSubmitting: false });
      toast.error("Fee schedules haven't loaded for this facility yet - please retry in a moment.");
      const facilityId = this.currentTransactionDetails()?.facility?.id;
      if (facilityId) {
        this.props.getFacilityFeeSchedules(facilityId, this.props.transactionId);
      }
      return;
    }
    if (!selectedFeeSchedule) {
      this.setState({ quickEntryBillingSubmitting: false });
      toast.error("This fee schedule isn't available for this facility - please select one from the list.");
      return;
    }

    const billingPayload: Record<string, any> = {
      transactionId: this.props.transactionId,
      feeScheduleId: fields.feeScheduleId,
      releaseMethodId: fields.releaseMethodId,
      // The UpdateTransaction endpoint resolves the caller via userID and 500s
      // ("user not found") if it's absent - updateBillingPaneFieldsAPI serializes
      // payload keys straight into the query string, so it must be sent here just
      // like Classic Mode's own billing update does (DataEntryDetailsRightPane).
      // NOTE: the patient-select link (patientDataid) is NOT here - it now persists in
      // the awaited Confirm-All PATCH (above), so it survives a bail-to-Classic and
      // stays symmetric with the requestor link.
      userID: global.userID,
    };
    // Layout parity: Shipping Service + Charge for Postage ride updateBillingPaneFields
    // under Classic's own keys (`shippingService` = service name; `postageIsApplied` =
    // the Default/Yes/No radio value - autosaveBillingPaneField keyName mapping,
    // RightPane 1294-1302). Sent only when the specialist set them.
    if (fields.shippingService) {
      billingPayload.shippingService = fields.shippingService;
    }
    if (fields.chargeForPostage) {
      billingPayload.postageIsApplied = fields.chargeForPostage;
    }
    // AC3 (review LOW-1 confirmed): with AutoCertification OFF, the "Certification
    // Requested?" flag rides updateBillingPaneFields under Classic's `certRequired`
    // key. Classic maps CERTIFICATION_REQUESTED -> "certRequired" (RightPane 1288-1290)
    // and dispatches it through the SAME updateBillingPaneFields/UpdateTransaction path
    // (autosaveBillingPaneField -> props.updateBillingPaneFields, RightPane 1382-1392)
    // that serializes payload keys into the query string - so the flag persists here.
    if (!autoCertification) {
      billingPayload.certRequired = Boolean(fields.certificationRequested);
    }

    // HIGH-2 (review round 1): bill-to + prepayment persist through Classic's
    // updateBillToRequestorData, whose API PATCHes ONLY when a bill-to contact id is
    // present (updateBillToContactDetailsAPI). For a Quick Entry transaction that id
    // is created server-side when the requestor is linked at Confirm All and then
    // refreshed onto transactionDetails. If it isn't present yet, abort with a clear
    // error instead of letting completion fire while bill-to + prepayment silently
    // no-op (security.md §Error Handling; same read-before-commit race class PR 9520
    // fixed for the billing scalar). The saga also signals onError when it issues no
    // PATCH, as a backstop.
    // Rule #10: bill-to only applies when the selected fee schedule's billingTypeId === 1.
    // When it doesn't apply the section is hidden, so don't require the contact id or
    // dispatch the bill-to save (mirrors Classic gating the whole accordion on billingType 1).
    const billingTypeOne = additionalChargesEnabled;
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const billToContactId = this.props.transactionDetails?.billToContact?.id;
    if (billingTypeOne && !billToContactId) {
      this.setState({ quickEntryBillingSubmitting: false });
      toast.error("This transaction's bill-to contact isn't ready yet - please retry in a moment, or set billing in Classic Mode.");
      return;
    }

    // AB#35095 (validation-parity gap): Classic requires the release-method-specific
    // delivery detail to be resolved before a transaction can move into the
    // records-ready state (localValidations.ts:368-372) - this abort-before-any-save
    // check is the persistence-time backstop for that rule; QuickEntryBillingPane's
    // creationDisabled is the UI-time one. Both must independently enforce it, since
    // either "Create Transaction" or "Create & Continue" reaches patchBillingComplete's
    // MoveToRPQ below, which sets the SAME records-ready status either way.
    //
    // AB#37981 (review round 1, WARNING 2): read the requestor fax/email from the SAME source the
    // UI-time gate does (getQuickEntryBillingSendToAddress -> the live requestor form fields), not
    // from this.props.requestorDetails. Two independent enforcements of one rule must not disagree
    // about the input, and the live form is the Classic-correct source: Classic's own release-method
    // validation reads values[RequestorFormConstants.FAX_NUMBER] / [EMAIL]
    // (validations/localValidations.ts:327-328, applied 368-387), never the requestorDetails slice.
    // Reading the slice here meant a fax the specialist had just typed and re-entered enabled
    // "Create Transaction" and was then refused by this gate with "does not match the assigned
    // requestor contact fax number" - about the fax on screen, matching itself.
    const sendToAddress = this.getQuickEntryBillingSendToAddress();
    const onFileFax = sendToAddress?.fax || "";
    const onFileEmail = sendToAddress?.email || "";
    if (fields.releaseMethodId === 2 && !onFileEmail) {
      this.setState({ quickEntryBillingSubmitting: false });
      toast.error("Requestor contact must have an email assigned for download delivery.");
      return;
    }

    // #7 Digital Fax (release method 3): Classic re-enters the fax to CONFIRM it matches
    // the requestor's on-file contact fax, then validates via putDigitalFaxValidation; on
    // MISMATCH it shows the error and skips the PUT (DataEntryDetailsRightPane 1659-1673).
    // Mirror that comparison here and abort BEFORE any save dispatches so completion never
    // proceeds on a skipped validation (no false success). The PUT is fanned in below.
    // AB#35095: tightened to match Classic's full rule (localValidations.ts:374-387) - the
    // re-entered fax is REQUIRED (>=12 chars) whenever Digital Fax is selected, not just
    // checked for a mismatch when a value happens to be present; and a re-entered fax with
    // no on-file fax to confirm against is likewise invalid, not silently skipped.
    if (fields.releaseMethodId === 3) {
      const enteredFax = fields.digitalFax ?? "";
      // The comparison MUST be the same one the pane's creationDisabled gate uses
      // (digitalFaxMatchesOnFile - both values through normalizePhone), or this abort would
      // reject with a toast exactly the re-entries the enabled button just invited: onFileFax
      // is the RAW stored string here too (requestorInfo.fax), while the pane's input is
      // normalizePhone-masked. Shared, not re-implemented, so the two cannot drift.
      const digitalFaxInvalid = enteredFax.length < 12 || !digitalFaxMatchesOnFile(enteredFax, onFileFax);
      if (digitalFaxInvalid) {
        this.setState({ quickEntryBillingSubmitting: false });
        toast.error(
          enteredFax.length < 12
            ? "Enter valid fax number"
            : "Fax number entered does not match the assigned requestor contact fax number",
        );
        return;
      }
    }

    // AC1/AC4: bill-to + prepayment keyed exactly like generateUpdateBillToRequestorObject
    // (appUtils.ts). These fields are PII/PHI and are never logged (hipaa-compliance.md).
    const billToPayload = {
      requestorbillingcontactid: billToContactId,
      transactionId: this.props.transactionId,
      data: {
        requestorbillinglocation: fields.billToRequestorName,
        firstname: fields.billToFirstName,
        lastname: fields.billToLastName,
        address1: fields.billToAddressLine1,
        address2: fields.billToAddressLine2 || undefined,
        city: fields.billToCity,
        state: fields.billToState,
        zipcode: fields.billToZip,
        country: "United States",
        prepay: fields.requiresPrepayment === true,
        email: fields.billToEmail,
        phone: fields.billToPhone,
        fax: fields.billToFax,
        billingtypeid: 1,
        userID: global.userID,
        requestorNameId: this.props.requestorDetails?.requestorID,
        // Layout parity: Delivery Instructions rides the bill-to PATCH under Classic's
        // `deliveryInstructions` key, encodeURI'd exactly like onBlurBillingPangeFields
        // (RightPane 762-764). Omitted when blank so it isn't sent as an empty string.
        ...(fields.deliveryInstructions
          ? { deliveryInstructions: encodeURI(fields.deliveryInstructions) }
          : {}),
      },
    };

    // HIGH-1 (review round 1) / AC2: additional charges reuse Classic's EXACT contract
    // (AdditionalChargeRows.callPatchAdditionalCharge) - ONE PATCH carrying the full row
    // array, body key `transactionId` (lower-case) + `requestData` array. Row shape and
    // 2-dp amount formatting mirror Classic; id defaults to 0 for a new row.
    const chargeRows = additionalChargesEnabled ? (fields.additionalCharges ?? []) : [];
    const additionalChargesPayload = {
      transactionId: this.props.transactionId,
      requestData: chargeRows.map(charge => ({
        id: charge.id != null ? charge.id : 0,
        glCodeID: charge.glCodeID,
        description: charge.description,
        chargeAmount: parseFloat(String(charge.chargeAmount)).toFixed(2),
      })),
    };

    // AB#39575: client-side membership (above) can't cover the case where Confirm-All's own
    // requestor/purpose writes changed the server's valid fee-schedule set moments ago - the
    // list can be correct when loaded and wrong when saved. Pre-flight against the same
    // validator the billing PATCH itself will run; on failure, abort and refetch instead of
    // firing a PATCH already known to 400.
    const feeScheduleStillValid = await validateFeeScheduleApi(this.props.transactionId, selectedFeeSchedule.id)
      .then(() => true)
      .catch(() => false);
    if (!feeScheduleStillValid) {
      this.setState({ quickEntryBillingSubmitting: false });
      toast.error("This fee schedule is no longer valid for this request - please reselect.");
      const facilityId = this.currentTransactionDetails()?.facility?.id;
      if (facilityId) {
        this.props.getFacilityFeeSchedules(facilityId, this.props.transactionId);
      }
      return;
    }

    // Each save is a DISTINCT action type (no takeLatest collision with each other) and
    // is dispatched once; each resolves to a success boolean and never rejects, so a
    // single failure aborts completion instead of promoting a half-saved transaction.
    const saves: Promise<boolean>[] = [];
    saves.push(new Promise<boolean>(resolve =>
      this.props.updateBillingPaneFields?.(billingPayload, true, () => resolve(true), () => resolve(false))));
    // Rule #10: the FULL bill-to PATCH (address set + prepayment + delivery instructions)
    // only persists for billingTypeId === 1, matching where the bill-to block is shown.
    if (billingTypeOne) {
      saves.push(new Promise<boolean>(resolve =>
        this.props.updateBillToRequestorData?.(billToPayload, () => resolve(true), () => resolve(false))));
    } else if (fields.deliveryInstructions && billToContactId) {
      // MEDIUM-1 (review round 3): Delivery Instructions renders for ALL fee-schedule types
      // (Classic shows it regardless of billingType), so it must still persist when the
      // bill-to block is hidden - otherwise #10's gating silently drops it on a billingType!=1
      // schedule. Send a delivery-instructions-ONLY PATCH: the bill-to address fields are
      // omitted (the API drops undefined keys) so a hidden bill-to is never overwritten.
      // Requires an existing bill-to contact; skipped if none (Classic's endpoint no-ops too).
      const deliveryInstructionsOnlyPayload = {
        requestorbillingcontactid: billToContactId,
        transactionId: this.props.transactionId,
        data: {
          deliveryInstructions: encodeURI(fields.deliveryInstructions),
          userID: global.userID,
          requestorNameId: this.props.requestorDetails?.requestorID,
        },
      };
      saves.push(new Promise<boolean>(resolve =>
        this.props.updateBillToRequestorData?.(deliveryInstructionsOnlyPayload, () => resolve(true), () => resolve(false))));
    }
    // AC3: certification template only when AutoCertification is ON and a template
    // was chosen (Remove Certification leaves it undefined; a brand-new transaction
    // has none to clear, so we skip rather than send a spurious removal).
    if (autoCertification && fields.certificationTemplateId !== undefined && fields.certificationTemplateId !== null) {
      // certificationTemplateId is already the GUID STRING selected in the dropdown -
      // pass it straight through (a prior String() coercion turned a NaN-typed number
      // into the literal "NaN"; the field is a string now, AB#35095).
      saves.push(new Promise<boolean>(resolve =>
        this.props.setCertificationTemplate?.(this.props.transactionId, fields.certificationTemplateId!, () => resolve(true), () => resolve(false))));
    }
    // AC2: one dispatch carrying the full row array (see additionalChargesPayload).
    if (chargeRows.length > 0) {
      saves.push(new Promise<boolean>(resolve =>
        this.props.updateAdditionalCharges?.(additionalChargesPayload, () => resolve(true), () => resolve(false))));
    }
    // #7: digital-fax validation (release method 3 - required + confirmed matching by
    // the abort-gate above, so reaching this line guarantees it's valid). Classic PUTs
    // putDigitalFaxValidation (auditTrail/{id}/digitalfax?faxNumber=...).
    //
    // Send the ON-FILE fax, which is what Classic sends: its onBlurDigitalFaxField reads
    // `const faxNumber = values[RequestorFormConstants.FAX_NUMBER]` - the stored contact fax -
    // and passes THAT to putDigitalFaxValidation, not the `value` the specialist re-typed
    // (DataEntryDetailsRightPane.tsx:1884-1895). Until the gate compared both sides through
    // normalizePhone the two were byte-identical, so the distinction was invisible; now that a
    // contact whose fax is stored `703.555.1313` can be confirmed by typing `703-555-1313`, they
    // differ, and sending the re-entry would write a fax into the audit trail that is not the one
    // on the transaction. The audit record is evidence of which number the specialist confirmed
    // PHI would be faxed to, so it has to be the stored value that will actually be dialled.
    if (fields.releaseMethodId === 3) {
      saves.push(new Promise<boolean>(resolve =>
        this.props.putDigitalFaxValidation?.(this.props.transactionId, onFileFax, () => resolve(true), () => resolve(false))));
    }

    const results = await Promise.all(saves);

    if (results.some(ok => !ok)) {
      this.setState({ quickEntryBillingSubmitting: false });
      toast.error("Could not save billing fields - please try again.");
      return;
    }

    // AB#35145 (reopened): read the additional charges BACK, under the same condition as the
    // write above so it only fires when a PATCH actually happened. `additionalChargeRecords` has
    // exactly one other writer - getAdditionalChargeRecords inside initialAPICalls - which runs on
    // mount and on a transaction-id change only. "Create & continue to Record Attachment" hands
    // off to Classic INSIDE THE SAME MOUNT (setClassicModeOverride + onChangeDataEntryTab(4)), so
    // without this the Classic Billing > Additional Charges grid initialises from the slice fetched
    // before any charge existed and shows nothing. A plain dispatch is sufficient - nothing here
    // awaits the slice: DataEntryDetailsRightPaneBillingSection's existing effect
    // (changeFieldValue(ADDITIONAL_CHARGES, ...) when the slice is non-empty) populates the grid
    // whenever it lands. Placed after the fan-in so it re-reads the POST-write set, and after the
    // failure abort so a failed PATCH never overwrites the operator's rows with the stale server set.
    if (chargeRows.length > 0) {
      this.props.getAdditionalChargeRecords(this.props.transactionId);
    }

    // Every billing write has landed - only now is it safe to fire the completion
    // signal (AuditTask 22 + MoveToRPQ, which moves the transaction into the next
    // queue stage).
    this.props.patchBillingComplete?.(
      this.props.transactionId,
      () => {
        this.setState({ quickEntryBillingSubmitting: false });
        onPersisted();
      },
      () => {
        this.setState({ quickEntryBillingSubmitting: false });
        toast.error("Could not finalize this transaction's billing - please try again.");
      },
    );
  }

  /**
   * Spec #35135 (AC9/AC9a): the Disclosure Accounting completion path - the
   * Billing-free counterpart of persistQuickEntryBillingFields +
   * onQuickEntryCreateTransaction.
   *
   * Why completeTransaction and not patchBillingComplete: completeTransaction
   * (COMPLETE_TRANSACTION_REQUEST_SAGA -> completeTransactionAPI) is the SHARED
   * finalize CompleteTransactionPopUp dispatches unconditionally for every
   * request type, before any type branching. patchBillingComplete is unreachable
   * for type 66 in Classic - it only fires from the Billing tab, and tabs 3/4 are
   * hard-disabled for this type - so calling it here would invent a code path
   * Classic never runs.
   *
   * Why the auto-advance instead of Classic's history.push("/home"): a deliberate,
   * documented UX divergence (Spec #35135). Classic's popup drops the specialist on
   * the home page for type 66; Quick Entry's whole value proposition is
   * uninterrupted queue throughput, so it reuses the SAME transaction-created card
   * + scheduleQuickEntryAutoAdvance -> onNextQueueItem -> getNextTransactionId
   * chain every other Quick Entry request type already ends with. The server-side
   * outcome is identical either way - only the post-completion navigation differs.
   *
   * Reuses quickEntryBillingSubmitting as the in-flight guard (the same flag the
   * billing completion path uses) so a double-click can't fire two finalizes.
   */
  completeQuickEntryDisclosureAccounting = async () => {
    if (this.state.quickEntryBillingSubmitting) {
      return;
    }
    this.setState({ quickEntryBillingSubmitting: true });

    // AC4b: the finalize READS the transaction, so every Confirm-All write -
    // including the disclosure write - must have committed first. The gate
    // resolves false if any prerequisite failed; in that case abort completion
    // rather than finalize a half-written transaction (the entered values stay in
    // local state so the specialist can retry without re-typing).
    if (this.quickEntryPersistPromise) {
      const persistOk = await this.quickEntryPersistPromise;
      if (!persistOk) {
        this.setState({ quickEntryBillingSubmitting: false });
        toast.error("Some request details couldn't be saved - please retry before creating the transaction.");
        return;
      }
    }

    // AB#31605 (round-1 review CRITICAL-4): wait for the DetailsComplete audit write
    // too, not just the persist gate. For Disclosure Accounting the finalize below is
    // MoveToRPQ - INSERT into tblRPQ plus DELETE of the tblRequestBuffer row - while
    // DetailsComplete INSERTs audit rows against that same transaction. Awaiting only
    // the persist promise left both resolving in the same microtask drain, so the two
    // requests raced and took locks in opposite order: the reproduced deadlock shape.
    //
    // This does NOT gate on the audit write's outcome (the promise resolves either
    // way) - it only serializes. A failed audit event must not stop a transaction from
    // completing.
    if (this.quickEntryDetailsCompletePromise) {
      await this.quickEntryDetailsCompletePromise;
    }

    // Round-2 review W-3: settle-guarded, and this is the write where an unsettled promise
    // is WORST. COMPLETE_TRANSACTION_REQUEST_SAGA is takeLatest, and
    // quickEntryBillingSubmitting is cleared ONLY in the two callbacks below - so a
    // cancelled generator leaves it true forever and the in-flight guard at the top of this
    // method then blocks EVERY retry for the rest of the session, with no toast and no
    // visible state. Falls back to FALSE so the flag is always cleared and the specialist
    // can try again.
    const finalizeOk = await this.settleGuardedWrite<boolean>(false, settle => {
      this.props.completeTransaction?.(
        this.props.transactionId,
        () => settle(true),
        () => settle(false),
      );
    });

    if (finalizeOk) {
      this.setState({
        quickEntryBillingSubmitting: false,
        quickEntryTransactionCreated: true,
        quickEntryShowTransactionCreatedCard: true,
      });
      this.scheduleQuickEntryAutoAdvance();
      return;
    }

    // Reached on a real failure AND on a timed-out/cancelled saga. Both leave the
    // transaction un-finalized from the client's point of view, and both must clear the
    // in-flight flag - that is the whole point of the guard.
    this.setState({ quickEntryBillingSubmitting: false });
    toast.error("Could not complete this transaction - please try again.");
  }

  /**
   * AC8/AC9 (Spec #34102 / F1d): "Create Transaction" (primary) - the "I'm
   * done with this one" path. Shows the Billing pane's "Transaction created"
   * success card (Request ID + auto-advance message, mirroring
   * master-demo-v6.html's .txn-created state) and schedules the real
   * auto-advance-to-next-queue-item navigation - not just a toast.
   */
  onQuickEntryCreateTransaction = (fields: QuickEntryBillingFields) => {
    this.setState({ quickEntryBillingFields: fields });
    this.persistQuickEntryBillingFields(fields, () => {
      this.setState({ quickEntryTransactionCreated: true, quickEntryShowTransactionCreatedCard: true });
      this.scheduleQuickEntryAutoAdvance();
    });
  }

  /**
   * AC8/AC9 (Spec #34102 / F1d): "Create & Continue to Record Attachment"
   * (secondary) - the specialist is staying on THIS transaction, so unlike
   * "Create Transaction" above this does NOT show the auto-advance success
   * card (that copy would be actively wrong here).
   *
   * Bug fix (Spec #34102 / F1d, direct user report 2026-07-17): this
   * previously just switched to Quick Entry's OWN Records tab
   * (QuickEntryRecordsPane) - a deliberately read-only summary, since
   * "Record attachment itself" is Out of Scope for this Spec. That left the
   * specialist with nowhere to actually do the work despite the button's
   * own name promising otherwise.
   *
   * Verified end to end (ROIS_RPQ_ins / ROIS_HomeScreenTXCount_Sel source,
   * pulled live 2026-07-17): BillingComplete's MoveToRPQ call sets
   * StatusIndicatorID=100 ("Ready to Scan/Attach Records") whenever no
   * tblReqItemInTC row exists yet for this RequestBufferID - true for every
   * transaction reaching this point, since record attachment is always the
   * NEXT stage, never done yet. ROIS_HomeScreenTXCount_Sel counts exactly
   * that combination (status 100, no tblReqItemInTC match) under its
   * RecordAttachment bucket. So this transaction is now guaranteed to be
   * sitting in the real Record Attachment queue - the correct next step is
   * the SAME one-way hand-off to Classic Mode "Leave Quick Entry" already
   * uses (AC11/AC12, setClassicModeOverride), landing directly on Classic
   * Mode's own functional Records tab (activeTabId 4) via the SAME
   * onChangeDataEntryTab call componentDidMount already uses when a
   * transaction is opened straight from the Record Attachment/Record
   * Validation queue (requestContext 3/4) - so a specialist who continues
   * here sees exactly the tab they'd land on if they left and reopened this
   * same transaction from that queue, without the extra round trip. Unlike
   * onConfirmLeaveQuickEntry, this does NOT call
   * revertQuickEntryRecordsAndSensitiveInfo - that path is for bailing out
   * mid-Quick-Entry and discarding the draft; this is the opposite, a
   * successful completion, so there is nothing to revert.
   */
  onQuickEntryCreateAndContinueToRecordAttachment = (fields: QuickEntryBillingFields) => {
    this.setState({ quickEntryBillingFields: fields });
    this.persistQuickEntryBillingFields(fields, () => {
      this.setState({ quickEntryTransactionCreated: true });
      // Bug fix (2026-07-29, DOB validation blocking Requestor tab after this
      // hand-off): patientDetailsAttributes is now fetched inside
      // persistQuickEntryBillingFields itself, BEFORE patchBillingComplete's
      // MoveToRPQ call moves this transaction's status out of Quick Entry's
      // eligible range (see that function's comment for the full mechanism -
      // in short, render()'s Quick-Entry-vs-Classic switch depends on
      // transaction status alone, so it can flip to the classic pane before
      // this callback even runs, and that pane's redux-form state never
      // clears across mounts - so the fetch has to land before ANYTHING can
      // move the status, not just before this hand-off's own mode-switch
      // call). By this point patientDetailsAttributes is already correct
      // regardless of when/whether the classic pane has already mounted.
      this.props.setClassicModeOverride?.(true);
      this.props.onChangeDataEntryTab(4, true);
      // Bug fix (AB#35140): onChangeDataEntryTab moves the CONTENT to Records but never the
      // breadcrumb highlight, so the specialist landed on Records with "Details" still bold.
      // The highlight lives in this component's own state.active, and the two ways it normally
      // syncs both miss here: handleClick (a real tab click) calls handleSelectedTab itself,
      // and componentDidUpdate's handleNavigation only fires when proceedBtnClick is true -
      // which the onChangeTab reducer sets INVERTED (`action.tabClick ? false : true`), so
      // passing tabClick=true above specifically suppresses it. Set it directly, exactly as
      // componentDidMount does for a transaction opened from the Record Attachment/Validation
      // queue (requestContext 3/4), so this hand-off lands identically to that one.
      this.handleSelectedTab(4 - 1);
      toast.success(`Transaction created - Request ID ${this.props.transactionId}`);
    });
  }

  /** AC9: starts (or restarts) the auto-advance countdown after "Create Transaction" succeeds. */
  scheduleQuickEntryAutoAdvance = () => {
    if (this.quickEntryAutoAdvanceTimer) {
      clearTimeout(this.quickEntryAutoAdvanceTimer);
    }
    this.quickEntryAutoAdvanceTimer = setTimeout(() => {
      this.quickEntryAutoAdvanceTimer = null;
      this.onNextQueueItem();
    }, QUICK_ENTRY_AUTO_ADVANCE_DELAY_MS);
  }

  /**
   * AC9: the real "next Data Entry queue item" navigation - fired either by
   * the auto-advance timer above or by the success card's manual "Next Queue
   * Item" button. Mirrors QuickEntryActionFooter.tsx's onNextRequest exactly
   * (same getNextTransactionId/resetDataEntryState/clearTransactionId/
   * resetForm sequence) since both are "leave this transaction, load the
   * next one in queue" - there is deliberately only one real implementation
   * of that sequence to copy from, not two independently-invented ones.
   */
  onNextQueueItem = () => {
    if (this.quickEntryAutoAdvanceTimer) {
      clearTimeout(this.quickEntryAutoAdvanceTimer);
      this.quickEntryAutoAdvanceTimer = null;
    }
    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const facilityId = this.props.transactionDetails?.facility?.id;
    if (facilityId) {
      this.props.getNextTransactionId?.(facilityId, this.props.requestContext ?? 1);
    }
    this.props.resetDataEntryState();
    this.props.clearTransactionId?.();
    this.props.resetForm();
  }

  /**
   * AB#35095 (AC4) / AB#37981 fix: the send-to address the billing pane's "Same as send to"
   * affordance copies FROM.
   *
   * AB#37981: this used to read state.dataEntryState.requestorDetails. That slice IS populated
   * once the requestor is linked - every QE link path re-dispatches getTransactionAttributes,
   * whose saga loads it, and Billing is unreachable until Confirm All has set
   * sendToRequestor.id - but it is not CURRENT: Quick Entry's own select/edit handlers
   * (writeRequestorToForm) write the LIVE redux-form requestor fields only, so between an inline
   * pick or edit and the next link+refetch the slice still holds the pre-edit values, and before
   * any link at all it is undefined. So "Same as send to" copied stale values or nothing.
   * Reading the live form values fixes both, and mirrors Classic's onCheck copy
   * (DataEntryDetailsRightPane ~768-809), which has no second state tree to fall out of sync
   * with. Same framing as the sibling docblock on
   * quickEntryBillingDefaults.getQuickEntryBillingSendToAddressFromFormValues - a staleness fix,
   * which is also why the all-blank guard there returns undefined rather than an empty copy
   * (review round 6, thread 53045 findings 1 and 3).
   * PII/PHI - passed as props only, never logged.
   */
  getQuickEntryBillingSendToAddress = () =>
    getQuickEntryBillingSendToAddressFromFormValues(this.props.formState?.values);

  /**
   * AB#35289 (AC5): is the LIVE-selected request type Internal? Quick Entry defers
   * type/purpose persistence to Confirm All, so the persisted
   * transactionRequest.isInternalRequest flag lags an operator who has just edited
   * the type to Internal. The requestor search must honor that in-flight edit, so
   * we read the live redux form value (FormConstants.REQUEST_TYPE) - not the
   * persisted flag. Returns false when no type is selected yet.
   */
  isLiveRequestTypeInternal = (): boolean => {
    const values = this.props.formState?.values ?? {};
    return Number(values[FormConstants.REQUEST_TYPE]) === INTERNAL;
  }

  /** AC10 (Spec #34102 / F1d): read-only Records tab summary, sourced from values already captured on the Quick Entry row list - no new data fetch. */
  getQuickEntryRecordsSummary = (): QuickEntryRecordsPaneSummary => {
    const releaseInfo = this.getQuickEntryReleaseInfo();
    const { from, to } = this.getQuickEntryServiceDateRange();
    return {
      // The description belongs on this surface too - it is the other place the specialist
      // reads back what they typed (Mike Hamilton, PR !10721). Same helper as the row's own
      // display parts, so the two surfaces cannot attach the description to different types.
      recordsRequested: recordsRequestedDisplayNames(releaseInfo, this.getQuickEntryReleaseComments()),
      // Same range, same rule, same day as that pane's From/To rows - which is the whole point:
      // these two surfaces render one value and must not disagree. Both now branch on
      // isUtcMidnightDate instead of reading UTC unconditionally (AB#38463): an AI-extracted
      // date-only value is UTC midnight and denotes its UTC day, while a specialist-picked one
      // denotes its LOCAL day and rendered as the WRONG day whenever its local time-of-day pushed
      // the instant past a UTC midnight (reported: picking 3/31 showed 4/1 on a US Eastern host).
      // See formatServiceDate's docblock in RecordsRequestedField.tsx for the full invariant -
      // these are the two functions that carve-out named, fixed together.
      serviceDateFrom: from ? formatQuickEntryServiceDateShort(from) : undefined,
      serviceDateTo: to ? formatQuickEntryServiceDateShort(to) : undefined,
    };
  }

  render() {
    const { selectedHealthOrganizationDetails, selectedFacilityDetails, transactionId } = this.props
    const homeText = getRoutePathName(selectedHealthOrganizationDetails, selectedFacilityDetails)
    const storedWidth = localStorage.getItem('centerPanelWidth') || '50%';

    // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
    // eslint-disable-next-line no-restricted-syntax
    const docAIProcessID = this.props.transactionDetails?.docAIProcessID;
    // Bug fix (independent audit finding): reads getQuickEntrySensitiveInfo()
    // (the optimistic local draft, falling back to transactionDetails) rather
    // than transactionDetails.sensitiveInfo directly - now that Sensitive Info
    // defers its actual persist to Confirm All, the raw transactionDetails
    // value no longer updates live as the specialist checks boxes in Quick
    // Entry, which would otherwise leave the document viewer's entity
    // authorization/redaction driven by this value frozen at the pre-session
    // state for the whole Quick Entry session.
    const quickEntrySensitiveInfoForAuth = this.getQuickEntrySensitiveInfo();
    // AB#37856 (round-1 review W1, developer decision 2026-08-11): gated on the specialist
    // having actually RESOLVED the questionnaire. An authorized entity type is excluded from
    // markedEntities (PdfViewer - not annotated for redaction), dropped from the entity-type
    // picker, hidden from the entity list and subtracted from the sensitive-entity count badge.
    // The AI seed authorizes categories with no specialist involvement, so ungated it would
    // shrink the "sensitive entities needing attention" signal the operator works from purely on
    // model recall, while the row itself still reads NeedsEntry. Those categories keep being
    // treated as needing redaction until the specialist decides.
    //
    // Behavior-preserving for every pre-existing path: the only way to be Authorized while the
    // row is unresolved is the seed, because any real checkbox click resolves every remaining
    // category in the same pass (buildUpdatedSensitiveInfo). The one exception is a transaction
    // whose PERSISTED answers are a partial mix - ROIS already reports that row as NeedsEntry,
    // so treating an incomplete disclosure answer as not-yet-authorized is the same call.
    //
    // `==` preserved from the original comparisons purely because tightening it is not work this
    // fix requires (change-discipline.md), NOT because string stateIDs are established. An earlier
    // version of this comment asserted they "can arrive off the API as strings"; round-3 review W4
    // found the evidence contradicts that - the ten other stateID comparisons in this area are
    // strict, several of them pre-dating AB#37856 on load-bearing paths that work in production
    // (buildUpdatedSensitiveInfo's NotMentioned collapse, the audit message, the DISCLOSE_ALL_INFO
    // writes), so strings would already be breaking those. Treat the `==` as legacy; converting it
    // is a recorded follow-up covering every comparison at once, not a local cleanup. The
    // precondition is a numeric stateID, and isSensitiveInfoResolved normalizes with Number()
    // defensively so this gate cannot fail open either way (security review L1).
    //
    // Security review L2, recorded deliberately rather than fixed: ReadOnlyTransaction.tsx:144-150
    // builds the identical five-key map UNGATED, straight off readOnlyTransactionDetails.
    // sensitiveInfo. So for a transaction whose persisted answers are a partial mix, this Data
    // Entry viewer treats every category as unauthorized while the read-only viewer still treats
    // the Authorized ones as authorized, and the two screens disagree about which entity types are
    // annotated, listed and counted. That is a consistency/operator-trust gap, NOT a disclosure
    // one: this path moved strictly toward MORE redaction, the read-only path is untouched, and it
    // reads only persisted values so the AI seed provably cannot reach it. The read-only viewer
    // keeps the old semantics on purpose here - unifying them is a follow-up, not this fix's diff.

    // AB#37856 (developer decision 2026-08-12): "resolved" is no longer sufficient on its own. The
    // seed now pre-fills every category, so isSensitiveInfoResolved goes true the moment the
    // extraction lands - and gating on that alone would un-redact HIV / mental-health content off
    // model output before a human ever saw the row, which is the exact disclosure the W1 gate
    // exists to prevent. The row being OPEN FOR REVIEW (AB#35073's editing set, which the seed
    // joins it to) is what distinguishes AI-proposed answers from specialist-accepted ones, so the
    // gate additionally requires the specialist to have Confirmed the row.
    const sensitiveInfoAwaitingReview = this.state.quickEntryEditingRowIds.has(SENSITIVE_INFO_ROW_ID);
    const sensitiveInfoAnswered = isSensitiveInfoResolved(quickEntrySensitiveInfoForAuth) && !sensitiveInfoAwaitingReview;
    const isSensitiveCategoryAuthorized = (categoryId: SensitiveInfoType) => sensitiveInfoAnswered
      && quickEntrySensitiveInfoForAuth.some(inf => inf.id == categoryId && inf.stateID == SensitiveInfoRelease.Authorized);
    const authorizedEntities: {readonly [key in EntityTypeId]?: boolean} = {
      [DRUG]: isSensitiveCategoryAuthorized(SensitiveInfoType.SubstanceAbuse),
      [STD]: isSensitiveCategoryAuthorized(SensitiveInfoType.Std),
      [PSYC_MHLT]: isSensitiveCategoryAuthorized(SensitiveInfoType.MentalHealth),
      [HIV]: isSensitiveCategoryAuthorized(SensitiveInfoType.HivAids),
      [HPV]: isSensitiveCategoryAuthorized(SensitiveInfoType.Std),
    };

    homeText.push("Data Entry")
    return (
      <div>
        {/* AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites). */}
        {/* eslint-disable-next-line no-restricted-syntax */}
        {this.state.showLoadingSpinner || !this.props.transactionDetails ? <LoadingSpinner /> :
          <Container fluid className="app-container-custom-style" style={{"maxHeight": "100vh", "overflow": "hidden"}}>
            <div className="landing-page-header pb-0">
              <Header name="Data Entry" homeText={homeText} getNextQATransaction={getNextQATransaction} />
            </div>
            <Row className='mr-0 data-entry-wrapper'>
              <div
                id="leftPanel"
                className="pr-0 h-100 d-flex flex-column"
                style={{
                  "position": "relative",
                  "overflow": "hidden",
                  "minWidth": "15%",
                  "maxWidth": "50%",
                  "width": localStorage.getItem("leftWidth") ?? "25%",
                  "resize": "horizontal"
                }}
                onMouseUp={(_event) => this.savePanelSizes()}
              >
                <DataEntryDetailsLeftPane
                  hideFooter={this.isQuickEntryEligible()}
                  transactionNotes={this.props.transactionNotes}
                  // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
                  // eslint-disable-next-line no-restricted-syntax
                  transactionDetails={this.props.transactionDetails}
                  requestorDetails={this.props.requestorDetails}
                  transactionId={transactionId}
                  patientDetails={this.props.patientDetails}
                  userTasks={this.props.userTasks}
                  userTaskComments={this.props.userTaskComments}
                  resetForm={this.props.resetForm}
                  setEscalation={this.setIsEscalated}
                  assessmentResult={this.props.assessmentResult}
                  authorizedEntities={authorizedEntities}
                  qaErrors={this.props.qaErrors}
                  qaIssues={this.props.QAIssues}
                  getQAPDIssues={this.props.getQAPDIssues}
                  setPageNumber={this.props.setPageNumber}
                  setCurrentFileType={this.props.setCurrentFileType}
                  currentFileType = {this.props.currentFileType}
                  pageNumber = {this.props.pageNumber}
                  currentFile = {this.props.currentFile}
                  auditTrail = {this.props.auditTrail}
                  documentsList={this.props.documentsList}
                />
              </div>
              <div className='pr-0 d-flex flex-column h-100 flex-grow-1 flex-shrink-1' style={{"flexBasis": "auto", "position": "relative"}}>
                <Row className='mx-0 w-100'>
                  <Col lg={12} className='pr-0 pl-lg-0'>
                    {this.isQuickEntryEligible() ? (
                      this.renderQuickEntryStepTabs()
                    ) : (
                      <div className="breadcrumb-wrapper">
                        {this.renderTabItems()}
                      </div>
                    )}
                  </Col>
                </Row>
                <Row className={`request-content-wrapper mr-0${this.isQuickEntryEligible() ? " qe-active" : ""}`} style={{ zIndex: 2 }}>
                  <div
                    id="centerPanel"
                    className='request-pdf-wrapper'
                    style={{
                      position: "relative",
                      minWidth: "740px",
                      maxWidth: "85%",
                      width: localStorage.getItem("centerWidth") ?? "50%",
                      resize: "horizontal",
                    }}
                    onMouseUp={(_event) => this.savePanelSizes()}
                  >
                    <DataEntryDetailsBody
                      documentsList={this.props.documentsList}
                      uploadMultipleDocuments={this.props.uploadMultipleDocuments}
                      transactionId={transactionId}
                      // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
                      // eslint-disable-next-line no-restricted-syntax
                      transactionDetails={this.props.transactionDetails}
                      activeTabId={this.props.activeTabId}
                      getDocumentById={this.props.getDocumentById}
                      getTransactionDocuments={this.props.getTransactionDocuments}
                      updateDocument={this.props.updateDocument}
                      documentSources={this.props.documentSources}
                      deleteDocument={this.props.deleteDocument}
                      deleteAuxDocument={this.props.deleteAuxDocument}
                      deleteDocumentSuccess={this.props.deleteDocumentSuccess}
                      hasUserMadeAnyChanges={this.state.hasUserMadeAnyChanges}
                      userHasMadeChanged={this.userHasMadeChanged}
                      docAIProcessID={docAIProcessID}
                      getTransactionDocumentsAPIStatus={this.props.getTransactionDocumentsAPIStatus}
                      setPageNumber={this.props.setPageNumber}
                      setCurrentFileType={this.props.setCurrentFileType}
                      currentFileType = {this.props.currentFileType}
                      pageNumber = {this.props.pageNumber}
                      currentFile = {this.props.currentFile}
                      assessmentResult={this.props.assessmentResult}
                      authorizedEntities={authorizedEntities}
                      showClassicModeButton={this.isQuickEntryEligible()}
                      onClickLeaveQuickEntry={this.onClickLeaveQuickEntry}
                      liveRequestTypeId={this.props.formState?.values?.[FormConstants.REQUEST_TYPE]}
                    />
                  </div>
                  <div className={`pr-0 data-entry-form-wrapper flex-grow-1 flex-shrink-1${this.isQuickEntryEligible() ? " qe-active" : ""}`} style={{"flexBasis": "auto", "position": "relative"}}>
                    {this.isQuickEntryEligible() ?
                      this.renderQuickEntryActiveStepPane()
                      :
                      <DataEntryDetailsRightPane
                        onChangeDataEntryTab={this.props.onChangeDataEntryTab}
                        activeTabId={this.props.activeTabId}
                        proceedBtnClick={this.props.proceedBtnClick}
                        retrieveProtocol={this.props.retrieveProtocol}
                        // AB#39495: pre-existing raw read - suppressed, not converted (no behaviour change outside the four fixed sites).
                        // eslint-disable-next-line no-restricted-syntax
                        transactionDetails={this.props.transactionDetails}
                        additionalChargeRecords={this.props.additionalChargeRecords}
                        getFacilityFeeSchedules={this.props.getFacilityFeeSchedules}
                        getFacilityReleaseMethods={this.props.getFacilityReleaseMethods}
                        getFacilityShippingServices={this.props.getFacilityShippingServices}
                        userHasMadeChanged={this.userHasMadeChanged}
                        getQAPDIssues={this.props.getQAPDIssues}
                        qaPDIssues={this.props.qaPDIssues}
                      />
                    }






                  </div>
                </Row>
              </div>
              <LeaveQuickEntryModal
                show={this.state.quickEntryShowLeaveModal}
                onCancel={this.onCancelLeaveQuickEntry}
                onConfirm={this.onConfirmLeaveQuickEntry}
              />
            </Row>
          </Container>
        }
        {this.props.isRequestorVerificationEmailSent? this.requestorToast() : null}

        <Toaster toastOptions={{
                  className: 'toast-notification',
                }}
         position="top-right" />
      </div>
    );
  }
}

function mapStateToProps(state: RootState) {
  //These two lines assume that the landingPageState.getHealthOrganizationsSearch will contain the entire health org list that the user will have access to.
  //If we move to a back end paging/searching system (paging and searching controlled by the db stored procedure) this will have to change
  //and it will require either the transaction search receiving the Health Org Id, or a way to search health orgs/facilities using only the facility id

  // const healthOrgDetails = state.landingPageState.selectedHealthOrganizationDetails ??
  //   state.landingPageState.getHealthOrganizationsSearch?.filter(h => h.healthSystem.facilities
  //     .some(f => f.facility.id == state.landingPageState.selectedFacilityDetails?.facility.id))[0]

  // const facilityDetails = state.landingPageState.selectedFacilityDetails?.facility?.name
  //   ? state.landingPageState.selectedFacilityDetails
  //   : healthOrgDetails?.facilityCounts?.find(f => f.facility.id === state.landingPageState.selectedFacilityDetails.facility.id);

  return {
    activeTabId: state.dataEntryState.activeTabId,
    proceedBtnClick: state.dataEntryState.proceedBtnClick,
    selectedHealthOrganizationDetails: state.landingPageState.selectedHealthOrganizationDetails,
    selectedFacilityDetails: state.landingPageState.selectedFacilityDetails,
    transactionId: state.landingPageState.transactionId,
    transactionIDAttributes: state.dataEntryState.transactionIDAttributes,
    patientDetails: state.dataEntryState.leftPanePatientDetailsAttributes,
    transactionNotes: state.dataEntryState.transactionNotes,
    documentsList: state.dataEntryState.documentsList,
    documentSources: state.dataEntryState.documentSources,
    retrieveProtocol: state.dataEntryState.retrieveProtocol,
    formState: state.form && state.form[FormConstants.DATA_ENTRY_FIELDS_FORM],
    discloseInstitutions: state.dataEntryState.discloseInstitutions,
    // Spec #35289 (AC1): Audit(53) option lists - same slices Classic's RightPane
    // reads (getAuditTypesAPI -> ROIS_RequestorAuditType_sel; getOBOsAPI). AB#35289
    // (AC4 fix): Quick Entry now fetches these itself (fetchAuditFieldOptionsForQuickEntry)
    // since it never mounts RightPane; the API-status slices below drive that fetch-once.
    auditTypes: state.dataEntryState.auditTypes,
    onBehalfOf: state.dataEntryState.onBehalfOf,
    getAuditTypesAPIStatus: state.dataEntryState.getAuditTypesAPIStatus,
    getOBOsAPIStatus: state.dataEntryState.getOBOsAPIStatus,
    // Spec #35135 (AC3): already-loaded Disclosure Reason options (fetched once by
    // initialAPICalls' getDisclosureReasons) - same slice Classic's disclosure
    // accordion reads. No new fetch is introduced by the Quick Entry row.
    disclosureReasons: state.dataEntryState.disclosureReasons,
    selectedPHICodes: state.dataEntryState.selectedPHICodes,
    transactionDetails: state.dataEntryState.transactionDetails,
    userTasks: state.dataEntryState.userTasks,
    userTaskComments: state.dataEntryState.userTaskComments,
    feeSchedules: state.dataEntryState.feeSchedules,
    additionalChargeRecords: state.dataEntryState.additionalChargeRecords,
    // AB#35095: option sources for the Quick Entry billing pane's certification +
    // additional-charge controls - same slices Classic's billing tab reads.
    certificationTypes: state.dataEntryState.certificationTypes,
    additionalChargeType: state.dataEntryState.additionalChargeType,
    isRequestorVerificationEmailSent: state.dataEntryState.requestorVerificationEmailSent,
    requestorVerificationEmailPopupTriggered: state.dataEntryState.requestorVerificationEmailPopupTriggered,
    requestorDetails: state.dataEntryState.requestorDetails,
    // AB#37981: the slice Classic's Bill To section is seeded from (see DataEntryDetailsRightPane
    // mapStateToProps ~2845-2856).
    requestorBillingDetails: state.dataEntryState.requestorBillingDetails,
    deleteDocumentSuccess: state.dataEntryState.deleteDocumentAPISuccess,
    intiaTxlSagaCallCount: state.dataEntryState.intiaTxlSagaCallCount,
    requestContext: state.landingPageState.requestContext,
    uploadDocumentSuccess: state.dataEntryState.uploadDocumentSuccess,
    assessmentResult: state.dataEntryState.assessmentResult,
    qaErrors: state.dataEntryState.getQAErrors,
    QAIssues: state.dataEntryState.getQAIssues,
    qaPDIssues: state.dataEntryState.qaPDIssues,
    featureFlags: state.loginState.featureFlags,
    getTransactionDocumentsAPIStatus: state.dataEntryState.getTransactionDocumentsAPIStatus,
    currentFileType: state.dataEntryState.currentFileType,
    pageNumber: state.dataEntryState.pageNumber,
    currentFile: state.dataEntryState.currentFile,
    auditTrail: state.dataEntryState.auditTrail,
    // Fallback type/purpose resolution, applied HERE so every reader downstream - the seed, the
    // dropdowns, the row label, the grounding icons and the red "not a listed type" hint - sees one
    // consistent answer instead of each having to know about it. Untouched (same reference) whenever
    // the Intake API supplied ids, which is the normal path; it only fills the gap when the API
    // returned free text and no ids. See requestTypePurposeResolver for why that gap exists.
    requestAnalysis: withResolvedTypePurpose(state.dataEntryState.requestAnalysis, state.dataEntryState.requestTypes),
    getIntakeIntelligenceStatus: state.dataEntryState.getIntakeIntelligenceStatus,
    requestIntakeIntelligenceStatus: state.dataEntryState.requestIntakeIntelligenceStatus,
    // Same selector DataEntryDetailsBody.tsx already uses for the classic
    // Extract button's facility-level gate (Tech Lead note, AB#34098).
    facilityConfiguration: state.dataEntryState.facilityConfiguration,
    // F1d #34102 owns the real Classic-Mode exit dialog/state; defaults to
    // false until that lands.
    classicModeOverride: Boolean((state.dataEntryState as any).classicModeOverride),
    healthSystemDataEntryCount: state.landingPageState.selectedFacilityDetails?.transactionCounts?.dataEntry,
    // AC11 (F1a): mirrors DataEntryDetailsRightPane's own
    // `requestTypes: state.dataEntryState.requestTypes` binding, needed to
    // mount the shared RequestTypePurposeField inside the Quick Entry row.
    requestTypes: state.dataEntryState.requestTypes,
    // Spec #34102 (F1d), AC7: Quick Entry Billing pane's Release Method
    // options - same list the classic Billing tab already fetches via
    // getFacilityReleaseMethods (called unconditionally on mount, both modes).
    releaseMethodOptions: state.dataEntryState.releaseMethod,
    // AB#35095 layout parity: Shipping Service picker options (value=name), same slice
    // Classic's billing tab reads; already fetched on mount via getFacilityShippingServices.
    shippingServiceOptions: state.dataEntryState.shippingService,
    // Spec #35136 (F1f): DDS barcode-scan result + status, the SAME slices Classic's
    // RightPane already maps - reused so the Quick Entry DDS row can auto-populate.
    transactionDDS: state.dataEntryState.readBarCodeDDS,
    readBarCodeDDSAPIStatus: state.dataEntryState.readBarCodeDDSAPIStatus,
  };
}

function mapDispatchToProps(dispatch: Function): any {
  return {
    // AC11 (F1a): raw dispatch passthrough, needed because
    // RequestTypePurposeField's contract takes `dispatch: Function` directly
    // (it calls writeFieldToForm itself, same as DataEntryDetailsRightPane
    // does when it renders this same component).
    dispatch,
    // Spec #35136 (F1f): the SAME readBarCodeDDSRequest action Classic's RightPane
    // dispatches - reused unchanged, only its binding into this container is new.
    readBarCodeDDSRequest: (documentId: string) => dispatch(readBarCodeDDSRequest(documentId)),
    onChangeDataEntryTab: (data: number, tabClick: boolean) =>
      dispatch(onChangeDataEntryTab(data, tabClick)),
    resetForm: () => dispatch(reset(FormConstants.DATA_ENTRY_FIELDS_FORM)),
    saveInformationToRelease: (data: ReleaseInfoUpdate, onSuccess?: () => void, onError?: () => void) => dispatch(updateInformationToReleaseActionCreator(data, onSuccess, onError)),
    saveAndUpdateSensitiveInfo: (data: SensitiveInfoUpdateAPI) => dispatch(updateSensitiveInfoActionCreator(data)),
    putAuditTransactionSensitiveInfo: (transactionId: string, recordContains: string) => dispatch(putAuditTransactionSensitiveInfoCreator(transactionId, recordContains)),
    getAuditTrailData: (transactionId: string) => dispatch(getAuditTrail(transactionId)),
    getTransactionAttributes: (transactionId: string, onSuccess?: () => void) =>
      dispatch(getTransactionAttributesActionCreator(transactionId, onSuccess)),
    getDocumentById: (documentId: string, auditOnShowDoc: boolean) =>
      dispatch(getDocumentByIdActionCreator(documentId, auditOnShowDoc)),
    getFacilityFeeSchedules: (organizationId: number, transactionId: string) => dispatch(getFeeScheduleData(organizationId, transactionId, false)),
    // AB#35289 (Internal billing parity): setDefault=true so getFeeSchedules re-dispatches
    // getTransactionAttributes, pulling the backend-assigned courtesy schedule + fresh
    // isInternalRequest. Fired ONCE after the Confirm-All persist resolves (not on every
    // update), so it does not trigger the getTransactionAttributes loop.
    refreshBillingAfterConfirmAll: (facilityId: number, transactionId: string) => dispatch(getFeeScheduleData(facilityId, transactionId, true)),
    getFacilityShippingServices: (facilityId: number) => dispatch(getShippingServicesData(facilityId)),
    getFacilityReleaseMethods: (facilityId: number, transactionId: string) => dispatch(getReleaseMethodOptionsData(facilityId, transactionId)),
    // AB#38349: the SAME setReleaseMethod action Classic's contact-PATCH saga puts.
    setReleaseMethod: (releaseMethodId: number) => dispatch(setReleaseMethodActionCreator(releaseMethodId)),

    getTransactionNotesRequest: (transactionId: string) =>
      dispatch(getTransactionNotesRequest(transactionId)),
    getAdditionalChargeType: (facilityId: number) =>
      dispatch(getAdditionalChargeType(facilityId)),
    getAdditionalChargeRecords: (transactionId: string) =>
      dispatch(getAdditionalChargeRecordsCreator(transactionId)),
    getTransactionDocuments: (transactionId: string) =>
      dispatch(getTransactionDocuments(transactionId)),
    getRejectOptions: (facilityId: number) => dispatch(getRejectOptions(facilityId)),
    getTransactionNoteTypes: (facilityId: number) => dispatch(getTransactionNoteTypes(facilityId)),
    uploadMultipleDocuments: (data: DocumentUploadRequest) => dispatch(uploadMultipleDocumentsActionCreator(data)),
    resetDataEntryState: () => dispatch(resetDataEntryState()),
    getDocumentSources: (data: any) => dispatch(getDoucmentSourcesActionCreator(data)),
    deleteAuxDocument: (transactionId: string) => dispatch(deleteDocumentActionCreator("AUX", transactionId)),
    deleteIntDocument: (transactionId: string) => dispatch(deleteDocumentActionCreator("INT", transactionId)),
    deleteDocument: (documentId: any) => dispatch(deleteDocumentActionCreator("MED", documentId)),
    getRetrieveProtocol: (data: any) => dispatch(getRetrieveProtocolActionCreator(data)),
    transactionCancellationReasons: (facilityId: number) => dispatch(getCancellationReasons(facilityId)),
    // AB#35095: same duplicate-check action Classic dispatches on Billing-tab entry.
    checkDuplicateTransactions: (transactionId: string, caseNumber: string) => dispatch(checkDuplicateTransactions(transactionId, caseNumber)),
    getSelectedPHICodes: (transactionId: string) =>
      dispatch(getSelectedPHICodesActionCreator(transactionId)),
    // AB#35289 (AC4 fix): the SAME argument-less fetches Classic dispatches from RightPane
    // (getAuditTypesSaga/getOBOsSaga call getAuditTypesAPI/getOBOsAPI with no params).
    getAuditTypesRequest: () => dispatch(getAuditTypesRequest(undefined)),
    getOBOsRequest: () => dispatch(getOBOsRequest(undefined)),
    getPHICodesRequest: (facilityId: number) => dispatch(getPHICodesRequest(facilityId)),
    getUserGroups: (facilityId: number) => dispatch(getUserGroupsActionCreator(facilityId)),
    getDisclosureReasons: (facilityId: number) => dispatch(getDisclosureReasonActionCreator(facilityId)),
    stopSubmit: (validations: any) => dispatch(stopSubmit(FormConstants.DATA_ENTRY_FIELDS_FORM, validations)),
    updateFormSyncErrors: (data: any) => dispatch(updateFormSyncErrorsActionCreator(data)),
    getUserTasks: (data: any) => dispatch(getUserTasksActionCreator(data)),
    submitForm: () => dispatch(submit(FormConstants.DATA_ENTRY_FIELDS_FORM)),
    touch: (fields: any) => dispatch(touch(FormConstants.DATA_ENTRY_FIELDS_FORM, fields)),
    getRequestsAndPurposes: (healthSystemId: number) => dispatch(getRequestTypesAndPurposesRequest(healthSystemId)),
    getFacilityDiscloseInstitutionsRequest: (facilityId: number) => dispatch(getFacilityDiscloseInstitutionsRequest(facilityId)),
    requestorVerificationEmailSent: () => dispatch(requestorVerificationEmailSent()),
    requestorVerificationEmailSentReset: () => dispatch(RequestorVerificationEmailSentReset()),
    setLastUsedRequestorInfo: (data: any) => dispatch(setLastUsedRequestorInfo(data)),
    patchRequestorComplete: (data: string) => dispatch(requestorCompleteActionCreator(data)),
    patchBillingComplete: (data: string, onSuccess?: () => void, onError?: () => void) => dispatch(billingCompleteActionCreator(data, onSuccess, onError)),
    patchDetailsComplete: (data: string, onSuccess?: () => void, onError?: () => void) =>
      dispatch(detailsCompleteActionCreator(data, onSuccess, onError)),
    // Spec #35135 (AC4a): Classic's existing disclosure save, now callback-capable
    // so the Quick Entry Confirm-All gate can await it.
    updateDisclosureInformation: (data: any, onSuccess?: () => void, onError?: () => void) => dispatch(updateDisclosureInformationActionCreator(data, onSuccess, onError)),
    // Spec #35135 (AC9): the SHARED finalize (COMPLETE_TRANSACTION_REQUEST_SAGA ->
    // completeTransactionAPI) CompleteTransactionPopUp already dispatches for every
    // request type. It existed in the Ducks but was only mapped in
    // DataEntryDetailsRightPane; Quick Entry's Disclosure Accounting completion
    // needs it here (patchBillingComplete is unreachable for type 66).
    completeTransaction: (transactionId: string, onSuccess?: () => void, onError?: () => void) => dispatch(completeTransactionTaskActionCreator(transactionId, onSuccess, onError)),
    postCancellationReasonsDispatch: (transactionId: string, id: any, cancelReasonText: string) => dispatch(postCancellationReasonsActionCreators(transactionId, id, cancelReasonText)),
    getFacilityAdditionalFieldsActionCreator: (data) => dispatch(getFacilityAdditionalFieldsActionCreator(data)),
    transactionWaitAndHoldReasons: (data) => dispatch(getWaitAndHoldReasons(data)),
    getOutboundTemplateRequest: () => dispatch(getOutboundTemplateRequest()),
    getAssessmentResults: (transactionId: string) => dispatch(getAssessmentResultsActionCreator(transactionId)),
    getReviewEntities: (transactionId: string) => dispatch(getReviewEntitiesActionCreator(transactionId)),
    getEntityTypes: () => dispatch(getSensitivityTypesActionCreator()),
    getQAErrors:() => dispatch(getQAErrorsActionCreator()),
    getQAIssues: (transactionId: string) => dispatch(getQAIssuesActionCreator(transactionId)),
    getQAPDIssues:(transactionId: string) => dispatch(getQAPDIssuesActionCreator(transactionId)),
    updateBillingPaneFields: (data: any, updateData?: boolean, onSuccess?: () => void, onError?: () => void) => {return dispatch(updateBillingPaneFields(data, updateData, onSuccess, onError))},
    // AB#35095: Classic's existing bill-to / certification / additional-charges save paths,
    // now callback-capable so the Quick Entry completion gate can await them.
    updateBillToRequestorData: (data: any, onSuccess?: () => void, onError?: () => void) => dispatch(updateBillToRequestorDetailsRequest(data, onSuccess, onError)),
    setCertificationTemplate: (transactionId: string, certificationType: string, onSuccess?: () => void, onError?: () => void) => dispatch(setCertificationTemplateAction(transactionId, certificationType, onSuccess, onError)),
    updateAdditionalCharges: (requestData: any, onSuccess?: () => void, onError?: () => void) => dispatch(updateAdditionalChargesActionCreator(requestData, onSuccess, onError)),
    putDigitalFaxValidation: (transactionId: string, faxNumber: any, onSuccess?: () => void, onError?: () => void) => dispatch(putDigitalFaxValidationCreator(transactionId, faxNumber, onSuccess, onError)),
    createPatientRecordRequest: (data: any, onSuccess?: () => void, onError?: () => void) => dispatch(createPatientRecordRequest(data, onSuccess, onError)),
    getAIFeedback: () => dispatch(getAIFeedbackActionCreator()),
    getAuditUsers: (transactionId: string) => dispatch(getAuditUsersActionCreator(transactionId)),
    getCertificationTypes: () => dispatch(getCertificationTypesAction()),
    setPageNumber: (pageNumber: number, fileDesc: string) => dispatch(setPDFPageNumberActionCreator(pageNumber, fileDesc)),
    setGroundingHighlight: (grounding?: FieldGrounding) => dispatch(setGroundingHighlightActionCreator(grounding)),
    setCurrentFileType: (fileType) => dispatch(setCurrentFileTypeActionCreator(fileType)),
    updateDocument: (data: any) => dispatch(updateDocumentActionCreator(data)),
    getFacilityConfiguration: (facilityId: number) => dispatch(getFacilityConfigurationsActionCreator(facilityId)),
    getIntakeIntelligence: (organizationId: number, requestBufferId: number) =>
        dispatch(getIntakeIntelligenceActionCreator(organizationId, requestBufferId)),
    getQAFeatureFlagsRequest: () => dispatch(getQAFeatureFlagsRequestActionCreator()),
    // Spec #34102 (F1d), AC4/AC5/AC6: the Confirm-All bulk correction commit.
    commitQuickEntry: (
      organizationId: number,
      requestBufferId: number,
      corrections: readonly QuickEntryCorrectionPayload[],
      onSuccess?: (completedDate: string) => void,
      onConflict?: () => void,
      onNoIntakeRecord?: () => void,
      onError?: () => void,
      matchSummary?: QuickEntryMatchSummaryPayload,
    ) => dispatch(commitQuickEntryActionCreator(organizationId, requestBufferId, corrections, onSuccess, onConflict, onNoIntakeRecord, onError, matchSummary)),
    // Spec #34102 (F1d), AC11/AC12: the only writer of classicModeOverride.
    setClassicModeOverride: (value: boolean) => dispatch(setClassicModeOverrideActionCreator(value)),
    // Spec #34102 (F1d), AC9: same queue-navigation actions QuickEntryActionFooter's own "Next Request" already dispatches.
    getNextTransactionId: (facilityId: number, context: number) => dispatch(nextTransactionIdActionCreator(facilityId, context)),
    clearTransactionId: () => dispatch(clearTransactionId()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DataEntryDetails);
